
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("fImWv", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $da002f83cf061f88$export$d0aef4d352cf8b14 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "ctj29",
    name: "AnalyticsByLine",
    loader: async ()=>(await (parcelRequire("fTz11"))).AnalyticsByLine
});
module.exports["AnalyticsByLine"] = $da002f83cf061f88$export$d0aef4d352cf8b14;

});

parcelRegister("fTz11", function(module, exports) {

let $b9272768621092be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b9272768621092be$var$load("6wr18"),
    $b9272768621092be$var$load("4RHRd"),
    $b9272768621092be$var$load("6XCf4"),
    $b9272768621092be$var$load("ebvEF"),
    $b9272768621092be$var$load("ffEVr"),
    $b9272768621092be$var$load("7EorR"),
    $b9272768621092be$var$load("aEiTV"),
    $b9272768621092be$var$load("1qlDN"),
    $b9272768621092be$var$load("1yVM6"),
    $b9272768621092be$var$load("6c9wI")
]).then(()=>parcelRequire('ffp8s'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("kaFRI", function(module, exports) {
/**
 * @generated SignedSource<<64af480c914c91db1b510fce34177ff2>>
 * @relayHash 90308ee3f23c965d3be02cc175a44ffc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID c4ce5797d5f0008be560a06960fc2d934a6caa4c0b65b5dabd656144a79eb196
const $ee0ab3671dea2507$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPrivacyModeGateEnabled"
    }, v3 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "title"
                },
                {
                    "concreteType": "ContentMetadata",
                    "kind": "LinkedField",
                    "name": "metadata",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "createdDate"
                        }
                    ]
                }
            ]
        },
        {
            "condition": "isPrivacyModeGateEnabled",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
                {
                    "alias": "privacyMode",
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "ConfluencePrivacyMode",
                    "kind": "LinkedField",
                    "name": "confluence_isPrivacyModeEnabled",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "isPrivacyModeEnabled"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "AnalyticsDialogAnalyticsContentQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "AnalyticsDialogAnalyticsContentQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "90308ee3f23c965d3be02cc175a44ffc",
            "id": "c4ce5797d5f0008be560a06960fc2d934a6caa4c0b65b5dabd656144a79eb196",
            "metadata": {},
            "name": "AnalyticsDialogAnalyticsContentQuery",
            "operationKind": "query",
            "text": "query AnalyticsDialogAnalyticsContentQuery($contentId:ID!,$cloudId:ID!,$isPrivacyModeGateEnabled:Boolean!){singleContent(id:$contentId){id,type,subType,title,metadata{createdDate}},privacyMode:confluence_isPrivacyModeEnabled(cloudId:$cloudId)@include(if:$isPrivacyModeGateEnabled){isPrivacyModeEnabled}}"
        }
    };
}();
$ee0ab3671dea2507$var$node.hash = "fe1ea5ee176ed78040ab6497bb6eafa9";
var $ee0ab3671dea2507$export$2e2bcd8739ae039 = $ee0ab3671dea2507$var$node;
module.exports["default"] = $ee0ab3671dea2507$export$2e2bcd8739ae039;

});

parcelRegister("a9SX7", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $db22052f45cd3c08$export$aeb07f2d59756a1b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "VfqBC",
    name: "ListenByline",
    loader: async ()=>(await (parcelRequire("58QGN"))).ListenByline
});
module.exports["ListenByline"] = $db22052f45cd3c08$export$aeb07f2d59756a1b;

});

parcelRegister("58QGN", function(module, exports) {

let $3be69215d5d33d99$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3be69215d5d33d99$var$load("ebXHc"),
    $3be69215d5d33d99$var$load("bb3WM"),
    $3be69215d5d33d99$var$load("5lo9L")
]).then(()=>parcelRequire('lFyOr'));

});

parcelRegister("l2a4I", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $lpNn5 = parcelRequire("lpNn5");


var $lsxnT = parcelRequire("lsxnT");


var $ew8wg = parcelRequire("ew8wg");


var $3plmx = parcelRequire("3plmx");





var $idfQJ = parcelRequire("idfQJ");


var $fONL3 = parcelRequire("fONL3");

const $b3c77e69626f7927$var$getIconKey = (providerDisplayName)=>providerDisplayName?.replace(/([a-z])([A-Z])/g, '$1 $2') ?? 'Repository';
const $b3c77e69626f7927$var$getProviderIcon = (provider, providerDisplayName)=>{
    return {
        key: `devdocs-provider-${$b3c77e69626f7927$var$getIconKey(providerDisplayName)}`,
        kind: 'element',
        label: providerDisplayName,
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idfQJ.DevDocsScmProviderIcon), {
            provider: provider
        })
    };
};
const $b3c77e69626f7927$export$65120229cda600d = (connection)=>{
    if (!connection) return null;
    const providerConfig = (0, $fONL3.getDevDocsSourceProviderConfigFromValue)(connection.provider);
    const providerDisplayName = providerConfig?.displayName ?? (0, $fONL3.getDevDocsSourceProviderDisplayName)(connection.provider);
    if (!providerDisplayName) return null;
    return {
        key: providerConfig ? $b3c77e69626f7927$var$getIconKey(providerConfig.displayName) : providerDisplayName,
        label: providerDisplayName,
        icon: $b3c77e69626f7927$var$getProviderIcon(connection.provider, providerDisplayName)
    };
};



var $5vi32 = parcelRequire("5vi32");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $I7TEB = parcelRequire("I7TEB");

/* BylineConnectionsTrigger.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");








var $w6R6I = parcelRequire("w6R6I");


var $aZ9If = parcelRequire("aZ9If");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $hTfX9 = parcelRequire("hTfX9");

const $55dbae87bfebb50e$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "byline-connections.label",
        defaultMessage: "Context"
    }
});
const $55dbae87bfebb50e$var$styles = {
    wrapper: "_2sNsIg7NXe _3iDTPbccYA _0hPCNLDIqT _2xTnZx1Y8M _0jFU0VoWWg _1ANEUSzUZr",
    wrapperLoaded: "_1UtDYzZpcK",
    wrapperPlaceholder: "_1UtDYzot27",
    trigger: "_2sNsIg7NXe _0bjKvDKxmn _4FKVYE1Y8M _3iDTPbccYA _0hPCNLDIqT _17lj8p1Y8M _0KLXrujOvk _1ANEUSLRg7",
    triggerLoaded: "_0wOv4Q7zJH _1UtDYzZpcK _1eOmH6o126 _3gzVzLN4oS",
    triggerPlaceholder: "_0wOv4QOLYo _1UtDYzot27"
};
const $55dbae87bfebb50e$export$8b56d9356350e1f6 = ({ appearance: appearance, children: children, ...htmlAttributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...htmlAttributes,
        className: (0, $hekY6.default)([
            $55dbae87bfebb50e$var$styles.wrapper,
            appearance === 'loaded' ? $55dbae87bfebb50e$var$styles.wrapperLoaded : $55dbae87bfebb50e$var$styles.wrapperPlaceholder
        ])
    }, children);
const $55dbae87bfebb50e$export$a5631cafd5b67535 = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { additionalIcons: additionalIcons, appearance: appearance, incomingLinks: incomingLinks, links: links, minIcons: minIcons } = props;
    const isPlaceholder = appearance === 'placeholder';
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))), {
        label: "",
        size: "small",
        color: isPlaceholder ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
        testId: "byline-connections-teamwork-graph-icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "span",
        size: "small",
        color: isPlaceholder ? 'color.text.disabled' : 'color.text.subtle'
    }, formatMessage($55dbae87bfebb50e$var$i18n.label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTfX9.BylineConnectionIconStack), {
        links: links,
        incomingLinks: incomingLinks,
        additionalIcons: additionalIcons,
        appearance: isPlaceholder ? 'placeholder' : 'default',
        minIcons: minIcons,
        spacing: "none"
    }));
    if (props.appearance === 'placeholder') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        isDisabled: true,
        "aria-hidden": "true",
        testId: "byline-connections-trigger",
        xcss: (0, $w6R6I.cx)($55dbae87bfebb50e$var$styles.trigger, $55dbae87bfebb50e$var$styles.triggerPlaceholder)
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        ...props.buttonProps,
        testId: "byline-connections-trigger",
        xcss: (0, $w6R6I.cx)($55dbae87bfebb50e$var$styles.trigger, $55dbae87bfebb50e$var$styles.triggerLoaded)
    }, content);
};






var $fZLJ8 = parcelRequire("fZLJ8");









var $jJhQa = parcelRequire("jJhQa");


var $f0mzK = parcelRequire("f0mzK");

const $25cd036cbf182d70$var$i18n = (0, $kSwu1.defineMessages)({
    loadingConnections: {
        id: "byline-connections.loading",
        defaultMessage: "Loading connections"
    }
});
const $25cd036cbf182d70$var$placeholderIcons = Array.from({
    length: (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS)
}, (_, index)=>(0, $f0mzK.createPlaceholderConnectionIcon)(index));
const $25cd036cbf182d70$export$3914fbcb8a4d6407 = ({ testId: testId = 'byline-connections-ssr-placeholder' })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55dbae87bfebb50e$export$8b56d9356350e1f6), {
        appearance: "placeholder",
        role: "status",
        "aria-label": formatMessage($25cd036cbf182d70$var$i18n.loadingConnections),
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55dbae87bfebb50e$export$a5631cafd5b67535), {
        appearance: "placeholder",
        links: [],
        additionalIcons: $25cd036cbf182d70$var$placeholderIcons
    }));
};



var $3C8hL = parcelRequire("3C8hL");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6U179 = parcelRequire("6U179");


var $47TZD = parcelRequire("47TZD");

// Passed only while the read is skipped, so the exact value never keys a real cache lookup.
const $c1244bdd1b458e82$var$SKIPPED_VARIABLES = {
    cypherQuery: '',
    first: 0
};
const $c1244bdd1b458e82$export$36c53bcdf571f79b = (contentId)=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const variables = !contentId || !cloudId ? undefined : (0, $47TZD.buildIncomingLinksSampleVariables)(cloudId, contentId);
    const { data: data } = (0, $jMyy4.useQueryInterop)((0, $6U179.default), {
        variables: variables ?? $c1244bdd1b458e82$var$SKIPPED_VARIABLES,
        fetchPolicy: 'cache-only',
        skip: variables === undefined,
        interopApolloAggClient: true,
        __callerPackage__: "byline-connections"
    });
    // An undefined `variables` forces `skip`, which forces `data` undefined, so the `data` guard
    // already covers it; the `contentId` guard also narrows it to a string for the normalizer.
    if (!contentId || data === undefined) return undefined;
    return (0, $47TZD.normalizeIncomingLinksSsrState)(contentId, data);
};



var $6SsN4 = parcelRequire("6SsN4");


var $8VTwN = parcelRequire("8VTwN");







const $4fdcf8c799fd8a14$export$4ec68330314c7b96 = (contentId)=>{
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $8VTwN.default), {
        contentId: contentId ?? '',
        first: (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS),
        smartLinksFromDraft: false
    }, {
        fetchPolicy: 'store-only'
    });
    if (contentId === undefined) return undefined;
    return (0, $3C8hL.normalizeOutboundBylineSsrState)(contentId, data);
};


const $d13ffa3aaf9dd66c$export$f8ba3742be6a3e0d = ({ contentId: contentId, connectionAncestors: connectionAncestors })=>{
    // Read the preloaded outbound state on the client too (cache-only, hydrated from the SSR
    // preload). This lets the placeholder stay visible after the post-paint hydration and while the
    // LoadableAfterPaint chunk loads, instead of blanking — which caused the "SSR placeholder →
    // nothing → skeleton → item" flash. The result is derived purely from the hydrated cache and
    // dev-docs, so it is identical on the server and the client's first render (no hydration
    // mismatch). Pages with no connections still render nothing (no client footprint). CCINT-8752
    const outboundState = (0, $4fdcf8c799fd8a14$export$4ec68330314c7b96)(contentId);
    const incomingLinksState = (0, $c1244bdd1b458e82$export$36c53bcdf571f79b)(contentId);
    const devDocsConnection = (0, $fZLJ8.useDevDocsBylineConnection)(connectionAncestors);
    const reservedIconCount = (0, $3C8hL.getReservedBylineIconCount)(outboundState, devDocsConnection !== null, incomingLinksState?.status === 'present');
    if (reservedIconCount === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $25cd036cbf182d70$export$3914fbcb8a4d6407), null);
};










/* ConnectionsByLineMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $ad7Ou = parcelRequire("ad7Ou");


var $aRvnq = parcelRequire("aRvnq");





var $6IL1T = parcelRequire("6IL1T");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");











var $huzJY = parcelRequire("huzJY");


var $8FgJC = parcelRequire("8FgJC");


var $e9QBI = parcelRequire("e9QBI");

const $c0311709cd7c6fed$var$i18n = (0, $kSwu1.defineMessages)({
    syncedWith: {
        id: "dev-docs.byline-connection.menu.section.synced-with.ai-non-final",
        defaultMessage: "Synced with ({count, number})"
    }
});
const $c0311709cd7c6fed$export$23d9bfb525ce3655 = ({ connection: connection, onNavigate: onNavigate })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huzJY.default), null, formatMessage($c0311709cd7c6fed$var$i18n.syncedWith, {
        count: 1
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e9QBI.DevDocsConnectionRow), {
        connection: connection,
        onNavigate: onNavigate
    }));
};





/* ConnectionsByLineExpandableLinkSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 


















var $6F7l4 = parcelRequire("6F7l4");

const $92feead83550977e$var$styles = {
    expandButton: "_2Y7lL48HPE _46hvQmgVvo _0xmtko8HPE"
};
// links. Renders nothing when there are no links to show.
const $92feead83550977e$var$ConnectionsByLineLinkSection = ({ heading: heading, links: links, compact: compact, refreshLinkUrl: refreshLinkUrl, linkDirection: linkDirection, onNavigate: onNavigate, analyticsSource: analyticsSource })=>{
    if (links.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8FgJC.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $huzJY.default), null, heading), links.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6F7l4.ConnectionsByLineMenuItem), {
            key: `${item.url}-${item.occurrenceIndex}`,
            item: item,
            refreshLinkUrl: refreshLinkUrl,
            linkDirection: linkDirection,
            onNavigate: onNavigate,
            compact: compact,
            analyticsSource: analyticsSource,
            // them is a plain static list: no Connect, no row actions, no hover card.
            // The preview panel keeps the hover affordances. (CCINT-9250)
            disableHover: true
        }))));
};
const $92feead83550977e$export$825be6248d440e90 = ({ heading: heading, links: links, shouldShowExpandButton: shouldShowExpandButton = false, expandButtonLabel: expandButtonLabel, onExpand: onExpand, refreshLinkUrl: refreshLinkUrl, linkDirection: linkDirection, onNavigate: onNavigate, compact: compact, analyticsSource: analyticsSource })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($92feead83550977e$var$ConnectionsByLineLinkSection, {
        heading: heading,
        links: links,
        compact: compact,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: linkDirection,
        onNavigate: onNavigate,
        analyticsSource: analyticsSource
    }), shouldShowExpandButton && expandButtonLabel && onExpand ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $92feead83550977e$var$styles.expandButton
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        shouldFitContainer: true,
        onClick: onExpand
    }, expandButtonLabel)) : null);









var $cS4kb = parcelRequire("cS4kb");


var $1UApO = parcelRequire("1UApO");


var $8dynS = parcelRequire("8dynS");





var $kOUwv = parcelRequire("kOUwv");

function $8ab372ddb9ea7e6c$export$284907af4a465a72(traitName, parse, { skip: skip } = {}) {
    const { data: data, loading: loading, error: error } = (0, $kOUwv.useSiteTraits)({
        skipBootstrap: !!skip
    });
    const parseRef = (0, $cozmU.useRef)(parse);
    parseRef.current = parse;
    const value = (0, $cozmU.useMemo)(()=>{
        if (skip || !data?.attributes) return undefined;
        const raw = data.attributes.find(({ name: name })=>name === traitName)?.value;
        return parseRef.current(raw);
    }, [
        skip,
        data,
        traitName
    ]);
    return {
        value: value,
        loading: loading,
        error: error
    };
}


const $11c55f3cb3c29119$export$3d6612235992a7fe = 'google-drive';
function $11c55f3cb3c29119$export$2bffffe5ac9dc808(raw) {
    if (raw === undefined || raw.trim() === '') return undefined;
    const counts = raw.split(',').reduce((acc, segment)=>{
        const colonIdx = segment.indexOf(':');
        if (colonIdx === -1) return acc;
        const provider = segment.slice(0, colonIdx).trim();
        const countRaw = segment.slice(colonIdx + 1).trim();
        if (!provider || countRaw === '') return acc;
        const count = Number(countRaw);
        if (!Number.isInteger(count) || count < 0) return acc;
        acc[provider] = count;
        return acc;
    }, {});
    return Object.keys(counts).length > 0 ? counts : undefined;
}
function $11c55f3cb3c29119$export$2bd9a43397bfe114({ skip: skip } = {}) {
    return (0, $8ab372ddb9ea7e6c$export$284907af4a465a72)((0, $8dynS.SMARTLINK_CONNECTION_LINK_COUNT_TRAIT), $11c55f3cb3c29119$export$2bffffe5ac9dc808, {
        skip: skip
    });
}


/* GdriveConnectorPromoBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $1sCHt = parcelRequire("1sCHt");


var $l3wuH = parcelRequire("l3wuH");











var $9NPFC = parcelRequire("9NPFC");


var $9Jc29 = parcelRequire("9Jc29");


var $jmjWc = parcelRequire("jmjWc");


const $aa7ff97a50d7e018$var$UnconnectedConnectorHoverCardLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "R6X72",
    name: "UnconnectedConnectorHoverCardLoadable",
    loader: async ()=>(await (parcelRequire("7su1d"))).UnconnectedConnectorHoverCard
});
const $aa7ff97a50d7e018$var$i18n = (0, $kSwu1.defineMessages)({
    message: {
        id: "byline-connections.menu.footer.connect-placeholder",
        defaultMessage: "Connect Google drive to see rich previews across Confluence"
    },
    connectAction: {
        id: "byline-connections.menu.footer.connect-action",
        defaultMessage: "Connect"
    },
    connectingAction: {
        id: "byline-connections.menu.footer.connecting-action",
        defaultMessage: "Connecting..."
    },
    dismissAction: {
        id: "byline-connections.menu.footer.dismiss-action",
        defaultMessage: "Dismiss"
    },
    googleDriveIconAlt: {
        id: "byline-connections.menu.footer.google-drive-icon.alt",
        defaultMessage: "Google Drive"
    }
});
const $aa7ff97a50d7e018$var$styles = {
    footer: "_4c065U8HPE _2Y7lL45zaO _0KLXrunmFW _0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67",
    message: "_2sNsIg7NXe _1UtDYzy7kJ",
    connect: "_2sNsIgmnOE _4FKVYEPgdg _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3hxITiYbGa _1UtDYzM7Tp _0KLXrujOvk _0wOv4Q7zJH _3YEZNOdnbC _253ZDm98eZ _2r76lK0Rl6 _4umoPx6wH8 _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    connecting: "_2sNsIgmnOE _4FKVYEPgdg _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _3hxITiYbGa _1UtDYzot27 _0KLXrujOvk _0wOv4Q18ZR _3YEZNOdnbC"
};
const $aa7ff97a50d7e018$export$e7e7ab663009ba26 = ({ onConnect: onConnect, onDismiss: onDismiss, isConnecting: isConnecting })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [isBannerHovered, setIsBannerHovered] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aa7ff97a50d7e018$var$UnconnectedConnectorHoverCardLoadable, {
        providerKey: "gdrive",
        isOpen: isBannerHovered
    }, ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: ref,
            ...triggerProps,
            xcss: $aa7ff97a50d7e018$var$styles.footer,
            onMouseEnter: ()=>setIsBannerHovered(true),
            onMouseLeave: ()=>setIsBannerHovered(false),
            onFocus: ()=>setIsBannerHovered(true),
            onBlur: ()=>setIsBannerHovered(false)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center",
            spread: "space-between"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.100",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: formatMessage($aa7ff97a50d7e018$var$i18n.googleDriveIconAlt),
            size: "small",
            backgroundColor: "color.background.neutral",
            isInset: false,
            hasBorder: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9Jc29.GoogleDriveAppSelectorIcon), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $aa7ff97a50d7e018$var$styles.message
        }, formatMessage($aa7ff97a50d7e018$var$i18n.message))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            space: "space.050",
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: isConnecting ? $aa7ff97a50d7e018$var$styles.connecting : $aa7ff97a50d7e018$var$styles.connect,
            onClick: onConnect,
            isDisabled: isConnecting,
            "aria-busy": isConnecting
        }, formatMessage(isConnecting ? $aa7ff97a50d7e018$var$i18n.connectingAction : $aa7ff97a50d7e018$var$i18n.connectAction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
            label: formatMessage($aa7ff97a50d7e018$var$i18n.dismissAction),
            onClick: onDismiss
        })))));
};





const $4aa630edd4fe23e7$export$b1294d95ffe11792 = 'connectionsBylinePromoBanner';
const $4aa630edd4fe23e7$export$450e9e5e468adef1 = 'google';
const $4aa630edd4fe23e7$export$57e0ff4c2905037a = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'viewed',
            actionSubject: 'banner',
            actionSubjectId: $4aa630edd4fe23e7$export$b1294d95ffe11792,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: attributes
        }
    });
const $4aa630edd4fe23e7$export$c308d47e70cf3cab = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'dismissed',
            actionSubject: 'banner',
            actionSubjectId: $4aa630edd4fe23e7$export$b1294d95ffe11792,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: attributes
        }
    });
const $4aa630edd4fe23e7$export$3155a85848c110b5 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'notShown',
            actionSubject: 'banner',
            actionSubjectId: $4aa630edd4fe23e7$export$b1294d95ffe11792,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: attributes
        }
    });
const $4aa630edd4fe23e7$export$aa60f051027ec020 = 'connectionsBylineGdrivePromoConnect';
const $4aa630edd4fe23e7$export$89e0f005fead14a3 = 'connectionsBylineGdrivePromoAuth';
const $4aa630edd4fe23e7$export$53f4484811034e3e = ()=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: $4aa630edd4fe23e7$export$aa60f051027ec020,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: {
                bannerType: 'gdrivePromo',
                connector: $4aa630edd4fe23e7$export$450e9e5e468adef1
            }
        }
    });
const $4aa630edd4fe23e7$export$a58cc560aa8bc031 = ()=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: 'auth',
            actionSubjectId: $4aa630edd4fe23e7$export$89e0f005fead14a3,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: {
                bannerType: 'gdrivePromo',
                connector: $4aa630edd4fe23e7$export$450e9e5e468adef1,
                status: 'success'
            }
        }
    });
const $4aa630edd4fe23e7$export$8d43fd709df6585d = (reason)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: 'auth',
            actionSubjectId: $4aa630edd4fe23e7$export$89e0f005fead14a3,
            source: (0, $I7TEB.MENU_FOOTER_SOURCE),
            attributes: {
                bannerType: 'gdrivePromo',
                connector: $4aa630edd4fe23e7$export$450e9e5e468adef1,
                status: 'failed',
                reason: reason
            }
        }
    });






var $17wUi = parcelRequire("17wUi");

const $aa04272ccb3d246a$var$readPages = (storageKey)=>{
    const value = (0, $17wUi.confluenceLocalStorageInstance).getItem(storageKey);
    return Array.isArray(value) ? value : [];
};
const $aa04272ccb3d246a$var$isPageDismissed = (storageKey, contentId)=>{
    if (!contentId) return false;
    return $aa04272ccb3d246a$var$readPages(storageKey).includes(contentId);
};
const $aa04272ccb3d246a$var$markPageDismissed = (storageKey, contentId)=>{
    const previous = $aa04272ccb3d246a$var$readPages(storageKey);
    const updated = [
        contentId,
        ...previous.filter((id)=>id !== contentId)
    ];
    (0, $17wUi.confluenceLocalStorageInstance).setItem(storageKey, updated);
};
const $aa04272ccb3d246a$export$6542d147ca3e4064 = (storageKey, contentId)=>{
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(()=>$aa04272ccb3d246a$var$isPageDismissed(storageKey, contentId));
    const dismiss = (0, $cozmU.useCallback)(()=>{
        if (contentId) $aa04272ccb3d246a$var$markPageDismissed(storageKey, contentId);
        setIsDismissed(true);
    }, [
        storageKey,
        contentId
    ]);
    return {
        isDismissed: isDismissed,
        dismiss: dismiss
    };
};






var $eEPSE = parcelRequire("eEPSE");


var $7zxJs = parcelRequire("7zxJs");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");





var $8gF2o = parcelRequire("8gF2o");

const $ef409225f8f5ce6a$export$bf91246c5b17e0bf = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    const { aaId: aaId, productKey: productKey } = t0;
    const [payload, setPayload] = (0, $cozmU.useState)(null);
    const [env, setEnv] = (0, $cozmU.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [optimisticAuthed, setOptimisticAuthed] = (0, $cozmU.useState)(false);
    let t1;
    if ($[0] !== aaId) {
        t1 = ()=>{
            setOptimisticAuthed(false);
            let cancelled = false;
            setIsLoading(true);
            (0, $8gF2o.fetchOutboundAuthAccounts)(aaId).then((fetched)=>{
                if (cancelled) return;
                setPayload(fetched);
                setEnv((0, $8gF2o.detectEnvFromPayload)(fetched) ?? undefined);
                setIsLoading(false);
            }).catch(()=>{
                if (cancelled) return;
                setPayload(null);
                setEnv(undefined);
                setIsLoading(false);
            });
            return ()=>{
                cancelled = true;
            };
        };
        $[0] = aaId;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== aaId || $[3] !== productKey) {
        t2 = [
            aaId,
            productKey
        ];
        $[2] = aaId;
        $[3] = productKey;
        $[4] = t2;
    } else t2 = $[4];
    (0, $cozmU.useEffect)(t1, t2);
    let t3;
    let t4;
    if ($[5] !== optimisticAuthed || $[6] !== payload) {
        t3 = ()=>{
            if (payload && optimisticAuthed) setOptimisticAuthed(false);
        };
        t4 = [
            payload,
            optimisticAuthed
        ];
        $[5] = optimisticAuthed;
        $[6] = payload;
        $[7] = t3;
        $[8] = t4;
    } else {
        t3 = $[7];
        t4 = $[8];
    }
    (0, $cozmU.useEffect)(t3, t4);
    let t5;
    if ($[9] !== aaId) {
        t5 = ()=>{
            if (!aaId) return;
            setOptimisticAuthed(true);
            (0, $8gF2o.fetchOutboundAuthAccounts)(aaId, {
                forceRefresh: true
            }).then((fresh)=>{
                if (fresh) {
                    setPayload(fresh);
                    setEnv((0, $8gF2o.detectEnvFromPayload)(fresh) ?? undefined);
                }
            });
        };
        $[9] = aaId;
        $[10] = t5;
    } else t5 = $[10];
    const onConnected = t5;
    let t6;
    if ($[11] !== env || $[12] !== productKey) {
        t6 = (0, $8gF2o.hasSmartLinkContainerMapping)(productKey, env) ? (0, $8gF2o.buildSmartLinkAuthUrl)(productKey, env) ?? undefined : undefined;
        $[11] = env;
        $[12] = productKey;
        $[13] = t6;
    } else t6 = $[13];
    const authUrl = t6;
    let t7;
    if ($[14] !== env || $[15] !== optimisticAuthed || $[16] !== payload || $[17] !== productKey) {
        t7 = optimisticAuthed || (0, $8gF2o.isAuthenticatedForProduct)(payload, productKey, env);
        $[14] = env;
        $[15] = optimisticAuthed;
        $[16] = payload;
        $[17] = productKey;
        $[18] = t7;
    } else t7 = $[18];
    let t8;
    if ($[19] !== authUrl || $[20] !== isLoading || $[21] !== onConnected || $[22] !== t7) {
        t8 = {
            authUrl: authUrl,
            isAuthenticated: t7,
            isLoading: isLoading,
            onConnected: onConnected
        };
        $[19] = authUrl;
        $[20] = isLoading;
        $[21] = onConnected;
        $[22] = t7;
        $[23] = t8;
    } else t8 = $[23];
    return t8;
} : ({ aaId: aaId, productKey: productKey })=>{
    const [payload, setPayload] = (0, $cozmU.useState)(null);
    const [env, setEnv] = (0, $cozmU.useState)(undefined);
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(true);
    const [optimisticAuthed, setOptimisticAuthed] = (0, $cozmU.useState)(false);
    (0, $cozmU.useEffect)(()=>{
        setOptimisticAuthed(false);
        let cancelled = false;
        setIsLoading(true);
        (0, $8gF2o.fetchOutboundAuthAccounts)(aaId).then((fetched)=>{
            if (cancelled) return;
            setPayload(fetched);
            setEnv((0, $8gF2o.detectEnvFromPayload)(fetched) ?? undefined);
            setIsLoading(false);
        }).catch(()=>{
            if (cancelled) return;
            setPayload(null);
            setEnv(undefined);
            setIsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        aaId,
        productKey
    ]);
    // Auto-heal optimistic flip once ground truth arrives: clears stale
    // optimism even if the OAuth popup closed without granting scopes.
    (0, $cozmU.useEffect)(()=>{
        if (payload && optimisticAuthed) setOptimisticAuthed(false);
    }, [
        payload,
        optimisticAuthed
    ]);
    const onConnected = (0, $cozmU.useCallback)(()=>{
        if (!aaId) return;
        setOptimisticAuthed(true);
        // Bypass the 30-min cache so a later re-mount sees the fresh grant
        // instead of the stale pre-OAuth payload.
        (0, $8gF2o.fetchOutboundAuthAccounts)(aaId, {
            forceRefresh: true
        }).then((fresh)=>{
            if (fresh) {
                setPayload(fresh);
                setEnv((0, $8gF2o.detectEnvFromPayload)(fresh) ?? undefined);
            }
        });
    }, [
        aaId
    ]);
    const authUrl = (0, $8gF2o.hasSmartLinkContainerMapping)(productKey, env) ? (0, $8gF2o.buildSmartLinkAuthUrl)(productKey, env) ?? undefined : undefined;
    return {
        authUrl: authUrl,
        isAuthenticated: optimisticAuthed || (0, $8gF2o.isAuthenticatedForProduct)(payload, productKey, env),
        isLoading: isLoading,
        onConnected: onConnected
    };
};



var $fR63l = parcelRequire("fR63l");






var $bEvUu = parcelRequire("bEvUu");

const $ce8c0a0fac7ee6d6$export$f4c25aea7c19a132 = ()=>{
    const { userId: userId } = (0, $bQm3c.useSessionData)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isConnecting, setIsConnecting] = (0, $cozmU.useState)(false);
    const { authUrl: authUrl, isAuthenticated: isAuthenticated, isLoading: isLoading, onConnected: onConnected } = (0, $ef409225f8f5ce6a$export$bf91246c5b17e0bf)({
        aaId: userId ?? undefined,
        productKey: (0, $fR63l.ProductKeys3P).GoogleDrive
    });
    const connect = (0, $cozmU.useCallback)(async ()=>{
        if (!authUrl || isConnecting) return;
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$53f4484811034e3e)()).fire();
        setIsConnecting(true);
        try {
            await (0, $eEPSE.auth)(authUrl);
            createAnalyticsEvent((0, $4aa630edd4fe23e7$export$a58cc560aa8bc031)()).fire();
            // Optimistically flip + force-refresh the shared outbound-auth cache
            // so the banner self-hides on the next render without a page reload.
            onConnected();
        } catch (err) {
            // Swallow (incl. user-cancelled AuthError) so the banner stays put and the
            // fire-and-forget onClick caller never sees an unhandled rejection.
            const reason = err instanceof (0, $7zxJs.AuthError) ? err.type ?? null : null;
            createAnalyticsEvent((0, $4aa630edd4fe23e7$export$8d43fd709df6585d)(reason)).fire();
        } finally{
            setIsConnecting(false);
        }
    }, [
        authUrl,
        isConnecting,
        onConnected,
        createAnalyticsEvent
    ]);
    return {
        authUrl: authUrl,
        isAuthenticated: isAuthenticated,
        isLoading: isLoading,
        isConnecting: isConnecting,
        connect: connect
    };
};





const $df045363bf2d3f3b$var$SHOWN_ATTRIBUTES = {
    bannerType: 'gdrivePromo',
    connector: (0, $4aa630edd4fe23e7$export$450e9e5e468adef1)
};
const $df045363bf2d3f3b$export$e5db6c134b99f42d = ({ links: links, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const isPageFirstPartyOnly = links.length > 0 && links.every((l)=>(0, $cS4kb.isFirstPartyLink)(l.url));
    const { value: linkCounts, loading: isLinkCountLoading } = (0, $11c55f3cb3c29119$export$2bd9a43397bfe114)({
        skip: !isPageFirstPartyOnly
    });
    const hasSiteWideDriveLinks = (linkCounts?.[0, $11c55f3cb3c29119$export$3d6612235992a7fe] ?? 0) >= 1;
    const { authUrl: authUrl, isAuthenticated: isAuthenticated, isLoading: isAuthLoading, isConnecting: isConnecting, connect: connect } = (0, $ce8c0a0fac7ee6d6$export$f4c25aea7c19a132)();
    const { isDismissed: isDismissed, dismiss: dismiss } = (0, $aa04272ccb3d246a$export$6542d147ca3e4064)((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_BYLINE_CONNECTIONS_GDRIVE_BANNER_DISMISSED_PAGES, contentId);
    const isLoading = isLinkCountLoading || isAuthLoading;
    // First terminal failure in check order; loading yields `undefined` (not reported).
    let ineligibleReason;
    if (!isPageFirstPartyOnly) ineligibleReason = 'notFirstPartyOnly';
    else if (isLoading) ineligibleReason = undefined;
    else if (!hasSiteWideDriveLinks) ineligibleReason = 'noSiteWideDriveLinks';
    else if (isAuthenticated) ineligibleReason = 'alreadyAuthenticated';
    else if (isDismissed) ineligibleReason = 'dismissed';
    else if (!authUrl) ineligibleReason = 'noAuthUrl';
    const shouldShow = !isLoading && ineligibleReason === undefined;
    const hasFiredShownRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldShow || hasFiredShownRef.current) return;
        hasFiredShownRef.current = true;
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$57e0ff4c2905037a)($df045363bf2d3f3b$var$SHOWN_ATTRIBUTES)).fire();
    }, [
        shouldShow,
        createAnalyticsEvent
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$c308d47e70cf3cab)($df045363bf2d3f3b$var$SHOWN_ATTRIBUTES)).fire();
        dismiss();
    }, [
        createAnalyticsEvent,
        dismiss
    ]);
    if (!shouldShow) return {
        element: null,
        ineligibleReason: ineligibleReason
    };
    return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aa7ff97a50d7e018$export$e7e7ab663009ba26), {
            onConnect: connect,
            onDismiss: handleDismiss,
            isConnecting: isConnecting
        }),
        ineligibleReason: undefined
    };
};









const $f1588a16e52e7972$export$6472f9a534a66ffb = 'confluence_smartlink_connector_adoption_by_app';
function $f1588a16e52e7972$export$983a3bcefb295c3f(raw) {
    if (raw === undefined || raw.trim() === '') return undefined;
    const rates = raw.split(',').reduce((acc, segment)=>{
        const colonIdx = segment.indexOf(':');
        if (colonIdx === -1) return acc;
        const provider = segment.slice(0, colonIdx).trim();
        const percentRaw = segment.slice(colonIdx + 1).trim();
        if (!provider || percentRaw === '') return acc;
        const percent = Number(percentRaw);
        if (Number.isNaN(percent)) return acc;
        acc[provider] = percent;
        return acc;
    }, {});
    return Object.keys(rates).length > 0 ? rates : undefined;
}
function $f1588a16e52e7972$export$5d94aa936f525952({ skip: skip } = {}) {
    return (0, $8ab372ddb9ea7e6c$export$284907af4a465a72)($f1588a16e52e7972$export$6472f9a534a66ffb, $f1588a16e52e7972$export$983a3bcefb295c3f, {
        skip: skip
    });
}



var $5b9Ab = parcelRequire("5b9Ab");




const $e34182895af441bd$export$76cb2c3a079a73ad = (link)=>!(0, $cS4kb.isFirstPartyLink)(link.url) && link.access === 'unauthorized' && (link.authProviders?.length ?? 0) > 0;
const $e34182895af441bd$export$2422c4837d41b3e1 = (key)=>key?.replace(/-object-provider$/, '');
const $e34182895af441bd$export$41c181e9c9608a62 = (rates, unconnectedTraitKeys)=>{
    if (!rates) return undefined;
    let best;
    for (const [traitKey, percent] of Object.entries(rates)){
        if (!unconnectedTraitKeys.has(traitKey)) continue;
        if (!best || percent > best.percent) best = {
            traitKey: traitKey,
            percent: percent
        };
    }
    return best;
};
const $e34182895af441bd$export$8a9749363d54b4fa = (links)=>{
    const traitKeys = new Set();
    for (const link of links){
        const traitKey = $e34182895af441bd$export$2422c4837d41b3e1(link.key);
        if (traitKey) traitKeys.add(traitKey);
    }
    return traitKeys;
};


/* OrgConnectedAppsPromoBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 





















var $38aC9 = parcelRequire("38aC9");

const $056e9a986d0dc712$export$5237495f42936402 = 30;
const $056e9a986d0dc712$var$i18n = (0, $kSwu1.defineMessages)({
    highAdoptionMessageTeamworkGraph: {
        id: "byline-connections.menu.footer.org-connected-apps.high-adoption.teamwork-graph",
        defaultMessage: "{percent}% of your org uses connected apps to see how their pages connect to their team's work"
    },
    lowAdoptionMessage: {
        id: "byline-connections.menu.footer.org-connected-apps.low-adoption",
        defaultMessage: "Top teams use connected apps to get richer previews instantly"
    },
    dismissAction: {
        id: "byline-connections.menu.footer.org-connected-apps.dismiss-action",
        defaultMessage: "Dismiss"
    }
});
const $056e9a986d0dc712$var$styles = {
    footer: "_4c065U8HPE _2Y7lL45zaO _0KLXrunmFW _0vfIXINvrM _4hyvPa6wH8 _1KhSQW9r67",
    message: "_2sNsIg7NXe _1UtDYzy7kJ"
};
const $056e9a986d0dc712$export$ef9e86b15c3c921f = ({ icon: icon, productLabel: productLabel, topAppPercent: topAppPercent, onDismiss: onDismiss })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const isHighAdoption = topAppPercent !== undefined && topAppPercent >= $056e9a986d0dc712$export$5237495f42936402;
    const message = isHighAdoption ? formatMessage($056e9a986d0dc712$var$i18n.highAdoptionMessageTeamworkGraph, {
        percent: topAppPercent
    }) : formatMessage($056e9a986d0dc712$var$i18n.lowAdoptionMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $056e9a986d0dc712$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: productLabel,
        size: "small",
        backgroundColor: "color.background.neutral",
        hasBorder: true
    }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
        icon: icon,
        size: "menu"
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $056e9a986d0dc712$var$styles.message
    }, message)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))),
        label: formatMessage($056e9a986d0dc712$var$i18n.dismissAction),
        onClick: onDismiss
    })));
};







const $68b45a19d32ba347$export$ac27ad92182d0edf = ({ links: links, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const unconnectedThirdPartyLinks = links.filter((0, $e34182895af441bd$export$76cb2c3a079a73ad));
    const hasUnconnectedThirdParty = unconnectedThirdPartyLinks.length > 0;
    const { value: orgRates, loading: isRatesLoading } = (0, $f1588a16e52e7972$export$5d94aa936f525952)({
        skip: !hasUnconnectedThirdParty
    });
    const unconnectedTraitKeys = new Set();
    for (const l of unconnectedThirdPartyLinks){
        const traitKey = (0, $e34182895af441bd$export$2422c4837d41b3e1)(l.key);
        if (traitKey) unconnectedTraitKeys.add(traitKey);
    }
    const topApp = (0, $e34182895af441bd$export$41c181e9c9608a62)(orgRates, unconnectedTraitKeys);
    const { isDismissed: isDismissed, dismiss: dismiss } = (0, $aa04272ccb3d246a$export$6542d147ca3e4064)((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_BYLINE_CONNECTIONS_ORG_CONNECTED_APPS_BANNER_DISMISSED_PAGES, contentId);
    // First terminal failure in check order; loading yields `undefined` (not reported).
    let ineligibleReason;
    if (!hasUnconnectedThirdParty) ineligibleReason = 'noUnconnectedThirdParty';
    else if (isRatesLoading) ineligibleReason = undefined;
    else if (!topApp) ineligibleReason = 'noTopApp';
    else if (isDismissed) ineligibleReason = 'dismissed';
    const shouldShow = !isRatesLoading && ineligibleReason === undefined && !!topApp;
    const shownAttributes = (0, $cozmU.useMemo)(()=>topApp ? {
            bannerType: 'orgConnectedApps',
            connector: topApp.traitKey,
            variant: topApp.percent >= (0, $056e9a986d0dc712$export$5237495f42936402) ? 'highAdoption' : 'lowAdoption',
            topAppPercent: topApp.percent
        } : undefined, [
        topApp
    ]);
    const hasFiredShownRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (!shouldShow || !shownAttributes || hasFiredShownRef.current) return;
        hasFiredShownRef.current = true;
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$57e0ff4c2905037a)(shownAttributes)).fire();
    }, [
        shouldShow,
        shownAttributes,
        createAnalyticsEvent
    ]);
    const handleDismiss = (0, $cozmU.useCallback)(()=>{
        if (shownAttributes) createAnalyticsEvent((0, $4aa630edd4fe23e7$export$c308d47e70cf3cab)(shownAttributes)).fire();
        dismiss();
    }, [
        createAnalyticsEvent,
        shownAttributes,
        dismiss
    ]);
    if (!shouldShow || !topApp) return {
        element: null,
        ineligibleReason: ineligibleReason
    };
    const matchingLink = unconnectedThirdPartyLinks.find((l)=>(0, $e34182895af441bd$export$2422c4837d41b3e1)(l.key) === topApp.traitKey);
    const productLabel = matchingLink?.product ?? matchingLink?.authProviders[0]?.displayName ?? '';
    const icon = matchingLink ? (0, $5b9Ab.getSmartLinkIcon)(matchingLink) : undefined;
    return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $056e9a986d0dc712$export$ef9e86b15c3c921f), {
            icon: icon,
            productLabel: productLabel,
            topAppPercent: topApp.percent,
            onDismiss: handleDismiss
        }),
        ineligibleReason: undefined
    };
};






const $bdf06e0777a6f6ad$export$5a9fbaf775882c40 = ({ links: links, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const gdrive = (0, $df045363bf2d3f3b$export$e5db6c134b99f42d)({
        links: links,
        contentId: contentId
    });
    const orgConnectedApps = (0, $68b45a19d32ba347$export$ac27ad92182d0edf)({
        links: links,
        contentId: contentId
    });
    const element = gdrive.element ?? orgConnectedApps.element ?? null;
    // Settled = rendered or has a terminal reason; both null/undefined = still loading.
    const gdriveSettled = gdrive.element !== null || gdrive.ineligibleReason !== undefined;
    const orgConnectedAppsSettled = orgConnectedApps.element !== null || orgConnectedApps.ineligibleReason !== undefined;
    // A shown-then-dismissed banner is covered by the dismissed event, not notShown.
    const hasShownBannerRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (element !== null) hasShownBannerRef.current = true;
    }, [
        element
    ]);
    // Wait for both to settle so an early-settling banner can't drop the other's reason.
    const hasFiredNotShownRef = (0, $cozmU.useRef)(false);
    const isSettledNotShown = element === null && gdriveSettled && orgConnectedAppsSettled;
    (0, $cozmU.useEffect)(()=>{
        if (!isSettledNotShown || hasFiredNotShownRef.current || hasShownBannerRef.current) return;
        hasFiredNotShownRef.current = true;
        createAnalyticsEvent((0, $4aa630edd4fe23e7$export$3155a85848c110b5)({
            gdriveIneligibleReason: gdrive.ineligibleReason,
            orgConnectedAppsIneligibleReason: orgConnectedApps.ineligibleReason
        })).fire();
    }, [
        element,
        isSettledNotShown,
        gdrive.ineligibleReason,
        orgConnectedApps.ineligibleReason,
        createAnalyticsEvent
    ]);
    return element;
};



var $eyzEJ = parcelRequire("eyzEJ");

const $7d8abc6089406daa$var$OTHER_PRODUCT_KEY = 'Others';
const $7d8abc6089406daa$export$d5a13f0f4d135b4b = (link)=>// Atlas links collapse under a single "Goals" group; provider casing (e.g.
    // GitHub, OneDrive) is preserved; everything else is Title-Cased. Product-less
    // links fall into the catch-all "Others" bucket.
    (0, $eyzEJ.formatProduct)(link.product) ?? $7d8abc6089406daa$var$OTHER_PRODUCT_KEY;
const $7d8abc6089406daa$var$getProductKey = (link)=>{
    if (link.access === 'unauthorized') {
        const authKey = link.authProviders[0]?.key;
        if (authKey) return authKey;
    }
    return link.product || $7d8abc6089406daa$var$OTHER_PRODUCT_KEY;
};
const $7d8abc6089406daa$var$isUnconnected = (link)=>link.access === 'unauthorized';
// Group ordering tier: unconnected-only groups float to the top, fully connected
// groups sink to the bottom, and mixed groups sit in between. Lower rank = higher up.
const $7d8abc6089406daa$var$UNCONNECTED_ONLY = 0;
const $7d8abc6089406daa$var$MIXED = 1;
const $7d8abc6089406daa$var$CONNECTED_ONLY = 2;
const $7d8abc6089406daa$var$getGroupRank = (bucket)=>{
    if (bucket.unconnectedLinks.length === 0) return $7d8abc6089406daa$var$CONNECTED_ONLY;
    if (bucket.connectedLinks.length === 0) return $7d8abc6089406daa$var$UNCONNECTED_ONLY;
    return $7d8abc6089406daa$var$MIXED;
};
// The catch-all "Others" bucket (product-less links) is always pinned to the very
// bottom of the menu, below every named-product bucket, regardless of its tier.
const $7d8abc6089406daa$var$isOtherBucket = (bucket)=>bucket.product === $7d8abc6089406daa$var$OTHER_PRODUCT_KEY;
function $7d8abc6089406daa$export$e6dd401ecbdb01d(links) {
    const buckets = new Map();
    for (const link of links){
        const label = $7d8abc6089406daa$export$d5a13f0f4d135b4b(link);
        let bucket = buckets.get(label);
        if (!bucket) {
            bucket = {
                product: label,
                productKey: $7d8abc6089406daa$var$getProductKey(link),
                unconnectedLinks: [],
                connectedLinks: []
            };
            buckets.set(label, bucket);
        }
        ($7d8abc6089406daa$var$isUnconnected(link) ? bucket.unconnectedLinks : bucket.connectedLinks).push(link);
    }
    const allBuckets = Array.from(buckets.values());
    const productBuckets = allBuckets.filter((bucket)=>!$7d8abc6089406daa$var$isOtherBucket(bucket));
    const otherBucket = allBuckets.find($7d8abc6089406daa$var$isOtherBucket);
    // Stable sort keeps groups of equal rank in first-appearance order. "Others"
    // is held out of the sort and appended last so it always sits at the bottom.
    const orderedBuckets = productBuckets.sort((a, b)=>$7d8abc6089406daa$var$getGroupRank(a) - $7d8abc6089406daa$var$getGroupRank(b));
    if (otherBucket) orderedBuckets.push(otherBucket);
    return orderedBuckets.map(({ product: product, productKey: productKey, unconnectedLinks: unconnectedLinks, connectedLinks: connectedLinks })=>({
            product: product,
            productKey: productKey,
            items: [
                ...unconnectedLinks,
                ...connectedLinks
            ]
        }));
}



var $86sr7 = parcelRequire("86sr7");

const $f18dee4c2180353b$export$7ca6ed2e32ded1fd = 3;
const $f18dee4c2180353b$export$6b0d42ce6f300e4e = 5;
const $f18dee4c2180353b$export$2fb5469733250ea6 = ({ relatedContentLinks: relatedContentLinks = [], incomingLinks: incomingLinks = [], outgoingLinks: outgoingLinks = [] }, limit = $f18dee4c2180353b$export$6b0d42ce6f300e4e)=>{
    const relatedContent = relatedContentLinks.slice(0, limit);
    const appearsIn = incomingLinks.slice(0, limit - relatedContent.length);
    const linksTo = (0, $86sr7.getTopConnectionLinks)([
        ...outgoingLinks
    ], limit - relatedContent.length - appearsIn.length);
    return {
        relatedContent: relatedContent,
        appearsIn: appearsIn,
        linksTo: linksTo,
        total: relatedContent.length + appearsIn.length + linksTo.length
    };
};
const $f18dee4c2180353b$export$4184afff02de6fec = (sources)=>$f18dee4c2180353b$export$2fb5469733250ea6(sources).total >= $f18dee4c2180353b$export$7ca6ed2e32ded1fd;





const $70835a6aefe6c403$var$MENU_WIDTH = '320px';
const $70835a6aefe6c403$var$TWG_MENU_BODY_MAX_HEIGHT = '600px';
const $70835a6aefe6c403$var$i18n = (0, $kSwu1.defineMessages)({
    connectionsTwg: {
        id: "byline-connections.menu.header.title-teamwork-graph-twg.do-not-translate",
        defaultMessage: "Teamwork Graph"
    },
    viewMoreContext: {
        id: "byline-connections.menu.view-more-context",
        defaultMessage: "View more context"
    },
    relatedContent: {
        id: "byline-connections.menu.section.related-content",
        defaultMessage: "Related content ({count})"
    },
    appearsIn: {
        id: "byline-connections.menu.section.appears-in",
        defaultMessage: "Appears in ({count})"
    },
    linksTo: {
        id: "byline-connections.menu.section.links-to",
        defaultMessage: "Links to ({count})"
    }
});
const $70835a6aefe6c403$export$80311957bc63d8ad = $70835a6aefe6c403$var$i18n.relatedContent;
const $70835a6aefe6c403$var$styles = {
    menu: "_0bjKvDKTcp _39xV02sz7G _0KLXruoI2d",
    twgContent: "_0xmtkoFQfX _0NUa3rpNyl _2WAcuGIZbP",
    viewMoreContext: "_2Y7lL42ADO _4c065U8HPE"
};
const $70835a6aefe6c403$export$ea24a1e73cdd39d8 = (groups = [])=>{
    const attrs = {
        linkCount: 0,
        productBreakdown: {},
        authorizedLinkCount: 0,
        unauthorizedLinkCount: 0,
        connectableLinkCount: 0
    }; // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- linear in total link count; groups partition a finite link set
    for (const group of groups)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity -- linear in total link count; groups partition a finite link set
    for (const item of group.items){
        attrs.linkCount += 1;
        attrs.productBreakdown[group.productKey] = (attrs.productBreakdown[group.productKey] ?? 0) + 1;
        const isAuthorized = item.access === 'granted';
        if (isAuthorized) attrs.authorizedLinkCount += 1;
        else {
            attrs.unauthorizedLinkCount += 1;
            if ((item.authProviders?.length ?? 0) > 0) attrs.connectableLinkCount += 1;
        }
    }
    return attrs;
};
const $70835a6aefe6c403$export$b19b53e17ade0c8f = (links = [])=>links.filter((link)=>link.access === 'unauthorized').length;
const $70835a6aefe6c403$export$e4220f7b255072a8 = ({ showFooter: showFooter = true, links: links, incomingLinks: incomingLinks, additionalIcons: additionalIcons, minIcons: minIcons, relatedContentLinks: relatedContentLinks, devDocsConnection: devDocsConnection, contentId: contentId, refreshLinkUrl: refreshLinkUrl, onNavigate: onNavigate, onOpenPreviewPanel: onOpenPreviewPanel })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)(); // Related content leads; Appears in and Links to fill the remaining rows when it is thin.
    const menuLinks = (0, $cozmU.useMemo)(()=>(0, $f18dee4c2180353b$export$2fb5469733250ea6)({
            relatedContentLinks: relatedContentLinks,
            incomingLinks: incomingLinks,
            outgoingLinks: links
        }), [
        relatedContentLinks,
        incomingLinks,
        links
    ]);
    const visibleLinks = (0, $cozmU.useMemo)(()=>[
            ...menuLinks.relatedContent,
            ...menuLinks.appearsIn,
            ...menuLinks.linksTo
        ], [
        menuLinks
    ]); // Only rendered rows count as viewed links; the footer and app icons read the full lists.
    const menuShownAttributes = (0, $cozmU.useMemo)(()=>({
            ...$70835a6aefe6c403$export$ea24a1e73cdd39d8((0, $7d8abc6089406daa$export$e6dd401ecbdb01d)(visibleLinks)),
            relatedContentCount: menuLinks.relatedContent.length,
            appearsInCount: menuLinks.appearsIn.length,
            linksToCount: menuLinks.linksTo.length
        }), [
        menuLinks,
        visibleLinks
    ]);
    const unauthenticatedLinkCount = (0, $cozmU.useMemo)(()=>$70835a6aefe6c403$export$b19b53e17ade0c8f(visibleLinks), [
        visibleLinks
    ]);
    const hasFiredRef = (0, $cozmU.useRef)(false);
    const hasFiredUnauthenticatedRef = (0, $cozmU.useRef)(false);
    const handleViewMoreContext = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'connectionsBylineViewMoreContext',
                source: 'connectionsBylineMenu'
            }
        }).fire();
        onOpenPreviewPanel();
    }, [
        createAnalyticsEvent,
        onOpenPreviewPanel
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'menu',
                actionSubjectId: 'connectionsBylineMenu',
                source: 'connectionsBylineMenu',
                attributes: menuShownAttributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        menuShownAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredUnauthenticatedRef.current || unauthenticatedLinkCount === 0) return;
        hasFiredUnauthenticatedRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'unauthenticatedSmartlink',
                actionSubjectId: 'connectionsBylineMenu',
                source: 'connectionsBylineMenu',
                attributes: {
                    unauthenticatedLinkCount: unauthenticatedLinkCount
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        unauthenticatedLinkCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $70835a6aefe6c403$var$styles.menu,
        role: "dialog",
        "aria-label": formatMessage($70835a6aefe6c403$var$i18n.connectionsTwg)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $70835a6aefe6c403$var$styles.twgContent,
        testId: "connections-byline-menu.content"
    }, devDocsConnection ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6IL1T.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c0311709cd7c6fed$export$23d9bfb525ce3655), {
        connection: devDocsConnection,
        onNavigate: onNavigate
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92feead83550977e$export$825be6248d440e90), {
        heading: formatMessage($70835a6aefe6c403$var$i18n.relatedContent, {
            count: relatedContentLinks?.length ?? 0
        }),
        links: menuLinks.relatedContent,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: "incoming",
        onNavigate: onNavigate,
        compact: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92feead83550977e$export$825be6248d440e90), {
        heading: formatMessage($70835a6aefe6c403$var$i18n.appearsIn, {
            count: incomingLinks?.length ?? 0
        }),
        links: menuLinks.appearsIn,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: "incoming",
        onNavigate: onNavigate,
        compact: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92feead83550977e$export$825be6248d440e90), {
        heading: formatMessage($70835a6aefe6c403$var$i18n.linksTo, {
            count: links?.length ?? 0
        }),
        links: menuLinks.linksTo,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: "outgoing",
        onNavigate: onNavigate,
        compact: true
    }), showFooter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bdf06e0777a6f6ad$export$5a9fbaf775882c40), {
        links: links ?? [],
        contentId: contentId
    }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $70835a6aefe6c403$var$styles.viewMoreContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))),
        iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))),
        shouldFitContainer: true,
        onClick: handleViewMoreContext,
        testId: "connections-byline-menu.view-more-context-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "regular"
    }, formatMessage($70835a6aefe6c403$var$i18n.viewMoreContext)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTfX9.BylineConnectionIconStack), {
        links: links ?? [],
        incomingLinks: incomingLinks,
        additionalIcons: additionalIcons,
        minIcons: minIcons,
        spacing: "none"
    })))))));
};


/* EmbeddedConnectionsByLineMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 















var $lfoFx = parcelRequire("lfoFx");














var $kC09O = parcelRequire("kC09O");

const $413f8f6d87a9e0c2$var$MENU_WIDTH = '320px';
const $413f8f6d87a9e0c2$var$MENU_BODY_MAX_HEIGHT = '600px';
const $413f8f6d87a9e0c2$var$i18n = (0, $kSwu1.defineMessages)({
    menuLabel: {
        id: "byline-connections.embedded-menu.label.do-not-translate",
        defaultMessage: "Teamwork Graph"
    },
    linksTo: {
        id: "byline-connections.embedded-menu.section.links-to",
        defaultMessage: "Links to ({count})"
    },
    empty: {
        id: "byline-connections.embedded-menu.empty",
        defaultMessage: "This content doesn\u2019t have any related content or links yet."
    }
});
const $413f8f6d87a9e0c2$var$styles = {
    menu: "_0bjKvDKTcp _39xV02sz7G _0KLXruoI2d",
    content: "_4c065U2ADO _0NUa3rpNyl _2WAcuGIZbP",
    showMore: "_2Y7lL48HPE _0xmtko2ADO",
    emptyState: "_4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _37wbyuDIqT"
};
// preview panel, so this is the only way to see more.
const $413f8f6d87a9e0c2$var$EmbeddedLinkSection = ({ section: section, heading: heading, links: links, linkDirection: linkDirection, compact: compact, refreshLinkUrl: refreshLinkUrl, onNavigate: onNavigate })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(false);
    const hasMore = links.length > (0, $86sr7.DEFAULT_VISIBLE_LINK_COUNT);
    const visibleLinks = (0, $cozmU.useMemo)(()=>isExpanded ? links : links.slice(0, (0, $86sr7.DEFAULT_VISIBLE_LINK_COUNT)), [
        isExpanded,
        links
    ]);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.MENU_SHOW_MORE_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.EMBEDDED_MENU_SOURCE),
                attributes: {
                    section: section,
                    isExpanded: !isExpanded,
                    linkCount: links.length
                }
            }
        }).fire();
        setIsExpanded((wasExpanded)=>!wasExpanded);
    }, [
        createAnalyticsEvent,
        isExpanded,
        links.length,
        section
    ]);
    if (links.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $92feead83550977e$export$825be6248d440e90), {
        heading: heading,
        links: visibleLinks,
        refreshLinkUrl: refreshLinkUrl,
        linkDirection: linkDirection,
        onNavigate: onNavigate,
        compact: compact,
        analyticsSource: (0, $I7TEB.EMBEDDED_MENU_SOURCE)
    }), hasMore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.showMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handleToggle,
        "aria-expanded": isExpanded,
        testId: `connections-byline-embedded-menu.${section}.show-more-button`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "regular",
        color: "color.text.subtlest"
    }, formatMessage(isExpanded ? (0, $kC09O.showLessMessage) : (0, $kC09O.showMoreMessage))))) : null);
};
const $413f8f6d87a9e0c2$export$661e43968c0d4a47 = ({ links: links, relatedContentLinks: relatedContentLinks, relatedContentLoading: relatedContentLoading = false, refreshLinkUrl: refreshLinkUrl, onNavigate: onNavigate })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const relatedLinks = (0, $cozmU.useMemo)(()=>relatedContentLinks ?? [], [
        relatedContentLinks
    ]); // Same order as the preview panel's Links to: unconnected first, then document order.
    const linksToLinks = (0, $cozmU.useMemo)(()=>(0, $86sr7.getTopConnectionLinks)(links ?? [], links?.length ?? 0), [
        links
    ]);
    const initiallyVisibleLinks = (0, $cozmU.useMemo)(()=>[
            ...relatedLinks.slice(0, (0, $86sr7.DEFAULT_VISIBLE_LINK_COUNT)),
            ...linksToLinks.slice(0, (0, $86sr7.DEFAULT_VISIBLE_LINK_COUNT))
        ], [
        relatedLinks,
        linksToLinks
    ]);
    const menuShownAttributes = (0, $cozmU.useMemo)(()=>(0, $70835a6aefe6c403$export$ea24a1e73cdd39d8)((0, $7d8abc6089406daa$export$e6dd401ecbdb01d)(initiallyVisibleLinks)), [
        initiallyVisibleLinks
    ]);
    const unauthenticatedLinkCount = (0, $cozmU.useMemo)(()=>(0, $70835a6aefe6c403$export$b19b53e17ade0c8f)(initiallyVisibleLinks), [
        initiallyVisibleLinks
    ]);
    const hasFiredRef = (0, $cozmU.useRef)(false);
    const hasFiredUnauthenticatedRef = (0, $cozmU.useRef)(false);
    const isEmpty = relatedLinks.length === 0 && linksToLinks.length === 0;
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        hasFiredRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'menu',
                actionSubjectId: 'connectionsBylineMenu',
                source: (0, $I7TEB.EMBEDDED_MENU_SOURCE),
                attributes: menuShownAttributes
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        menuShownAttributes
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredUnauthenticatedRef.current || unauthenticatedLinkCount === 0) return;
        hasFiredUnauthenticatedRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'unauthenticatedSmartlink',
                actionSubjectId: 'connectionsBylineMenu',
                source: (0, $I7TEB.EMBEDDED_MENU_SOURCE),
                attributes: {
                    unauthenticatedLinkCount: unauthenticatedLinkCount
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        unauthenticatedLinkCount
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.menu,
        role: "dialog",
        "aria-label": formatMessage($413f8f6d87a9e0c2$var$i18n.menuLabel),
        testId: "connections-byline-embedded-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.content,
        testId: "connections-byline-embedded-menu.content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($413f8f6d87a9e0c2$var$EmbeddedLinkSection, {
        section: "relatedContent",
        heading: formatMessage((0, $70835a6aefe6c403$export$80311957bc63d8ad), {
            count: relatedLinks.length
        }),
        links: relatedLinks,
        linkDirection: "incoming",
        refreshLinkUrl: refreshLinkUrl,
        onNavigate: onNavigate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($413f8f6d87a9e0c2$var$EmbeddedLinkSection, {
        section: "linksTo",
        heading: formatMessage($413f8f6d87a9e0c2$var$i18n.linksTo, {
            count: linksToLinks.length
        }),
        links: linksToLinks,
        linkDirection: "outgoing",
        refreshLinkUrl: refreshLinkUrl,
        onNavigate: onNavigate,
        compact: true
    }), isEmpty && relatedContentLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.emptyState
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        testId: "connections-byline-embedded-menu.loading"
    })) : null, isEmpty && !relatedContentLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $413f8f6d87a9e0c2$var$styles.emptyState,
        testId: "connections-byline-embedded-menu.empty"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtlest"
    }, formatMessage($413f8f6d87a9e0c2$var$i18n.empty))) : null));
};















var $kcIQr = parcelRequire("kcIQr");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");







const $c484d458bde3f527$export$1c32d73668cee9f0 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: 'atAGlanceSummary',
            actionSubjectId: (0, $I7TEB.AT_A_GLANCE_ACTION_SUBJECT_ID),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $c484d458bde3f527$export$c94aa1bf4dcf738d = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: 'atAGlanceSummary',
            actionSubjectId: (0, $I7TEB.AT_A_GLANCE_ACTION_SUBJECT_ID),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $c484d458bde3f527$export$7688f758e142df9b = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'aborted',
            actionSubject: 'atAGlanceSummary',
            actionSubjectId: (0, $I7TEB.AT_A_GLANCE_ACTION_SUBJECT_ID),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });



var $6B1vK = parcelRequire("6B1vK");

const $03bac7ea60cf471f$export$492c3dde363c3c4a = 300;
const $03bac7ea60cf471f$var$CARD_NODE_TYPES = new Set([
    'inlineCard',
    'blockCard',
    'embedCard'
]);
const $03bac7ea60cf471f$var$BLOCK_CONTAINERS = new Set([
    'paragraph',
    'heading',
    'blockquote',
    'listItem',
    'tableCell',
    'tableHeader'
]);
const $03bac7ea60cf471f$var$asUrl = (value)=>typeof value === 'string' && value ? value : undefined;
const $03bac7ea60cf471f$var$cardUrl = (node)=>{
    if (!$03bac7ea60cf471f$var$CARD_NODE_TYPES.has(node.type ?? '')) return undefined;
    return $03bac7ea60cf471f$var$asUrl(node.attrs?.url);
};
/**
 * `href` of the node's `link` mark, i.e. an ordinary text hyperlink. These are
 * smart links too: `collectSmartLinks` walks the ADF with link marks included,
 * so a bare `<a>` in prose becomes a connection row and needs an excerpt.
 */ const $03bac7ea60cf471f$var$linkMarkUrl = (node)=>$03bac7ea60cf471f$var$asUrl(node.marks?.find((mark)=>mark?.type === 'link')?.attrs?.href);
const $03bac7ea60cf471f$var$readText = (node)=>{
    if (!node) return '';
    if (typeof node.text === 'string') return node.text;
    if ($03bac7ea60cf471f$var$cardUrl(node)) return '';
    if (!Array.isArray(node.content)) return '';
    const parts = [];
    for (const child of node.content){
        // ADF documents are bounded trees; this walk is linear in node count.
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        const text = $03bac7ea60cf471f$var$readText(child);
        if (text) parts.push(text);
    }
    return parts.join(' ');
};
const $03bac7ea60cf471f$var$collectLinkUrls = (node, urls)=>{
    const url = $03bac7ea60cf471f$var$cardUrl(node) ?? $03bac7ea60cf471f$var$linkMarkUrl(node);
    if (url) urls.push(url);
    if (!Array.isArray(node.content)) return;
    for (const child of node.content)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    $03bac7ea60cf471f$var$collectLinkUrls(child, urls);
};
const $03bac7ea60cf471f$var$normalizeExcerpt = (text)=>{
    const excerpt = text.replace(/\s+/g, ' ').trim().slice(0, $03bac7ea60cf471f$export$492c3dde363c3c4a);
    return excerpt || undefined;
};
const $03bac7ea60cf471f$export$6c4343d44e5cebbf = (adf)=>{
    const excerpts = new Map();
    if (!adf) return excerpts;
    const visit = (node)=>{
        if (node.type && $03bac7ea60cf471f$var$BLOCK_CONTAINERS.has(node.type)) {
            const urls = [];
            $03bac7ea60cf471f$var$collectLinkUrls(node, urls);
            const excerpt = $03bac7ea60cf471f$var$normalizeExcerpt($03bac7ea60cf471f$var$readText(node));
            if (excerpt) {
                for (const url of urls)if (!excerpts.has(url)) excerpts.set(url, excerpt);
            }
        }
        if (!Array.isArray(node.content)) return;
        for (const child of node.content)// eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        visit(child);
    };
    visit(adf);
    return excerpts;
};


const $db72bc08cbbd6b4c$export$ec1ca82b1edf9048 = 12000;
const $db72bc08cbbd6b4c$var$BLOCK_CONTAINERS = new Set([
    'doc',
    'bulletList',
    'orderedList',
    'blockquote'
]);
const $db72bc08cbbd6b4c$var$readNode = (node)=>{
    if (!node) return '';
    if (typeof node.text === 'string') return node.text;
    if (!Array.isArray(node.content)) return '';
    const parts = [];
    for (const child of node.content){
        // ADF documents are bounded trees; this walk is linear in node count.
        // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
        const text = $db72bc08cbbd6b4c$var$readNode(child);
        if (text) parts.push(text);
    }
    const joiner = node.type && $db72bc08cbbd6b4c$var$BLOCK_CONTAINERS.has(node.type) ? '\n' : '';
    return parts.join(joiner);
};
const $db72bc08cbbd6b4c$export$a8e659250f355f39 = (adf, limit = $db72bc08cbbd6b4c$export$ec1ca82b1edf9048)=>{
    const text = $db72bc08cbbd6b4c$var$readNode(adf).trim();
    return {
        excerpt: text.slice(0, limit),
        truncated: text.length > limit
    };
};


const $ecb19719bff78326$export$2fae90a4e4e36b78 = 500;
const $ecb19719bff78326$export$9416c2a80a09f13b = 500;
const $ecb19719bff78326$export$48d048be5cad15bc = 200;
const $ecb19719bff78326$export$9683d79c925e4028 = 100;
const $ecb19719bff78326$export$a550edcb8bc20dd8 = 100;
const $ecb19719bff78326$export$365e7098654a67ce = 35;
const $ecb19719bff78326$var$bound = (value, limit)=>{
    const normalized = value?.trim();
    return normalized ? normalized.slice(0, limit) : undefined;
};
const $ecb19719bff78326$var$toIsoInstant = (value)=>{
    if (typeof value !== 'string') return undefined;
    const normalized = value.trim();
    if (!normalized || !/(?:Z|[+-]\d{2}:\d{2})$/i.test(normalized)) return undefined;
    const timestamp = new Date(normalized);
    return Number.isNaN(timestamp.getTime()) ? undefined : timestamp.toISOString();
};
const $ecb19719bff78326$var$toPositiveContentVersion = (value)=>typeof value === 'number' && Number.isInteger(value) && value > 0 ? value : undefined;
const $ecb19719bff78326$var$relationshipFor = (collection, link, sourceExcerpts)=>{
    if (collection === 'appears_in') return {
        collection: collection,
        type: 'content_referenced_entity',
        direction: 'incoming',
        source_excerpt: null
    };
    if (collection === 'related_content') return {
        collection: collection,
        type: 'confluence_content_has_related_confluence_content',
        direction: 'outgoing',
        source_excerpt: null
    };
    return {
        collection: collection,
        type: 'page_contains_smart_link',
        direction: 'outgoing',
        source_excerpt: $ecb19719bff78326$var$bound(sourceExcerpts.get(link.url), (0, $03bac7ea60cf471f$export$492c3dde363c3c4a)) ?? null
    };
};
const $ecb19719bff78326$var$entityContextFor = (link)=>{
    const summary = $ecb19719bff78326$var$bound(link.summary, $ecb19719bff78326$export$9416c2a80a09f13b);
    const status = $ecb19719bff78326$var$bound(link.taskStatus, $ecb19719bff78326$export$48d048be5cad15bc) ?? $ecb19719bff78326$var$bound(link.state, $ecb19719bff78326$export$48d048be5cad15bc);
    const updatedAt = $ecb19719bff78326$var$toIsoInstant(link.updatedAt);
    return summary || status || updatedAt ? {
        ...summary ? {
            summary: summary
        } : {},
        ...status ? {
            status: status
        } : {},
        ...updatedAt ? {
            updated_at: updatedAt
        } : {}
    } : undefined;
};
const $ecb19719bff78326$var$mergeEntityContext = (primary, secondary)=>{
    if (!primary) return secondary;
    if (!secondary) return primary;
    const summary = primary.summary ?? secondary.summary;
    const status = primary.status ?? secondary.status;
    const updatedAt = primary.updated_at ?? secondary.updated_at;
    return {
        ...summary ? {
            summary: summary
        } : {},
        ...status ? {
            status: status
        } : {},
        ...updatedAt ? {
            updated_at: updatedAt
        } : {}
    };
};
const $ecb19719bff78326$var$toEntity = (link, collection, sourceExcerpts)=>{
    const title = $ecb19719bff78326$var$bound(link.title, $ecb19719bff78326$export$2fae90a4e4e36b78);
    if (link.access !== 'granted' || !link.ari || !title) return null;
    const entityContext = $ecb19719bff78326$var$entityContextFor(link);
    const product = $ecb19719bff78326$var$bound(link.product, $ecb19719bff78326$export$9683d79c925e4028);
    const resourceType = $ecb19719bff78326$var$bound(link.resourceType, $ecb19719bff78326$export$a550edcb8bc20dd8);
    return {
        ari: link.ari,
        title: title,
        ...product ? {
            product: product
        } : {},
        ...resourceType ? {
            resource_type: resourceType
        } : {},
        relationships: [
            $ecb19719bff78326$var$relationshipFor(collection, link, sourceExcerpts)
        ],
        ...entityContext ? {
            entity_context: entityContext
        } : {}
    };
};
const $ecb19719bff78326$var$collectEntities = (links, collection, sourceExcerpts)=>{
    const entities = [];
    for (const link of links){
        const entity = $ecb19719bff78326$var$toEntity(link, collection, sourceExcerpts);
        if (entity) entities.push(entity);
    }
    return entities;
};
const $ecb19719bff78326$var$structuralParentEntityFor = (cloudId, ancestors)=>{
    if (!ancestors) return null;
    // Confluence ancestors are root-first. Select one nearest page ancestor so
    // hierarchy evidence stays useful and bounded even below folders/databases.
    for(let index = ancestors.length - 1; index >= 0; index--){
        const ancestor = ancestors[index];
        const id = ancestor?.id?.trim();
        const title = $ecb19719bff78326$var$bound(ancestor?.title ?? undefined, $ecb19719bff78326$export$2fae90a4e4e36b78);
        if (!id || !title || ancestor?.type?.toLowerCase() !== 'page') continue;
        return {
            ari: (0, $6B1vK.ConfluencePageAri).create({
                siteId: cloudId,
                pageId: id
            }).toString(),
            title: title,
            product: 'confluence',
            resource_type: 'page',
            relationships: [
                {
                    collection: 'ancestors',
                    type: 'confluence_page_has_child_confluence_page',
                    direction: 'incoming',
                    source_excerpt: null
                }
            ]
        };
    }
    return null;
};
/**
 * Deduplicates entities by ARI and keeps one relationship per collection. An entity reached
 * through several collections carries all of them: each names a different thing the page and the
 * entity have to do with each other, and only the `links_to` relationship can carry a
 * `source_excerpt`. The count needs no limit of its own — `AtAGlanceCollection` has four members,
 * so four relationships is the ceiling.
 */ const $ecb19719bff78326$var$mergeByAri = (entities)=>{
    const byAri = new Map();
    for (const entity of entities){
        const existing = byAri.get(entity.ari);
        const nextRelationship = entity.relationships[0];
        if (!existing) {
            byAri.set(entity.ari, entity);
            continue;
        }
        if (!nextRelationship) continue;
        const existingRelationshipIndex = existing.relationships.findIndex((relationship)=>relationship.collection === nextRelationship.collection);
        if (existingRelationshipIndex !== -1) {
            const existingRelationship = existing.relationships[existingRelationshipIndex];
            if (!existingRelationship) continue;
            const entityContext = $ecb19719bff78326$var$mergeEntityContext(existing.entity_context, entity.entity_context);
            const relationship = !existingRelationship.source_excerpt && nextRelationship.source_excerpt ? {
                ...existingRelationship,
                source_excerpt: nextRelationship.source_excerpt
            } : existingRelationship;
            const relationships = [
                ...existing.relationships
            ];
            relationships[existingRelationshipIndex] = relationship;
            byAri.set(entity.ari, {
                ...existing,
                product: existing.product ?? entity.product,
                resource_type: existing.resource_type ?? entity.resource_type,
                relationships: relationships,
                ...entityContext ? {
                    entity_context: entityContext
                } : {}
            });
            continue;
        }
        const entityContext = $ecb19719bff78326$var$mergeEntityContext(existing.entity_context, entity.entity_context);
        byAri.set(entity.ari, {
            ...existing,
            product: existing.product ?? entity.product,
            resource_type: existing.resource_type ?? entity.resource_type,
            relationships: [
                ...existing.relationships,
                nextRelationship
            ],
            ...entityContext ? {
                entity_context: entityContext
            } : {}
        });
    }
    return [
        ...byAri.values()
    ];
};
const $ecb19719bff78326$export$1d4beabc419323b8 = ({ cloudId: cloudId, contentId: contentId, locale: locale, pageTitle: pageTitle, pageVersion: pageVersion, pageUpdatedAt: pageUpdatedAt, pageAdf: pageAdf, structuralAncestors: structuralAncestors, incomingLinks: incomingLinks, outgoingLinks: outgoingLinks, relatedContentLinks: relatedContentLinks = [] })=>{
    const normalizedLocale = locale.trim();
    const title = $ecb19719bff78326$var$bound(pageTitle, $ecb19719bff78326$export$2fae90a4e4e36b78);
    if (!normalizedLocale || normalizedLocale.length > $ecb19719bff78326$export$365e7098654a67ce || !title) return null;
    const { excerpt: excerpt, truncated: truncated } = (0, $db72bc08cbbd6b4c$export$a8e659250f355f39)(pageAdf);
    if (!excerpt) return null;
    const sourceExcerpts = outgoingLinks.length > 0 ? (0, $03bac7ea60cf471f$export$6c4343d44e5cebbf)(pageAdf) : new Map();
    const incoming = $ecb19719bff78326$var$collectEntities(incomingLinks, 'appears_in', sourceExcerpts);
    const outgoing = $ecb19719bff78326$var$collectEntities(outgoingLinks, 'links_to', sourceExcerpts);
    const related = $ecb19719bff78326$var$collectEntities(relatedContentLinks, 'related_content', sourceExcerpts);
    const structuralParent = $ecb19719bff78326$var$structuralParentEntityFor(cloudId, structuralAncestors);
    // Every deduplicated entity is sent. cc-smarts reconciles this inventory with its own
    // unbounded graph discovery, and it cannot recover what is dropped here: incoming-only
    // entities, related content, ancestors, and outgoing links whose graph type its discovery
    // does not decode all reach the model only via this list.
    //
    // The order is evidence strength, not priority for a cap: related content (the only
    // collection whose one-liners the UI renders), then the structural parent, then links the
    // page makes explicitly, then references to it. `mergeByAri` keeps an entity at its first
    // occurrence, so the order is deterministic and the request body stays a stable cache key.
    const linkedEntities = $ecb19719bff78326$var$mergeByAri([
        ...related,
        ...structuralParent ? [
            structuralParent
        ] : [],
        ...outgoing,
        ...incoming
    ]);
    if (linkedEntities.length === 0) return null;
    const version = $ecb19719bff78326$var$toPositiveContentVersion(pageVersion);
    const updatedAt = $ecb19719bff78326$var$toIsoInstant(pageUpdatedAt);
    return {
        content_ari: (0, $6B1vK.ConfluencePageAri).create({
            siteId: cloudId,
            pageId: contentId
        }).toString(),
        locale: normalizedLocale,
        central_page: {
            title: title,
            mime_type: 'text/markdown',
            excerpt: excerpt,
            truncated: truncated,
            ...version ? {
                version: version
            } : {},
            ...updatedAt ? {
                updated_at: updatedAt
            } : {}
        },
        linked_entities: linkedEntities
    };
};


const $994dd0020fdf55a7$var$MAX_OVERVIEW_ITEMS = 3;
const $994dd0020fdf55a7$var$MAX_SUMMARIES = 30;
const $994dd0020fdf55a7$var$MAX_ARI_LENGTH = 1000;
const $994dd0020fdf55a7$var$MAX_OUTPUT_TEXT_LENGTH = 500;
const $994dd0020fdf55a7$var$MAX_LABEL_LENGTH = 40;
const $994dd0020fdf55a7$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $994dd0020fdf55a7$var$isNonEmptyString = (value, limit)=>typeof value === 'string' && value.trim().length > 0 && value.length <= limit;
const $994dd0020fdf55a7$var$adaptOverviewItem = (value)=>{
    const normalized = value.replace(/\*\*/g, '').trim();
    const separatorIndex = normalized.indexOf(': ');
    if (separatorIndex <= 0 || separatorIndex > $994dd0020fdf55a7$var$MAX_LABEL_LENGTH) return {
        label: '',
        text: normalized,
        evidence: []
    };
    return {
        label: normalized.slice(0, separatorIndex),
        text: normalized.slice(separatorIndex + 2),
        evidence: []
    };
};
const $994dd0020fdf55a7$export$6b24c40e5c2263a8 = (value)=>{
    const { overview: overview, summaries: summaries } = value;
    if ('status' in value || !Array.isArray(overview) || !Array.isArray(summaries)) return null;
    const parsedOverview = [];
    const seenOverview = new Set();
    for (const item of overview){
        if (!$994dd0020fdf55a7$var$isNonEmptyString(item, $994dd0020fdf55a7$var$MAX_OUTPUT_TEXT_LENGTH)) continue;
        const normalized = item.trim();
        if (seenOverview.has(normalized)) continue;
        seenOverview.add(normalized);
        parsedOverview.push($994dd0020fdf55a7$var$adaptOverviewItem(normalized));
        if (parsedOverview.length === $994dd0020fdf55a7$var$MAX_OVERVIEW_ITEMS) break;
    }
    const parsedSummaries = [];
    for (const summary of summaries){
        if (!$994dd0020fdf55a7$var$isRecord(summary)) continue;
        if (!$994dd0020fdf55a7$var$isNonEmptyString(summary.ari, $994dd0020fdf55a7$var$MAX_ARI_LENGTH) || !$994dd0020fdf55a7$var$isNonEmptyString(summary.title, $994dd0020fdf55a7$var$MAX_OUTPUT_TEXT_LENGTH) || !$994dd0020fdf55a7$var$isNonEmptyString(summary.oneLiner, $994dd0020fdf55a7$var$MAX_OUTPUT_TEXT_LENGTH)) continue;
        parsedSummaries.push({
            ari: summary.ari.trim(),
            title: summary.title.trim(),
            oneLiner: summary.oneLiner.trim(),
            evidence: []
        });
        if (parsedSummaries.length === $994dd0020fdf55a7$var$MAX_SUMMARIES) break;
    }
    return {
        status: 'GENERATED',
        overview: parsedOverview,
        summaries: parsedSummaries
    };
};


const $66ddd238965febb3$var$isRecord = (value)=>typeof value === 'object' && value !== null;
const $66ddd238965febb3$var$isNonEmptyString = (value)=>typeof value === 'string' && value.trim().length > 0;
const $66ddd238965febb3$var$isStatus = (value)=>value === 'GENERATED' || value === 'INSUFFICIENT_EVIDENCE' || value === 'UNAVAILABLE';
const $66ddd238965febb3$var$parseEvidence = (value)=>{
    if (!Array.isArray(value)) return null;
    const evidence = [];
    for (const item of value){
        if (!$66ddd238965febb3$var$isRecord(item)) continue;
        const { id: id, type: type, entityAri: entityAri, label: label, observedAt: observedAt } = item;
        if (!$66ddd238965febb3$var$isNonEmptyString(id) || !$66ddd238965febb3$var$isNonEmptyString(type) || !$66ddd238965febb3$var$isNonEmptyString(entityAri) || !$66ddd238965febb3$var$isNonEmptyString(label) || !(observedAt === undefined || observedAt === null || typeof observedAt === 'string')) continue;
        evidence.push({
            id: id.trim(),
            type: type.trim(),
            entityAri: entityAri.trim(),
            label: label.trim(),
            observedAt: observedAt ?? null
        });
    }
    return evidence;
};
const $66ddd238965febb3$export$e55d72037394dd46 = (value)=>{
    if (!$66ddd238965febb3$var$isRecord(value)) return null;
    const output = value.ai_feature_output;
    if (!$66ddd238965febb3$var$isRecord(output)) return null;
    const { status: status, overview: overview, summaries: summaries } = output;
    if (!$66ddd238965febb3$var$isStatus(status)) return (0, $994dd0020fdf55a7$export$6b24c40e5c2263a8)(output);
    if (!Array.isArray(overview) || !Array.isArray(summaries)) return null;
    if (overview.some((item)=>typeof item === 'string')) return null;
    const parsedOverview = [];
    for (const item of overview){
        if (!$66ddd238965febb3$var$isRecord(item)) continue;
        const evidence = $66ddd238965febb3$var$parseEvidence(item.evidence);
        if (!$66ddd238965febb3$var$isNonEmptyString(item.label) || !$66ddd238965febb3$var$isNonEmptyString(item.text) || !evidence) continue;
        parsedOverview.push({
            label: item.label.trim(),
            text: item.text.trim(),
            evidence: evidence
        });
    }
    const parsedSummaries = [];
    for (const summary of summaries){
        if (!$66ddd238965febb3$var$isRecord(summary)) continue;
        const evidence = $66ddd238965febb3$var$parseEvidence(summary.evidence);
        if (!$66ddd238965febb3$var$isNonEmptyString(summary.ari) || !$66ddd238965febb3$var$isNonEmptyString(summary.title) || !$66ddd238965febb3$var$isNonEmptyString(summary.oneLiner) || !evidence) continue;
        parsedSummaries.push({
            ari: summary.ari.trim(),
            title: summary.title.trim(),
            oneLiner: summary.oneLiner.trim(),
            evidence: evidence
        });
    }
    return {
        status: status,
        overview: parsedOverview,
        summaries: parsedSummaries
    };
};


const $47daad24abd23110$var$DEFAULT_RETRY_DELAY_MS = 30000;
const $47daad24abd23110$var$MAX_TIMEOUT_MS = 2147483647;
const $47daad24abd23110$export$86526f40287dee0d = (header)=>{
    if (header !== null && /^\d+$/.test(header.trim())) {
        const seconds = Number(header);
        if (Number.isSafeInteger(seconds) && seconds <= 2147483647) return seconds * 1000;
    }
    return $47daad24abd23110$var$DEFAULT_RETRY_DELAY_MS;
};
const $47daad24abd23110$export$334a87e4fb3ba41a = (notBefore, callback)=>{
    let timer;
    const schedule = ()=>{
        const remaining = notBefore - Date.now();
        if (remaining <= 0) {
            callback();
            return;
        }
        timer = setTimeout(schedule, Math.min(remaining, $47daad24abd23110$var$MAX_TIMEOUT_MS));
    };
    schedule();
    return ()=>clearTimeout(timer);
};


const $e2bf91e4975d6fca$var$ENDPOINT = '/gateway/api/ai/v2/ai-feature/twg-hub-summaries';
const $e2bf91e4975d6fca$var$EXPERIENCE_ID = 'confluence-twg-hub-summaries';
const $e2bf91e4975d6fca$var$createSingleEntryCache = ()=>{
    let entry;
    return {
        get: (key)=>entry?.key === key ? entry.value : undefined,
        set: (key, value)=>{
            entry = {
                key: key,
                value: value
            };
        },
        clear: ()=>{
            entry = undefined;
        }
    };
};
// Reuse only the most recent successful response. This survives panel/modal
// remounts without accumulating one entry per page, and the exact request body
// makes every input that can affect the summaries part of cache identity.
// This intentionally has no TTL: backend-only prompt or model changes are not
// observed until another success replaces the entry or the page reloads. That
// trade-off is acceptable because this cache targets immediate consecutive opens.
const $e2bf91e4975d6fca$var$resultCache = $e2bf91e4975d6fca$var$createSingleEntryCache();
const $e2bf91e4975d6fca$export$2317690a8ca68a01 = ()=>{
    $e2bf91e4975d6fca$var$resultCache.clear();
};
const $e2bf91e4975d6fca$var$isAbortError = (error)=>typeof error === 'object' && error !== null && 'name' in error && error.name === 'AbortError';
const $e2bf91e4975d6fca$var$toError = (error)=>error instanceof Error ? error : new Error(String(error));
const $e2bf91e4975d6fca$var$isAiFeatureErrorResponse = (value)=>{
    if (!value || typeof value !== 'object') return false;
    const error = value.error;
    if (!error || typeof error !== 'object') return false;
    const candidate = error;
    return typeof candidate.code === 'string' && typeof candidate.message === 'string' && typeof candidate.retryable === 'boolean' && typeof candidate.requestId === 'string';
};
class $e2bf91e4975d6fca$export$fa6239a82d776b89 extends Error {
    constructor(status, responseBody, retryAfter = null){
        super(`At a Glance request failed with HTTP ${status}`);
        this.status = void 0;
        this.code = void 0;
        this.retryable = void 0;
        this.requestId = void 0;
        this.serviceMessage = void 0;
        this.retryAfterMs = void 0;
        this.name = 'AtAGlanceRequestError';
        this.status = status;
        this.retryAfterMs = (0, $47daad24abd23110$export$86526f40287dee0d)(retryAfter);
        if ($e2bf91e4975d6fca$var$isAiFeatureErrorResponse(responseBody)) {
            this.code = responseBody.error.code;
            this.retryable = responseBody.error.retryable;
            this.requestId = responseBody.error.requestId;
            this.serviceMessage = responseBody.error.message;
        }
    }
}
const $e2bf91e4975d6fca$export$72b2d05bd0aa0669 = ({ enabled: enabled, contentId: contentId, connections: connections, pageTitle: pageTitle, pageAdf: pageAdf, pageVersion: pageVersion, pageUpdatedAt: pageUpdatedAt, structuralAncestors: structuralAncestors, outgoingLinksLoading: outgoingLinksLoading = false })=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { locale: locale } = (0, $kSwu1.useIntl)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const [resultState, setResultState] = (0, $cozmU.useState)(null);
    const requestBody = (0, $cozmU.useMemo)(()=>{
        if (!enabled || !contentId || !cloudId || !pageAdf || typeof pageTitle !== 'string' || connections.appearsIn.loading || outgoingLinksLoading) return null;
        const input = (0, $ecb19719bff78326$export$1d4beabc419323b8)({
            cloudId: cloudId,
            contentId: contentId,
            locale: locale,
            pageTitle: pageTitle,
            pageVersion: pageVersion,
            pageUpdatedAt: pageUpdatedAt,
            pageAdf: pageAdf,
            structuralAncestors: structuralAncestors,
            incomingLinks: connections.appearsIn.links,
            outgoingLinks: connections.linksTo.links,
            relatedContentLinks: connections.relatedContent.links
        });
        if (!input) return null;
        return JSON.stringify({
            ai_feature_input: input
        });
    }, [
        enabled,
        pageAdf,
        pageTitle,
        pageUpdatedAt,
        pageVersion,
        structuralAncestors,
        cloudId,
        connections.appearsIn.links,
        connections.appearsIn.loading,
        outgoingLinksLoading,
        connections.linksTo.links,
        connections.relatedContent.links,
        contentId,
        locale
    ]);
    const cachedOutput = requestBody ? $e2bf91e4975d6fca$var$resultCache.get(requestBody) ?? null : null;
    const currentResultState = resultState?.contentId === contentId ? resultState : null;
    const output = cachedOutput ?? currentResultState?.output ?? null;
    const error = cachedOutput ? null : currentResultState?.error ?? null;
    // Raw link counts for analytics, in a ref so they never drive the effect: the
    // payload filters and caps these links, so the counts can change while the
    // request body does not. The effect snapshots them when it fires.
    const linkCountsRef = (0, $cozmU.useRef)({
        incomingLinkCount: 0,
        outgoingLinkCount: 0
    });
    linkCountsRef.current = {
        incomingLinkCount: connections.appearsIn.links.length,
        outgoingLinkCount: connections.linksTo.links.length
    };
    (0, $cozmU.useEffect)(()=>{
        if (!requestBody || !cloudId || !contentId) {
            setResultState((current)=>current ? {
                    contentId: current.contentId,
                    output: current.output,
                    error: current.error
                } : null);
            return;
        }
        const cachedResult = $e2bf91e4975d6fca$var$resultCache.get(requestBody);
        if (cachedResult) {
            // Keep this mounted consumer stable if another page later replaces the
            // single module-level cache entry. A cache hit is not a request, so no
            // operational event fires here.
            setResultState({
                contentId: contentId,
                output: cachedResult,
                error: null
            });
            return;
        }
        const controller = new AbortController();
        const startedAt = performance.now();
        const { incomingLinkCount: incomingLinkCount, outgoingLinkCount: outgoingLinkCount } = linkCountsRef.current;
        let cancelled = false;
        let settled = false;
        let cancelRetryTimer;
        let retryCount = 0;
        setResultState((current)=>({
                contentId: contentId,
                output: current && current.contentId === contentId ? current.output : null,
                error: null
            }));
        // Deliberately preserve the current output: hold the bullets we have while a refetch is in
        // flight. `requestBody` changes whenever the links do, and one response now feeds both
        // the panel and the modal — so clearing here would blank both surfaces back to
        // skeletons the moment a reader pressed "show more" on "Appears in", and make them wait
        // out a fresh LLM round trip for an answer already on screen. `loading` stays false for
        // the same reason (see below).
        const elapsedMs = ()=>Math.round(performance.now() - startedAt);
        const reportFailure = (reason, failure, statusCode)=>{
            if (cancelled || settled) return;
            settled = true;
            setResultState((current)=>({
                    contentId: contentId,
                    output: current && current.contentId === contentId ? current.output : null,
                    error: failure
                }));
            (0, $5ZqQS.getMonitoringClient)().submitError(failure, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            createEvent((0, $c484d458bde3f527$export$c94aa1bf4dcf738d)({
                reason: reason,
                statusCode: statusCode,
                incomingLinkCount: incomingLinkCount,
                outgoingLinkCount: outgoingLinkCount,
                durationMs: elapsedMs(),
                ...retryCount ? {
                    retryCount: retryCount
                } : {}
            })).fire();
        };
        const setRetryState = (retryPending)=>{
            setResultState((current)=>({
                    contentId: contentId,
                    output: current?.contentId === contentId ? current.output : null,
                    error: retryPending ? null : current?.error ?? null,
                    retryPending: retryPending
                }));
        };
        const runRequest = (allowAutomaticRetry)=>{
            if (cancelled) return;
            fetch($e2bf91e4975d6fca$var$ENDPOINT, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    'ATL-CloudId': cloudId,
                    'x-experience-id': $e2bf91e4975d6fca$var$EXPERIENCE_ID,
                    'x-product': 'confluence'
                },
                body: requestBody,
                signal: controller.signal
            }).then(async (response)=>{
                const responseBody = await response.json().catch(()=>null);
                if (cancelled) return;
                if (!response.ok) throw new $e2bf91e4975d6fca$export$fa6239a82d776b89(response.status, responseBody, response.headers.get('Retry-After'));
                const parsed = (0, $66ddd238965febb3$export$e55d72037394dd46)(responseBody);
                if (!parsed) {
                    reportFailure('malformedResponse', new Error('At a Glance response envelope is malformed'));
                    return;
                }
                settled = true;
                $e2bf91e4975d6fca$var$resultCache.set(requestBody, parsed);
                setResultState({
                    contentId: contentId,
                    output: parsed,
                    error: null
                });
                createEvent((0, $c484d458bde3f527$export$1c32d73668cee9f0)({
                    overviewCount: parsed.overview.length,
                    summariesCount: parsed.summaries.length,
                    incomingLinkCount: incomingLinkCount,
                    outgoingLinkCount: outgoingLinkCount,
                    durationMs: elapsedMs(),
                    ...retryCount ? {
                        retryCount: retryCount
                    } : {}
                })).fire();
            }).catch((caught)=>{
                if (cancelled || $e2bf91e4975d6fca$var$isAbortError(caught)) return;
                const rateLimited = caught instanceof $e2bf91e4975d6fca$export$fa6239a82d776b89 && caught.status === 503 && caught.code === 'AI_FEATURE_RATE_LIMITED' && caught.retryable === true;
                if (rateLimited && allowAutomaticRetry) {
                    const retryNotBefore = Date.now() + caught.retryAfterMs + 250 + Math.floor(Math.random() * 1000);
                    setRetryState(true);
                    cancelRetryTimer = (0, $47daad24abd23110$export$334a87e4fb3ba41a)(retryNotBefore, ()=>{
                        retryCount = 1;
                        setRetryState(false);
                        runRequest(false);
                    });
                    return;
                }
                reportFailure(rateLimited ? 'rateLimited' : caught instanceof $e2bf91e4975d6fca$export$fa6239a82d776b89 ? 'httpError' : 'networkError', $e2bf91e4975d6fca$var$toError(caught), caught instanceof $e2bf91e4975d6fca$export$fa6239a82d776b89 ? caught.status : undefined);
            });
        };
        runRequest(true);
        return ()=>{
            cancelled = true;
            cancelRetryTimer?.();
            controller.abort();
            if (!settled) createEvent((0, $c484d458bde3f527$export$7688f758e142df9b)({
                incomingLinkCount: incomingLinkCount,
                outgoingLinkCount: outgoingLinkCount,
                durationMs: elapsedMs(),
                ...retryCount ? {
                    retryCount: retryCount
                } : {}
            })).fire();
        };
    }, [
        cloudId,
        contentId,
        createEvent,
        requestBody
    ]);
    const waitingOnPrereqs = Boolean(contentId && cloudId && (!pageAdf || pageTitle === undefined || connections.appearsIn.loading || outgoingLinksLoading));
    const loading = Boolean(enabled && !output && !error && (waitingOnPrereqs || requestBody));
    const retryPending = cachedOutput ? false : currentResultState?.retryPending;
    return (0, $cozmU.useMemo)(()=>({
            output: output,
            error: error,
            loading: loading,
            retryPending: retryPending
        }), [
        output,
        error,
        loading,
        retryPending
    ]);
};



var $jDHty = parcelRequire("jDHty");

const $e881057e0de27ea9$export$3b542486c8925d39 = {
    contentId: undefined,
    atAGlance: {
        output: null,
        loading: true,
        error: null
    }
};
// BylineConnections is the sole producer. Readers never fetch or hydrate this stream.
const $e881057e0de27ea9$var$bridge = (0, $jDHty.createPanelDataBridge)($e881057e0de27ea9$export$3b542486c8925d39);
const $e881057e0de27ea9$export$d7ea14a22c3a1260 = $e881057e0de27ea9$var$bridge.publish;
const $e881057e0de27ea9$export$932fff4b8bd41d62 = $e881057e0de27ea9$var$bridge.clear;
const $e881057e0de27ea9$export$850ea50adc381c = $e881057e0de27ea9$var$bridge.useValue;
const $e881057e0de27ea9$export$e980d9608a04fb97 = $e881057e0de27ea9$var$bridge.clearForTesting;





const $3b6532377f19c330$export$8e74f165501ea398 = {
    contentId: undefined,
    devDocsConnection: null
};
/**
 * Carries the Dev Docs source the connections byline resolved from the content
 * header's `ancestors`. See `createPanelDataBridge` for why the panel needs a
 * bridge at all.
 *
 * Kept separate from `outgoingLinksBridge` because the producers differ: links come
 * from walking the page ADF, this from a GraphQL query, so the two resolve at
 * different times and sharing one store would let each clobber the other.
 *
 * Only ever written from an effect, so nothing publishes during SSR and this
 * module-level state cannot leak between server requests.
 */ const $3b6532377f19c330$var$devDocsConnectionBridge = (0, $jDHty.createPanelDataBridge)($3b6532377f19c330$export$8e74f165501ea398);
const $3b6532377f19c330$export$bef8e2d39680b9a8 = $3b6532377f19c330$var$devDocsConnectionBridge.publish;
const $3b6532377f19c330$export$962a90b3959f19a3 = $3b6532377f19c330$var$devDocsConnectionBridge.clear;
const $3b6532377f19c330$export$e9fa78d134203a1f = $3b6532377f19c330$var$devDocsConnectionBridge.subscribe;
const $3b6532377f19c330$export$27db6e7d91fcef66 = $3b6532377f19c330$var$devDocsConnectionBridge.useValue;
const $3b6532377f19c330$export$4c93bdc6dd1bcc11 = $3b6532377f19c330$var$devDocsConnectionBridge.clearForTesting;



var $21leH = parcelRequire("21leH");


var $Hnn0l = parcelRequire("Hnn0l");


var $4ao9J = parcelRequire("4ao9J");

/**
 * @generated SignedSource<<1451702ecad23462e6bc64881a7b8625>>
 * @relayHash 8df7adabc51bb38c03296a37df5bdd3f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID eb45f1b003742727b2be6d8636ab4b50248a4ad9a5a398b3c8703b2c52f169e6
const $35a3bdd83e28fdf1$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cypherQuery"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "cypherQuery"
        }
    ], v4 = {
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            },
            {
                "kind": "ScalarField",
                "name": "endCursor"
            }
        ]
    }, v5 = {
        "kind": "ScalarField",
        "name": "cursor"
    }, v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v8 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceBlogPost_links",
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceDatabase_links",
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluenceDatabase"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceEmbed_links",
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluenceEmbed"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceFolder_links",
                "concreteType": "ConfluenceFolderLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluenceFolder"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceFooterComment_links",
                "concreteType": "ConfluenceCommentLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluenceFooterComment"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceInlineComment_links",
                "concreteType": "ConfluenceCommentLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluenceInlineComment"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluencePage_links",
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceSlide_links",
                "concreteType": "ConfluenceSlideLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluenceSlide"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceSpace_links",
                "concreteType": "ConfluenceSpaceLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluenceSpace"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceWhiteboard_links",
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v8 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "JiraIssue_webUrl",
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraIssue"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "JiraPlatformComment_webUrl",
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraPlatformComment"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "JiraProject_webUrl",
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraProject"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "JiraServiceManagementComment_webUrl",
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraServiceManagementComment"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareComment_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareComment"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareGoal_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareGoal"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareGoalUpdate_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareGoalUpdate"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareProject_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareProject"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareProjectUpdate_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareProjectUpdate"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "LoomComment_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "LoomComment"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "LoomSpace_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "LoomSpace"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "LoomVideo_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "LoomVideo"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "MercuryAsk_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "MercuryAsk"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "MercuryFocusArea_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "MercuryFocusArea"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "BitbucketRepository_href",
                "kind": "ScalarField",
                "name": "href"
            }
        ],
        "type": "BitbucketRepository"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "DeploymentSummary_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "DeploymentSummary"
    }, v35 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "DevOpsDesign_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "DevOpsDesign"
    }, v36 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "DevOpsDocument_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "DevOpsDocument"
    }, v37 = {
        "alias": "DevOpsOperationsIncidentDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v38 = {
        "alias": "DevOpsOperationsPostIncidentReviewDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v39 = {
        "alias": "DevOpsProjectDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v40 = {
        "alias": "DevOpsPullRequestDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v41 = {
        "alias": "DevOpsRepository_url",
        "kind": "ScalarField",
        "name": "url"
    }, v42 = {
        "alias": "DevOpsSecurityVulnerabilityDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "CompassComponent_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "CompassComponent"
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalBranch_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalBranch"
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalBuildInfo_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalBuildInfo"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalCalendarEvent_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalCalendarEvent"
    }, v47 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalComment_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalComment"
    }, v48 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalCommit_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalCommit"
    }, v49 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalConversation_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalConversation"
    }, v50 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDashboard_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDashboard"
    }, v51 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDataTable_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDataTable"
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDeal_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDeal"
    }, v53 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDeployment_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDeployment"
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDesign_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDesign"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDocument_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDocument"
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalMessage_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalMessage"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalPullRequest_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalPullRequest"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalRemoteLink_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalRemoteLink"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalRepository_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalRepository"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalSoftwareService_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalSoftwareService"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalSpace_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalSpace"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalTest_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalTest"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalVideo_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalVideo"
    }, v64 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalVulnerability_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalVulnerability"
    }, v65 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalWorkItem_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalWorkItem"
    }, v66 = {
        "kind": "ScalarField",
        "name": "id"
    }, v67 = [
        v66 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useIncomingLinksQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v38 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v39 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v40 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v41 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v42 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        v43 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        v46 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v51 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v54 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        v58 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v64 /*: any*/ ,
                                                                        v65 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useIncomingLinksQuery",
            "selections": [
                {
                    "args": v3 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ ,
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v7 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isGraphStoreCypherQueryV2AriNodeUnion"
                                                                        },
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        v35 /*: any*/ ,
                                                                        v36 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v37 /*: any*/ ,
                                                                                v66 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                v66 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                v66 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v40 /*: any*/ ,
                                                                                v66 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v41 /*: any*/ ,
                                                                                v66 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v42 /*: any*/ ,
                                                                                v66 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        v43 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        v46 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v51 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v54 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        v58 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        v64 /*: any*/ ,
                                                                        v65 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "TeamCustomFieldValue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "TeamType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v67 /*: any*/ ,
                                                                            "type": "ThirdPartyUser"
                                                                        }
                                                                    ]
                                                                },
                                                                v66 /*: any*/ 
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "8df7adabc51bb38c03296a37df5bdd3f",
            "id": "eb45f1b003742727b2be6d8636ab4b50248a4ad9a5a398b3c8703b2c52f169e6",
            "metadata": {},
            "name": "useIncomingLinksQuery",
            "operationKind": "query",
            "text": "query useIncomingLinksQuery($cypherQuery:String!,$first:Int,$after:String){graphStore_cypherQueryV2(query:$cypherQuery,first:$first,after:$after)@optIn(to:\"GraphStoreCypherQueryV2\"){pageInfo{hasNextPage,endCursor},edges{cursor,node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{data{__typename,__isGraphStoreCypherQueryV2AriNodeUnion:__typename,...on ConfluenceBlogPost{ConfluenceBlogPost_links:links{base,webUi}},...on ConfluenceDatabase{ConfluenceDatabase_links:links{base,webUi}},...on ConfluenceEmbed{ConfluenceEmbed_links:links{base,webUi}},...on ConfluenceFolder{ConfluenceFolder_links:links{base,webUi}},...on ConfluenceFooterComment{ConfluenceFooterComment_links:links{base,webUi}},...on ConfluenceInlineComment{ConfluenceInlineComment_links:links{base,webUi}},...on ConfluencePage{ConfluencePage_links:links{base,webUi}},...on ConfluenceSlide{ConfluenceSlide_links:links{base,webUi}},...on ConfluenceSpace{ConfluenceSpace_links:links{base,webUi}},...on ConfluenceWhiteboard{ConfluenceWhiteboard_links:links{base,webUi}},...on JiraIssue{JiraIssue_webUrl:webUrl},...on JiraPlatformComment{JiraPlatformComment_webUrl:webUrl},...on JiraProject{JiraProject_webUrl:webUrl},...on JiraServiceManagementComment{JiraServiceManagementComment_webUrl:webUrl},...on TownsquareComment{TownsquareComment_url:url},...on TownsquareGoal{TownsquareGoal_url:url},...on TownsquareGoalUpdate{TownsquareGoalUpdate_url:url},...on TownsquareProject{TownsquareProject_url:url},...on TownsquareProjectUpdate{TownsquareProjectUpdate_url:url},...on LoomComment{LoomComment_url:url},...on LoomSpace{LoomSpace_url:url},...on LoomVideo{LoomVideo_url:url},...on MercuryAsk{MercuryAsk_url:url},...on MercuryFocusArea{MercuryFocusArea_url:url},...on BitbucketRepository{BitbucketRepository_href:href},...on DeploymentSummary{DeploymentSummary_url:url},...on DevOpsDesign{DevOpsDesign_url:url},...on DevOpsDocument{DevOpsDocument_url:url},...on DevOpsOperationsIncidentDetails{DevOpsOperationsIncidentDetails_url:url,id},...on DevOpsOperationsPostIncidentReviewDetails{DevOpsOperationsPostIncidentReviewDetails_url:url,id},...on DevOpsProjectDetails{DevOpsProjectDetails_url:url,id},...on DevOpsPullRequestDetails{DevOpsPullRequestDetails_url:url,id},...on DevOpsRepository{DevOpsRepository_url:url,id},...on DevOpsSecurityVulnerabilityDetails{DevOpsSecurityVulnerabilityDetails_url:url,id},...on CompassComponent{CompassComponent_url:url},...on ExternalBranch{ExternalBranch_url:url},...on ExternalBuildInfo{ExternalBuildInfo_url:url},...on ExternalCalendarEvent{ExternalCalendarEvent_url:url},...on ExternalComment{ExternalComment_url:url},...on ExternalCommit{ExternalCommit_url:url},...on ExternalConversation{ExternalConversation_url:url},...on ExternalDashboard{ExternalDashboard_url:url},...on ExternalDataTable{ExternalDataTable_url:url},...on ExternalDeal{ExternalDeal_url:url},...on ExternalDeployment{ExternalDeployment_url:url},...on ExternalDesign{ExternalDesign_url:url},...on ExternalDocument{ExternalDocument_url:url},...on ExternalMessage{ExternalMessage_url:url},...on ExternalPullRequest{ExternalPullRequest_url:url},...on ExternalRemoteLink{ExternalRemoteLink_url:url},...on ExternalRepository{ExternalRepository_url:url},...on ExternalSoftwareService{ExternalSoftwareService_url:url},...on ExternalSpace{ExternalSpace_url:url},...on ExternalTest{ExternalTest_url:url},...on ExternalVideo{ExternalVideo_url:url},...on ExternalVulnerability{ExternalVulnerability_url:url},...on ExternalWorkItem{ExternalWorkItem_url:url},...on Node{__isNode:__typename,id},...on AppUser{id},...on AtlassianAccountUser{id},...on CustomerUser{id},...on DevOpsFeatureFlag{id},...on DevOpsOperationsComponentDetails{id},...on JiraAutodevJob{id},...on JiraConfluenceRemoteIssueLink{id},...on JiraCustomRemoteIssueLink{id},...on JiraIssueRemoteIssueLink{id},...on JiraWebRemoteIssueLink{id},...on TeamCustomFieldValue{id},...on TeamType{id},...on ThirdPartyUser{id}},id}}}}}}}"
        }
    };
}();
$35a3bdd83e28fdf1$var$node.hash = "56481ab26b9cdb10fdd54e061bdba4d2";
var $35a3bdd83e28fdf1$export$2e2bcd8739ae039 = $35a3bdd83e28fdf1$var$node;






var $bI14T = parcelRequire("bI14T");














var $7Sm4c = parcelRequire("7Sm4c");














var $6CHZa = parcelRequire("6CHZa");


var $7LPcf = parcelRequire("7LPcf");


var $lXmY5 = parcelRequire("lXmY5");


var $ddzkt = parcelRequire("ddzkt");


var $cbT5r = parcelRequire("cbT5r");


var $e1RBl = parcelRequire("e1RBl");


var $ltT9o = parcelRequire("ltT9o");


var $hHrlI = parcelRequire("hHrlI");


var $7YvXl = parcelRequire("7YvXl");


var $4FdKz = parcelRequire("4FdKz");


var $2GG3F = parcelRequire("2GG3F");

/**
 * Extracts a plain string status name from the raw `atlassian:state` JSON-LD
 * field, which can appear in several forms:
 *
 *   - a bare string          e.g. "open", "merged", "draft"
 *   - an Object with .name  e.g. { "@type": "Object", "name": "In Progress" }
 *
 * Returns undefined when the field is absent or carries no usable name.
 * Applies to Document, SourceCodePullRequest, Project, and Goal data shapes.
 */ function $66be44d2f9c9a1f4$export$e0422c1366f8a53d(rawState) {
    if (typeof rawState === 'string' && rawState.length > 0) return rawState;
    if (typeof rawState === 'object' && rawState !== null) {
        const name = rawState.name;
        if (typeof name === 'string' && name.length > 0) return name;
    }
    return undefined;
}






var $giSsj = parcelRequire("giSsj");

const $78ed55159915b828$var$DISPLAY_NAME_PREFIX_REGEX = /^Atlassian(?:\s+(?:Links|Connector))?\s*-\s*/i;
const $78ed55159915b828$var$stripDisplayNamePrefix = (displayName)=>displayName.replace($78ed55159915b828$var$DISPLAY_NAME_PREFIX_REGEX, '').trim();
const $78ed55159915b828$var$statusNameFromTagItem = (value)=>{
    if (typeof value === 'string') return value.trim() || undefined;
    if (!value || typeof value !== 'object') return undefined;
    const name = value.name;
    return typeof name === 'string' ? name.trim() || undefined : undefined;
};
/**
 * Mirrors Smart Card's visible Task-lozenge precedence without using its
 * private extractor: tag may be a string, array, or object, and its first
 * usable name wins over atlassian:taskStatus.
 */ const $78ed55159915b828$var$statusNameFromTaskTag = (value)=>{
    if (!Array.isArray(value)) return $78ed55159915b828$var$statusNameFromTagItem(value);
    for (const item of value){
        const name = $78ed55159915b828$var$statusNameFromTagItem(item);
        if (name) return name;
    }
    return undefined;
};
function $78ed55159915b828$export$9ebf81041d234ef6(url, occurrenceIndex, response, normalizeShallowJira = false) {
    const resp = response ?? undefined;
    const data = resp?.data;
    const meta = resp?.meta;
    // The ORS batch resolver ("Referenced in") can return a shallow Jira payload — the raw Jira REST
    // issue (no top-level `data.icon`, with the issue type under `data.fields.issuetype`). Read the
    // icon and type from there. Gated so the hydrated "Links to" path is untouched.
    const issuetype = normalizeShallowJira && !data?.icon ? data?.fields?.issuetype : undefined;
    const shallowJiraIssuetype = issuetype?.iconUrl ? issuetype : undefined;
    // ── identity ──────────────────────────────────────────────────────────────
    const ari = data ? (0, $lXmY5.extractSmartLinkAri)(resp) : undefined;
    // ── display ───────────────────────────────────────────────────────────────
    const title = data ? (0, $7YvXl.extractSmartLinkTitle)(resp) : undefined;
    const summaryRaw = data && 'summary' in data ? data.summary : undefined;
    const summary = typeof summaryRaw === 'string' && summaryRaw.trim() ? summaryRaw.trim() : undefined;
    const iconUrl = data?.icon ? (0, $2GG3F.extractUrlFromIconJsonLd)(data.icon) : shallowJiraIssuetype?.iconUrl;
    // ── classification ────────────────────────────────────────────────────────
    const key = meta?.key != null ? String(meta.key) : undefined;
    const metaProduct = meta?.product != null ? String(meta.product) : undefined;
    const subproduct = meta?.subproduct != null ? String(meta.subproduct) : undefined;
    const resourceTypeRaw = meta?.resourceSubType ?? shallowJiraIssuetype?.name ?? meta?.resourceType;
    const fallbackResourceType = resourceTypeRaw != null ? String(resourceTypeRaw) : undefined;
    // The JSON-LD generator names the app that produced the object (e.g. "Focus",
    // "Loom"). It's the product-name fallback when `meta.product` is absent, and
    // the per-row app label for the collapsed townsquare/"Goals" group. Skip the
    // bare-string generator — extractSmartLinkProvider (via extractProvider)
    // throws on it rather than returning undefined.
    const generatorName = data != null && typeof data.generator !== 'string' ? (0, $hHrlI.extractSmartLinkProvider)(resp)?.text : undefined;
    // Atlas Projects/Goals arrive as the `townsquare` codename and collapse under
    // the "Goals" group; surface the specific app (generator name) as the row's
    // resource type so the metadata line shows the real product.
    const isTownsquare = (0, $giSsj.isTownsquareProduct)(metaProduct);
    const resourceType = isTownsquare ? generatorName ?? fallbackResourceType : fallbackResourceType;
    const jsonLdTypes = data ? (0, $4FdKz.extractType)(data) : undefined;
    const jsonLdType = jsonLdTypes?.[0];
    const isTask = jsonLdTypes?.includes('atlassian:Task') ?? false;
    // ── people ────────────────────────────────────────────
    const owner = data ? (0, $7LPcf.extractPersonOwnedBy)(data)?.[0]?.name : undefined;
    const assignedTo = data ? (0, $6CHZa.extractPersonAssignedTo)(data)?.name : undefined;
    const createdBy = data ? (0, $ddzkt.extractSmartLinkCreatedBy)(resp) : undefined;
    const updatedBy = data ? (0, $e1RBl.extractSmartLinkModifiedBy)(resp) : undefined;
    // ── dates ─────────────────────────────────────────────────────────────────
    const createdAt = data ? (0, $cbT5r.extractSmartLinkCreatedOn)(resp) : undefined;
    const updatedAt = data ? (0, $ltT9o.extractSmartLinkModifiedOn)(resp) : undefined;
    // ── status ────────────────────────────────────────────────────────────────
    const taskStatusRaw = data?.['atlassian:taskStatus'];
    const taskStatusFromObject = taskStatusRaw?.name != null ? String(taskStatusRaw.name).trim() || undefined : undefined;
    const taskStatus = (isTask ? $78ed55159915b828$var$statusNameFromTaskTag(data?.tag) : undefined) ?? taskStatusFromObject;
    const state = (0, $66be44d2f9c9a1f4$export$e0422c1366f8a53d)(data?.['atlassian:state']);
    // ── auth ──────────────────────────────────────────────────────────────────
    const access = meta?.access;
    const visibility = meta?.visibility;
    const authProviders = Array.isArray(meta?.auth) ? meta.auth.filter((a)=>typeof a === 'object' && typeof a.displayName === 'string' && typeof a.key === 'string' && typeof a.url === 'string') : [];
    const providerDisplayName = authProviders[0]?.displayName;
    const productFromAuthProvider = typeof providerDisplayName === 'string' && providerDisplayName.length > 0 ? $78ed55159915b828$var$stripDisplayNamePrefix(providerDisplayName) : undefined;
    // `meta.product` wins; else the connected provider's display name (unauthorized
    // 3P links); else the JSON-LD generator name (Focus, Loom, …) — which is how
    // product-less 1P links get classified instead of falling into "Other".
    const resolvedProduct = metaProduct ?? productFromAuthProvider ?? generatorName;
    const iconSource = {
        ari: ari,
        occurrenceIndex: occurrenceIndex,
        product: resolvedProduct,
        url: url
    };
    const icon = shallowJiraIssuetype?.iconUrl ? (0, $5b9Ab.buildImageIcon)(shallowJiraIssuetype.iconUrl, iconSource) : (0, $5b9Ab.extractSmartLinkIcon)(resp, iconSource);
    return {
        url: url,
        occurrenceIndex: occurrenceIndex,
        ari: ari,
        title: title,
        summary: summary,
        icon: icon,
        iconUrl: iconUrl,
        product: resolvedProduct,
        key: key,
        subproduct: subproduct,
        resourceType: resourceType,
        jsonLdType: jsonLdType,
        isTask: isTask,
        owner: owner,
        assignedTo: assignedTo,
        createdBy: createdBy,
        updatedBy: updatedBy,
        createdAt: createdAt,
        updatedAt: updatedAt,
        taskStatus: taskStatus,
        state: state,
        access: access,
        visibility: visibility,
        authProviders: authProviders
    };
}


const $f79f602b4ce45ce7$var$EXACT_ISSUE_KEY_JQL = /^(?:key|issuekey)\s*=\s*(?:"([a-z][a-z0-9_]*-\d+)"|([a-z][a-z0-9_]*-\d+))\s*$/i;
const $f79f602b4ce45ce7$export$95cb0164e578921c = (value)=>{
    let url;
    try {
        url = new URL(value);
    } catch  {
        return value;
    }
    if (url.protocol !== 'https:' || url.pathname !== '/issues' && url.pathname !== '/issues/') return value;
    const jql = url.searchParams.get('jql');
    const match = jql?.match($f79f602b4ce45ce7$var$EXACT_ISSUE_KEY_JQL);
    const issueKey = match?.[1] ?? match?.[2];
    if (!issueKey) return value;
    return new URL(`/browse/${issueKey.toUpperCase()}`, url.origin).toString();
};


// ORS has no provider for the URL, so a retry cannot change the answer.
const $7454a2cee359837e$var$UNSUPPORTED_ERROR_TYPES = new Set([
    'UnsupportedError',
    'ResolveUnsupportedError'
]);
const $7454a2cee359837e$var$unresolvableUrls = new Set();
const $7454a2cee359837e$export$33c396b527166c44 = (url)=>$7454a2cee359837e$var$unresolvableUrls.has(url);
const $7454a2cee359837e$export$3cf1317826e24a95 = (error)=>{
    const type = error?.type;
    return typeof type === 'string' && $7454a2cee359837e$var$UNSUPPORTED_ERROR_TYPES.has(type);
};
const $7454a2cee359837e$export$b646b603813a2189 = (url)=>{
    $7454a2cee359837e$var$unresolvableUrls.add(url);
};
const $7454a2cee359837e$export$b0f64faf64d11b1 = ()=>{
    $7454a2cee359837e$var$unresolvableUrls.clear();
};


async function $7e1486aa62dbf166$export$ab14756fcd367a5(url, occurrenceIndex, store, cardClient) {
    const resolutionUrl = (0, $f79f602b4ce45ce7$export$95cb0164e578921c)(url);
    const cached = store.getState()[resolutionUrl]?.details;
    let response = cached?.data ? cached : null;
    // Failed resolves never reach the store, so every pass would re-request them.
    if (!response && !(0, $7454a2cee359837e$export$33c396b527166c44)(resolutionUrl)) response = await cardClient.fetchData(resolutionUrl).catch((err)=>{
        // Expected for a plain hyperlink, so remember it instead of reporting it.
        if ((0, $7454a2cee359837e$export$3cf1317826e24a95)(err)) {
            (0, $7454a2cee359837e$export$b646b603813a2189)(resolutionUrl);
            return null;
        }
        const errorObj = err instanceof Error ? err : new Error(String(err));
        (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        return null;
    });
    return {
        link: (0, $78ed55159915b828$export$9ebf81041d234ef6)(url, occurrenceIndex, response),
        isResolved: response != null
    };
}


async function $89f81df02d4c8ccc$export$4f12cb865d88dee(urls, store, cardClient) {
    const resolved = await Promise.all(urls.map((url, index)=>(0, $7e1486aa62dbf166$export$ab14756fcd367a5)(url, index, store, cardClient)));
    const links = [];
    const seen = new Set();
    resolved.forEach(({ link: link, isResolved: isResolved })=>{
        const key = link.ari ?? link.url;
        if (!isResolved || seen.has(key)) return;
        seen.add(key);
        links.push(link);
    });
    return links;
}








/**
 * @generated SignedSource<<ca905a33aedcb0ca46e4cc8b0f597b95>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $5d1460e83753641a$var$node = function() {
    var v0 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "incomingLinkTypes_node",
        "selections": [
            {
                "kind": "ScalarField",
                "name": "__typename"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceBlogPost_links",
                        "concreteType": "ConfluenceBlogPostLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceBlogPost"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceDatabase_links",
                        "concreteType": "ConfluenceDatabaseLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceDatabase"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceEmbed_links",
                        "concreteType": "ConfluenceEmbedLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceEmbed"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceFolder_links",
                        "concreteType": "ConfluenceFolderLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceFolder"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceFooterComment_links",
                        "concreteType": "ConfluenceCommentLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceFooterComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceInlineComment_links",
                        "concreteType": "ConfluenceCommentLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceInlineComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluencePage_links",
                        "concreteType": "ConfluencePageLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluencePage"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceSlide_links",
                        "concreteType": "ConfluenceSlideLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceSlide"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceSpace_links",
                        "concreteType": "ConfluenceSpaceLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceSpace"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ConfluenceWhiteboard_links",
                        "concreteType": "ConfluenceWhiteboardLinks",
                        "kind": "LinkedField",
                        "name": "links",
                        "plural": false,
                        "selections": v0 /*: any*/ 
                    }
                ],
                "type": "ConfluenceWhiteboard"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "JiraIssue_webUrl",
                        "kind": "ScalarField",
                        "name": "webUrl"
                    }
                ],
                "type": "JiraIssue"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "JiraPlatformComment_webUrl",
                        "kind": "ScalarField",
                        "name": "webUrl"
                    }
                ],
                "type": "JiraPlatformComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "JiraProject_webUrl",
                        "kind": "ScalarField",
                        "name": "webUrl"
                    }
                ],
                "type": "JiraProject"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "JiraServiceManagementComment_webUrl",
                        "kind": "ScalarField",
                        "name": "webUrl"
                    }
                ],
                "type": "JiraServiceManagementComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareComment_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareGoal_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareGoal"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareGoalUpdate_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareGoalUpdate"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareProject_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareProject"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "TownsquareProjectUpdate_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "TownsquareProjectUpdate"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "LoomComment_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "LoomComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "LoomSpace_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "LoomSpace"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "LoomVideo_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "LoomVideo"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "MercuryAsk_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "MercuryAsk"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "MercuryFocusArea_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "MercuryFocusArea"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "BitbucketRepository_href",
                        "kind": "ScalarField",
                        "name": "href"
                    }
                ],
                "type": "BitbucketRepository"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DeploymentSummary_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DeploymentSummary"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsDesign_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsDesign"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsDocument_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsDocument"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsOperationsIncidentDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsOperationsIncidentDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsOperationsPostIncidentReviewDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsOperationsPostIncidentReviewDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsProjectDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsProjectDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsPullRequestDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsPullRequestDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsRepository_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsRepository"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "DevOpsSecurityVulnerabilityDetails_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "DevOpsSecurityVulnerabilityDetails"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "CompassComponent_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "CompassComponent"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalBranch_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalBranch"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalBuildInfo_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalBuildInfo"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalCalendarEvent_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalCalendarEvent"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalComment_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalComment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalCommit_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalCommit"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalConversation_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalConversation"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDashboard_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDashboard"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDataTable_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDataTable"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDeal_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDeal"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDeployment_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDeployment"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDesign_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDesign"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalDocument_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalDocument"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalMessage_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalMessage"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalPullRequest_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalPullRequest"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalRemoteLink_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalRemoteLink"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalRepository_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalRepository"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalSoftwareService_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalSoftwareService"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalSpace_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalSpace"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalTest_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalTest"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalVideo_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalVideo"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalVulnerability_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalVulnerability"
            },
            {
                "kind": "InlineFragment",
                "selections": [
                    {
                        "alias": "ExternalWorkItem_url",
                        "kind": "ScalarField",
                        "name": "url"
                    }
                ],
                "type": "ExternalWorkItem"
            }
        ],
        "type": "GraphStoreCypherQueryV2AriNodeUnion",
        "abstractKey": "__isGraphStoreCypherQueryV2AriNodeUnion"
    };
}();
$5d1460e83753641a$var$node.hash = "fe89e1513a003dbeaf6c82d35fb23448";
var $5d1460e83753641a$export$2e2bcd8739ae039 = $5d1460e83753641a$var$node;


const $2489f951d151b954$export$b4eefb28d6bb1ef8 = {
    // Confluence — `links.webUi` is site-relative and needs `links.base` prepended.
    ConfluenceBlogPost: 'links',
    ConfluenceDatabase: 'links',
    ConfluenceEmbed: 'links',
    ConfluenceFolder: 'links',
    ConfluenceFooterComment: 'links',
    ConfluenceInlineComment: 'links',
    ConfluencePage: 'links',
    ConfluenceSlide: 'links',
    ConfluenceSpace: 'links',
    ConfluenceWhiteboard: 'links',
    // Jira
    JiraIssue: 'webUrl',
    JiraPlatformComment: 'webUrl',
    JiraProject: 'webUrl',
    JiraServiceManagementComment: 'webUrl',
    // Atlas (townsquare)
    TownsquareComment: 'url',
    TownsquareGoal: 'url',
    TownsquareGoalUpdate: 'url',
    TownsquareProject: 'url',
    TownsquareProjectUpdate: 'url',
    // Loom
    LoomComment: 'url',
    LoomSpace: 'url',
    LoomVideo: 'url',
    // Focus (mercury)
    MercuryAsk: 'url',
    MercuryFocusArea: 'url',
    // Bitbucket and the DevOps graph
    BitbucketRepository: 'href',
    DeploymentSummary: 'url',
    DevOpsDesign: 'url',
    DevOpsDocument: 'url',
    DevOpsOperationsIncidentDetails: 'url',
    DevOpsOperationsPostIncidentReviewDetails: 'url',
    DevOpsProjectDetails: 'url',
    DevOpsPullRequestDetails: 'url',
    DevOpsRepository: 'url',
    DevOpsSecurityVulnerabilityDetails: 'url',
    // Compass
    CompassComponent: 'url',
    // Third-party ("External") peers
    ExternalBranch: 'url',
    ExternalBuildInfo: 'url',
    ExternalCalendarEvent: 'url',
    ExternalComment: 'url',
    ExternalCommit: 'url',
    ExternalConversation: 'url',
    ExternalDashboard: 'url',
    ExternalDataTable: 'url',
    ExternalDeal: 'url',
    ExternalDeployment: 'url',
    ExternalDesign: 'url',
    ExternalDocument: 'url',
    ExternalMessage: 'url',
    ExternalPullRequest: 'url',
    ExternalRemoteLink: 'url',
    ExternalRepository: 'url',
    ExternalSoftwareService: 'url',
    ExternalSpace: 'url',
    ExternalTest: 'url',
    ExternalVideo: 'url',
    ExternalVulnerability: 'url',
    ExternalWorkItem: 'url'
};
const $2489f951d151b954$export$f73902fb102e0802 = Object.keys($2489f951d151b954$export$b4eefb28d6bb1ef8);
const $2489f951d151b954$export$937a624f4e276713 = (typename)=>typename != null && typename in $2489f951d151b954$export$b4eefb28d6bb1ef8;
const $2489f951d151b954$export$83340287504d9ea3 = (typename)=>`${typename}_${$2489f951d151b954$export$b4eefb28d6bb1ef8[typename]}`;
const $2489f951d151b954$export$e255b16248ce204b = (0, $5d1460e83753641a$export$2e2bcd8739ae039);


const $feb6b0240ba5ead3$var$joinLinks = (links)=>{
    if (!links?.base || !links.webUi) return undefined;
    return `${links.base.replace(/\/+$/, '')}/${links.webUi.replace(/^\/+/, '')}`;
};
const $feb6b0240ba5ead3$export$367b5466dd42229d = (data)=>{
    const typename = data?.__typename;
    if (!data || !(0, $2489f951d151b954$export$937a624f4e276713)(typename)) return undefined;
    // The alias is built at runtime from the typename, so the generated union type
    // can't narrow the lookup — hence the one cast, over both shapes a curated type
    // can carry.
    const selected = data[(0, $2489f951d151b954$export$83340287504d9ea3)(typename)];
    return typeof selected === 'string' ? selected || undefined : $feb6b0240ba5ead3$var$joinLinks(selected);
};



const $ceb5f0113009896a$export$7d6dd950f56cfaae = (data)=>{
    const urls = [];
    const seenUrls = new Set();
    const uncataloguedTypenames = new Set();
    let missingUrlCount = 0;
    // Work is bounded by the query's `first` (≤1000 rows, each with a single
    // column), so this flat/map chain is linear, not quadratic.
    // eslint-disable-next-line @atlassian/perf-linting/no-quadratic-complexity
    const nodeData = (data?.graphStore_cypherQueryV2?.edges ?? []).flatMap((edge)=>edge?.node?.columns ?? []).map((column)=>column?.value?.data);
    nodeData.forEach((node)=>{
        if (!node) return;
        const url = (0, $feb6b0240ba5ead3$export$367b5466dd42229d)(node);
        if (url) {
            if (!seenUrls.has(url)) {
                seenUrls.add(url);
                urls.push(url);
            }
            return;
        }
        if ((0, $2489f951d151b954$export$937a624f4e276713)(node.__typename)) missingUrlCount += 1;
        else uncataloguedTypenames.add(node.__typename);
    });
    if (uncataloguedTypenames.size > 0) (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`readIncomingLinkUrls: incoming link node type(s) missing from the catalog: ${[
        ...uncataloguedTypenames
    ].join(', ')}`), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
    if (missingUrlCount > 0) (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`readIncomingLinkUrls: ${missingUrlCount} curated incoming link node(s) had no url`), {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
    return urls;
};





const $48cafc2affcc1872$export$f7e6e403c5c87e79 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: (0, $I7TEB.INCOMING_LINKS_ACTION_SUBJECT),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $48cafc2affcc1872$export$76206bc26a4d1ef = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: (0, $I7TEB.INCOMING_LINKS_ACTION_SUBJECT),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $48cafc2affcc1872$export$974f529324b8e135 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: (0, $I7TEB.INCOMING_LINKS_LOAD_MORE_ACTION_SUBJECT),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });


const $8a6630d12e0f6d27$export$ce3a4a8f39618efe = 50;
const $8a6630d12e0f6d27$export$852c54c52214ab2 = 50;
const $8a6630d12e0f6d27$var$INITIAL_RESOLVED_LINK_TARGET = 3;
// Classify by the error's contents rather than the code path: an Apollo error
// with only a networkError is transport-level; one carrying graphQLErrors is a
// query/data failure. Anything unrecognised is treated as a network error.
const $8a6630d12e0f6d27$var$classifyError = (err)=>!err.networkError && err.graphQLErrors?.length ? 'graphql' : 'network';
// Upper bound on the rows the graph will match; 1000 is the AGG cypherQueryV2
// max. Pagination (`first`/`after`) walks this matched set a page at a time.
const $8a6630d12e0f6d27$var$MAX_INCOMING_LINKS = 1000;
// `(source)-[:content_referenced_entity]->(page:ConfluencePage)`: any-product or
// third-party entity that references this page. Confirmed against real TWG data by
// the [Spike] 3P Incoming Links investigation.
const $8a6630d12e0f6d27$var$LINKS_RELATIONSHIP = 'content_referenced_entity';
// Byline only knows the content id, so assume the dominant `page` type; other
// types match nothing and the section stays empty.
const $8a6630d12e0f6d27$var$buildConfluencePageAri = (cloudId, contentId)=>(0, $6B1vK.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: contentId
    }).toString();
// AGG requires an `X-Query-Context` header naming the site (or workspace) ARI for
// `graphStore_*` fields, otherwise the gateway rejects the request with
// "Query context must not be null". The site ARI is derived from the cloudId.
const $8a6630d12e0f6d27$var$buildQueryContext = (cloudId)=>`ari:cloud:platform::site/${cloudId}`;
// `ORDER BY` puts the most recently updated referencing entities on page 1, which
// is all either surface shows: the byline's top-3 and the section's first page both
// stop well short of the 1000 matched rows.
//
// `lastUpdated` resolves against the *graph* node types this relationship can bind
// (`JiraIssue`, `GraphPullRequest`, ...), not the AGG types in the `data` union
// below -- the two namespaces disagree, e.g. `ExternalPullRequest` carries
// `lastUpdate` and no `lastUpdated`. No `content-referenced-entity` source type
// opts out of `lastUpdated`, but 32 node types do, so check
// `graph-catalogue/src/data/nodes.ts` (not the AGG schema) before ordering on any
// other property. Do not reach for `coalesce()` to bridge the namespaces: the
// gateway rejects the whole query.
const $8a6630d12e0f6d27$var$buildIncomingLinksCypher = (pageAri)=>[
        `MATCH (source)-[:${$8a6630d12e0f6d27$var$LINKS_RELATIONSHIP}]->(page:ConfluencePage {ari: "${pageAri}"})`,
        `RETURN source`,
        `ORDER BY source.lastUpdated DESC`,
        `LIMIT ${$8a6630d12e0f6d27$var$MAX_INCOMING_LINKS}`
    ].join('\n');
// URL-only hydration. The graph is asked for one thing per row — a navigable URL —
// and every link is then resolved from that URL through ORS, exactly as the
// outgoing links are (see `hydrateIncomingLinks`). Node ARIs are deliberately not
// selected: they are not needed for identity (the url is), and ORS resolves URLs
// where `/resolve/ari/batch` 404s on many of the same entities.
//
// `pageInfo`/`cursor` drive `after`-based pagination.
const $8a6630d12e0f6d27$var$IncomingLinksQuery = (0, $35a3bdd83e28fdf1$export$2e2bcd8739ae039);
const $8a6630d12e0f6d27$var$readPageInfo = (data)=>{
    const pageInfo = data?.graphStore_cypherQueryV2?.pageInfo;
    return {
        hasNextPage: pageInfo?.hasNextPage ?? false,
        endCursor: pageInfo?.endCursor ?? null
    };
};
// `updateQuery` merge shared by both paged fetches (the initial catch-up loop and
// `loadMore`): append the incoming page's edges after the ones already in the cache
// entry, and adopt the new page's `pageInfo` so the next fetch reads the latest
// cursor. A response with no connection leaves the cache untouched.
const $8a6630d12e0f6d27$var$appendNextPage = (previousResult, fetchMoreResult)=>{
    const nextConnection = fetchMoreResult?.graphStore_cypherQueryV2;
    if (!nextConnection) return previousResult;
    const previousEdges = previousResult?.graphStore_cypherQueryV2?.edges ?? [];
    return {
        ...previousResult,
        graphStore_cypherQueryV2: {
            ...nextConnection,
            edges: [
                ...previousEdges,
                ...nextConnection.edges
            ],
            pageInfo: nextConnection.pageInfo
        }
    };
};
const $8a6630d12e0f6d27$export$4a27c1a938f63c6e = (contentId, options)=>{
    const initialPageSize = options?.initialPageSize ?? $8a6630d12e0f6d27$export$ce3a4a8f39618efe;
    const loadMorePageSize = options?.loadMorePageSize ?? $8a6630d12e0f6d27$export$852c54c52214ab2;
    const enabled = options?.enabled ?? true;
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const { connections: connections, store: store } = (0, $bI14T.useSmartLinkContext)();
    // `@confluence/analytics`, not the platform analytics-bridge helper. `fireOperationalAnalytics`
    // fires on the `analyticsBridge` channel, and `AnalyticsListener` only invokes its handler when
    // its own `channel` is `'*'` or equal to the event's; `ConfluenceAnalyticsListener` passes no
    // `channel`, so bridge events never reached it at all. See `.agents/incoming-links.md`. CCINT-9105
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    // Dedupes across pages so re-renders and merged-store updates never re-resolve a url.
    const knownUrlsRef = (0, $cozmU.useRef)(new Set());
    const initialResolvedRef = (0, $cozmU.useRef)(false);
    // The SmartCard provider rebuilds its context value with `lodash.merge({}, ...)`, which mints a
    // new `store` object on every recompute even though the underlying Redux store is unchanged. We
    // read it through a ref and keep it out of the hydration callback's deps so an ancestor re-render
    // does not re-create the callback and re-fire the hydration effect.
    const storeRef = (0, $cozmU.useRef)(store);
    (0, $cozmU.useEffect)(()=>{
        storeRef.current = store;
    }, [
        store
    ]);
    const skip = !enabled || !contentId || !cloudId;
    const [links, setLinks] = (0, $cozmU.useState)([]);
    const [initialResolved, setInitialResolved] = (0, $cozmU.useState)(false);
    const [resolving, setResolving] = (0, $cozmU.useState)(false);
    const [loadingMore, setLoadingMore] = (0, $cozmU.useState)(false);
    const reportError = (0, $cozmU.useCallback)((err)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(err, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        (0, $7Sm4c.markErrorAsHandled)(err);
        createEvent((0, $48cafc2affcc1872$export$76206bc26a4d1ef)({
            errorType: $8a6630d12e0f6d27$var$classifyError(err)
        })).fire();
    }, [
        createEvent
    ]);
    const { data: data, loading: queryLoading, error: error, fetchMore: fetchMore } = (0, $jMyy4.useQueryInterop)($8a6630d12e0f6d27$var$IncomingLinksQuery, {
        variables: {
            cypherQuery: skip ? '' : $8a6630d12e0f6d27$var$buildIncomingLinksCypher($8a6630d12e0f6d27$var$buildConfluencePageAri(cloudId, contentId)),
            first: initialPageSize,
            after: null
        },
        skip: skip,
        interopApolloAggClient: true,
        // Keep partial data on GraphQL errors. Hydrating cross-activation 3P
        // entities can raise a per-node error ("Cross activation id requests are
        // not allowed") while still returning the rest of the rows; with the
        // default 'none' policy that partial data is discarded before it reaches
        // us. 'all' surfaces `data` alongside `error` so we can render what came
        // back (see the effect below), and `onError` still reports the error.
        errorPolicy: 'all',
        context: skip ? undefined : {
            headers: {
                'X-Query-Context': $8a6630d12e0f6d27$var$buildQueryContext(cloudId)
            }
        },
        onError: reportError,
        __callerPackage__: "byline-connections"
    });
    const { hasNextPage: hasNextPage, endCursor: endCursor } = $8a6630d12e0f6d27$var$readPageInfo(data);
    // Hydrate only the urls not seen before and append them in order. `knownUrlsRef`
    // is advanced only after a hydration commits, so a cancelled attempt (e.g.
    // StrictMode double-invoke) leaves those urls for the surviving attempt.
    const hydrateAndAppendPage = (0, $cozmU.useCallback)(async (urls, isCancelled)=>{
        const newUrls = urls.filter((url)=>!knownUrlsRef.current.has(url));
        if (newUrls.length === 0) return 0;
        const hydrated = await (0, $89f81df02d4c8ccc$export$4f12cb865d88dee)(newUrls, storeRef.current, connections.client);
        if (isCancelled()) return 0;
        newUrls.forEach((url)=>knownUrlsRef.current.add(url));
        setLinks((prev)=>[
                ...prev,
                // occurrenceIndex is the global position, preserving recency order across pages.
                ...hydrated.map((link, index)=>({
                        ...link,
                        occurrenceIndex: prev.length + index
                    }))
            ]);
        return hydrated.length;
    }, [
        connections.client
    ]);
    // Hydrate the initial page once the query settles. We deliberately do NOT gate on
    // `error`: with `errorPolicy: 'all'` a partial cross-activation error still returns
    // usable rows, and bailing here would drop them (see the query's `errorPolicy`
    // note) — error *reporting* stays in `onError`. `initialResolvedRef` stops
    // loadMore's merged-store updates from re-running this initial hydration.
    (0, $cozmU.useEffect)(()=>{
        if (skip || queryLoading || !data || initialResolvedRef.current) return;
        let cancelled = false;
        setResolving(true);
        // When the first graph page hydrates to 0 displayable links (common when
        // page-1 rows are uncatalogued or unresolvable), keep paging until we have
        // enough links to render the initial section or pagination is exhausted.
        const hydrateInitialPages = async ()=>{
            let resolvedCount = 0;
            let currentData = data;
            while(!cancelled){
                resolvedCount += await hydrateAndAppendPage((0, $ceb5f0113009896a$export$7d6dd950f56cfaae)(currentData), ()=>cancelled);
                const currentPageInfo = $8a6630d12e0f6d27$var$readPageInfo(currentData);
                if (cancelled || resolvedCount >= $8a6630d12e0f6d27$var$INITIAL_RESOLVED_LINK_TARGET) break;
                if (!currentPageInfo.hasNextPage || !currentPageInfo.endCursor) break;
                const nextPageResult = await fetchMore({
                    variables: {
                        first: loadMorePageSize,
                        after: currentPageInfo.endCursor
                    },
                    updateQuery: (previousResult, { fetchMoreResult: fetchMoreResult })=>$8a6630d12e0f6d27$var$appendNextPage(previousResult, fetchMoreResult)
                });
                currentData = nextPageResult.data;
            }
            return resolvedCount;
        };
        hydrateInitialPages().then((count)=>{
            if (cancelled) return;
            initialResolvedRef.current = true;
            setInitialResolved(true);
            setResolving(false);
            if (!hasFiredRef.current) {
                hasFiredRef.current = true;
                createEvent((0, $48cafc2affcc1872$export$f7e6e403c5c87e79)({
                    count: count
                })).fire();
            }
        }).catch(()=>{
            // hydrateIncomingLinks/resolveSmartLinkByUrl swallow and report per-url
            // failures themselves; this guards against an unexpected rejection
            // leaving `resolving` stuck. Mark the initial attempt resolved (even though it
            // failed) so the `initialResolutionPending` loading window closes and the effect
            // does not retry.
            if (!cancelled) {
                initialResolvedRef.current = true;
                setInitialResolved(true);
                setResolving(false);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        skip,
        queryLoading,
        data,
        loadMorePageSize,
        fetchMore,
        hydrateAndAppendPage,
        createEvent
    ]);
    const loadMore = (0, $cozmU.useCallback)(()=>{
        // `initialResolvedRef` gates against a click landing before the first page's
        // urls are committed to `knownUrlsRef`, which would re-resolve page 1 and
        // duplicate its links.
        if (skip || loadingMore || !hasNextPage || !endCursor || !initialResolvedRef.current) return;
        setLoadingMore(true);
        fetchMore({
            variables: {
                first: loadMorePageSize,
                after: endCursor
            },
            updateQuery: (previousResult, { fetchMoreResult: fetchMoreResult })=>$8a6630d12e0f6d27$var$appendNextPage(previousResult, fetchMoreResult)
        }).then((result)=>hydrateAndAppendPage((0, $ceb5f0113009896a$export$7d6dd950f56cfaae)(result.data), ()=>false).then((count)=>{
                createEvent((0, $48cafc2affcc1872$export$974f529324b8e135)({
                    count: count
                })).fire();
            }))// fetchMore errors surface via the query `onError`; just release the flag.
        .catch(()=>{}).finally(()=>setLoadingMore(false));
    }, [
        skip,
        loadingMore,
        hasNextPage,
        endCursor,
        loadMorePageSize,
        fetchMore,
        hydrateAndAppendPage,
        createEvent
    ]);
    // Stay `loading` from query start through the first hydration commit. `queryLoading || resolving`
    // alone leaves a gap: after the query settles (`queryLoading` → false) but before the hydration
    // effect sets `resolving`, one render commits with `loading` false and `links` still empty. An
    // inbound-only byline returns `null` on that render, so it flashes out and back in before the
    // resolved trigger appears. Deriving the pending window from `data`/`initialResolved` (both
    // available during render, no effect latency) closes the gap. CCINT-8932
    // Keep completion in state as well as the guard ref: an empty/cached page can resolve before
    // React commits `resolving: true`, and automatic batching can otherwise collapse the true/false
    // updates without producing the render that observes the updated ref. CCINT-9096
    const initialResolutionPending = !skip && data != null && !initialResolved;
    return {
        links: links,
        loading: queryLoading || resolving || initialResolutionPending,
        loadingMore: loadingMore,
        hasNextPage: hasNextPage,
        endCursor: endCursor,
        loadMore: loadMore,
        error: error
    };
};


/**
 * @generated SignedSource<<aa5670f3957718d3a14deb92bcb7c7d3>>
 * @relayHash 59c372d91928cd50e803ef9956058e6c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1486fef19505802172befeeac18b16919fcffd407a15fbbd43471b585f180656
const $abef7549b9813037$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cypherQuery"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryContext"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "version"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "cypherQuery"
        },
        {
            "kind": "Variable",
            "name": "queryContext",
            "variableName": "queryContext"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "version"
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "base"
        },
        {
            "kind": "ScalarField",
            "name": "webUi"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceBlogPost_links",
                "concreteType": "ConfluenceBlogPostLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceBlogPost"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceDatabase_links",
                "concreteType": "ConfluenceDatabaseLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceDatabase"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceEmbed_links",
                "concreteType": "ConfluenceEmbedLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceEmbed"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceFolder_links",
                "concreteType": "ConfluenceFolderLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceFolder"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceFooterComment_links",
                "concreteType": "ConfluenceCommentLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceFooterComment"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceInlineComment_links",
                "concreteType": "ConfluenceCommentLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceInlineComment"
    }, v13 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluencePage_links",
                "concreteType": "ConfluencePageLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluencePage"
    }, v14 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceSlide_links",
                "concreteType": "ConfluenceSlideLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceSlide"
    }, v15 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceSpace_links",
                "concreteType": "ConfluenceSpaceLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceSpace"
    }, v16 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ConfluenceWhiteboard_links",
                "concreteType": "ConfluenceWhiteboardLinks",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": v6 /*: any*/ 
            }
        ],
        "type": "ConfluenceWhiteboard"
    }, v17 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "JiraIssue_webUrl",
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraIssue"
    }, v18 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "JiraPlatformComment_webUrl",
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraPlatformComment"
    }, v19 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "JiraProject_webUrl",
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraProject"
    }, v20 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "JiraServiceManagementComment_webUrl",
                "kind": "ScalarField",
                "name": "webUrl"
            }
        ],
        "type": "JiraServiceManagementComment"
    }, v21 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareComment_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareComment"
    }, v22 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareGoal_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareGoal"
    }, v23 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareGoalUpdate_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareGoalUpdate"
    }, v24 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareProject_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareProject"
    }, v25 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "TownsquareProjectUpdate_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "TownsquareProjectUpdate"
    }, v26 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "LoomComment_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "LoomComment"
    }, v27 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "LoomSpace_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "LoomSpace"
    }, v28 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "LoomVideo_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "LoomVideo"
    }, v29 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "MercuryAsk_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "MercuryAsk"
    }, v30 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "MercuryFocusArea_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "MercuryFocusArea"
    }, v31 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "BitbucketRepository_href",
                "kind": "ScalarField",
                "name": "href"
            }
        ],
        "type": "BitbucketRepository"
    }, v32 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "DeploymentSummary_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "DeploymentSummary"
    }, v33 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "DevOpsDesign_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "DevOpsDesign"
    }, v34 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "DevOpsDocument_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "DevOpsDocument"
    }, v35 = {
        "alias": "DevOpsOperationsIncidentDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v36 = {
        "alias": "DevOpsOperationsPostIncidentReviewDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v37 = {
        "alias": "DevOpsProjectDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v38 = {
        "alias": "DevOpsPullRequestDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v39 = {
        "alias": "DevOpsRepository_url",
        "kind": "ScalarField",
        "name": "url"
    }, v40 = {
        "alias": "DevOpsSecurityVulnerabilityDetails_url",
        "kind": "ScalarField",
        "name": "url"
    }, v41 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "CompassComponent_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "CompassComponent"
    }, v42 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalBranch_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalBranch"
    }, v43 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalBuildInfo_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalBuildInfo"
    }, v44 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalCalendarEvent_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalCalendarEvent"
    }, v45 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalComment_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalComment"
    }, v46 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalCommit_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalCommit"
    }, v47 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalConversation_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalConversation"
    }, v48 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDashboard_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDashboard"
    }, v49 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDataTable_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDataTable"
    }, v50 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDeal_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDeal"
    }, v51 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDeployment_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDeployment"
    }, v52 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDesign_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDesign"
    }, v53 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalDocument_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalDocument"
    }, v54 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalMessage_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalMessage"
    }, v55 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalPullRequest_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalPullRequest"
    }, v56 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalRemoteLink_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalRemoteLink"
    }, v57 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalRepository_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalRepository"
    }, v58 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalSoftwareService_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalSoftwareService"
    }, v59 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalSpace_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalSpace"
    }, v60 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalTest_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalTest"
    }, v61 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalVideo_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalVideo"
    }, v62 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalVulnerability_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalVulnerability"
    }, v63 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "ExternalWorkItem_url",
                "kind": "ScalarField",
                "name": "url"
            }
        ],
        "type": "ExternalWorkItem"
    }, v64 = {
        "kind": "ScalarField",
        "name": "id"
    }, v65 = [
        v64 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "useRelatedContentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v35 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v36 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v37 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v38 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v39 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v40 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        v41 /*: any*/ ,
                                                                        v42 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        v46 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v51 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v54 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        v58 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v63 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "useRelatedContentQuery",
            "selections": [
                {
                    "args": v4 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v5 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v5 /*: any*/ ,
                                                                        {
                                                                            "kind": "TypeDiscriminator",
                                                                            "abstractKey": "__isGraphStoreCypherQueryV2AriNodeUnion"
                                                                        },
                                                                        v7 /*: any*/ ,
                                                                        v8 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        v11 /*: any*/ ,
                                                                        v12 /*: any*/ ,
                                                                        v13 /*: any*/ ,
                                                                        v14 /*: any*/ ,
                                                                        v15 /*: any*/ ,
                                                                        v16 /*: any*/ ,
                                                                        v17 /*: any*/ ,
                                                                        v18 /*: any*/ ,
                                                                        v19 /*: any*/ ,
                                                                        v20 /*: any*/ ,
                                                                        v21 /*: any*/ ,
                                                                        v22 /*: any*/ ,
                                                                        v23 /*: any*/ ,
                                                                        v24 /*: any*/ ,
                                                                        v25 /*: any*/ ,
                                                                        v26 /*: any*/ ,
                                                                        v27 /*: any*/ ,
                                                                        v28 /*: any*/ ,
                                                                        v29 /*: any*/ ,
                                                                        v30 /*: any*/ ,
                                                                        v31 /*: any*/ ,
                                                                        v32 /*: any*/ ,
                                                                        v33 /*: any*/ ,
                                                                        v34 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v35 /*: any*/ ,
                                                                                v64 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v36 /*: any*/ ,
                                                                                v64 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v37 /*: any*/ ,
                                                                                v64 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                v64 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v39 /*: any*/ ,
                                                                                v64 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v40 /*: any*/ ,
                                                                                v64 /*: any*/ 
                                                                            ],
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        v41 /*: any*/ ,
                                                                        v42 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        v44 /*: any*/ ,
                                                                        v45 /*: any*/ ,
                                                                        v46 /*: any*/ ,
                                                                        v47 /*: any*/ ,
                                                                        v48 /*: any*/ ,
                                                                        v49 /*: any*/ ,
                                                                        v50 /*: any*/ ,
                                                                        v51 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v53 /*: any*/ ,
                                                                        v54 /*: any*/ ,
                                                                        v55 /*: any*/ ,
                                                                        v56 /*: any*/ ,
                                                                        v57 /*: any*/ ,
                                                                        v58 /*: any*/ ,
                                                                        v59 /*: any*/ ,
                                                                        v60 /*: any*/ ,
                                                                        v61 /*: any*/ ,
                                                                        v62 /*: any*/ ,
                                                                        v63 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "AtlassianAccountUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "CustomerUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "TeamCustomFieldValue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "TeamType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v65 /*: any*/ ,
                                                                            "type": "ThirdPartyUser"
                                                                        }
                                                                    ]
                                                                },
                                                                v64 /*: any*/ 
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "59c372d91928cd50e803ef9956058e6c",
            "id": "1486fef19505802172befeeac18b16919fcffd407a15fbbd43471b585f180656",
            "metadata": {},
            "name": "useRelatedContentQuery",
            "operationKind": "query",
            "text": "query useRelatedContentQuery($cypherQuery:String!,$queryContext:String!,$version:GraphStoreCypherQueryV2VersionEnum,$first:Int!){graphStore_cypherQueryV2(query:$cypherQuery,queryContext:$queryContext,version:$version,first:$first)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{value{__typename,...on GraphStoreCypherQueryV2AriNode{data{__typename,__isGraphStoreCypherQueryV2AriNodeUnion:__typename,...on ConfluenceBlogPost{ConfluenceBlogPost_links:links{base,webUi}},...on ConfluenceDatabase{ConfluenceDatabase_links:links{base,webUi}},...on ConfluenceEmbed{ConfluenceEmbed_links:links{base,webUi}},...on ConfluenceFolder{ConfluenceFolder_links:links{base,webUi}},...on ConfluenceFooterComment{ConfluenceFooterComment_links:links{base,webUi}},...on ConfluenceInlineComment{ConfluenceInlineComment_links:links{base,webUi}},...on ConfluencePage{ConfluencePage_links:links{base,webUi}},...on ConfluenceSlide{ConfluenceSlide_links:links{base,webUi}},...on ConfluenceSpace{ConfluenceSpace_links:links{base,webUi}},...on ConfluenceWhiteboard{ConfluenceWhiteboard_links:links{base,webUi}},...on JiraIssue{JiraIssue_webUrl:webUrl},...on JiraPlatformComment{JiraPlatformComment_webUrl:webUrl},...on JiraProject{JiraProject_webUrl:webUrl},...on JiraServiceManagementComment{JiraServiceManagementComment_webUrl:webUrl},...on TownsquareComment{TownsquareComment_url:url},...on TownsquareGoal{TownsquareGoal_url:url},...on TownsquareGoalUpdate{TownsquareGoalUpdate_url:url},...on TownsquareProject{TownsquareProject_url:url},...on TownsquareProjectUpdate{TownsquareProjectUpdate_url:url},...on LoomComment{LoomComment_url:url},...on LoomSpace{LoomSpace_url:url},...on LoomVideo{LoomVideo_url:url},...on MercuryAsk{MercuryAsk_url:url},...on MercuryFocusArea{MercuryFocusArea_url:url},...on BitbucketRepository{BitbucketRepository_href:href},...on DeploymentSummary{DeploymentSummary_url:url},...on DevOpsDesign{DevOpsDesign_url:url},...on DevOpsDocument{DevOpsDocument_url:url},...on DevOpsOperationsIncidentDetails{DevOpsOperationsIncidentDetails_url:url,id},...on DevOpsOperationsPostIncidentReviewDetails{DevOpsOperationsPostIncidentReviewDetails_url:url,id},...on DevOpsProjectDetails{DevOpsProjectDetails_url:url,id},...on DevOpsPullRequestDetails{DevOpsPullRequestDetails_url:url,id},...on DevOpsRepository{DevOpsRepository_url:url,id},...on DevOpsSecurityVulnerabilityDetails{DevOpsSecurityVulnerabilityDetails_url:url,id},...on CompassComponent{CompassComponent_url:url},...on ExternalBranch{ExternalBranch_url:url},...on ExternalBuildInfo{ExternalBuildInfo_url:url},...on ExternalCalendarEvent{ExternalCalendarEvent_url:url},...on ExternalComment{ExternalComment_url:url},...on ExternalCommit{ExternalCommit_url:url},...on ExternalConversation{ExternalConversation_url:url},...on ExternalDashboard{ExternalDashboard_url:url},...on ExternalDataTable{ExternalDataTable_url:url},...on ExternalDeal{ExternalDeal_url:url},...on ExternalDeployment{ExternalDeployment_url:url},...on ExternalDesign{ExternalDesign_url:url},...on ExternalDocument{ExternalDocument_url:url},...on ExternalMessage{ExternalMessage_url:url},...on ExternalPullRequest{ExternalPullRequest_url:url},...on ExternalRemoteLink{ExternalRemoteLink_url:url},...on ExternalRepository{ExternalRepository_url:url},...on ExternalSoftwareService{ExternalSoftwareService_url:url},...on ExternalSpace{ExternalSpace_url:url},...on ExternalTest{ExternalTest_url:url},...on ExternalVideo{ExternalVideo_url:url},...on ExternalVulnerability{ExternalVulnerability_url:url},...on ExternalWorkItem{ExternalWorkItem_url:url},...on Node{__isNode:__typename,id},...on AppUser{id},...on AtlassianAccountUser{id},...on CustomerUser{id},...on DevOpsFeatureFlag{id},...on DevOpsOperationsComponentDetails{id},...on JiraAutodevJob{id},...on JiraConfluenceRemoteIssueLink{id},...on JiraCustomRemoteIssueLink{id},...on JiraIssueRemoteIssueLink{id},...on JiraWebRemoteIssueLink{id},...on TeamCustomFieldValue{id},...on TeamType{id},...on ThirdPartyUser{id}},id}}}}}}}"
        }
    };
}();
$abef7549b9813037$var$node.hash = "011163ebc71d122de750de5a410667e4";
var $abef7549b9813037$export$2e2bcd8739ae039 = $abef7549b9813037$var$node;











var $5Wig1 = parcelRequire("5Wig1");
























/**
 * The Teamwork Graph edges "Related content" is read over, from the page to the entity the graph
 * infers as related. The first-party edge targets Confluence content; the second targets
 * third-party entities such as Google Drive files and Figma designs.
 */ const $1736f7a9f3d6c286$var$RELATED_CONTENT_RELATIONSHIPS = [
    'confluence_content_has_related_confluence_content',
    'confluence_content_has_related_entity'
];
const $1736f7a9f3d6c286$var$MAX_RELATED_CONTENT_PER_RELATIONSHIP = 6;
const $1736f7a9f3d6c286$export$55aac79ee103d4c5 = $1736f7a9f3d6c286$var$MAX_RELATED_CONTENT_PER_RELATIONSHIP * $1736f7a9f3d6c286$var$RELATED_CONTENT_RELATIONSHIPS.length;
const $1736f7a9f3d6c286$export$264f5646b95aac63 = (pageAri)=>$1736f7a9f3d6c286$var$RELATED_CONTENT_RELATIONSHIPS.map((relationship)=>[
            `MATCH (page {ari: "${pageAri}"})-[:${relationship}]->(entity)`,
            'RETURN DISTINCT entity AS relatedContent',
            `LIMIT ${$1736f7a9f3d6c286$var$MAX_RELATED_CONTENT_PER_RELATIONSHIP}`
        ].join('\n')).join('\nUNION ALL\n');


const $632b20f216f6f413$var$recencyTimestamp = (link)=>{
    const raw = link.updatedAt ?? link.createdAt;
    if (!raw) return Number.NEGATIVE_INFINITY;
    const time = Date.parse(raw);
    return Number.isNaN(time) ? Number.NEGATIVE_INFINITY : time;
};
const $632b20f216f6f413$export$39c6ffa318fec2a1 = (links)=>[
        ...links
    ].sort((left, right)=>$632b20f216f6f413$var$recencyTimestamp(right) - $632b20f216f6f413$var$recencyTimestamp(left));





const $fd09cd053ed09fc1$export$cabc6f3cbae372ae = ()=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'requested',
            actionSubject: (0, $I7TEB.RELATED_CONTENT_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE)
        }
    });
const $fd09cd053ed09fc1$export$a1bd93651ef6059c = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: (0, $I7TEB.RELATED_CONTENT_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE),
            attributes: attributes
        }
    });
const $fd09cd053ed09fc1$export$9b59566ec381a62 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: (0, $I7TEB.RELATED_CONTENT_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE),
            attributes: attributes
        }
    });


const $8d208cf49c8d5b5a$var$classifyError = (error)=>!error.networkError && error.graphQLErrors?.length ? 'graphql' : 'network';
const $8d208cf49c8d5b5a$var$RelatedContentQuery = (0, $abef7549b9813037$export$2e2bcd8739ae039);
const $8d208cf49c8d5b5a$export$e0a19cb5df8c4186 = (contentId, options)=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    const { connections: connections, store: store } = (0, $bI14T.useSmartLinkContext)();
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const hasRequestedRef = (0, $cozmU.useRef)(false);
    const hasSucceededRef = (0, $cozmU.useRef)(false);
    const hasReportedErrorRef = (0, $cozmU.useRef)(false);
    const skip = options?.enabled === false || !contentId || !cloudId || !activationId || !(0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment');
    const [links, setLinks] = (0, $cozmU.useState)([]);
    const [resolving, setResolving] = (0, $cozmU.useState)(false);
    const resolvedDataRef = (0, $cozmU.useRef)(undefined);
    const storeRef = (0, $cozmU.useRef)(store);
    (0, $cozmU.useEffect)(()=>{
        storeRef.current = store;
    }, [
        store
    ]);
    const reportError = (0, $cozmU.useCallback)((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        createEvent((0, $fd09cd053ed09fc1$export$9b59566ec381a62)({
            errorType: $8d208cf49c8d5b5a$var$classifyError(error)
        })).fire();
    }, [
        createEvent
    ]);
    // `skip` gates the query, so its first `false` is the moment the fetch fires.
    (0, $cozmU.useEffect)(()=>{
        if (skip || hasRequestedRef.current) return;
        hasRequestedRef.current = true;
        createEvent((0, $fd09cd053ed09fc1$export$cabc6f3cbae372ae)()).fire();
    }, [
        skip,
        createEvent
    ]);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($8d208cf49c8d5b5a$var$RelatedContentQuery, {
        variables: {
            cypherQuery: skip ? '' : (0, $1736f7a9f3d6c286$export$264f5646b95aac63)((0, $6B1vK.ConfluencePageAri).create({
                siteId: cloudId,
                pageId: contentId
            }).toString()),
            queryContext: skip ? '' : (0, $5Wig1.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            version: 'V3',
            first: (0, $1736f7a9f3d6c286$export$55aac79ee103d4c5)
        },
        skip: skip,
        interopApolloAggClient: true,
        errorPolicy: 'all',
        __callerPackage__: "byline-connections"
    });
    // Report from the returned `error`, not the query's `onError`. Under `errorPolicy: 'all'`
    // the Apollo route delivers GraphQL errors as `{ data, error }` and never calls `onError`
    // (it only fires for network errors), so a GraphQL failure would otherwise go unreported.
    // Driving off `error` covers both network and GraphQL errors on either route. Fired once;
    // the ref resets when `error` clears so a later refetch can report again.
    (0, $cozmU.useEffect)(()=>{
        if (!error) {
            hasReportedErrorRef.current = false;
            return;
        }
        if (hasReportedErrorRef.current) return;
        hasReportedErrorRef.current = true;
        reportError(error);
    }, [
        error,
        reportError
    ]);
    const urls = (0, $cozmU.useMemo)(()=>(0, $ceb5f0113009896a$export$7d6dd950f56cfaae)(data), [
        data
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (skip || loading || !data) {
            resolvedDataRef.current = undefined;
            setLinks([]);
            setResolving(false);
            return;
        }
        let cancelled = false;
        setResolving(true);
        (0, $89f81df02d4c8ccc$export$4f12cb865d88dee)(urls, storeRef.current, connections.client).then((resolvedLinks)=>{
            if (!cancelled) {
                resolvedDataRef.current = data;
                setLinks((0, $632b20f216f6f413$export$39c6ffa318fec2a1)(resolvedLinks));
                setResolving(false);
                if (!hasSucceededRef.current && !error) {
                    hasSucceededRef.current = true;
                    createEvent((0, $fd09cd053ed09fc1$export$a1bd93651ef6059c)({
                        resolvedCount: resolvedLinks.length,
                        totalCount: data.graphStore_cypherQueryV2?.edges?.length ?? 0
                    })).fire();
                }
            }
        }).catch((error)=>{
            // Per-URL resolution reports expected ORS failures. This only prevents an
            // unexpected rejection from leaving the hook in a loading state.
            if (!cancelled) {
                (0, $5ZqQS.getMonitoringClient)().submitError(error instanceof Error ? error : new Error(String(error)), {
                    attribution: (0, $3IBnw.Attribution).INTEGRATIONS
                });
                resolvedDataRef.current = data;
                setLinks([]);
                setResolving(false);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        connections.client,
        createEvent,
        data,
        error,
        loading,
        skip,
        urls
    ]);
    const resolutionPending = !skip && data != null && resolvedDataRef.current !== data;
    return {
        enabled: !skip,
        links: links,
        loading: loading || resolving || resolutionPending,
        error: error
    };
};





















var $5J49L = parcelRequire("5J49L");


var $de2j9 = parcelRequire("de2j9");


var $grd6j = parcelRequire("grd6j");

const $ab91ec1e712ab335$var$EMPTY_DOCUMENT = {
    adf: null,
    contentId: undefined
};
function $ab91ec1e712ab335$export$3b493f85f069c3ed(contentId) {
    const isEditorPage = (0, $de2j9.useIsEditorPage)();
    const editorDocument = (0, $5J49L.usePageAdf)(isEditorPage ? contentId : undefined);
    const data = (0, $6SsN4.useLazyLoadQuery)((0, $grd6j.default), {
        contentId: isEditorPage ? null : contentId ?? null
    }, {
        fetchPolicy: 'store-only'
    });
    const content = data?.content?.nodes?.find((node)=>node?.id === contentId);
    const body = content?.body?.dynamic;
    const queryAdf = (0, $cozmU.useMemo)(()=>{
        if (body?.representation !== 'atlas_doc_format' || !body.value) return null;
        try {
            const doc = JSON.parse(body.value);
            return doc?.type === 'doc' && doc.version === 1 && Array.isArray(doc.content) ? doc : null;
        } catch  {
            return null;
        }
    }, [
        body?.representation,
        body?.value
    ]);
    if (isEditorPage) return editorDocument;
    return queryAdf ? {
        adf: queryAdf,
        contentId: contentId
    } : $ab91ec1e712ab335$var$EMPTY_DOCUMENT;
}



var $bnSPF = parcelRequire("bnSPF");


const $316ae114bb16e7af$var$getDraftSmartCardsFromWindow = ()=>{
    const draftCards = globalThis.__SMART_CARDS_IN_DRAFT__;
    return Array.isArray(draftCards) ? draftCards : [];
};
const $316ae114bb16e7af$var$getDraftSmartLinkPositions = (smartCardsInDraft)=>{
    const seen = new Set();
    const positions = [];
    let counter = 0;
    for (const card of smartCardsInDraft){
        const type = card?.type;
        const url = card?.attrs?.url;
        const isSmartCardType = type === 'inlineCard' || type === 'blockCard' || type === 'embedCard';
        if (!isSmartCardType || typeof url !== 'string' || url.length === 0 || seen.has(url)) continue;
        seen.add(url);
        positions.push({
            url: url,
            occurrenceIndex: counter++
        });
    }
    return positions;
};
async function $316ae114bb16e7af$export$4d683cb1a551a6b2(adf, store, cardClient) {
    const adfPositions = (0, $bnSPF.extractSmartLinksFromAdf)(adf, true);
    // The page ADF document is authoritative for the current page once it is available.
    // Only bridge with the draft snapshot (`__SMART_CARDS_IN_DRAFT__`) while the document is
    // not yet available (`adf == null`); otherwise a brand-new/empty page would surface the
    // previous page's stale draft smart cards, since that window global persists across
    // client-side navigation and is not reset when creating a new page.
    const smartCardsInDraft = $316ae114bb16e7af$var$getDraftSmartCardsFromWindow();
    const draftPositions = $316ae114bb16e7af$var$getDraftSmartLinkPositions(smartCardsInDraft);
    const positions = adf ? adfPositions : draftPositions;
    if (positions.length === 0) return [];
    return Promise.all(positions.map(async ({ url: url, occurrenceIndex: occurrenceIndex })=>{
        const { link: link } = await (0, $7e1486aa62dbf166$export$ab14756fcd367a5)(url, occurrenceIndex, store, cardClient);
        return link;
    }));
}




const $20238d45d0fd30b1$var$ADF_WAIT_TIMEOUT_MS = 10000;
const $20238d45d0fd30b1$var$reportSmartLinkError = (err)=>{
    const errorObj = err instanceof Error ? err : new Error(String(err));
    (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
    return errorObj;
};
const $20238d45d0fd30b1$var$mergeRefreshedSmartLink = (link, response)=>{
    const refreshedLink = (0, $78ed55159915b828$export$9ebf81041d234ef6)(link.url, link.occurrenceIndex, response);
    return {
        ...refreshedLink,
        iconUrl: refreshedLink.iconUrl ?? link.iconUrl,
        product: link.product ?? refreshedLink.product,
        subproduct: link.subproduct ?? refreshedLink.subproduct
    };
};
function $20238d45d0fd30b1$export$379fef9d512fc4aa(contentId) {
    const document = (0, $ab91ec1e712ab335$export$3b493f85f069c3ed)(contentId);
    const adf = document.contentId === contentId ? document.adf : null;
    const { connections: connections, store: store } = (0, $bI14T.useSmartLinkContext)();
    const [result, setResult] = (0, $cozmU.useState)({
        contentId: contentId,
        links: [],
        adf: null,
        loading: true,
        refreshing: false,
        hasResolved: false,
        error: null
    });
    const linksRef = (0, $cozmU.useRef)([]);
    const currentContentId = (0, $cozmU.useRef)(contentId);
    currentContentId.current = contentId;
    const storeRef = (0, $cozmU.useRef)(store);
    (0, $cozmU.useEffect)(()=>{
        storeRef.current = store;
    }, [
        store
    ]);
    (0, $cozmU.useEffect)(()=>{
        linksRef.current = [];
    }, [
        contentId
    ]);
    (0, $cozmU.useEffect)(()=>{
        let cancelled = false;
        setResult((previous)=>{
            const samePage = previous.contentId === contentId;
            return {
                contentId: contentId,
                links: samePage ? previous.links : [],
                adf: samePage ? previous.adf : null,
                hasResolved: samePage && previous.hasResolved,
                loading: !samePage || !previous.hasResolved,
                refreshing: true,
                error: null
            };
        });
        if (!adf) {
            const timeout = setTimeout(()=>{
                setResult((previous)=>({
                        ...previous,
                        loading: false,
                        refreshing: false
                    }));
            }, $20238d45d0fd30b1$var$ADF_WAIT_TIMEOUT_MS);
            return ()=>clearTimeout(timeout);
        }
        (0, $316ae114bb16e7af$export$4d683cb1a551a6b2)(adf, storeRef.current, connections.client).then((links)=>{
            if (cancelled) return;
            linksRef.current = links;
            setResult({
                contentId: contentId,
                links: links,
                adf: adf,
                loading: false,
                refreshing: false,
                hasResolved: true,
                error: null
            });
        }).catch((err)=>{
            if (cancelled) return;
            const error = $20238d45d0fd30b1$var$reportSmartLinkError(err);
            setResult((previous)=>({
                    ...previous,
                    loading: false,
                    refreshing: false,
                    error: error
                }));
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        adf,
        contentId,
        connections.client
    ]);
    const refreshLinkUrl = (0, $cozmU.useCallback)(async (item)=>{
        const productLabel = (0, $7d8abc6089406daa$export$d5a13f0f4d135b4b)(item);
        const productLinks = [];
        for (const link of linksRef.current){
            const isSameProduct = (0, $7d8abc6089406daa$export$d5a13f0f4d135b4b)(link) === productLabel;
            if (isSameProduct) productLinks.push(link);
        }
        const urlsToRefresh = [];
        const seenUrls = new Set();
        for (const link of productLinks)if (!seenUrls.has(link.url)) {
            seenUrls.add(link.url);
            urlsToRefresh.push(link.url);
        }
        const refreshedDataByUrl = new Map();
        await Promise.all(urlsToRefresh.map(async (url)=>{
            try {
                const response = await connections.client.fetchData(url, true);
                refreshedDataByUrl.set(url, response);
            } catch (err) {
                $20238d45d0fd30b1$var$reportSmartLinkError(err);
            }
        }));
        if (currentContentId.current !== contentId || refreshedDataByUrl.size === 0) return undefined;
        let refreshedMatchingItem;
        const refreshedLinks = linksRef.current.map((link)=>{
            if ((0, $7d8abc6089406daa$export$d5a13f0f4d135b4b)(link) !== productLabel) return link;
            const response = refreshedDataByUrl.get(link.url);
            if (!response) return link;
            const refreshedLink = $20238d45d0fd30b1$var$mergeRefreshedSmartLink(link, response);
            if (link.url === item.url && link.occurrenceIndex === item.occurrenceIndex) refreshedMatchingItem = refreshedLink;
            return refreshedLink;
        });
        linksRef.current = refreshedLinks;
        setResult((previous)=>({
                ...previous,
                links: refreshedLinks
            }));
        return refreshedMatchingItem;
    }, [
        connections.client,
        contentId
    ]);
    const links = (0, $cozmU.useMemo)(()=>result.contentId === contentId ? result.links : [], [
        result.contentId,
        result.links,
        contentId
    ]);
    const groups = (0, $cozmU.useMemo)(()=>(0, $7d8abc6089406daa$export$e6dd401ecbdb01d)(links), [
        links
    ]);
    const samePage = result.contentId === contentId;
    return {
        groups: groups,
        links: links,
        collectedForContentId: samePage && result.hasResolved ? contentId : undefined,
        collectedAdf: samePage ? result.adf : null,
        loading: !samePage || result.loading,
        refreshing: !samePage || result.refreshing,
        error: samePage ? result.error : null,
        refreshLinkUrl: refreshLinkUrl
    };
}


const $14b4659b7aaed708$export$bb74724ea117ee6f = ({ atAGlanceEnabled: atAGlanceEnabled, contentId: contentId, connectionAncestors: connectionAncestors, pageVersion: pageVersion, pageUpdatedAt: pageUpdatedAt, pageTitle: pageTitle })=>{
    const outgoing = (0, $20238d45d0fd30b1$export$379fef9d512fc4aa)(contentId);
    const { links: incomingLinks, loading: loading, loadingMore: loadingMore, hasNextPage: hasNextPage, endCursor: endCursor, loadMore: loadMore, error: error } = (0, $8a6630d12e0f6d27$export$4a27c1a938f63c6e)(contentId);
    // Keep bridge snapshots stable when unrelated byline or AI state changes.
    const incoming = (0, $cozmU.useMemo)(()=>({
            links: incomingLinks,
            loading: loading,
            loadingMore: loadingMore,
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            loadMore: loadMore,
            error: error
        }), [
        incomingLinks,
        loading,
        loadingMore,
        hasNextPage,
        endCursor,
        loadMore,
        error
    ]);
    const { enabled: enabled, links: relatedLinks, loading: relatedLoading, error: relatedError } = (0, $8d208cf49c8d5b5a$export$e0a19cb5df8c4186)(contentId);
    const relatedContent = (0, $cozmU.useMemo)(()=>({
            enabled: enabled,
            links: relatedLinks,
            loading: relatedLoading,
            error: relatedError
        }), [
        enabled,
        relatedLinks,
        relatedLoading,
        relatedError
    ]);
    const devDocsConnection = (0, $fZLJ8.useDevDocsBylineConnection)(connectionAncestors);
    const atAGlance = (0, $e2bf91e4975d6fca$export$72b2d05bd0aa0669)({
        enabled: atAGlanceEnabled,
        contentId: contentId,
        pageTitle: pageTitle,
        pageAdf: outgoing.collectedForContentId === contentId ? outgoing.collectedAdf : null,
        pageVersion: pageVersion,
        pageUpdatedAt: pageUpdatedAt,
        structuralAncestors: connectionAncestors,
        outgoingLinksLoading: outgoing.loading || outgoing.refreshing,
        // useAtAGlance also waits for incoming.loading via appearsIn. Related
        // content is sent when it is ready and does not block the first request.
        connections: {
            appearsIn: incoming,
            linksTo: {
                links: outgoing.links
            },
            relatedContent: relatedContent
        }
    });
    // The preview panel mounts outside this subtree and reads the bridge.
    // Publish links with their document snapshot to keep page transitions consistent.
    (0, $cozmU.useEffect)(()=>{
        (0, $Hnn0l.publishOutgoingLinks)({
            contentId: outgoing.collectedForContentId,
            pageAdf: outgoing.collectedAdf,
            pageVersion: outgoing.collectedForContentId === contentId ? pageVersion : undefined,
            pageUpdatedAt: outgoing.collectedForContentId === contentId ? pageUpdatedAt : undefined,
            structuralAncestors: outgoing.collectedForContentId === contentId ? connectionAncestors : undefined,
            outgoingLinks: outgoing.links,
            refreshLinkUrl: outgoing.refreshLinkUrl
        });
    }, [
        outgoing.collectedForContentId,
        connectionAncestors,
        contentId,
        outgoing.links,
        outgoing.collectedAdf,
        pageUpdatedAt,
        pageVersion,
        outgoing.refreshLinkUrl
    ]);
    // Separate from the publish effect so the store is only emptied when the
    // byline actually goes away, not on every republish.
    (0, $cozmU.useEffect)(()=>(0, $Hnn0l.clearOutgoingLinks), []);
    // Tagged with `contentId` rather than a collected-for id because
    // `connectionAncestors` arrives as a prop alongside it, so the two move together.
    (0, $cozmU.useEffect)(()=>{
        (0, $3b6532377f19c330$export$bef8e2d39680b9a8)({
            contentId: contentId,
            devDocsConnection: devDocsConnection
        });
    }, [
        contentId,
        devDocsConnection
    ]);
    (0, $cozmU.useEffect)(()=>(0, $3b6532377f19c330$export$962a90b3959f19a3), []);
    (0, $cozmU.useEffect)(()=>{
        (0, $21leH.publishIncomingLinks)({
            contentId: contentId,
            incomingLinks: incoming
        });
    }, [
        contentId,
        incoming
    ]);
    (0, $cozmU.useEffect)(()=>(0, $21leH.clearIncomingLinks), []);
    (0, $cozmU.useEffect)(()=>{
        (0, $4ao9J.publishRelatedContent)({
            contentId: contentId,
            relatedContent: relatedContent
        });
    }, [
        contentId,
        relatedContent
    ]);
    (0, $cozmU.useEffect)(()=>(0, $4ao9J.clearRelatedContent), []);
    (0, $cozmU.useEffect)(()=>{
        (0, $e881057e0de27ea9$export$d7ea14a22c3a1260)({
            contentId: contentId,
            atAGlance: atAGlance
        });
    }, [
        contentId,
        atAGlance
    ]);
    (0, $cozmU.useEffect)(()=>(0, $e881057e0de27ea9$export$932fff4b8bd41d62), []);
    return {
        outgoing: outgoing,
        incoming: incoming,
        relatedContent: relatedContent,
        devDocsConnection: devDocsConnection,
        atAGlance: atAGlance
    };
};









var $1kHsc = parcelRequire("1kHsc");


var $irVI7 = parcelRequire("irVI7");

const $460c5801038ac219$export$7705042750e63836 = (contentId, isResolving, hasConnection, error)=>{
    const tracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const activeLoad = (0, $cozmU.useRef)(undefined);
    // Match the page before using a clock retained from an earlier route.
    let pageExperience;
    for (const name of [
        (0, $irVI7.VIEW_PAGE_EXPERIENCE),
        (0, $irVI7.EDIT_PAGE_EXPERIENCE)
    ]){
        const state = tracker.getExperienceState(name);
        if (state && (state.taskId === contentId || state.attributes?.contentId === contentId) && (!pageExperience || state.startTime > pageExperience.startTime)) pageExperience = state;
    }
    const pageExperienceName = pageExperience?.name;
    const startTime = pageExperience?.startTime;
    const loadId = pageExperience ? `${contentId}:${pageExperience.name}:${pageExperience.startTime}` : undefined;
    (0, $cozmU.useEffect)(()=>{
        const name = (0, $irVI7.BYLINE_CONNECTIONS_LOAD_EXPERIENCE);
        activeLoad.current = loadId;
        if (!loadId || startTime === undefined) return;
        if (tracker.getExperienceState(name)?.taskId !== loadId) tracker.start({
            name: name,
            id: loadId,
            startTime: startTime,
            attributes: {
                pageExperience: pageExperienceName,
                errorAttribution: (0, $3IBnw.Attribution).INTEGRATIONS
            }
        });
        if (!isResolving) {
            if (error) tracker.stopOnError({
                name: name,
                error: error
            });
            else tracker.succeed({
                name: name,
                attributes: {
                    hasConnection: hasConnection
                }
            });
        }
        return ()=>{
            activeLoad.current = undefined;
            // Let StrictMode restore the effect before treating cleanup as navigation.
            Promise.resolve().then(()=>{
                const state = tracker.getExperienceState(name);
                if (activeLoad.current !== loadId && state?.taskId === loadId) tracker.abort({
                    name: name,
                    reason: 'Byline connections unmounted before resolution'
                });
            });
        };
    }, [
        error,
        tracker,
        hasConnection,
        isResolving,
        loadId,
        pageExperienceName,
        startTime
    ]);
};






var $87whh = parcelRequire("87whh");


var $lRhY3 = parcelRequire("lRhY3");




const $27c759556091eb4c$export$637980bdae204918 = {
    contentId: undefined,
    prompt: null
};
/**
 * Carries a prompt the preview panel should open its Rovo chat with, for callers outside the
 * panel's tree — today only the byline popup's share-context modal.
 *
 * A bridge rather than a prop because preview-panels treats a repeat `open()` with the same panel
 * id as a no-op, so the `content` closure can never be handed fresh props once the panel is open.
 * `useTeamworkGraphPreviewPanelMode` clears it on leaving Rovo and on unmount, so a later open
 * does not land back in a seeded chat.
 *
 * Only ever written from an event handler, so nothing publishes during SSR.
 */ const $27c759556091eb4c$var$bridge = (0, $jDHty.createPanelDataBridge)($27c759556091eb4c$export$637980bdae204918);
const $27c759556091eb4c$export$a0353d0d9eb2f715 = $27c759556091eb4c$var$bridge.publish;
const $27c759556091eb4c$export$7be1644a289b1480 = $27c759556091eb4c$var$bridge.clear;
const $27c759556091eb4c$export$c742177e1216e93c = $27c759556091eb4c$var$bridge.useValue;
const $27c759556091eb4c$export$d68d76e856dd0f94 = $27c759556091eb4c$var$bridge.clearForTesting;


const $5f7d816a14638938$export$ddbac920bdbdb256 = 'confluencePreviewPanel';
const $5f7d816a14638938$export$e8a5079e96625ede = 'confluence-teamworkGraph';
const $5f7d816a14638938$export$f6fc4a5779d5dc2c = 'confluence';
const $5f7d816a14638938$export$e043f5004f4e5a4 = 'teamwork-graph-preview-panel';


/* TeamworkGraphPreviewPanel.tsx generated by @compiled/babel-plugin v3.0.2 */ 








var $5WTxQ = parcelRequire("5WTxQ");


var $kMhHg = parcelRequire("kMhHg");


var $fE1YT = parcelRequire("fE1YT");





















var $6Cgm9 = parcelRequire("6Cgm9");


var $3u0dr = parcelRequire("3u0dr");











var $euL71 = parcelRequire("euL71");





var $kwDQA = parcelRequire("kwDQA");


var $kaFRI = parcelRequire("kaFRI");


var $1MB8j = parcelRequire("1MB8j");

const $df93accb317ff293$export$de2d69f0cd77adf5 = (0, $3u0dr.isReactCompilerActiveV2)() ? (contentId, t0)=>{
    const $ = (0, $bDgLe.c)(14);
    const skip = t0 === undefined ? false : t0;
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const isPrivacyModeEligible = (0, $1MB8j.useIsPrivacyModeEligible)();
    const enabled = !skip && !!contentId && !!cloudId && edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    let t1;
    if ($[0] !== cloudId || $[1] !== contentId || $[2] !== enabled || $[3] !== environment || $[4] !== isPrivacyModeEligible) {
        t1 = {
            contentId: contentId,
            cloudId: cloudId,
            enabled: enabled,
            isPrivacyModeEligible: isPrivacyModeEligible,
            environment: environment
        };
        $[0] = cloudId;
        $[1] = contentId;
        $[2] = enabled;
        $[3] = environment;
        $[4] = isPrivacyModeEligible;
        $[5] = t1;
    } else t1 = $[5];
    const request = t1;
    const [result, setResult] = (0, $cozmU.useState)();
    let t2;
    let t3;
    if ($[6] !== request) {
        t2 = ()=>{
            if (!request.enabled) return;
            let permission;
            let privacy;
            let error;
            const publish = ()=>{
                const isPrivacyModeEnabled = request.isPrivacyModeEligible && privacy?.privacyMode?.isPrivacyModeEnabled !== false;
                const loading = !error && (!permission || request.isPrivacyModeEligible && !privacy);
                setResult({
                    request: request,
                    access: {
                        canView: !loading && !error && !isPrivacyModeEnabled && permission?.user?.confluence?.permissionType === "INTERNAL",
                        isPrivacyModeEnabled: isPrivacyModeEnabled,
                        loading: loading,
                        error: error
                    }
                });
            };
            const onError = (queryError)=>{
                error = queryError;
                publish();
            };
            const permissionSubscription = (0, $6SsN4.fetchQuery)(request.environment, (0, $kwDQA.default), {
                contentId: request.contentId
            }, {
                fetchPolicy: "store-or-network"
            }).subscribe({
                next: (data)=>{
                    permission = data;
                    publish();
                },
                error: onError
            });
            const privacySubscription = request.isPrivacyModeEligible ? (0, $6SsN4.fetchQuery)(request.environment, (0, $kaFRI.default), {
                contentId: request.contentId,
                cloudId: request.cloudId,
                isPrivacyModeGateEnabled: true
            }, {
                fetchPolicy: "store-or-network"
            }).subscribe({
                next: (data_0)=>{
                    privacy = data_0;
                    publish();
                },
                error: onError
            }) : undefined;
            return ()=>{
                permissionSubscription.unsubscribe();
                privacySubscription?.unsubscribe();
            };
        };
        t3 = [
            request
        ];
        $[6] = request;
        $[7] = t2;
        $[8] = t3;
    } else {
        t2 = $[7];
        t3 = $[8];
    }
    (0, $cozmU.useEffect)(t2, t3);
    let t4;
    if ($[9] !== enabled || $[10] !== isPrivacyModeEligible || $[11] !== request || $[12] !== result) {
        t4 = enabled && result?.request === request ? result.access : {
            canView: false,
            isPrivacyModeEnabled: isPrivacyModeEligible,
            loading: enabled,
            error: undefined
        };
        $[9] = enabled;
        $[10] = isPrivacyModeEligible;
        $[11] = request;
        $[12] = result;
        $[13] = t4;
    } else t4 = $[13];
    return t4;
} : (contentId, skip = false)=>{
    const { cloudId: cloudId, edition: edition } = (0, $bQm3c.useSessionData)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const isPrivacyModeEligible = (0, $1MB8j.useIsPrivacyModeEligible)();
    const enabled = !skip && !!contentId && !!cloudId && edition === (0, $euL71.ConfluenceEdition).PREMIUM;
    const request = (0, $cozmU.useMemo)(()=>({
            contentId: contentId,
            cloudId: cloudId,
            enabled: enabled,
            isPrivacyModeEligible: isPrivacyModeEligible,
            environment: environment
        }), [
        contentId,
        cloudId,
        enabled,
        isPrivacyModeEligible,
        environment
    ]);
    const [result, setResult] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (!request.enabled) return;
        let permission;
        let privacy;
        let error;
        const publish = ()=>{
            const isPrivacyModeEnabled = request.isPrivacyModeEligible && privacy?.privacyMode?.isPrivacyModeEnabled !== false;
            const loading = !error && (!permission || request.isPrivacyModeEligible && !privacy);
            setResult({
                request: request,
                access: {
                    canView: !loading && !error && !isPrivacyModeEnabled && permission?.user?.confluence?.permissionType === 'INTERNAL',
                    isPrivacyModeEnabled: isPrivacyModeEnabled,
                    loading: loading,
                    error: error
                }
            });
        };
        const onError = (queryError)=>{
            error = queryError;
            publish();
        };
        const permissionSubscription = (0, $6SsN4.fetchQuery)(request.environment, (0, $kwDQA.default), {
            contentId: request.contentId
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                permission = data;
                publish();
            },
            error: onError
        });
        const privacySubscription = request.isPrivacyModeEligible ? (0, $6SsN4.fetchQuery)(request.environment, (0, $kaFRI.default), {
            contentId: request.contentId,
            cloudId: request.cloudId,
            isPrivacyModeGateEnabled: true
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data_0)=>{
                privacy = data_0;
                publish();
            },
            error: onError
        }) : undefined;
        return ()=>{
            permissionSubscription.unsubscribe();
            privacySubscription?.unsubscribe();
        };
    }, [
        request
    ]);
    // Previous-page access must not enable viewer fetching while the next request starts.
    return enabled && result?.request === request ? result.access : {
        canView: false,
        isPrivacyModeEnabled: isPrivacyModeEligible,
        loading: enabled,
        error: undefined
    };
};

















const $6e04cdfd924900fc$export$63b388e9743a81ae = (contentId)=>{
    const access = (0, $df93accb317ff293$export$de2d69f0cd77adf5)(contentId, !contentId || !(0, $6mKj3.expVal)('ai_agent_analytics', 'isEnabled', false));
    const skip = !access.canView;
    const { contentId: viewersContentId, viewers: viewers, loadViewers: loadViewers, isLoading: isLoading, isLoadViewersCalled: isLoadViewersCalled, error: error } = (0, $6Cgm9.usePageViews)(contentId, {
        // The shared hook requests one extra row; keep the request within the 200-row API limit.
        limit: 199,
        skip: skip,
        isPrivacyModeEnabled: access.isPrivacyModeEnabled,
        includeViewersActorType: true,
        includeAgentTypePreview: false
    });
    (0, $cozmU.useEffect)(()=>{
        if (!skip) loadViewers();
    }, [
        skip,
        loadViewers
    ]);
    const agents = (0, $cozmU.useMemo)(()=>skip || viewersContentId !== contentId ? [] : (viewers ?? []).filter((viewer)=>'isAgent' in viewer && viewer.isAgent === true), [
        skip,
        viewersContentId,
        contentId,
        viewers
    ]);
    const loading = access.loading || !skip && (isLoading || !isLoadViewersCalled);
    const resultError = access.error ?? (skip ? undefined : error);
    (0, $cozmU.useEffect)(()=>{
        if (resultError && !(0, $7Sm4c.isErrorMarkedAsHandled)(resultError)) {
            (0, $5ZqQS.getMonitoringClient)().submitError(resultError, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(resultError);
        }
    }, [
        resultError
    ]);
    return (0, $cozmU.useMemo)(()=>({
            agents: agents,
            loading: loading,
            error: resultError
        }), [
        agents,
        loading,
        resultError
    ]);
};









var $9U6SN = parcelRequire("9U6SN");





var $1uFM6 = parcelRequire("1uFM6");













const $26f2396e152670eb$export$f3067e0497a6667f = (data)=>(data?.confluence_contentCollaborators?.nodes ?? []).flatMap((node)=>{
        if (!node?.agent) return [];
        const { agent: agent, person: person } = node;
        return [
            {
                accountId: agent.accountId,
                name: agent.displayName ?? '',
                avatarURL: agent.profilePicture?.path ?? '',
                attributedUsers: [
                    {
                        id: person.accountId || null,
                        name: person.displayName ?? '',
                        avatarURL: person.profilePicture?.path
                    }
                ]
            }
        ];
    });


const $e4e9a1aeda282667$export$b08610bd07f7d5f0 = (contentId, { enabled: enabled = true } = {})=>{
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const environment = (0, $6SsN4.useRelayEnvironment)();
    const skip = !enabled || !contentId || !cloudId;
    const request = (0, $cozmU.useMemo)(()=>({
            cloudId: cloudId,
            contentId: contentId,
            skip: skip,
            environment: environment
        }), [
        cloudId,
        contentId,
        skip,
        environment
    ]);
    const [result, setResult] = (0, $cozmU.useState)();
    (0, $cozmU.useEffect)(()=>{
        if (request.skip || !request.contentId || !request.cloudId) return;
        const subscription = (0, $6SsN4.fetchQuery)(request.environment, (0, $9U6SN.default), {
            cloudId: request.cloudId,
            id: request.contentId,
            first: 2147483647
        }, {
            fetchPolicy: 'store-or-network'
        }).subscribe({
            next: (data)=>{
                setResult({
                    request: request,
                    data: data
                });
            },
            error: (error)=>{
                setResult({
                    request: request,
                    error: error
                });
            }
        });
        return ()=>{
            subscription.unsubscribe();
        };
    }, [
        request
    ]);
    // Hide previous-page data immediately, before the next subscription starts.
    const currentResult = !skip && result?.request === request ? result : undefined;
    const data = currentResult?.data;
    const resultError = currentResult?.error;
    const loading = !skip && !currentResult;
    (0, $cozmU.useEffect)(()=>{
        if (resultError && !(0, $7Sm4c.isErrorMarkedAsHandled)(resultError)) {
            // Permission failures leave the independent people/viewer streams available.
            if (!(0, $1uFM6.isUnauthorizedError)(resultError)) (0, $5ZqQS.getMonitoringClient)().submitError(resultError, {
                attribution: (0, $3IBnw.Attribution).INTEGRATIONS
            });
            (0, $7Sm4c.markErrorAsHandled)(resultError);
        }
    }, [
        resultError
    ]);
    const availability = skip ? 'disabled' : loading ? 'loading' : resultError ? 'error' : data?.confluence_contentCollaborators == null ? 'unavailable' : 'available';
    const agents = (0, $cozmU.useMemo)(()=>availability === 'available' ? (0, $26f2396e152670eb$export$f3067e0497a6667f)(data) : [], [
        availability,
        data
    ]);
    return (0, $cozmU.useMemo)(()=>({
            agents: agents,
            loading: availability === 'loading',
            error: resultError,
            availability: availability
        }), [
        agents,
        availability,
        resultError
    ]);
};


/**
 * @generated SignedSource<<b14600f7c34b5ab0d87599e6d109da6b>>
 * @relayHash 94b2c6e0d3e4c04de93855fc6893a44a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4f5191d9421bc8ec2898df082e1b0aabe61684736a663651ae2eeef06b1fa2fc
const $d01d6f08de6a92ee$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cypherQuery"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "queryContext"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "version"
        }
    ], v1 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 110
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "cypherQuery"
        },
        {
            "kind": "Variable",
            "name": "queryContext",
            "variableName": "queryContext"
        },
        {
            "kind": "Variable",
            "name": "version",
            "variableName": "version"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "key"
    }, v3 = {
        "kind": "ScalarField",
        "name": "id"
    }, v4 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v5 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v6 = {
        "kind": "ScalarField",
        "name": "name"
    }, v7 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v8 = {
        "kind": "ScalarField",
        "name": "accountStatus"
    }, v9 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ ,
            {
                "concreteType": "AtlassianAccountUserExtendedProfile",
                "kind": "LinkedField",
                "name": "extendedProfile",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "jobTitle"
                    }
                ]
            }
        ],
        "type": "AtlassianAccountUser"
    }, v10 = {
        "kind": "InlineFragment",
        "selections": [
            v3 /*: any*/ ,
            v5 /*: any*/ ,
            v6 /*: any*/ ,
            v7 /*: any*/ ,
            v8 /*: any*/ 
        ],
        "type": "CustomerUser"
    }, v11 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "stringValue",
                "kind": "ScalarField",
                "name": "value"
            }
        ],
        "type": "GraphStoreCypherQueryV2StringObject"
    }, v12 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": "timestampValue",
                "kind": "ScalarField",
                "name": "value"
            }
        ],
        "type": "GraphStoreCypherQueryV2TimestampObject"
    }, v13 = [
        v3 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePagePeopleQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePagePeopleQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "GraphStoreCypherQueryV2Connection",
                    "kind": "LinkedField",
                    "name": "graphStore_cypherQueryV2",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphStoreCypherQueryV2Edge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "GraphStoreCypherQueryV2Node",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "GraphStoreCypherQueryV2Column",
                                            "kind": "LinkedField",
                                            "name": "columns",
                                            "plural": true,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "value",
                                                    "plural": false,
                                                    "selections": [
                                                        v4 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v3 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "data",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v4 /*: any*/ ,
                                                                        v9 /*: any*/ ,
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "Node",
                                                                            "abstractKey": "__isNode"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "AppUser"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsFeatureFlag"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsOperationsComponentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsOperationsIncidentDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsOperationsPostIncidentReviewDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsProjectDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsPullRequestDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsRepository"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "DevOpsSecurityVulnerabilityDetails"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraAutodevJob"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraConfluenceRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraCustomRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraIssueRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "JiraWebRemoteIssueLink"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "TeamCustomFieldValue"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "TeamType"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v13 /*: any*/ ,
                                                                            "type": "ThirdPartyUser"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "GraphStoreCypherQueryV2AriNode"
                                                        },
                                                        v11 /*: any*/ ,
                                                        v12 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "94b2c6e0d3e4c04de93855fc6893a44a",
            "id": "4f5191d9421bc8ec2898df082e1b0aabe61684736a663651ae2eeef06b1fa2fc",
            "metadata": {},
            "name": "usePagePeopleQuery",
            "operationKind": "query",
            "text": "query usePagePeopleQuery($cypherQuery:String!,$queryContext:String!,$version:GraphStoreCypherQueryV2VersionEnum){graphStore_cypherQueryV2(query:$cypherQuery,queryContext:$queryContext,version:$version,first:110)@optIn(to:\"GraphStoreCypherQueryV2\"){edges{node{columns{key,value{__typename,...on GraphStoreCypherQueryV2AriNode{id,data{__typename,...on AtlassianAccountUser{id,accountId,name,picture,accountStatus,extendedProfile{jobTitle}},...on CustomerUser{id,accountId,name,picture,accountStatus},...on Node{__isNode:__typename,id},...on AppUser{id},...on DevOpsFeatureFlag{id},...on DevOpsOperationsComponentDetails{id},...on DevOpsOperationsIncidentDetails{id},...on DevOpsOperationsPostIncidentReviewDetails{id},...on DevOpsProjectDetails{id},...on DevOpsPullRequestDetails{id},...on DevOpsRepository{id},...on DevOpsSecurityVulnerabilityDetails{id},...on JiraAutodevJob{id},...on JiraConfluenceRemoteIssueLink{id},...on JiraCustomRemoteIssueLink{id},...on JiraIssueRemoteIssueLink{id},...on JiraWebRemoteIssueLink{id},...on TeamCustomFieldValue{id},...on TeamType{id},...on ThirdPartyUser{id}}},...on GraphStoreCypherQueryV2StringObject{stringValue:value},...on GraphStoreCypherQueryV2TimestampObject{timestampValue:value}}}}}}}"
        }
    };
}();
$d01d6f08de6a92ee$var$node.hash = "af3f187b46363a2e3ea7b5f9ee9a63d5";
var $d01d6f08de6a92ee$export$2e2bcd8739ae039 = $d01d6f08de6a92ee$var$node;
































var $8WngQ = parcelRequire("8WngQ");

const $f27c506e525608c8$var$readColumn = (columns, key)=>columns.find((column)=>column.key === key)?.value ?? undefined;
const $f27c506e525608c8$var$isHydratedPerson = (user)=>(user?.__typename === 'AtlassianAccountUser' || user?.__typename === 'CustomerUser') && 'accountStatus' in user && user.accountStatus === 'active';
const $f27c506e525608c8$export$118d4ea22fb34073 = (data)=>{
    const peopleByAccount = new Map();
    const evidenceKeysByAccount = new Map();
    for (const edge of data?.graphStore_cypherQueryV2?.edges ?? []){
        const columns = edge.node.columns;
        const personValue = $f27c506e525608c8$var$readColumn(columns, 'person');
        const user = personValue?.data;
        const relationship = $f27c506e525608c8$var$readColumn(columns, 'relationship')?.stringValue;
        const direction = $f27c506e525608c8$var$readColumn(columns, 'direction')?.stringValue;
        if (!personValue?.id || !$f27c506e525608c8$var$isHydratedPerson(user) || !(0, $8WngQ.isPagePeopleRelationship)(relationship) || !(0, $8WngQ.isPagePeopleRelationshipDirection)(direction)) continue;
        const accountKey = user.accountId || personValue.id;
        const evidence = {
            relationship: relationship,
            direction: direction,
            lastUpdated: $f27c506e525608c8$var$readColumn(columns, 'relationshipTimestamp')?.timestampValue ?? null
        };
        const existing = peopleByAccount.get(accountKey);
        const evidenceKey = `${evidence.relationship}:${evidence.direction}:${evidence.lastUpdated ?? ''}`;
        // Get-or-create rather than optional chaining: a missing Set would otherwise
        // silently drop the key while still merging the relationship, so the next
        // duplicate row would be merged a second time.
        let evidenceKeys = evidenceKeysByAccount.get(accountKey);
        if (!evidenceKeys) {
            evidenceKeys = new Set();
            evidenceKeysByAccount.set(accountKey, evidenceKeys);
        }
        if (existing) {
            if (evidenceKeys.has(evidenceKey)) continue;
            evidenceKeys.add(evidenceKey);
            peopleByAccount.set(accountKey, {
                ...existing,
                relationships: [
                    ...existing.relationships,
                    evidence
                ]
            });
            continue;
        }
        evidenceKeys.add(evidenceKey);
        peopleByAccount.set(accountKey, {
            ari: personValue.id,
            accountId: user.accountId,
            name: user.name,
            picture: user.picture,
            ...user.__typename === 'AtlassianAccountUser' && user.extendedProfile?.jobTitle ? {
                jobTitle: user.extendedProfile.jobTitle
            } : {},
            relationships: [
                evidence
            ]
        });
    }
    return [
        ...peopleByAccount.values()
    ];
};






var $8vzGQ = parcelRequire("8vzGQ");




const $ddf282c684c07729$var$EXCLUDED_RELATIONSHIP_PRIORITY = 5;
const $ddf282c684c07729$var$relationshipOrder = new Map((0, $8WngQ.PAGE_PEOPLE_RELATIONSHIPS).map(({ relationship: relationship }, index)=>[
        relationship,
        index
    ]));
const $ddf282c684c07729$var$priority = (relationship, isAgent)=>{
    switch(relationship){
        case 'owns':
            return 0;
        case 'created':
        case 'contributed':
        case 'updated':
            return isAgent ? 3 : 1;
        case 'viewed':
            return isAgent ? 4 : $ddf282c684c07729$var$EXCLUDED_RELATIONSHIP_PRIORITY;
        case 'mentioned-in':
            return 2;
        default:
            return $ddf282c684c07729$var$EXCLUDED_RELATIONSHIP_PRIORITY;
    }
};
// Graph timestamps are relationship recency evidence, not necessarily individual action times.
const $ddf282c684c07729$var$timestamp = (value)=>value != null && Number.isFinite(value) ? value : -Infinity;
const $ddf282c684c07729$var$compareText = (left, right)=>left < right ? -1 : left > right ? 1 : 0;
const $ddf282c684c07729$var$compareRelationships = (left, right, isAgent)=>$ddf282c684c07729$var$priority(left.relationship, isAgent) - $ddf282c684c07729$var$priority(right.relationship, isAgent) || $ddf282c684c07729$var$timestamp(right.lastUpdated) - $ddf282c684c07729$var$timestamp(left.lastUpdated) || ($ddf282c684c07729$var$relationshipOrder.get(left.relationship) ?? Number.MAX_SAFE_INTEGER) - ($ddf282c684c07729$var$relationshipOrder.get(right.relationship) ?? Number.MAX_SAFE_INTEGER);
const $ddf282c684c07729$var$pickPrimaryRelationship = (person, isAgent)=>{
    let primary;
    for (const relationship of person.relationships)if (!primary || $ddf282c684c07729$var$compareRelationships(relationship, primary, isAgent) < 0) primary = relationship;
    return primary;
};
const $ddf282c684c07729$var$lastViewedTimestamp = (agent)=>{
    const timestamp = agent.lastViewedAt ? Date.parse(agent.lastViewedAt) : NaN;
    return Number.isFinite(timestamp) ? timestamp : null;
};
const $ddf282c684c07729$export$b2b3a37b350489c1 = (people, agents, contributors = [])=>{
    const agentsByIdentity = new Map();
    for (const contributor of contributors)// Without contribution timestamps, keep the first returned entry for each agent.
    if (!agentsByIdentity.has(contributor.accountId)) agentsByIdentity.set(contributor.accountId, {
        id: contributor.accountId,
        identityAccountId: contributor.accountId,
        name: contributor.name,
        avatarURL: contributor.avatarURL,
        attributedUser: contributor.attributedUsers[0],
        relationship: 'contributed'
    });
    for (const agent of agents){
        // Analytics IDs can include an attributed user's ID; the identity is the agent itself.
        // Unresolved agents retain their source row ID rather than guessing from a display name.
        const identity = agent.identityAccountId || agent.id;
        const existing = agentsByIdentity.get(identity);
        if (existing?.relationship === 'contributed') continue;
        if (!existing || ($ddf282c684c07729$var$lastViewedTimestamp(agent) ?? -Infinity) > ($ddf282c684c07729$var$lastViewedTimestamp(existing) ?? -Infinity)) agentsByIdentity.set(identity, {
            id: agent.id,
            identityAccountId: agent.identityAccountId,
            name: agent.name,
            avatarURL: agent.avatarURL || existing?.avatarURL || '',
            agentIcon: agent.agentIcon,
            lastViewedAt: agent.lastViewedAt,
            attributedUser: agent.attributedUsers?.find(({ name: name })=>name.trim()),
            relationship: 'viewed'
        });
    }
    const agentsByKey = new Map();
    const agentCandidates = [];
    for (const [identity, agent] of agentsByIdentity){
        // A local row key, never a graph ARI or a navigation target.
        const key = `agent:${identity}`;
        agentsByKey.set(key, agent);
        agentCandidates.push({
            ari: key,
            accountId: agent.identityAccountId ?? '',
            name: agent.name,
            picture: agent.avatarURL || null,
            relationships: [
                {
                    relationship: agent.relationship,
                    direction: 'incoming',
                    lastUpdated: agent.relationship === 'viewed' ? $ddf282c684c07729$var$lastViewedTimestamp(agent) : null
                }
            ]
        });
    }
    const candidates = [
        ...people,
        ...agentCandidates
    ].map((person)=>{
        const agent = agentsByKey.get(person.ari);
        return {
            person: person,
            agent: agent,
            primary: $ddf282c684c07729$var$pickPrimaryRelationship(person, !!agent)
        };
    });
    const eligiblePeople = candidates.filter((candidate)=>!!candidate.primary && $ddf282c684c07729$var$priority(candidate.primary.relationship, !!candidate.agent) < $ddf282c684c07729$var$EXCLUDED_RELATIONSHIP_PRIORITY);
    return eligiblePeople.sort((left, right)=>$ddf282c684c07729$var$priority(left.primary.relationship, !!left.agent) - $ddf282c684c07729$var$priority(right.primary.relationship, !!right.agent) || $ddf282c684c07729$var$timestamp(right.primary.lastUpdated) - $ddf282c684c07729$var$timestamp(left.primary.lastUpdated) || $ddf282c684c07729$var$compareText(left.person.ari, right.person.ari) || $ddf282c684c07729$var$compareText(left.person.accountId, right.person.accountId)).map(({ person: person, primary: primary, agent: agent })=>({
            ari: person.ari,
            accountId: person.accountId,
            name: person.name,
            picture: person.picture,
            ...person.jobTitle ? {
                jobTitle: person.jobTitle
            } : {},
            primaryRelationship: primary.relationship,
            relationshipDirection: primary.direction,
            ...agent ? {
                agent: agent
            } : {}
        }));
};





const $e82ef10e7fc62f37$export$ad1a0f8a61572f42 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'succeeded',
            actionSubject: (0, $I7TEB.PAGE_PEOPLE_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE),
            attributes: attributes
        }
    });
const $e82ef10e7fc62f37$export$61c3c7e275203673 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'failed',
            actionSubject: (0, $I7TEB.PAGE_PEOPLE_ACTION_SUBJECT),
            source: (0, $I7TEB.PANEL_SOURCE),
            attributes: attributes
        }
    });


const $5e7e7afa96016adb$var$CANDIDATES_PER_RELATIONSHIP = 10;
const $5e7e7afa96016adb$var$classifyError = (error)=>!error.networkError && error.graphQLErrors?.length ? 'graphql' : 'network';
const $5e7e7afa96016adb$var$buildRelationshipBranch = (pageAri, { cypherName: cypherName, relationship: relationship, direction: direction })=>{
    const match = direction === 'incoming' ? `MATCH (person)-[rel:${cypherName}]->(page {ari: "${pageAri}"})` : `MATCH (page {ari: "${pageAri}"})-[rel:${cypherName}]->(person)`;
    return [
        match,
        'WITH person, rel',
        'ORDER BY rel.lastUpdated DESC',
        `LIMIT ${$5e7e7afa96016adb$var$CANDIDATES_PER_RELATIONSHIP}`,
        `RETURN person AS person, "${relationship}" AS relationship, "${direction}" AS direction, rel.lastUpdated AS relationshipTimestamp`
    ].join('\n');
};
const $5e7e7afa96016adb$export$1967eabe5eea0d7 = (pageAri)=>(0, $8WngQ.PAGE_PEOPLE_RELATIONSHIPS).map((definition)=>$5e7e7afa96016adb$var$buildRelationshipBranch(pageAri, definition)).join('\nUNION ALL\n');
const $5e7e7afa96016adb$var$PagePeopleQuery = (0, $d01d6f08de6a92ee$export$2e2bcd8739ae039);
const $5e7e7afa96016adb$export$bc557ba2ed417c5d = (contentId, options)=>{
    const { cloudId: cloudId, activationId: activationId } = (0, $bQm3c.useSessionData)();
    // `@confluence/analytics`, not the platform analytics-bridge helper. `fireOperationalAnalytics`
    // fires on the `analyticsBridge` channel, and `AnalyticsListener` only invokes its handler when
    // its own `channel` is `'*'` or equal to the event's; `ConfluenceAnalyticsListener` passes no
    // `channel`, so bridge events never reached it at all. See `.agents/teamwork-graph-modal.md`.
    // CCINT-9105
    const { createEvent: createEvent } = (0, $kcIQr.useConfluenceAnalyticsEvents)();
    const hasFiredRef = (0, $cozmU.useRef)(false);
    const skip = options?.enabled === false || !contentId || !cloudId || !activationId || !(0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment');
    const reportError = (0, $cozmU.useCallback)((error)=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).INTEGRATIONS
        });
        (0, $7Sm4c.markErrorAsHandled)(error);
        createEvent((0, $e82ef10e7fc62f37$export$61c3c7e275203673)({
            errorType: $5e7e7afa96016adb$var$classifyError(error)
        })).fire();
    }, [
        createEvent
    ]);
    const { data: data, loading: loading, error: error } = (0, $jMyy4.useQueryInterop)($5e7e7afa96016adb$var$PagePeopleQuery, {
        variables: {
            cypherQuery: skip ? '' : $5e7e7afa96016adb$export$1967eabe5eea0d7((0, $6B1vK.ConfluencePageAri).create({
                siteId: cloudId,
                pageId: contentId
            }).toString()),
            queryContext: skip ? '' : (0, $5Wig1.ConfluenceWorkspaceAri).create({
                siteId: cloudId,
                activationId: activationId
            }).toString(),
            version: 'V3'
        },
        skip: skip,
        interopApolloAggClient: true,
        errorPolicy: 'all',
        onError: reportError,
        __callerPackage__: "byline-connections"
    });
    const candidates = (0, $cozmU.useMemo)(()=>skip ? [] : (0, $f27c506e525608c8$export$118d4ea22fb34073)(data), [
        data,
        skip
    ]);
    // Section role priorities must not change the canvas's people, order, or primary relationships.
    const people = (0, $cozmU.useMemo)(()=>(0, $8vzGQ.rankPagePeople)(candidates), [
        candidates
    ]);
    const ranked = (0, $cozmU.useMemo)(()=>(0, $ddf282c684c07729$export$b2b3a37b350489c1)(candidates, options?.agents ?? [], options?.agentContributors ?? []), [
        candidates,
        options?.agents,
        options?.agentContributors
    ]);
    const peopleAndAgents = (0, $cozmU.useMemo)(()=>ranked.filter(({ agent: agent })=>agent || !loading && !error).slice(0, (0, $8vzGQ.MAX_LISTED_PAGE_PEOPLE)), [
        ranked,
        loading,
        error
    ]);
    // Once per hook instance, so a re-render or a cache update does not inflate the
    // success count. `count` is the ranked list, so at most `MAX_LISTED_PAGE_PEOPLE` — not
    // however many a given surface goes on to show. No name, account id or other person
    // detail goes into the payload.
    (0, $cozmU.useEffect)(()=>{
        if (skip || loading || error || hasFiredRef.current) return;
        hasFiredRef.current = true;
        createEvent((0, $e82ef10e7fc62f37$export$ad1a0f8a61572f42)({
            count: people.length
        })).fire();
    }, [
        skip,
        loading,
        error,
        people.length,
        createEvent
    ]);
    return {
        people: people,
        peopleAndAgents: peopleAndAgents,
        loading: !skip && loading,
        error: error
    };
};









const $13c0a60f8ad3bb4e$export$275ee434c520938c = (contentId)=>{
    const { devDocsConnection: devDocsConnection } = (0, $3b6532377f19c330$export$27db6e7d91fcef66)(contentId);
    const { incomingLinks: incoming } = (0, $21leH.useIncomingLinksData)(contentId);
    const { links: incomingLinks, loading: loading, loadingMore: loadingMore, hasNextPage: hasNextPage, endCursor: endCursor, loadMore: loadMore, error: incomingError } = incoming;
    const { outgoingLinks: outgoingLinks } = (0, $Hnn0l.useOutgoingLinks)(contentId);
    const { relatedContent: relatedContent } = (0, $4ao9J.useRelatedContentData)(contentId);
    const { enabled: relatedContentEnabled, links: relatedContentLinks, loading: relatedContentLoading, error: relatedContentError } = relatedContent;
    const agentContributors = (0, $e4e9a1aeda282667$export$b08610bd07f7d5f0)(contentId);
    const agentViewers = (0, $6e04cdfd924900fc$export$63b388e9743a81ae)(contentId ?? '');
    const people = (0, $5e7e7afa96016adb$export$bc557ba2ed417c5d)(contentId, {
        agents: agentViewers.loading || agentViewers.error ? undefined : agentViewers.agents,
        agentContributors: agentContributors.availability === 'available' ? agentContributors.agents : undefined
    });
    return (0, $cozmU.useMemo)(()=>({
            syncedFrom: {
                connection: devDocsConnection
            },
            appearsIn: {
                links: incomingLinks,
                loading: loading,
                loadingMore: loadingMore,
                hasNextPage: hasNextPage,
                endCursor: endCursor,
                loadMore: loadMore,
                error: incomingError
            },
            linksTo: {
                links: outgoingLinks
            },
            relatedContent: {
                enabled: relatedContentEnabled,
                links: relatedContentLinks,
                loading: relatedContentLoading,
                error: relatedContentError
            },
            people: people,
            agentViewers: agentViewers,
            agentContributors: agentContributors
        }), [
        devDocsConnection,
        incomingLinks,
        loading,
        loadingMore,
        hasNextPage,
        endCursor,
        loadMore,
        incomingError,
        outgoingLinks,
        relatedContentEnabled,
        relatedContentLinks,
        relatedContentLoading,
        relatedContentError,
        people,
        agentViewers,
        agentContributors
    ]);
};
















var $ez9xU = parcelRequire("ez9xU");










const $c16ea8b659632d91$export$a02ae069a5aa8a95 = 'rovo_connector_authed_users_percentage_by_app';
function $c16ea8b659632d91$export$4555bcf1892bfb4({ skip: skip } = {}) {
    return (0, $8ab372ddb9ea7e6c$export$284907af4a465a72)($c16ea8b659632d91$export$a02ae069a5aa8a95, (0, $f1588a16e52e7972$export$983a3bcefb295c3f), {
        skip: skip
    });
}





/* ConnectorPromoBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 




















/* GhostConnectorIcons.tsx generated by @compiled/babel-plugin v3.0.2 */ 





// `ShareContextLogoPile` does: the stack's bordered tile doubles the border on 3P logos
// that already carry their own.
const $67edf747d1802569$var$styles = {
    pile: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _2YgrGrP0S5 _1YKVNsVx3j",
    firstTile: "_3iDTPbccYA _3YEZNOdnbC _42Yu6BPvK5",
    middleTile: "_3iDTPbccYA _3YEZNOdnbC _0GTcwR5UaJ _42Yu6Bbhqd _2AERac9ub0",
    lastTile: "_3iDTPbccYA _3YEZNOdnbC _0GTcwR5UaJ _42Yu6BgtVO"
};
const $67edf747d1802569$var$tileStyles = [
    $67edf747d1802569$var$styles.firstTile,
    $67edf747d1802569$var$styles.middleTile,
    $67edf747d1802569$var$styles.lastTile
];
const $67edf747d1802569$export$2792a10d5f4aa2f7 = ({ apps: apps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        "aria-hidden": "true",
        testId: "teamwork-graph-promo-banner-ghost-icons",
        xcss: $67edf747d1802569$var$styles.pile
    }, apps.map(({ productKey: productKey, id: id, Icon: Icon }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: productKey,
            xcss: $67edf747d1802569$var$tileStyles[index] ?? $67edf747d1802569$var$styles.lastTile,
            testId: `teamwork-graph-promo-banner-ghost-icon-${id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: "xsmall",
            label: ""
        }))));


const $836e02dfba756f43$export$5237495f42936402 = 30;
const $836e02dfba756f43$var$i18n = (0, $kSwu1.defineMessages)({
    gdriveMessage: {
        id: "byline-connections.preview-panel.modal.promo-banner.gdrive",
        defaultMessage: "Connect Google Drive to get rich previews and more powerful search"
    },
    highAdoptionMessage: {
        id: "byline-connections.preview-panel.modal.promo-banner.high-adoption",
        defaultMessage: "{percent}% of your org uses connected apps to see how their pages connect to their team's work"
    },
    genericMessage: {
        id: "byline-connections.preview-panel.modal.promo-banner.generic",
        defaultMessage: "Top teams use connected apps to get rich previews and more powerful search"
    },
    connectApps: {
        id: "byline-connections.preview-panel.modal.promo-banner.connect-apps",
        defaultMessage: "Connect apps"
    }
});
/** Eyeballed from the mock — confirm against Figma. */ const $836e02dfba756f43$var$GRID_PITCH = '32px'; /** Negative moves the lines up. Wraps every `GRID_PITCH`, so stay under it. */ 
const $836e02dfba756f43$var$GRID_OFFSET_BLOCK = '-16px';
const $836e02dfba756f43$var$styles = {
    banner: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _23rrnHyKLB _4c065U5zaO _2Y7lL45zaO _3hxITiYbGa _3iDTPbvLZJ _39xV02N91d _24h04i2Njc _2fwxA57p2s _0KLXrunmFW _0wOv4Q7zJH _1mT5xdRAKS _1eOmH6o126",
    grid: "_1mT5xdWVPG _2I62gzdnbC _1ZB6UydnbC _3iC0zddnbC _1OKFqYdnbC _3CkH9os4Wk _3OqcjTAe3X _1DJ2rVnolI _1pp6NdYbGa",
    content: "_1mT5xdRAKS",
    message: "_2sNsIg7NXe _1UtDYzy7kJ"
};
const $836e02dfba756f43$var$getMessageDescriptor = (variant, topAppPercent)=>{
    if (variant === 'gdrive') return $836e02dfba756f43$var$i18n.gdriveMessage;
     // Below the threshold the org copy is the generic copy, so the number is only quoted
    // when it is worth quoting.
    if (variant === 'orgConnectedApps' && topAppPercent !== undefined && topAppPercent >= $836e02dfba756f43$export$5237495f42936402) return $836e02dfba756f43$var$i18n.highAdoptionMessage;
    return $836e02dfba756f43$var$i18n.genericMessage;
}; /**
    * Deliberately not dismissible, unlike the byline menu footer banners: we want to see how
    * it performs before deciding whether users can hide it, so there is no dismissal state.
    */ 
const $836e02dfba756f43$export$f1c78716874e7f8b = ({ variant: variant, topAppPercent: topAppPercent, apps: apps, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $836e02dfba756f43$var$styles.banner,
        onClick: onClick,
        "aria-label": formatMessage($836e02dfba756f43$var$i18n.connectApps),
        testId: "teamwork-graph-promo-banner"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $836e02dfba756f43$var$styles.grid,
        "aria-hidden": "true"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.150",
        xcss: $836e02dfba756f43$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.100",
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $67edf747d1802569$export$2792a10d5f4aa2f7), {
        apps: apps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aRvnq))), {
        label: "",
        spacing: "none",
        color: "var(--ds-icon-subtle, #505258)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $836e02dfba756f43$var$styles.message
    }, formatMessage($836e02dfba756f43$var$getMessageDescriptor(variant, topAppPercent), {
        percent: topAppPercent
    }))));
};





const $e40f091c99315ed8$export$b1294d95ffe11792 = 'connectorPromoBanner';
const $e40f091c99315ed8$export$57e0ff4c2905037a = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'viewed',
            actionSubject: 'banner',
            actionSubjectId: $e40f091c99315ed8$export$b1294d95ffe11792,
            source: (0, $I7TEB.MODAL_SOURCE),
            attributes: attributes
        }
    });
const $e40f091c99315ed8$export$1711eb8ab907f796 = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'banner',
            actionSubjectId: $e40f091c99315ed8$export$b1294d95ffe11792,
            source: (0, $I7TEB.MODAL_SOURCE),
            attributes: attributes
        }
    });
const $e40f091c99315ed8$export$3155a85848c110b5 = (attributes)=>({
        type: 'sendOperationalEvent',
        data: {
            action: 'notShown',
            actionSubject: 'banner',
            actionSubjectId: $e40f091c99315ed8$export$b1294d95ffe11792,
            source: (0, $I7TEB.MODAL_SOURCE),
            attributes: attributes
        }
    });






var $5c5T9 = parcelRequire("5c5T9");


var $6bk1K = parcelRequire("6bk1K");


var $i9pyX = parcelRequire("i9pyX");







const $adae1c9eea9b105b$export$e03f0449a68f3b = 2;
const $adae1c9eea9b105b$var$EMPTY_APPS = [];
const $adae1c9eea9b105b$export$33e731add22822fa = ({ pinnedProductKey: pinnedProductKey, rates: rates } = {})=>{
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    // `undefined` until the fetch settles, distinguishing "loading" from "none qualified".
    const [unconnectedProductKeys, setUnconnectedProductKeys] = (0, $cozmU.useState)();
    const [apps, setApps] = (0, $cozmU.useState)($adae1c9eea9b105b$var$EMPTY_APPS);
    (0, $cozmU.useEffect)(()=>{
        if (!cloudId || !userId) {
            setUnconnectedProductKeys([]);
            return;
        }
        let isCurrent = true;
        Promise.all([
            (0, $i9pyX.get3pSearchConfig)({
                cloudId: cloudId,
                userId: userId
            }),
            (0, $8gF2o.fetchOutboundAuthAccounts)(userId)
        ]).then(([resources, grants])=>{
            if (!isCurrent) return;
            const env = (0, $8gF2o.detectEnvFromPayload)(grants) ?? undefined;
            setUnconnectedProductKeys(resources.reduce((keys, resource)=>{
                if (!(0, $6bk1K.isProductResourceTypes3P)(resource.type)) return keys;
                const productKey = (0, $5c5T9.connectorsConfig).getProductKey(resource.type);
                if (!productKey || keys.includes(productKey) || (0, $8gF2o.isAuthenticatedForProduct)(grants, productKey, env)) return keys;
                keys.push(productKey);
                return keys;
            }, []));
        }).catch(()=>{
            if (isCurrent) setUnconnectedProductKeys([]);
        });
        return ()=>{
            isCurrent = false;
        };
    }, [
        cloudId,
        userId
    ]);
    // Ranked before loading configs so only the winning two are imported.
    const topProductKeys = (0, $cozmU.useMemo)(()=>{
        if (unconnectedProductKeys === undefined) return undefined;
        const ranked = [
            ...unconnectedProductKeys
        ].filter((key)=>key !== pinnedProductKey).sort((a, b)=>(rates?.[b] ?? 0) - (rates?.[a] ?? 0));
        return (pinnedProductKey ? [
            pinnedProductKey,
            ...ranked
        ] : ranked).slice(0, $adae1c9eea9b105b$export$e03f0449a68f3b);
    }, [
        unconnectedProductKeys,
        rates,
        pinnedProductKey
    ]);
    // The effect below keys off the contents rather than the array, so a caller passing a
    // fresh `rates` object each render cannot spin it: new identity, same keys, no refetch.
    const topProductKeysId = topProductKeys?.join(',');
    const topProductKeysRef = (0, $cozmU.useRef)(topProductKeys);
    topProductKeysRef.current = topProductKeys;
    // Each config is a separate lazy chunk, hence a second async step rather than a
    // synchronous registry of every connector.
    (0, $cozmU.useEffect)(()=>{
        const keys = topProductKeysRef.current;
        if (keys === undefined || keys.length === 0) {
            setApps($adae1c9eea9b105b$var$EMPTY_APPS);
            return;
        }
        let isCurrent = true;
        Promise.all(keys.map((productKey)=>(0, $5c5T9.connectorsConfig).getConfig(productKey))).then((configs)=>{
            if (!isCurrent) return;
            setApps(configs.flatMap((config, index)=>config ? [
                    {
                        productKey: keys[index],
                        id: config.id,
                        // Not `iconBorderless`: the pile draws no container, so each logo
                        // supplies its own shape.
                        Icon: config.icon
                    }
                ] : []));
        }).catch(()=>{
            if (isCurrent) setApps($adae1c9eea9b105b$var$EMPTY_APPS);
        });
        return ()=>{
            isCurrent = false;
        };
    }, [
        topProductKeysId
    ]);
    return {
        apps: apps,
        loading: unconnectedProductKeys === undefined
    };
};





/** The gdrive banner reports `google` to line up with the org banner's trait keys. */ const $8e105220e5be9b9e$var$GDRIVE_ANALYTICS_CONNECTOR = 'google';
/** Attributed separately from the preview panel's "Manage connections" entry point. */ const $8e105220e5be9b9e$var$TEAMWORK_GRAPH_MODAL_SURFACE = 'confluence-teamwork-graph-modal';
/** The connector dialog's "Connect apps" tab — the banner is only ever about that one. */ const $8e105220e5be9b9e$var$APPS_TAB_ID = 'discovery';
/**
 * `ORG_CONNECTED_APPS_RATE_TRAIT` is keyed by smartlink provider family, which is coarser
 * than the `ProductKeys3P` the icons need — `google` covers Drive, Gmail and Calendar, so
 * Drive stands in for the family. Keys that already agree pass through.
 */ const $8e105220e5be9b9e$var$PROVIDER_FAMILY_TO_PRODUCT_KEY = {
    google: (0, $fR63l.ProductKeys3P).GoogleDrive
};
const $8e105220e5be9b9e$var$toProductKeyRates = (rates)=>{
    if (!rates) return undefined;
    const mapped = {};
    for (const [family, percent] of Object.entries(rates))mapped[$8e105220e5be9b9e$var$PROVIDER_FAMILY_TO_PRODUCT_KEY[family] ?? family] = percent;
    return mapped;
};
const $8e105220e5be9b9e$export$2fab414bcd04553f = ({ links: links })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const { cloudId: cloudId, isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const isPageFirstPartyOnly = links.length > 0 && links.every((l)=>(0, $cS4kb.isFirstPartyLink)(l.url));
    const { value: linkCounts, loading: isLinkCountLoading } = (0, $11c55f3cb3c29119$export$2bd9a43397bfe114)({
        skip: !isPageFirstPartyOnly
    });
    const hasSiteWideDriveLinks = (linkCounts?.[0, $11c55f3cb3c29119$export$3d6612235992a7fe] ?? 0) >= 1;
    const { isAuthenticated: isGdriveConnected, isLoading: isGdriveAuthLoading } = (0, $ce8c0a0fac7ee6d6$export$f4c25aea7c19a132)();
    const unconnectedThirdPartyLinks = (0, $cozmU.useMemo)(()=>links.filter((0, $e34182895af441bd$export$76cb2c3a079a73ad)), [
        links
    ]);
    const hasUnconnectedThirdParty = unconnectedThirdPartyLinks.length > 0;
    const { value: orgRates, loading: isRatesLoading } = (0, $f1588a16e52e7972$export$5d94aa936f525952)({
        skip: !hasUnconnectedThirdParty
    });
    const topApp = (0, $cozmU.useMemo)(()=>(0, $e34182895af441bd$export$41c181e9c9608a62)(orgRates, (0, $e34182895af441bd$export$8a9749363d54b4fa)(unconnectedThirdPartyLinks)), [
        orgRates,
        unconnectedThirdPartyLinks
    ]);
    // The trait hooks share one store with a global `loading` flag, so each is only
    // honoured when its branch is in play.
    const isLoading = isPageFirstPartyOnly && (isLinkCountLoading || isGdriveAuthLoading) || hasUnconnectedThirdParty && isRatesLoading;
    // First failing check, in order. `undefined` means the variant qualified — so these
    // double as the variant decision below, and cannot drift from it.
    const gdriveIneligibleReason = (0, $cozmU.useMemo)(()=>{
        if (!isPageFirstPartyOnly) return 'notFirstPartyOnly';
        if (!hasSiteWideDriveLinks) return 'noSiteWideDriveLinks';
        if (isGdriveConnected) return 'alreadyAuthenticated';
        return undefined;
    }, [
        isPageFirstPartyOnly,
        hasSiteWideDriveLinks,
        isGdriveConnected
    ]);
    const orgIneligibleReason = (0, $cozmU.useMemo)(()=>{
        if (!hasUnconnectedThirdParty) return 'noUnconnectedThirdParty';
        if (!topApp) return 'noTopApp';
        return undefined;
    }, [
        hasUnconnectedThirdParty,
        topApp
    ]);
    const variant = gdriveIneligibleReason === undefined ? 'gdrive' : orgIneligibleReason === undefined ? 'orgConnectedApps' : 'generic';
    const { value: connectorAuthRates } = (0, $c16ea8b659632d91$export$4555bcf1892bfb4)();
    // The org variant ranks its icons by the same trait its copy quotes, so the two agree.
    // The other variants quote no adoption figure, so they fall back to the Rovo connector
    // trait — the same one the CWR ghost icons rank on.
    const iconRates = (0, $cozmU.useMemo)(()=>variant === 'orgConnectedApps' ? $8e105220e5be9b9e$var$toProductKeyRates(orgRates) : connectorAuthRates, [
        variant,
        orgRates,
        connectorAuthRates
    ]);
    // The Drive variant names Google Drive, so its icons lead with Drive.
    const { apps: apps } = (0, $adae1c9eea9b105b$export$33e731add22822fa)({
        pinnedProductKey: variant === 'gdrive' ? (0, $fR63l.ProductKeys3P).GoogleDrive : undefined,
        rates: iconRates
    });
    const shownAttributes = (0, $cozmU.useMemo)(()=>{
        if (variant === 'gdrive') return {
            bannerType: 'gdrive',
            connector: $8e105220e5be9b9e$var$GDRIVE_ANALYTICS_CONNECTOR,
            ghostIconCount: apps.length
        };
        if (variant === 'orgConnectedApps' && topApp) return {
            bannerType: 'orgConnectedApps',
            connector: topApp.traitKey,
            topAppPercent: topApp.percent,
            gdriveIneligibleReason: gdriveIneligibleReason,
            ghostIconCount: apps.length
        };
        return {
            bannerType: 'generic',
            gdriveIneligibleReason: gdriveIneligibleReason,
            orgIneligibleReason: orgIneligibleReason,
            ghostIconCount: apps.length
        };
    }, [
        variant,
        topApp,
        gdriveIneligibleReason,
        orgIneligibleReason,
        apps.length
    ]);
    // Once per mount, on the variant first seen. Exactly one of `viewed` and `notShown`
    // fires, so `clicked / viewed` stays a click-through rate.
    const hasFiredRef = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredRef.current) return;
        if (!isRovoLLMEnabled) {
            hasFiredRef.current = true;
            createAnalyticsEvent((0, $e40f091c99315ed8$export$3155a85848c110b5)({
                reason: 'rovoDisabled'
            })).fire();
            return;
        }
        if (isLoading) return;
        hasFiredRef.current = true;
        createAnalyticsEvent((0, $e40f091c99315ed8$export$57e0ff4c2905037a)(shownAttributes)).fire();
    }, [
        isRovoLLMEnabled,
        isLoading,
        shownAttributes,
        createAnalyticsEvent
    ]);
    const fireClickedEvent = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $e40f091c99315ed8$export$1711eb8ab907f796)(shownAttributes)).fire();
    }, [
        createAnalyticsEvent,
        shownAttributes
    ]);
    // Pressing the banner opens `RovoSettingsModal`, which a site without Rovo has no use
    // for, so the surface goes rather than leading somewhere dead.
    if (!isRovoLLMEnabled || isLoading) return {
        element: null
    };
    return {
        element: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ez9xU.RovoSettingsModal), {
            product: "confluence",
            cloudId: cloudId,
            surface: $8e105220e5be9b9e$var$TEAMWORK_GRAPH_MODAL_SURFACE
        }, ({ open: open })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $836e02dfba756f43$export$f1c78716874e7f8b), {
                variant: variant,
                topAppPercent: topApp?.percent,
                apps: apps,
                onClick: ()=>{
                    fireClickedEvent();
                    open({
                        defaultTab: $8e105220e5be9b9e$var$APPS_TAB_ID
                    });
                }
            }))
    };
};



var $45zaV = parcelRequire("45zaV");


var $bT2y0 = parcelRequire("bT2y0");








// Rendered only while open, so Rovodal and the Rovo chat config graph stay out of
// the byline's after-paint chunk on the view page until the user asks for them.
// Nothing is lost by unmounting: Rovodal has no exit transition — it returns
// `null` when closed and has no outer `ModalTransition`.
const $5453bab8747bee12$var$TeamworkGraphModalLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "aKQO1",
    name: "TeamworkGraphModalLoadable",
    loader: async ()=>(await (parcelRequire("auHsF"))).TeamworkGraphModal
});
function $5453bab8747bee12$export$95c2e1a0aa71e8e6({ isOpen: isOpen, onClose: onClose, contentId: contentId, connections: connections, atAGlance: atAGlance, promoBanner: promoBanner }) {
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5453bab8747bee12$var$TeamworkGraphModalLoadable, {
        isOpen: true,
        onClose: onClose,
        contentId: contentId,
        connections: connections,
        atAGlance: atAGlance,
        promoBanner: promoBanner
    });
}


function $f4e49e5d05ed910d$export$99325b1bd5089116({ contentId: contentId, connections: connections, isRovoEnabled: isRovoEnabled, onAskRovo: onAskRovo, isModalOpen: isModalOpen, onCloseModal: onCloseModal }) {
    const { atAGlance: atAGlance } = (0, $e881057e0de27ea9$export$850ea50adc381c)(contentId);
    const { element: promoBanner } = (0, $8e105220e5be9b9e$export$2fab414bcd04553f)({
        links: connections.linksTo.links
    });
    // Bound here rather than at the row, so the switch/close analytics can name the control
    // without every row action carrying the trigger. Wrapped rather than passed straight through,
    // or React would forward the click event as the prompt.
    const onAskRovoFromRow = (0, $cozmU.useCallback)((prompt)=>onAskRovo('rowAction', prompt), [
        onAskRovo
    ]);
    // The panel's "At a glance" entry, seeded with every connection url — the same prompt the
    // modal's "Add links to Rovo context" button carries — so the chat opens with the links as
    // context. Null when there are no links to send, in which case it opens unseeded.
    // Wrapped so the click event never becomes the prompt.
    const atAGlanceLinksPrompt = (0, $bT2y0.useLinksContextPrompt)(connections);
    const onAskRovoFromAtAGlance = (0, $cozmU.useCallback)(()=>onAskRovo('atAGlance', atAGlanceLinksPrompt ?? undefined), [
        onAskRovo,
        atAGlanceLinksPrompt
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5453bab8747bee12$export$95c2e1a0aa71e8e6), {
        isOpen: isModalOpen,
        onClose: onCloseModal,
        contentId: contentId,
        connections: connections,
        atAGlance: atAGlance,
        promoBanner: promoBanner
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $45zaV.ConnectionSections), {
        connections: connections,
        atAGlance: atAGlance,
        onAskRovo: isRovoEnabled ? onAskRovoFromRow : undefined,
        onAtAGlanceAskRovo: isRovoEnabled ? onAskRovoFromAtAGlance : undefined
    }), promoBanner));
}


/* TeamworkGraphPreviewPanelFooter.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $6ckMU = parcelRequire("6ckMU");

const $d72cc0f2de9fb89d$var$styles = {
    footer: "_4c065U5zaO _2Y7lL4NHnM _3YEZNOdnbC _24h04i2Njc _3iDTPbQ4SZ _0hPCNLDIqT _2IVJ4M6wH8 _22sfPnNvrM _3zygPU9r67 _0KLXrulfZc"
};
function $d72cc0f2de9fb89d$export$265b9faed850f344({ contentId: contentId, testId: testId, onAskRovo: onAskRovo }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "footer",
        testId: testId,
        xcss: $d72cc0f2de9fb89d$var$styles.footer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ckMU.TeamworkGraphShareContextButton), {
        contentId: contentId,
        testId: testId && `${testId}-share-context`,
        variant: "footer",
        shouldFitContainer: true,
        onAskRovo: onAskRovo
    }));
}












var $a1ZzW = parcelRequire("a1ZzW");

const $1b4f773989b98515$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "byline-connections.preview-panel.info-button.label",
        defaultMessage: "About related context"
    },
    tooltip: {
        id: "byline-connections.preview-panel.info-button.tooltip",
        defaultMessage: "Links and references are automatically updated here as this page gets used across your team's work."
    }
});
const $1b4f773989b98515$export$bf99789ea211097a = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a1ZzW))),
        label: formatMessage($1b4f773989b98515$var$i18n.label),
        appearance: "subtle",
        isTooltipDisabled: false,
        tooltip: {
            content: formatMessage($1b4f773989b98515$var$i18n.tooltip)
        },
        testId: "teamwork-graph-preview-panel.info-button"
    });
};

















const $9456b78cdf0a1620$var$i18n = (0, $kSwu1.defineMessages)({
    label: {
        id: "byline-connections.preview-panel.open-graph-button.view-teamwork-graph",
        defaultMessage: "View Teamwork Graph"
    }
});
const $9456b78cdf0a1620$export$ee2b640a4973c09 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.OPEN_GRAPH_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE)
            }
        }).fire();
        onClick();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "default",
        onClick: handleClick,
        testId: "teamwork-graph-preview-panel.open-graph-button"
    }, formatMessage($9456b78cdf0a1620$var$i18n.label));
};












var $bRCqW = parcelRequire("bRCqW");

const $6c5d7a56221ed430$var$i18n = (0, $kSwu1.defineMessages)({
    title: {
        id: "byline-connections.preview-panel.title-context",
        defaultMessage: "Context"
    }
});
// `label=""` because the title text beside it already names the panel.
const $6c5d7a56221ed430$var$titleIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZ9If))), {
    label: "",
    testId: "teamwork-graph-preview-panel-title-icon"
});
const $6c5d7a56221ed430$export$d9fc4cda757f6729 = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bRCqW.PreviewPanelTitle), {
        title: formatMessage($6c5d7a56221ed430$var$i18n.title),
        icon: $6c5d7a56221ed430$var$titleIcon
    });
};






var $4agZx = parcelRequire("4agZx");





const $9c84783b364c71ba$export$5c8bfb5aab8fac9b = ({ isRovoEnabled: isRovoEnabled, contentId: contentId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [mode, setMode] = (0, $cozmU.useState)('connections');
    const [prefilledPrompt, setPrefilledPrompt] = (0, $cozmU.useState)(undefined);
    // The control that opened the chat, remembered so the close event can report it too.
    const [openTrigger, setOpenTrigger] = (0, $cozmU.useState)(undefined);
    const showRovo = (0, $cozmU.useCallback)((trigger, prompt)=>{
        createAnalyticsEvent((0, $4agZx.getRovoChatSwitchedEvent)({
            surface: 'panel',
            trigger: trigger
        })).fire();
        setOpenTrigger(trigger);
        setPrefilledPrompt(prompt);
        setMode('rovo');
    }, [
        createAnalyticsEvent
    ]);
    // A prompt published by the byline popup's share-context modal. Read as the mode rather than
    // copied into it, so there is no effect setting state from state. The bridge is therefore the
    // session's source of truth, which is why `showConnections` and unmount both clear it.
    const { prompt: seededPrompt } = (0, $27c759556091eb4c$export$c742177e1216e93c)(contentId);
    const isSeeded = seededPrompt !== null;
    const activeMode = isSeeded ? 'rovo' : mode;
    const activeTrigger = isSeeded ? 'shareContext' : openTrigger;
    // The seeded entry has no `showRovo` call to carry its `switched` event, so it fires here —
    // once per session, per the ref.
    const hasFiredShareContextSwitchRef = (0, $cozmU.useRef)(false);
    const createAnalyticsEventRef = (0, $cozmU.useRef)(createAnalyticsEvent);
    createAnalyticsEventRef.current = createAnalyticsEvent;
    (0, $cozmU.useEffect)(()=>{
        if (!isSeeded || !isRovoEnabled || hasFiredShareContextSwitchRef.current) return;
        hasFiredShareContextSwitchRef.current = true;
        createAnalyticsEventRef.current((0, $4agZx.getRovoChatSwitchedEvent)({
            surface: 'panel',
            trigger: 'shareContext'
        })).fire();
    }, [
        isSeeded,
        isRovoEnabled
    ]);
    // Only the Rovo chat's back button calls this, so it always leaves the chat.
    const showConnections = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $4agZx.getRovoChatClosedEvent)({
            surface: 'panel',
            method: 'back',
            trigger: activeTrigger
        })).fire();
        (0, $27c759556091eb4c$export$7be1644a289b1480)();
        hasFiredShareContextSwitchRef.current = false;
        setOpenTrigger(undefined);
        // Cleared on the way out, or it would reappear the next time Rovo is opened — including
        // from an entry meant to open empty, like a row whose link has no url or "At a glance"
        // when there are no connection links to seed.
        setPrefilledPrompt(undefined);
        setMode('connections');
    }, [
        createAnalyticsEvent,
        activeTrigger
    ]);
    // Read through refs from the unmount cleanup so it fires with the mode (and opening trigger) at
    // dismissal without re-subscribing (and re-running the cleanup) on every mode change or update.
    const showingRovoRef = (0, $cozmU.useRef)(false);
    showingRovoRef.current = isRovoEnabled && activeMode === 'rovo';
    const activeTriggerRef = (0, $cozmU.useRef)(activeTrigger);
    activeTriggerRef.current = activeTrigger;
    (0, $cozmU.useEffect)(()=>()=>{
            if (showingRovoRef.current) createAnalyticsEventRef.current((0, $4agZx.getRovoChatClosedEvent)({
                surface: 'panel',
                method: 'panelClose',
                trigger: activeTriggerRef.current
            })).fire();
            // The bridge outlives the panel, so an unconsumed prompt has to go with it.
            (0, $27c759556091eb4c$export$7be1644a289b1480)();
        }, []);
    return {
        // Entitlement is checked alongside the mode, as the modal does, so losing Rovo falls back
        // to the connections rather than stranding the user on a chat they cannot use.
        isRovo: isRovoEnabled && activeMode === 'rovo',
        prefilledPrompt: isSeeded ? seededPrompt : prefilledPrompt,
        showRovo: showRovo,
        showConnections: showConnections
    };
};



var $5tMCB = parcelRequire("5tMCB");

const $d9e3ca7255f16432$var$styles = {
    scroll: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _4kiQYAdnbC _2WAcuGIZbP",
    body: "_4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _3YEZNOdnbC _0jFU0VIZbP",
    chatBody: "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _4kiQYAdnbC"
};
function $d9e3ca7255f16432$export$f72b05b8836efb83({ contentId: contentId }) {
    const { close: close } = (0, $lRhY3.usePreviewPanelsActions)(); // The panel is only rendered while it is open, so its sections fetch as soon as it
    // mounts — no `enabled` gate, unlike the modal.
    const connections = (0, $13c0a60f8ad3bb4e$export$275ee434c520938c)(contentId);
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    const { isRovo: isRovo, prefilledPrompt: prefilledPrompt, showRovo: showRovo, showConnections: showConnections } = (0, $9c84783b364c71ba$export$5c8bfb5aab8fac9b)({
        isRovoEnabled: isRovoLLMEnabled,
        contentId: contentId
    });
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const openModal = (0, $cozmU.useCallback)(()=>setIsModalOpen(true), []);
    const closeModal = (0, $cozmU.useCallback)(()=>setIsModalOpen(false), []); // Close first: Rovo unmounts the column that mounts the modal, so an open flag left behind
    // would pop the modal back up on the way back to connections.
    const showRovoFromPanel = (0, $cozmU.useCallback)((...args)=>{
        setIsModalOpen(false);
        showRovo(...args);
    }, [
        showRovo
    ]); // Bound here, not in the footer, so the trigger stays a wiring-point concern like the others.
    const showRovoFromShareContext = (0, $cozmU.useCallback)((prompt)=>showRovoFromPanel('shareContext', prompt), [
        showRovoFromPanel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5WTxQ.PreviewPanel), {
        testId: "teamwork-graph-preview-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fE1YT.PreviewPanelHeader), {
        onClose: ()=>close(),
        analyticsClient: null,
        parentProduct: (0, $5f7d816a14638938$export$f6fc4a5779d5dc2c),
        panelType: (0, $5f7d816a14638938$export$e8a5079e96625ede),
        moreActions: !isRovo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9456b78cdf0a1620$export$ee2b640a4973c09), {
            onClick: openModal
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6c5d7a56221ed430$export$d9fc4cda757f6729), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1b4f773989b98515$export$bf99789ea211097a), null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $d9e3ca7255f16432$var$styles.scroll,
        testId: "teamwork-graph-preview-panel-scroll"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kMhHg.PreviewPanelBody), {
        analyticsClient: null,
        parentProduct: (0, $5f7d816a14638938$export$f6fc4a5779d5dc2c),
        panelType: (0, $5f7d816a14638938$export$e8a5079e96625ede),
        styles: isRovo ? $d9e3ca7255f16432$var$styles.chatBody : $d9e3ca7255f16432$var$styles.body
    }, isRovo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tMCB.TeamworkGraphChatColumn), {
        onBack: showConnections,
        prefilledPrompt: prefilledPrompt
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4e49e5d05ed910d$export$99325b1bd5089116), {
        contentId: contentId,
        connections: connections,
        isRovoEnabled: isRovoLLMEnabled,
        onAskRovo: showRovoFromPanel,
        isModalOpen: isModalOpen,
        onCloseModal: closeModal
    }))), !isRovo && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d72cc0f2de9fb89d$export$265b9faed850f344), {
        contentId: contentId,
        testId: "teamwork-graph-preview-panel-footer",
        onAskRovo: isRovoLLMEnabled ? showRovoFromShareContext : undefined
    }));
}
const $d9e3ca7255f16432$export$74c6829b8c7e1a4 = (0, $3plmx.withSmartCardProviderContext)($d9e3ca7255f16432$export$f72b05b8836efb83);


const $9fc15bfa2158121b$var$getPanelId = (contentId)=>contentId ? `${0, $5f7d816a14638938$export$e043f5004f4e5a4}_${contentId}` : (0, $5f7d816a14638938$export$e043f5004f4e5a4);
const $9fc15bfa2158121b$export$240bf3f47c27458b = (contentId)=>{
    const { open: open, close: close } = (0, $lRhY3.usePreviewPanelsActions)();
    const panelId = $9fc15bfa2158121b$var$getPanelId(contentId);
    // Asked for by id, not bare: `useIsPreviewPanelOpen()` reports any open preview panel,
    // so a page preview panel would read as this one.
    const isTeamworkGraphPreviewPanelOpen = (0, $87whh.useIsPreviewPanelOpen)(panelId);
    const openTeamworkGraphPreviewPanel = (0, $cozmU.useCallback)(()=>{
        open({
            panel: {
                id: panelId,
                type: (0, $5f7d816a14638938$export$e8a5079e96625ede),
                product: (0, $5f7d816a14638938$export$ddbac920bdbdb256),
                content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d9e3ca7255f16432$export$74c6829b8c7e1a4), {
                        contentId: contentId
                    })
            }
        });
    }, [
        open,
        panelId,
        contentId
    ]);
    /**
   * Opens the panel straight into a Rovo chat seeded with `prompt`, for callers with no Rovo of
   * their own — the byline popup's share-context modal.
   *
   * Published before `open()`, so an already-open panel (where `open()` is a no-op) still sees
   * the prompt. See `seededRovoPromptBridge`.
   */ const openTeamworkGraphPreviewPanelWithRovo = (0, $cozmU.useCallback)((prompt)=>{
        (0, $27c759556091eb4c$export$a0353d0d9eb2f715)({
            contentId: contentId,
            prompt: prompt
        });
        openTeamworkGraphPreviewPanel();
    }, [
        contentId,
        openTeamworkGraphPreviewPanel
    ]);
    const closeTeamworkGraphPreviewPanel = (0, $cozmU.useCallback)(()=>close(), [
        close
    ]);
    return {
        isTeamworkGraphPreviewPanelOpen: isTeamworkGraphPreviewPanelOpen,
        openTeamworkGraphPreviewPanel: openTeamworkGraphPreviewPanel,
        openTeamworkGraphPreviewPanelWithRovo: openTeamworkGraphPreviewPanelWithRovo,
        closeTeamworkGraphPreviewPanel: closeTeamworkGraphPreviewPanel
    };
};



const $e23f8c791f566bf8$export$2b794d642b6119fd = ({ isEmbeddedMenu: isEmbeddedMenu, outgoingLinks: outgoingLinks, incomingLinks: incomingLinks, relatedContentLinks: relatedContentLinks, hasDevDocsConnection: hasDevDocsConnection, outgoingLinksLoading: outgoingLinksLoading, incomingLinksLoading: incomingLinksLoading, relatedContentLoading: relatedContentLoading, outgoingFillsStack: outgoingFillsStack, reservedIconCount: reservedIconCount })=>{
    const hasConnection = isEmbeddedMenu ? outgoingLinks.length > 0 || hasDevDocsConnection || incomingLinks.length > 0 : hasDevDocsConnection || (0, $f18dee4c2180353b$export$4184afff02de6fec)({
        relatedContentLinks: relatedContentLinks,
        incomingLinks: incomingLinks,
        outgoingLinks: outgoingLinks
    });
    const isResolving = outgoingLinksLoading || incomingLinksLoading && !outgoingFillsStack || !isEmbeddedMenu && !hasConnection && relatedContentLoading;
    const shouldRenderByline = hasConnection || isEmbeddedMenu && reservedIconCount > 0;
    return {
        hasConnection: hasConnection,
        isResolving: isResolving,
        shouldRenderByline: shouldRenderByline
    };
};





const $55b5fa95660732ad$var$i18n = (0, $kSwu1.defineMessages)({
    tooltipTwg: {
        id: "byline-connections.tooltip-twg-v2",
        defaultMessage: "See how this content connects to your team's work"
    }
});
const $55b5fa95660732ad$export$d734136a7b018efe = (ref, node)=>{
    if (typeof ref === 'function') ref(node);
    else if (ref && 'current' in ref) ref.current = node;
};
/**
 * Resolves the byline tooltip text. Returns an empty string while the menu is
 * open (the tooltip is suppressed then), otherwise the Teamwork Graph label.
 */ const $55b5fa95660732ad$var$getTooltipContent = (isOpen, formatMessage)=>{
    if (isOpen) return '';
    return formatMessage($55b5fa95660732ad$var$i18n.tooltipTwg);
};
const $55b5fa95660732ad$var$BylineConnectionsInner = ({ contentId: contentId, connectionAncestors: connectionAncestors, pageVersion: pageVersion, pageUpdatedAt: pageUpdatedAt })=>{
    const { title: title, error: pageTitleError } = (0, $ew8wg.usePageTitle)({
        contentId: contentId
    });
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { Popup: Popup } = (0, $lsxnT.useChoreographerAssets)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const { isTeamworkGraphPreviewPanelOpen: isTeamworkGraphPreviewPanelOpen, openTeamworkGraphPreviewPanel: openTeamworkGraphPreviewPanel } = (0, $9fc15bfa2158121b$export$240bf3f47c27458b)(contentId);
    const [menuState, setMenuState] = (0, $cozmU.useState)({
        contentId: contentId,
        isOpen: false,
        hasOpenedPanel: false
    });
    if (menuState.contentId !== contentId) setMenuState({
        contentId: contentId,
        isOpen: false,
        hasOpenedPanel: isTeamworkGraphPreviewPanelOpen
    });
    else if (isTeamworkGraphPreviewPanelOpen && !menuState.hasOpenedPanel) setMenuState({
        ...menuState,
        hasOpenedPanel: true
    });
    const isCurrentPage = menuState.contentId === contentId;
    const isOpen = isCurrentPage && menuState.isOpen;
    // The popup's focus trap returns focus to the trigger on close by calling
    // `.focus()` (without `preventScroll`), which scrolls the trigger back into
    // view. For a link navigation that fights the in-page scroll, so we disable
    // the trap's focus return (`shouldReturnFocus={false}`) and instead restore
    // focus ourselves on non-navigation closes (Esc / outside click) using
    // `preventScroll` — keeping keyboard a11y without the scroll jump.
    const triggerRef = (0, $cozmU.useRef)(null);
    const navigatedRef = (0, $cozmU.useRef)(false);
    const hasFiredViewedRef = (0, $cozmU.useRef)(false);
    const { outgoing: outgoing, incoming: incoming, relatedContent: relatedContent, devDocsConnection: devDocsConnection } = (0, $14b4659b7aaed708$export$bb74724ea117ee6f)({
        contentId: contentId,
        connectionAncestors: connectionAncestors,
        pageVersion: pageVersion,
        pageUpdatedAt: pageUpdatedAt,
        pageTitle: pageTitleError ? null : title,
        atAGlanceEnabled: isCurrentPage && menuState.hasOpenedPanel
    });
    const { loading: outgoingLinksLoading, links: outgoingLinks, refreshLinkUrl: refreshLinkUrl } = outgoing;
    const { links: incomingLinks, loading: incomingLinksLoading } = incoming;
    const { links: relatedContentLinks, loading: relatedContentLoading } = relatedContent;
    // Embedded Confluence has no preview panel, so it gets a menu that never opens one.
    // Either the byline experiment or the planner gate turns it on.
    const isEmbeddedMenu = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)() && ((0, $6mKj3.isExperimentEnabled)('confluence_1p_and_3p_connection_byline_experiment') || (0, $9wGTI.fg)('migrate_planner_to_docs_tab'));
    const devDocsIcons = (0, $cozmU.useMemo)(()=>{
        const devDocsProviderIcon = (0, $b3c77e69626f7927$export$65120229cda600d)(devDocsConnection);
        return devDocsProviderIcon ? [
            devDocsProviderIcon
        ] : undefined;
    }, [
        devDocsConnection
    ]);
    // Outgoing links fill the stack first, so once they alone fill it no incoming icon can change
    // what is painted and the trigger need not wait for the graph query.
    const outgoingFillsStack = (0, $cozmU.useMemo)(()=>(0, $jJhQa.getBylineConnectionIcons)(outgoingLinks, devDocsIcons).length >= (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS), [
        outgoingLinks,
        devDocsIcons
    ]);
    const hasOutboundConnection = outgoingLinks.length > 0 || devDocsConnection !== null;
    const outboundState = (0, $4fdcf8c799fd8a14$export$4ec68330314c7b96)(contentId);
    const incomingState = (0, $c1244bdd1b458e82$export$36c53bcdf571f79b)(contentId);
    const reservedIconCount = (0, $3C8hL.getReservedBylineIconCount)(outboundState, devDocsConnection !== null, incomingState?.status === 'present');
    // The show/hide and wait rules for both menus live in `getBylineVisibility`.
    const { hasConnection: hasConnection, isResolving: isResolving, shouldRenderByline: shouldRenderByline } = (0, $cozmU.useMemo)(()=>(0, $e23f8c791f566bf8$export$2b794d642b6119fd)({
            isEmbeddedMenu: isEmbeddedMenu,
            outgoingLinks: outgoingLinks,
            incomingLinks: incomingLinks,
            relatedContentLinks: relatedContentLinks,
            hasDevDocsConnection: devDocsConnection !== null,
            outgoingLinksLoading: outgoingLinksLoading,
            incomingLinksLoading: incomingLinksLoading,
            relatedContentLoading: relatedContentLoading,
            outgoingFillsStack: outgoingFillsStack,
            reservedIconCount: reservedIconCount
        }), [
        isEmbeddedMenu,
        outgoingLinks,
        incomingLinks,
        relatedContentLinks,
        devDocsConnection,
        outgoingLinksLoading,
        incomingLinksLoading,
        relatedContentLoading,
        outgoingFillsStack,
        reservedIconCount
    ]);
    (0, $460c5801038ac219$export$7705042750e63836)(contentId, isResolving, hasConnection, outgoing.error || (!hasOutboundConnection ? incoming.error : null));
    // Fire a single "viewed" event the first time the byline actually renders its
    // content — skip while resolving and while there is nothing to show (both cases
    // early-return before the trigger is visible).
    (0, $cozmU.useEffect)(()=>{
        if (hasFiredViewedRef.current || isResolving || !shouldRenderByline) return;
        hasFiredViewedRef.current = true;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'viewed',
                actionSubject: 'byline',
                actionSubjectId: (0, $I7TEB.BYLINE_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE)
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        isResolving,
        shouldRenderByline
    ]);
    const handleClose = (0, $cozmU.useCallback)(()=>{
        setMenuState((current)=>({
                ...current,
                isOpen: false
            }));
        // Navigating away lands here too — the popup fires `onClose` once the panel
        // opens — and that is not a dismissal: it reports its own event, and focus belongs to
        // whatever is opening rather than back on the trigger.
        if (navigatedRef.current) return;
        // What is left is every real dismissal — Esc and outside clicks — so this is
        // one close event per close, mirroring the modals.
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.MENU_CLOSE_ACTION_SUBJECT_ID),
                source: isEmbeddedMenu ? (0, $I7TEB.EMBEDDED_MENU_SOURCE) : (0, $I7TEB.MENU_SOURCE)
            }
        }).fire();
        // Esc / outside-click close: return focus to the trigger without scrolling.
        triggerRef.current?.focus({
            preventScroll: true
        });
    }, [
        createAnalyticsEvent,
        isEmbeddedMenu
    ]);
    const handleNavigate = (0, $cozmU.useCallback)(()=>{
        navigatedRef.current = true;
        setMenuState((current)=>({
                ...current,
                isOpen: false
            }));
    }, []);
    const handleOpenPreviewPanel = (0, $cozmU.useCallback)(()=>{
        navigatedRef.current = true;
        openTeamworkGraphPreviewPanel();
        setMenuState((current)=>({
                ...current,
                isOpen: false
            }));
    }, [
        openTeamworkGraphPreviewPanel
    ]);
    const handleToggle = (0, $cozmU.useCallback)(()=>{
        navigatedRef.current = false;
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.BYLINE_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE)
            }
        }).fire();
        setMenuState((current)=>({
                ...current,
                isOpen: !isOpen
            }));
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    if (isResolving) // Keep three placeholder slots across SSR, chunk loading and data loading whenever a
    // preloaded connection signal exists. The visibility rules above still decide when the
    // loaded trigger can appear and whether the page reaches the row minimum. CCINT-9354
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d13ffa3aaf9dd66c$export$f8ba3742be6a3e0d), {
        contentId: contentId,
        connectionAncestors: connectionAncestors
    });
    if (!shouldRenderByline) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55dbae87bfebb50e$export$8b56d9356350e1f6), {
        appearance: "loaded"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Popup, {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-start",
        shouldReturnFocus: false,
        content: ()=>isEmbeddedMenu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $413f8f6d87a9e0c2$export$661e43968c0d4a47), {
                links: outgoingLinks,
                relatedContentLinks: relatedContentLinks,
                relatedContentLoading: relatedContentLoading,
                refreshLinkUrl: refreshLinkUrl,
                onNavigate: handleNavigate
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $70835a6aefe6c403$export$e4220f7b255072a8), {
                links: outgoingLinks,
                incomingLinks: incomingLinks,
                additionalIcons: devDocsIcons,
                minIcons: (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS),
                relatedContentLinks: relatedContentLinks,
                devDocsConnection: devDocsConnection,
                contentId: contentId,
                showFooter: outgoingLinks.length > 0,
                refreshLinkUrl: refreshLinkUrl,
                onNavigate: handleNavigate,
                onOpenPreviewPanel: handleOpenPreviewPanel
            }),
        trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: $55b5fa95660732ad$var$getTooltipContent(isOpen, formatMessage)
            }, ({ ref: tooltipRef, onClick: onTooltipClick, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $55dbae87bfebb50e$export$a5631cafd5b67535), {
                    appearance: "loaded",
                    links: outgoingLinks,
                    incomingLinks: incomingLinks,
                    additionalIcons: devDocsIcons,
                    minIcons: (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS),
                    buttonProps: {
                        ...tooltipProps,
                        ...triggerProps,
                        ref: (node)=>{
                            triggerRef.current = node;
                            $55b5fa95660732ad$export$d734136a7b018efe(ref, node);
                            tooltipRef(node);
                        },
                        onClick: (event)=>{
                            onTooltipClick(event);
                            handleToggle();
                        },
                        'aria-expanded': isOpen,
                        'aria-haspopup': 'dialog'
                    }
                }))
    }));
};
const $55b5fa95660732ad$export$867b5e5ad0743f37 = (0, $3plmx.withSmartCardProviderContext)($55b5fa95660732ad$var$BylineConnectionsInner);
module.exports["BylineConnections"] = $55b5fa95660732ad$export$867b5e5ad0743f37;

});

parcelRegister("I7TEB", function(module, exports) {
const $87dcbdc0d0f33628$export$f7109619a5e9e0d6 = 'byline-connections';
const $87dcbdc0d0f33628$export$101fcd7717c218c = 'teamworkGraphAskRovo';
const $87dcbdc0d0f33628$export$b27e11d1203504c6 = 'teamworkGraphAtAGlance';
const $87dcbdc0d0f33628$export$44da7239490811f0 = 'teamworkGraphByline';
const $87dcbdc0d0f33628$export$934aa167151db3b1 = 'teamworkGraphConnectionRow';
const $87dcbdc0d0f33628$export$44cb3909ff4c43b4 = 'teamworkGraphConnectionRowPreview';
const $87dcbdc0d0f33628$export$9f421e6b009b0c46 = 'embeddedConnectionsBylineMenu';
const $87dcbdc0d0f33628$export$cf7911cc0496896d = 'incomingLinks';
const $87dcbdc0d0f33628$export$55cebf666ed7ac96 = 'incomingLinksLoadMore';
const $87dcbdc0d0f33628$export$464cb4cd27148792 = 'connectionsBylineMenuClose';
const $87dcbdc0d0f33628$export$acc71150ed5ad64c = 'connectionsBylineMenuFooter';
const $87dcbdc0d0f33628$export$5ba4366f11f23c55 = 'connectionsBylineMenuShowMore';
const $87dcbdc0d0f33628$export$bba211f21228be2c = 'connectionsBylineMenu';
const $87dcbdc0d0f33628$export$40345c2a055906c6 = 'teamworkGraphModal';
const $87dcbdc0d0f33628$export$6d9fd39253136607 = 'teamworkGraphModalClose';
const $87dcbdc0d0f33628$export$a622ec92a443b64b = 'teamworkGraphModal';
const $87dcbdc0d0f33628$export$be7c2fb105208df8 = 'teamworkGraphOpenGraph';
const $87dcbdc0d0f33628$export$1b17b0123cd467d7 = 'pagePeople';
const $87dcbdc0d0f33628$export$1e3d227809c0b3f7 = 'teamworkGraphPreviewPanel';
const $87dcbdc0d0f33628$export$759cbc1c81b47827 = 'teamworkGraphPeopleAndAgentsRow';
const $87dcbdc0d0f33628$export$ebf3ac68dcdd04f3 = 'teamworkGraphPeopleAndAgentsShowMore';
const $87dcbdc0d0f33628$export$9de0d39be33ad03f = 'relatedContent';
const $87dcbdc0d0f33628$export$42ea7a21a01a98f7 = 'connectionsBylineMenuItemScroll';
const $87dcbdc0d0f33628$export$d4c2e3fd0fe0ee3e = 'teamworkGraphShareContext';
const $87dcbdc0d0f33628$export$9c4db6e16d3288ef = 'teamworkGraphShareContextClose';
const $87dcbdc0d0f33628$export$50e1feeed3c175fe = 'teamworkGraphShareContextCopyPrompt';
const $87dcbdc0d0f33628$export$547360dc458798ec = 'teamworkGraphShareContextModal';
const $87dcbdc0d0f33628$export$c5d0213fdeb686c8 = 'teamworkGraphShareContextTool';
module.exports["ANALYTICS_SOURCE"] = $87dcbdc0d0f33628$export$f7109619a5e9e0d6;
module.exports["ASK_ROVO_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$101fcd7717c218c;
module.exports["AT_A_GLANCE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$b27e11d1203504c6;
module.exports["BYLINE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$44da7239490811f0;
module.exports["CONNECTION_ROW_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$934aa167151db3b1;
module.exports["CONNECTION_ROW_PREVIEW_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$44cb3909ff4c43b4;
module.exports["EMBEDDED_MENU_SOURCE"] = $87dcbdc0d0f33628$export$9f421e6b009b0c46;
module.exports["INCOMING_LINKS_ACTION_SUBJECT"] = $87dcbdc0d0f33628$export$cf7911cc0496896d;
module.exports["INCOMING_LINKS_LOAD_MORE_ACTION_SUBJECT"] = $87dcbdc0d0f33628$export$55cebf666ed7ac96;
module.exports["MENU_CLOSE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$464cb4cd27148792;
module.exports["MENU_FOOTER_SOURCE"] = $87dcbdc0d0f33628$export$acc71150ed5ad64c;
module.exports["MENU_SHOW_MORE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$5ba4366f11f23c55;
module.exports["MENU_SOURCE"] = $87dcbdc0d0f33628$export$bba211f21228be2c;
module.exports["MODAL_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$40345c2a055906c6;
module.exports["MODAL_CLOSE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$6d9fd39253136607;
module.exports["MODAL_SOURCE"] = $87dcbdc0d0f33628$export$a622ec92a443b64b;
module.exports["OPEN_GRAPH_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$be7c2fb105208df8;
module.exports["PAGE_PEOPLE_ACTION_SUBJECT"] = $87dcbdc0d0f33628$export$1b17b0123cd467d7;
module.exports["PANEL_SOURCE"] = $87dcbdc0d0f33628$export$1e3d227809c0b3f7;
module.exports["PEOPLE_AND_AGENTS_ROW_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$759cbc1c81b47827;
module.exports["PEOPLE_AND_AGENTS_SHOW_MORE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$ebf3ac68dcdd04f3;
module.exports["RELATED_CONTENT_ACTION_SUBJECT"] = $87dcbdc0d0f33628$export$9de0d39be33ad03f;
module.exports["SCROLL_RESULT_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$42ea7a21a01a98f7;
module.exports["SHARE_CONTEXT_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$d4c2e3fd0fe0ee3e;
module.exports["SHARE_CONTEXT_CLOSE_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$9c4db6e16d3288ef;
module.exports["SHARE_CONTEXT_COPY_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$50e1feeed3c175fe;
module.exports["SHARE_CONTEXT_MODAL_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$547360dc458798ec;
module.exports["SHARE_CONTEXT_TOOL_ACTION_SUBJECT_ID"] = $87dcbdc0d0f33628$export$c5d0213fdeb686c8;

});

parcelRegister("hje3t", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $bUd6P = parcelRequire("bUd6P");


var $iMnC5 = parcelRequire("iMnC5");


var $9NPFC = parcelRequire("9NPFC");

function $fc837618e233a230$export$92d8fa668dcc84de({ size: size }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- `white` is a member of Tile's `backgroundColor` union, which the rule cannot see; `logo-third-party` suppresses this for the same reason.
        backgroundColor: "white",
        hasBorder: true,
        label: "",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        style: {
            lineHeight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bUd6P.RovoHexIcon), {
        label: "",
        size: size
    })));
}
module.exports["RovoTileIcon"] = $fc837618e233a230$export$92d8fa668dcc84de;

});

parcelRegister("6F7l4", function(module, exports) {
/* ConnectionsByLineMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $dinVW = parcelRequire("dinVW");


var $4aRua = parcelRequire("4aRua");


var $9NPFC = parcelRequire("9NPFC");


var $3jwuS = parcelRequire("3jwuS");


var $jmjWc = parcelRequire("jmjWc");


var $fURMF = parcelRequire("fURMF");


var $I7TEB = parcelRequire("I7TEB");

/* ConnectionsByLineRowActions.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $1sCHt = parcelRequire("1sCHt");




const $ad20e203017545fb$var$styles = {
    cluster: "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT _4xdlr0chRC _3YEZNOdnbC"
};
const $ad20e203017545fb$var$ConnectionsByLineRowActionButton = ({ action: action, item: item })=>{
    const handleClick = (0, $cozmU.useCallback)((event)=>{
        // The row itself is clickable — it scrolls to the rendered link or opens
        // it in a new tab — so an action click must not bubble into that handler.
        event.stopPropagation();
        action.onClick(item);
    }, [
        action,
        item
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        appearance: "subtle",
        spacing: "compact",
        icon: action.icon,
        label: action.label,
        isTooltipDisabled: false,
        onClick: handleClick,
        testId: `connections-byline-row-action-${action.id}`
    });
};
const $ad20e203017545fb$export$316485efcf724587 = ({ actions: actions, item: item })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $ad20e203017545fb$var$styles.cluster
    }, actions.map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($ad20e203017545fb$var$ConnectionsByLineRowActionButton, {
            key: action.id,
            action: action,
            item: item
        })));












var $bLfHG = parcelRequire("bLfHG");


var $4agZx = parcelRequire("4agZx");


var $bEvUu = parcelRequire("bEvUu");

/**
 * Derives the "Ask Rovo" row action for a connections row: an icon button that opens
 * the modal's Rovo chat seeded with this row's page as context.
 *
 * Returns null unless the caller passes an `onAskRovo` handler. The modal and the preview panel
 * both thread one, so the action is absent only in the byline popup, which has no Rovo at all.
 * Threaded as a prop alongside `onPreviewOpen` (rather than via context) so both callbacks reach
 * the row-action hooks the same way. Called by `ConnectionsByLineMenuItem` for every row,
 * alongside `useSmartLinkPreviewAction`.
 */ const $ab2f7621a35e6725$var$i18n = (0, $kSwu1.defineMessages)({
    askRovo: {
        id: "byline-connections.menu.item.ask-rovo",
        defaultMessage: "Ask Rovo"
    },
    contextPrompt: {
        id: "byline-connections.menu.item.ask-rovo-context-prompt",
        defaultMessage: "Fetch the content behind this link and use it as context for subsequent tasks:"
    }
});
const $ab2f7621a35e6725$var$ASK_ROVO_ACTION_ID = 'ask-rovo';
const $ab2f7621a35e6725$export$38f8161160ea9803 = (item, onAskRovo)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        if (!onAskRovo) return;
        createAnalyticsEvent((0, $4agZx.getAskRovoClickedEvent)({
            trigger: 'rowAction',
            product: item.product,
            resourceType: item.resourceType
        })).fire();
        // Prefill (not auto-send) a prompt pointing Rovo at this row's page, so the chat's
        // context is the connected page rather than the page the byline is on. The url is
        // joined on in code (not via the message) because the i18n extractor collapses a
        // newline inside a message to a space. Unseeded when the row has no url.
        onAskRovo(item.url ? [
            formatMessage($ab2f7621a35e6725$var$i18n.contextPrompt),
            item.url
        ].join('\n') : undefined);
    }, [
        createAnalyticsEvent,
        formatMessage,
        item.product,
        item.resourceType,
        item.url,
        onAskRovo
    ]);
    return (0, $cozmU.useMemo)(()=>onAskRovo ? {
            id: $ab2f7621a35e6725$var$ASK_ROVO_ACTION_ID,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bLfHG))),
            label: formatMessage($ab2f7621a35e6725$var$i18n.askRovo),
            onClick: handleClick
        } : null, [
        onAskRovo,
        formatMessage,
        handleClick
    ]);
};









var $8VfSP = parcelRequire("8VfSP");


var $gybyF = parcelRequire("gybyF");


var $faU9A = parcelRequire("faU9A");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");







/**
 * Derives the "Open preview" row action for a connections row from the link's
 * SmartCard state.
 *
 * Called by `ConnectionsByLineMenuItem` for every row, which appends the result
 * to the actions its section supplied. Returns null unless the link is granted
 * and its SmartCard entry yields a `preview-content` action, so rows that can't
 * be previewed show no affordance. Requires a SmartCard provider in scope.
 */ const $ba21ca9b5c973fa0$var$i18n = (0, $kSwu1.defineMessages)({
    openPreview: {
        id: "byline-connections.menu.item.open-preview",
        defaultMessage: "Open preview"
    }
});
const $ba21ca9b5c973fa0$var$PREVIEW_ACTION_ID = 'preview-content';
const $ba21ca9b5c973fa0$var$reportPreviewActionError = (err)=>{
    const errorObj = err instanceof Error ? err : new Error(String(err));
    (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
};
const $ba21ca9b5c973fa0$export$e1a8e9c541506962 = (item, onPreviewOpen)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const hasPreviewAccess = item.access === 'granted';
    const actions = (0, $gybyF.useSmartLinkActions)({
        url: item.url,
        appearance: 'inline',
        prefetch: hasPreviewAccess
    });
    const previewAction = actions.find((action)=>action.id === $ba21ca9b5c973fa0$var$PREVIEW_ACTION_ID);
    // The platform only derives `preview-content` when the SmartCard entry carries
    // an embed `data.preview`. Same-site Confluence pages often resolve without
    // one — unlike Jira/3P links — leaving the row with no preview affordance. A
    // full reload makes ORS return the embed, after which the action appears.
    const reloadLink = (0, $faU9A.useSmartLinkReload)({
        url: item.url
    });
    const hasRequestedPreviewResolveRef = (0, $cozmU.useRef)(false);
    // Reload on mount rather than on hover, so the icon is ready before the user
    // reaches the row, and at most once to avoid resolve loops. Deliberately not
    // gated on `actions.length`: a metadata-only entry yields zero actions, so
    // gating on it would block exactly the rows that need the reload.
    (0, $cozmU.useEffect)(()=>{
        if (hasPreviewAccess && !previewAction && !hasRequestedPreviewResolveRef.current) {
            hasRequestedPreviewResolveRef.current = true;
            reloadLink();
        }
    }, [
        hasPreviewAccess,
        previewAction,
        reloadLink
    ]);
    const handlePreviewInvoke = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.CONNECTION_ROW_PREVIEW_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE),
                attributes: {
                    product: item.product,
                    resourceType: item.resourceType
                }
            }
        }).fire();
        onPreviewOpen?.();
        previewAction?.invoke().catch($ba21ca9b5c973fa0$var$reportPreviewActionError);
    }, [
        createAnalyticsEvent,
        item.product,
        item.resourceType,
        onPreviewOpen,
        previewAction
    ]);
    const showPreviewAction = hasPreviewAccess && Boolean(previewAction);
    return (0, $cozmU.useMemo)(()=>showPreviewAction ? {
            id: $ba21ca9b5c973fa0$var$PREVIEW_ACTION_ID,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))),
            label: formatMessage($ba21ca9b5c973fa0$var$i18n.openPreview),
            onClick: handlePreviewInvoke
        } : null, [
        showPreviewAction,
        formatMessage,
        handlePreviewInvoke
    ]);
};


const $27e32f8ec84143be$export$e5922176f457b015 = (item, onPreviewOpen, onAskRovo)=>{
    const previewAction = (0, $ba21ca9b5c973fa0$export$e1a8e9c541506962)(item, onPreviewOpen);
    const askRovoAction = (0, $ab2f7621a35e6725$export$38f8161160ea9803)(item, onAskRovo);
    return (0, $cozmU.useMemo)(()=>[
            previewAction,
            askRovoAction
        ].filter((action)=>action !== null), [
        previewAction,
        askRovoAction
    ]);
};






var $eEPSE = parcelRequire("eEPSE");


var $7zxJs = parcelRequire("7zxJs");










const $ee74b2779b35b5c3$var$ANALYTICS_SOURCE = 'connectionsBylineMenu';
const $ee74b2779b35b5c3$var$getAnalyticsAttributes = (item, status, reason)=>({
        product: item.product,
        resourceType: item.resourceType,
        authProviderKey: item.authProviders[0]?.key ?? null,
        access: item.access,
        occurrenceIndex: item.occurrenceIndex,
        ...status ? {
            status: status
        } : {},
        ...reason !== undefined ? {
            reason: reason
        } : {}
    });
const $ee74b2779b35b5c3$var$reportConnectError = (err)=>{
    const errorObj = err instanceof Error ? err : new Error(String(err));
    (0, $5ZqQS.getMonitoringClient)().submitError(errorObj, {
        attribution: (0, $3IBnw.Attribution).INTEGRATIONS
    });
};
const $ee74b2779b35b5c3$export$d93037bf2dc1b1f0 = ({ item: item, refreshLinkUrl: refreshLinkUrl, onConnectSuccess: onConnectSuccess })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isConnecting, setIsConnecting] = (0, $cozmU.useState)(false);
    const connect = (0, $cozmU.useCallback)((event)=>{
        event.stopPropagation();
        if (isConnecting) return;
        const authProvider = item.authProviders[0];
        if (!authProvider) return;
        setIsConnecting(true);
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'connectionsBylineConnectButton',
                source: $ee74b2779b35b5c3$var$ANALYTICS_SOURCE,
                attributes: $ee74b2779b35b5c3$var$getAnalyticsAttributes(item)
            }
        }).fire();
        (async ()=>{
            try {
                await (0, $eEPSE.auth)(authProvider.url);
            } catch (err) {
                const reason = err instanceof (0, $7zxJs.AuthError) ? err.type ?? null : null;
                createAnalyticsEvent({
                    type: 'sendOperationalEvent',
                    data: {
                        action: 'failed',
                        actionSubject: 'auth',
                        actionSubjectId: 'connectionsBylineConnectAuth',
                        source: $ee74b2779b35b5c3$var$ANALYTICS_SOURCE,
                        attributes: $ee74b2779b35b5c3$var$getAnalyticsAttributes(item, 'failed', reason)
                    }
                }).fire();
                $ee74b2779b35b5c3$var$reportConnectError(err);
                setIsConnecting(false);
                return;
            }
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    action: 'succeeded',
                    actionSubject: 'auth',
                    actionSubjectId: 'connectionsBylineConnectAuth',
                    source: $ee74b2779b35b5c3$var$ANALYTICS_SOURCE,
                    attributes: $ee74b2779b35b5c3$var$getAnalyticsAttributes(item, 'success')
                }
            }).fire();
            try {
                await refreshLinkUrl(item);
                onConnectSuccess?.();
            } catch (err) {
                $ee74b2779b35b5c3$var$reportConnectError(err);
                setIsConnecting(false);
            }
        })();
    }, [
        createAnalyticsEvent,
        isConnecting,
        item,
        onConnectSuccess,
        refreshLinkUrl
    ]);
    return {
        connect: connect,
        isConnecting: isConnecting
    };
};


const $a0b23ddb5269aeb3$var$LIVE_PAGE_SCROLL_ROOT_SELECTOR = '.fabric-editor-popup-scroll-parent';
const $a0b23ddb5269aeb3$var$MAIN_CONTENT_ID = 'AkMainContent';
const $a0b23ddb5269aeb3$export$6980ce4ab4fcefe5 = (isLivePage)=>{
    const currentDocument = typeof document === 'undefined' ? undefined : document;
    if (!currentDocument) return undefined;
    if (isLivePage) return currentDocument.querySelector($a0b23ddb5269aeb3$var$LIVE_PAGE_SCROLL_ROOT_SELECTOR) ?? undefined;
    return currentDocument.getElementById($a0b23ddb5269aeb3$var$MAIN_CONTENT_ID) ?? currentDocument;
};
const $a0b23ddb5269aeb3$export$e8a1a083f5b3b175 = ({ root: root, url: url })=>{
    const element = Array.from(root.querySelectorAll('a[href]')).find((anchor)=>anchor.getAttribute('href') === url);
    return element ? {
        status: 'found',
        element: element
    } : {
        status: 'not_found'
    };
};



var $38aC9 = parcelRequire("38aC9");


var $eyzEJ = parcelRequire("eyzEJ");


var $hDf5o = parcelRequire("hDf5o");




function $4a8664392fb76f90$export$a8859a12c9f593b4(dateString, locale) {
    if (!dateString) return undefined;
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return undefined;
    const diffDays = Math.floor((Date.now() - date.getTime()) / 86400000);
    if (diffDays < 0) return undefined;
    const rtf = new Intl.RelativeTimeFormat(locale, {
        numeric: 'always'
    });
    if (diffDays < 7) return rtf.format(-diffDays, 'day');
    return rtf.format(-Math.floor(diffDays / 7), 'week');
}
const $4a8664392fb76f90$export$67580b1c13935958 = (item, locale)=>{
    // Slot 1 — classification: "{Product} {resourceType}". Product uses the
    // customer-facing label (never the `townsquare` codename); resourceType is
    // lowercased. Either part is omitted when its source field is absent.
    const productLabel = (0, $eyzEJ.formatProduct)(item.product);
    const resourceTypeLabel = (0, $hDf5o.formatLabel)(item.resourceType)?.toLowerCase();
    const parts = [
        productLabel,
        resourceTypeLabel
    ].filter((part)=>Boolean(part));
    // Guard against duplicate words (e.g. townsquare "Goals" app → "Goals goals").
    const slot1 = parts.length === 2 && parts[0].toLowerCase() === parts[1].toLowerCase() ? parts[0] : parts.join(' ') || undefined;
    // Slot 2 — person: who created, updated, or owns it.
    const slot2 = item.owner || item.createdBy || item.updatedBy || item.assignedTo;
    // Slot 3 — date: when it was last touched.
    const slot3 = $4a8664392fb76f90$export$a8859a12c9f593b4(item.updatedAt, locale) || $4a8664392fb76f90$export$a8859a12c9f593b4(item.createdAt, locale) || null;
    return [
        slot1,
        slot2,
        slot3
    ];
};



var $5b9Ab = parcelRequire("5b9Ab");





const $db3ade85489bc276$var$UnconnectedConnectorHoverCardLoadable = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "ZM6iy",
    name: "UnconnectedConnectorHoverCardLoadable",
    loader: async ()=>(await (parcelRequire("7su1d"))).UnconnectedConnectorHoverCard
});
const $db3ade85489bc276$var$i18n = (0, $kSwu1.defineMessages)({
    connect: {
        id: "byline-connections.menu.item.connect",
        defaultMessage: "Connect"
    },
    connecting: {
        id: "byline-connections.menu.item.connecting",
        defaultMessage: "Connecting..."
    },
    descriptionSeparator: {
        id: "byline-connections.menu.item.description-separator",
        defaultMessage: "{left} \u2022 {right}"
    },
    productLink: {
        id: "byline-connections.menu.item.product-link",
        defaultMessage: "{product} link"
    }
});
const $db3ade85489bc276$var$styles = {
    row: "_2mHwu82ADO _0bjKvDOLYo _23rrnHo10F _4c065U2ADO _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _4kiQYAUF4f _24h04i2Njc _1eOmH6o126",
    rowBody: "_2mHwu88HPE _2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _0bjKvDKxmn _4c065UPgdg _2Y7lL4Pgdg _3iDTPbQ4SZ _0hPCNLDIqT _4ouGXIdnbC _0KLXrujOvk _2fwxA5ecOK",
    textColumn: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    title: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1kk5Tku7m9 _1UtDYzy7kJ _1ANEUSLRg7 _39HuIbz8Lp",
    description: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1kk5Tku7m9 _1UtDYzKGUX _1ANEUSLRg7 _39HuIbz8Lp",
    aiSummary: "_1ANEUSzUZr",
    trailing: "_3YEZNOdnbC _3iDTPbccYA _0hPCNLDIqT"
};
const $db3ade85489bc276$var$pressableStyles = {
    connect: "_2sNsIgmnOE _0bjKvDKxmn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _2Y7lL41Y8M _1UtDYzM7Tp _0KLXrujOvk _0wOv4Q7zJH _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8",
    connecting: "_2sNsIgmnOE _0bjKvDKxmn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _4c065UPgdg _2Y7lL41Y8M _1UtDYzot27 _0KLXrujOvk _0wOv4Q18ZR"
};
const $db3ade85489bc276$var$getNonGrantedRowContent = (rawUrl)=>{
    let parsed;
    try {
        parsed = new URL(rawUrl);
    } catch  {
        // URL was unparseable — fall back to showing the raw URL.
        return {
            titleContent: rawUrl,
            descriptionContent: null
        };
    }
    const hostname = parsed.hostname.replace(/^www\./i, ''); // Only trim slashes from the pathname itself — slashes inside the query
    // or fragment are meaningful and must be preserved.
    const trimmedPath = parsed.pathname.replace(/^\/+|\/+$/g, '');
    const pathDisplay = `${trimmedPath}${parsed.search}${parsed.hash}` || hostname;
    return {
        titleContent: pathDisplay,
        descriptionContent: hostname
    };
}; /**
    * Builds the title/description for a granted byline row from the data the
    * link resolver returned (title, plus 1–2 description slots).
    */ 
const $db3ade85489bc276$var$getGrantedRowContent = (item, locale, formatMessage)=>{
    const parts = (0, $4a8664392fb76f90$export$67580b1c13935958)(item, locale).filter((slot)=>Boolean(slot));
    const descriptionContent = parts.length === 0 ? null : parts.reduce((left, right)=>formatMessage($db3ade85489bc276$var$i18n.descriptionSeparator, {
            left: left,
            right: right
        }));
    return {
        titleContent: item.title,
        descriptionContent: descriptionContent
    };
}; /**
    * Builds the title/description for a non-granted incoming byline row —
    * typically a third-party Teamwork Graph link created with `access: undefined`.
    * These often carry no resolver title, which would otherwise leave the row
    * showing a raw URL, so we prefer a human-readable title when the graph gave us
    * one, else a "{Product} link" label (e.g. "Slack link"), and only keep the
    * URL-derived fallback when neither a title nor a product is available. The
    * description stays the hostname in those fallback cases.
    */ 
const $db3ade85489bc276$var$getIncomingRowContent = (item, formatMessage)=>{
    const { descriptionContent: descriptionContent } = $db3ade85489bc276$var$getNonGrantedRowContent(item.url);
    if (item.title) return {
        titleContent: item.title,
        descriptionContent: descriptionContent
    };
    const product = (0, $eyzEJ.formatProduct)(item.product);
    if (product) return {
        titleContent: formatMessage($db3ade85489bc276$var$i18n.productLink, {
            product: product
        }),
        descriptionContent: descriptionContent
    };
    return $db3ade85489bc276$var$getNonGrantedRowContent(item.url);
}; /**
    * Selects and builds the row content for a byline row: granted rows use the
    * resolver data, non-granted incoming rows get the incoming-specific title
    * handling, and everything else falls back to the URL.
    */ 
const $db3ade85489bc276$var$getRowContent = (item, linkDirection, locale, formatMessage)=>{
    if (item.access === 'granted') return $db3ade85489bc276$var$getGrantedRowContent(item, locale, formatMessage);
    if (linkDirection === 'incoming') return $db3ade85489bc276$var$getIncomingRowContent(item, formatMessage);
    return $db3ade85489bc276$var$getNonGrantedRowContent(item.url);
};
const $db3ade85489bc276$var$ConnectButton = ({ item: item, refreshLinkUrl: refreshLinkUrl, onConnectSuccess: onConnectSuccess })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { connect: connect, isConnecting: isConnecting } = (0, $ee74b2779b35b5c3$export$d93037bf2dc1b1f0)({
        item: item,
        refreshLinkUrl: refreshLinkUrl,
        onConnectSuccess: onConnectSuccess
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $db3ade85489bc276$var$styles.trailing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: isConnecting ? $db3ade85489bc276$var$pressableStyles.connecting : $db3ade85489bc276$var$pressableStyles.connect,
        onClick: connect,
        isDisabled: isConnecting
    }, formatMessage(isConnecting ? $db3ade85489bc276$var$i18n.connecting : $db3ade85489bc276$var$i18n.connect)));
};
const $db3ade85489bc276$var$ConnectionsByLineMenuItemInner = ({ item: item, refreshLinkUrl: refreshLinkUrl, linkDirection: linkDirection, aiSummary: aiSummary, onConnectSuccess: onConnectSuccess, onHover: onHover, onNavigate: onNavigate, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, compact: compact, disableHover: disableHover, analyticsSource: analyticsSource = (0, $I7TEB.ANALYTICS_SOURCE) })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const [isRowHovered, setIsRowHovered] = (0, $cozmU.useState)(false);
    const [isRowFocused, setIsRowFocused] = (0, $cozmU.useState)(false);
    const isGranted = item.access === 'granted';
    const rowActions = (0, $27e32f8ec84143be$export$e5922176f457b015)(item, onPreviewOpen, onAskRovo);
    const fireItemClickAnalytics = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'connectionRow',
                actionSubjectId: (0, $I7TEB.CONNECTION_ROW_ACTION_SUBJECT_ID),
                source: analyticsSource,
                attributes: {
                    product: item.product,
                    resourceType: item.resourceType,
                    access: item.access,
                    occurrenceIndex: item.occurrenceIndex,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        analyticsSource,
        createAnalyticsEvent,
        isLivePage,
        item
    ]);
    const fireScrollResultAnalytics = (0, $cozmU.useCallback)((result)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: result === 'success' ? 'succeeded' : 'failed',
                actionSubject: 'smartLinkScroll',
                actionSubjectId: (0, $I7TEB.SCROLL_RESULT_ACTION_SUBJECT_ID),
                source: analyticsSource,
                attributes: {
                    result: result,
                    reason: result === 'success' ? undefined : result,
                    product: item.product,
                    resourceType: item.resourceType,
                    occurrenceIndex: item.occurrenceIndex,
                    isLivePage: isLivePage
                }
            }
        }).fire();
    }, [
        analyticsSource,
        createAnalyticsEvent,
        isLivePage,
        item
    ]);
    const handleRowClick = (0, $cozmU.useCallback)(()=>{
        fireItemClickAnalytics();
        if (linkDirection === 'incoming') {
            window.open(item.url, '_blank', 'noopener,noreferrer');
            onNavigate?.();
            return;
        }
        const root = (0, $a0b23ddb5269aeb3$export$6980ce4ab4fcefe5)(isLivePage);
        if (!root) {
            fireScrollResultAnalytics('not_found');
            return;
        }
        const result = (0, $a0b23ddb5269aeb3$export$e8a1a083f5b3b175)({
            root: root,
            url: item.url
        });
        if (result.status !== 'found') {
            fireScrollResultAnalytics(result.status);
            return;
        }
        try {
            (0, $fURMF.scrollToElement)(result.element, undefined, 'smooth', isLivePage);
            fireScrollResultAnalytics('success');
            onNavigate?.();
        } catch  {
            fireScrollResultAnalytics('scroll_error');
        }
    }, [
        fireItemClickAnalytics,
        fireScrollResultAnalytics,
        isLivePage,
        item,
        linkDirection,
        onNavigate
    ]);
    const handleMouseEnter = (0, $cozmU.useCallback)(()=>{
        if (disableHover) return;
        setIsRowHovered(true);
        onHover?.(item);
    }, [
        disableHover,
        onHover,
        item
    ]);
    const handleMouseLeave = (0, $cozmU.useCallback)(()=>{
        setIsRowHovered(false);
    }, []);
    const handleFocus = (0, $cozmU.useCallback)(()=>{
        if (disableHover) return;
        setIsRowFocused(true);
    }, [
        disableHover
    ]);
    const handleBlur = (0, $cozmU.useCallback)((event)=>{
        // Tabbing from the body to a trailing button must not hide it.
        if (!event.currentTarget.contains(event.relatedTarget)) setIsRowFocused(false);
    }, []);
    const showAffordances = !disableHover && (isRowHovered || isRowFocused); // `forbidden` means the user is authenticated to the provider but lacks
    // permission to this specific resource (e.g. a private Google Drive doc) —
    // connecting an account can't grant access, so don't offer Connect. (Note:
    // `meta.visibility` is unreliable here: accessible docs report 'restricted'
    // while the private one reports 'not_found', so we key on `access`.)
    const showConnectAction = !isGranted && item.access !== 'forbidden' && item.authProviders?.length > 0 && // Without a refresher there is nothing to update the row after a successful
    // auth, so the Connect flow would dead-end — don't offer it at all.
    Boolean(refreshLinkUrl);
    const { titleContent: titleContent, descriptionContent: descriptionContent } = $db3ade85489bc276$var$getRowContent(item, linkDirection, locale, formatMessage);
    const icon = (0, $5b9Ab.getSmartLinkIcon)(item);
    const row = (ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            ref: ref,
            xcss: $db3ade85489bc276$var$styles.row,
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onFocus: handleFocus,
            onBlur: handleBlur
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
            xcss: $db3ade85489bc276$var$styles.rowBody,
            onClick: handleRowClick
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "",
            size: "small",
            backgroundColor: "transparent",
            hasBorder: true
        }, icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
            icon: icon,
            size: "menu"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.textColumn
        }, compact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.title
        }, titleContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.title
        }, titleContent), aiSummary ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.aiSummary
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            as: "p",
            size: "small",
            weight: "regular",
            color: "color.text.subtlest",
            maxLines: 2
        }, aiSummary)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $db3ade85489bc276$var$styles.description
        }, descriptionContent)))), showConnectAction && refreshLinkUrl && showAffordances ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db3ade85489bc276$var$ConnectButton, {
            item: item,
            refreshLinkUrl: refreshLinkUrl,
            onConnectSuccess: onConnectSuccess
        }) : null, showAffordances && rowActions.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad20e203017545fb$export$316485efcf724587), {
            item: item,
            actions: rowActions
        }) : null); // `disableHover` rows never open the hover card, so skip the lazy wrapper entirely
    // rather than mount it with a permanently-closed `isOpen`.
    if (showConnectAction && !disableHover) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($db3ade85489bc276$var$UnconnectedConnectorHoverCardLoadable, {
        item: item,
        isOpen: isRowHovered
    }, (triggerProps)=>row(triggerProps.ref));
    return row();
};
const $db3ade85489bc276$export$26a6dbb0548cf180 = /*#__PURE__*/ (0, $cozmU.memo)($db3ade85489bc276$var$ConnectionsByLineMenuItemInner);
module.exports["ConnectionsByLineMenuItem"] = $db3ade85489bc276$export$26a6dbb0548cf180;

});

parcelRegister("4agZx", function(module, exports) {

var $I7TEB = parcelRequire("I7TEB");

const $d3ef9f581c529bcb$export$12b889841e4c036 = 'teamworkGraphRovoChat';
const $d3ef9f581c529bcb$export$6f13d53292529b34 = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: (0, $I7TEB.ASK_ROVO_ACTION_SUBJECT_ID),
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $d3ef9f581c529bcb$export$82f52ee21bdab663 = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'switched',
            actionSubject: 'rovoChat',
            actionSubjectId: $d3ef9f581c529bcb$export$12b889841e4c036,
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
const $d3ef9f581c529bcb$export$13200ced42a5781f = (attributes)=>({
        type: 'sendUIEvent',
        data: {
            action: 'closed',
            actionSubject: 'rovoChat',
            actionSubjectId: $d3ef9f581c529bcb$export$12b889841e4c036,
            source: (0, $I7TEB.ANALYTICS_SOURCE),
            attributes: attributes
        }
    });
module.exports["getAskRovoClickedEvent"] = $d3ef9f581c529bcb$export$6f13d53292529b34;
module.exports["getRovoChatSwitchedEvent"] = $d3ef9f581c529bcb$export$82f52ee21bdab663;
module.exports["getRovoChatClosedEvent"] = $d3ef9f581c529bcb$export$13200ced42a5781f;

});

parcelRegister("bEvUu", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");

// Minted on first use rather than at module load: the SSR process keeps modules between requests,
// so a load-time id would be one id shared by every reader of every page. No event fires during
// SSR, so the server never mints one.
let $457579216673ba99$var$twgTraceId;
const $457579216673ba99$export$fe6d17ef66ee2fa4 = ()=>{
    if ($457579216673ba99$var$twgTraceId === undefined) $457579216673ba99$var$twgTraceId = crypto.randomUUID();
    return $457579216673ba99$var$twgTraceId;
};
const $457579216673ba99$export$cde77d3ccbf7ce14 = ()=>{
    $457579216673ba99$var$twgTraceId = undefined;
};


const $90058fc8c3407f36$export$3f5d7a61053aa3cd = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const createTwgAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        // Confluence events are `{ type, data }`. Anything else is passed straight through.
        if (!payload.data) return createAnalyticsEvent(payload);
        return createAnalyticsEvent({
            ...payload,
            data: {
                ...payload.data,
                attributes: {
                    ...payload.data.attributes,
                    twgTraceId: (0, $457579216673ba99$export$fe6d17ef66ee2fa4)()
                }
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            createAnalyticsEvent: createTwgAnalyticsEvent
        }), [
        createTwgAnalyticsEvent
    ]);
};
module.exports["useTwgAnalyticsEvents"] = $90058fc8c3407f36$export$3f5d7a61053aa3cd;

});

parcelRegister("7su1d", function(module, exports) {

let $56e26efeea10e5c8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $56e26efeea10e5c8$var$load("hAcjP").then(()=>parcelRequire('kcVdk'));

});

parcelRegister("kC09O", function(module, exports) {
/* ShowMoreRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $hBYtq = parcelRequire("hBYtq");

const $6484606ef90b2a01$var$styles = {
    row: "_0bjKvDOLYo _2sNsIg7NXe _23rrnHo10F _4c065U8HPE _2Y7lL45zaO _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0KLXrujOvk _2fwxA5ecOK _1kk5Tkf7mX _1UtDYzZpcK _1eOmH6o126"
};
const $6484606ef90b2a01$var$i18n = (0, $kSwu1.defineMessages)({
    showMore: {
        id: "byline-connections.preview-panel.show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "byline-connections.preview-panel.show-less",
        defaultMessage: "Show less"
    }
}); /** Shared with the embedded connections byline menu, whose sections toggle the same way. */ 
const $6484606ef90b2a01$export$f82de8cbca70dfcb = $6484606ef90b2a01$var$i18n.showMore;
const $6484606ef90b2a01$export$6f96196723302358 = $6484606ef90b2a01$var$i18n.showLess;
const $6484606ef90b2a01$export$3590e0bf4f6b2ca2 = ({ isExpanded: isExpanded, onClick: onClick, testId: testId })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $6484606ef90b2a01$var$styles.row,
        "aria-expanded": isExpanded,
        onClick: onClick,
        testId: testId
    }, formatMessage(isExpanded ? $6484606ef90b2a01$var$i18n.showLess : $6484606ef90b2a01$var$i18n.showMore));
};
module.exports["showMoreMessage"] = $6484606ef90b2a01$export$f82de8cbca70dfcb;
module.exports["showLessMessage"] = $6484606ef90b2a01$export$6f96196723302358;
module.exports["ShowMoreRow"] = $6484606ef90b2a01$export$3590e0bf4f6b2ca2;

});

parcelRegister("21leH", function(module, exports) {

var $jDHty = parcelRequire("jDHty");

const $4adaf34aeab2c91c$export$c7b414e180315a71 = {
    contentId: undefined,
    incomingLinks: {
        links: [],
        loading: true,
        loadingMore: false,
        hasNextPage: false,
        endCursor: null,
        loadMore: ()=>{},
        error: undefined
    }
};
// BylineConnections is the sole producer. Readers never fetch or hydrate this stream.
const $4adaf34aeab2c91c$var$bridge = (0, $jDHty.createPanelDataBridge)($4adaf34aeab2c91c$export$c7b414e180315a71);
const $4adaf34aeab2c91c$export$838755d6e4074a19 = $4adaf34aeab2c91c$var$bridge.publish;
const $4adaf34aeab2c91c$export$82d95e6c3ee2cb53 = $4adaf34aeab2c91c$var$bridge.clear;
const $4adaf34aeab2c91c$export$a56df9ee573d1160 = $4adaf34aeab2c91c$var$bridge.useValue;
const $4adaf34aeab2c91c$export$5e509302065e8e8 = $4adaf34aeab2c91c$var$bridge.clearForTesting;
module.exports["publishIncomingLinks"] = $4adaf34aeab2c91c$export$838755d6e4074a19;
module.exports["clearIncomingLinks"] = $4adaf34aeab2c91c$export$82d95e6c3ee2cb53;
module.exports["useIncomingLinksData"] = $4adaf34aeab2c91c$export$a56df9ee573d1160;

});

parcelRegister("Hnn0l", function(module, exports) {

var $jDHty = parcelRequire("jDHty");

const $80a543aab06a3853$var$noopRefreshLinkUrl = async ()=>undefined;
const $80a543aab06a3853$export$3410a3ccc4d8e4fb = {
    contentId: undefined,
    pageAdf: null,
    pageVersion: undefined,
    pageUpdatedAt: undefined,
    outgoingLinks: [],
    refreshLinkUrl: $80a543aab06a3853$var$noopRefreshLinkUrl
};
/**
 * Carries the page ADF, version, update time, and smart links the connections byline has already
 * collected. See `createPanelDataBridge` for why the panel needs a bridge at all.
 *
 * The byline is the only producer: collecting the links needs the page ADF from
 * `RendererActionsContext` (or the editor API), which is only in scope deep inside
 * the content renderer. (`refreshLinkUrl` is carried so a row can be upgraded after
 * a Connect flow, but no panel section consumes it yet — the panel offers no
 * Connect action.)
 *
 * Only ever written from an effect, so nothing publishes during SSR and this
 * module-level state cannot leak between server requests.
 */ const $80a543aab06a3853$var$outgoingLinksBridge = (0, $jDHty.createPanelDataBridge)($80a543aab06a3853$export$3410a3ccc4d8e4fb);
const $80a543aab06a3853$export$397dc7f3cc2bb433 = $80a543aab06a3853$var$outgoingLinksBridge.publish;
const $80a543aab06a3853$export$8d2fbd86048952e1 = $80a543aab06a3853$var$outgoingLinksBridge.clear;
const $80a543aab06a3853$export$832705d949dd0d41 = $80a543aab06a3853$var$outgoingLinksBridge.subscribe;
const $80a543aab06a3853$export$3ec0983b8b493d18 = $80a543aab06a3853$var$outgoingLinksBridge.useValue;
const $80a543aab06a3853$export$506c885e440aa8aa = $80a543aab06a3853$var$outgoingLinksBridge.clearForTesting;
module.exports["publishOutgoingLinks"] = $80a543aab06a3853$export$397dc7f3cc2bb433;
module.exports["clearOutgoingLinks"] = $80a543aab06a3853$export$8d2fbd86048952e1;
module.exports["useOutgoingLinks"] = $80a543aab06a3853$export$3ec0983b8b493d18;

});

parcelRegister("4ao9J", function(module, exports) {

var $jDHty = parcelRequire("jDHty");

const $32154ea67d922195$export$f870547225cbe74b = {
    contentId: undefined,
    relatedContent: {
        enabled: false,
        links: [],
        loading: false,
        error: undefined
    }
};
// BylineConnections is the sole producer. Readers never fetch or hydrate this stream.
const $32154ea67d922195$var$bridge = (0, $jDHty.createPanelDataBridge)($32154ea67d922195$export$f870547225cbe74b);
const $32154ea67d922195$export$20ab1e77e1cd3cc2 = $32154ea67d922195$var$bridge.publish;
const $32154ea67d922195$export$ddbfb8004207fe5d = $32154ea67d922195$var$bridge.clear;
const $32154ea67d922195$export$e0a1f4af2d095c13 = $32154ea67d922195$var$bridge.useValue;
const $32154ea67d922195$export$cdaad0e5602ad257 = $32154ea67d922195$var$bridge.clearForTesting;
module.exports["publishRelatedContent"] = $32154ea67d922195$export$20ab1e77e1cd3cc2;
module.exports["clearRelatedContent"] = $32154ea67d922195$export$ddbfb8004207fe5d;
module.exports["useRelatedContentData"] = $32154ea67d922195$export$e0a1f4af2d095c13;

});

parcelRegister("8vzGQ", function(module, exports) {

var $8WngQ = parcelRequire("8WngQ");

const $fa339e1bc13008a7$export$fa2412b03251b330 = 4;
const $fa339e1bc13008a7$export$d2840e53de4c9ae1 = 10;
const $fa339e1bc13008a7$var$CONFLUENCE_PAGE_LEVEL_ONE = new Set([
    'created',
    'contributed'
]);
const $fa339e1bc13008a7$var$FALLBACK_PRIORITY_LEVEL = 7;
const $fa339e1bc13008a7$var$LEVEL_ONE_PRIORITY = 1;
const $fa339e1bc13008a7$var$PRIORITY_WEIGHT = 1000;
const $fa339e1bc13008a7$var$RECENCY_HALF_LIFE_DAYS = 30;
const $fa339e1bc13008a7$var$MILLISECONDS_PER_DAY = 86400000;
const $fa339e1bc13008a7$var$RELATIONSHIP_ORDER = new Map((0, $8WngQ.PAGE_PEOPLE_RELATIONSHIPS).map(({ relationship: relationship }, index)=>[
        relationship,
        index
    ]));
const $fa339e1bc13008a7$var$priorityLevel = ({ relationship: relationship })=>$fa339e1bc13008a7$var$CONFLUENCE_PAGE_LEVEL_ONE.has(relationship) ? $fa339e1bc13008a7$var$LEVEL_ONE_PRIORITY : $fa339e1bc13008a7$var$FALLBACK_PRIORITY_LEVEL;
/**
 * The bounded decay term used by object expansion. Priority bands always dominate; recency orders
 * evidence within a band and naturally loses influence as the relationship ages.
 */ const $fa339e1bc13008a7$var$recencyDecay = (lastUpdated, now)=>{
    if (lastUpdated == null || !Number.isFinite(lastUpdated)) return 0;
    const ageDays = Math.max(0, now - lastUpdated) / $fa339e1bc13008a7$var$MILLISECONDS_PER_DAY;
    return Math.exp(-Math.LN2 * ageDays / $fa339e1bc13008a7$var$RECENCY_HALF_LIFE_DAYS);
};
const $fa339e1bc13008a7$var$scoreRelationship = (relationship, now)=>(8 - $fa339e1bc13008a7$var$priorityLevel(relationship)) * $fa339e1bc13008a7$var$PRIORITY_WEIGHT + $fa339e1bc13008a7$var$recencyDecay(relationship.lastUpdated, now);
const $fa339e1bc13008a7$var$compareText = (left, right)=>left < right ? -1 : left > right ? 1 : 0;
const $fa339e1bc13008a7$var$compareRelationships = (left, right, now)=>{
    const scoreDifference = $fa339e1bc13008a7$var$scoreRelationship(right, now) - $fa339e1bc13008a7$var$scoreRelationship(left, now);
    if (scoreDifference !== 0) return scoreDifference;
    return ($fa339e1bc13008a7$var$RELATIONSHIP_ORDER.get(left.relationship) ?? Number.MAX_SAFE_INTEGER) - ($fa339e1bc13008a7$var$RELATIONSHIP_ORDER.get(right.relationship) ?? Number.MAX_SAFE_INTEGER);
};
const $fa339e1bc13008a7$var$pickPrimaryRelationship = (person, now)=>{
    let primary;
    for (const relationship of person.relationships)if (!primary || $fa339e1bc13008a7$var$compareRelationships(relationship, primary, now) < 0) primary = relationship;
    return primary;
};
const $fa339e1bc13008a7$export$9063a37a19a9a3c3 = (people, now = Date.now())=>$fa339e1bc13008a7$export$946ec57e8a4fe9d6(people, now).slice(0, $fa339e1bc13008a7$export$d2840e53de4c9ae1);
const $fa339e1bc13008a7$export$946ec57e8a4fe9d6 = (people, now = Date.now())=>{
    const rankedPeople = [];
    for (const person of people){
        const primaryRelationship = $fa339e1bc13008a7$var$pickPrimaryRelationship(person, now);
        if (primaryRelationship) rankedPeople.push({
            person: person,
            primaryRelationship: primaryRelationship,
            score: $fa339e1bc13008a7$var$scoreRelationship(primaryRelationship, now)
        });
    }
    return rankedPeople.sort((left, right)=>right.score - left.score || $fa339e1bc13008a7$var$compareText(left.person.ari, right.person.ari) || $fa339e1bc13008a7$var$compareText(left.person.accountId, right.person.accountId)).map(({ person: person, primaryRelationship: primaryRelationship })=>({
            ari: person.ari,
            accountId: person.accountId,
            name: person.name,
            picture: person.picture,
            ...person.jobTitle ? {
                jobTitle: person.jobTitle
            } : {},
            primaryRelationship: primaryRelationship.relationship,
            relationshipDirection: primaryRelationship.direction
        }));
};
module.exports["MAX_PAGE_PEOPLE"] = $fa339e1bc13008a7$export$fa2412b03251b330;
module.exports["MAX_LISTED_PAGE_PEOPLE"] = $fa339e1bc13008a7$export$d2840e53de4c9ae1;
module.exports["rankPagePeople"] = $fa339e1bc13008a7$export$9063a37a19a9a3c3;

});

parcelRegister("45zaV", function(module, exports) {
/* ConnectionSections.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kTb7m = parcelRequire("kTb7m");


var $iMnC5 = parcelRequire("iMnC5");


var $4aRua = parcelRequire("4aRua");


var $jmjWc = parcelRequire("jmjWc");

const $fc4cd27910e257d3$export$101b131926441521 = new Map();
const $fc4cd27910e257d3$export$4f955c0b5efa5938 = (output)=>{
    if (output?.status !== 'GENERATED' || !output.summaries.length) return $fc4cd27910e257d3$export$101b131926441521;
    const byAri = new Map();
    for (const { ari: ari, oneLiner: oneLiner } of output.summaries)if (!byAri.has(ari)) byAri.set(ari, oneLiner);
    return byAri;
};









var $g9HBv = parcelRequire("g9HBv");

/* ConnectionsByLineSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 









var $lfoFx = parcelRequire("lfoFx");


var $4B2M3 = parcelRequire("4B2M3");


var $hTfX9 = parcelRequire("hTfX9");


var $6F7l4 = parcelRequire("6F7l4");


var $bG6aJ = parcelRequire("bG6aJ");

// same 12px radius as the section card. Overflow-hidden confines whatever
// paint the row's internals apply.
const $bba263788d7ab919$var$roundedRowStyles = null;
const $bba263788d7ab919$var$styles = {
    loadingMore: "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _0jFU0VUF4f",
    emptyMessage: "_2sNsIgmnOE _1UtDYzot27 _2fwxA5DIqT"
};
const $bba263788d7ab919$export$deadd1488868c3d4 = ({ title: title, iconBefore: iconBefore, items: items, linkDirection: linkDirection, aiSummaries: aiSummaries, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, emptyMessage: emptyMessage, count: count = items.length, hasMore: hasMore, pagination: pagination, isExpanded: isExpanded, onToggleExpanded: onToggleExpanded, testId: testId })=>{
    // The body only exists while expanded, so the scroll root is held in state to
    // re-run the observer once the body mounts.
    const [scrollRoot, setScrollRoot] = (0, $cozmU.useState)(null); // `InfiniteScroll` rebuilds its observer whenever these options change identity.
    const observerOptions = (0, $cozmU.useMemo)(()=>({
            root: scrollRoot,
            rootMargin: '0px',
            threshold: 0.05
        }), [
        scrollRoot
    ]);
    const loadingMoreTestId = testId ? `${testId}--loading-more` : undefined;
    const isEmpty = items.length === 0 && !pagination?.isLoading && !pagination?.hasNextPage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bG6aJ.ConnectionsByLineSectionShell), {
        title: title,
        count: count ?? undefined,
        hasMore: hasMore,
        iconBefore: iconBefore,
        trailing: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hTfX9.BylineConnectionIconStack), {
            links: items
        }),
        bodyRef: setScrollRoot,
        isExpanded: isExpanded,
        onToggleExpanded: onToggleExpanded,
        testId: testId
    }, isEmpty && emptyMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bba263788d7ab919$var$styles.emptyMessage,
        testId: testId ? `${testId}--empty` : undefined
    }, emptyMessage) : null, items.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            key: `${item.url}-${item.occurrenceIndex}`,
            className: (0, $hekY6.default)([
                "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6F7l4.ConnectionsByLineMenuItem), {
            item: item,
            linkDirection: linkDirection,
            aiSummary: item.ari ? aiSummaries?.get(item.ari) : undefined,
            onPreviewOpen: onPreviewOpen,
            onAskRovo: onAskRovo
        }))), pagination?.hasNextPage ? // Mounted only while `onLoadMore` can act on it: `InfiniteScroll` marks a cursor
    // as used before calling back and ignores that the call was rejected, so a
    // sentinel left mounted during a fetch burns the next cursor and pagination
    // stops. Remounting resets that state.
    pagination.isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bba263788d7ab919$var$styles.loadingMore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        testId: loadingMoreTestId
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4B2M3.ObservableSpinner), {
        cursor: pagination.endCursor,
        onScrollTo: pagination.onLoadMore,
        observerOptions: observerOptions,
        spinnerSize: "small",
        testId: loadingMoreTestId ?? 'connections-by-line-section-loading-more'
    }) : null);
};


const $7ed3b9e6215820af$var$i18n = (0, $kSwu1.defineMessages)({
    appearsIn: {
        id: "byline-connections.preview-panel.section.appears-in",
        defaultMessage: "Appears in"
    },
    empty: {
        id: "byline-connections.preview-panel.section.appears-in.empty",
        defaultMessage: "This content is not referenced anywhere."
    }
});
const $7ed3b9e6215820af$export$696cfca056e338c6 = ({ links: links, loading: loading, loadingMore: loadingMore, hasNextPage: hasNextPage, endCursor: endCursor, loadMore: loadMore, error: error, aiSummaries: aiSummaries, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, isExpanded: isExpanded, onToggleExpanded: onToggleExpanded })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // The header count is pinned to the first page: the query returns no total, and even a
    // `count()` would not say how many of those rows ORS can resolve into rendered links.
    // `hasNextPage` adds the "+" instead.
    const initialCountRef = (0, $cozmU.useRef)(undefined);
    const hasFailedWithoutLinks = Boolean(error) && links.length === 0;
    if (initialCountRef.current === undefined && !loading && !hasFailedWithoutLinks) initialCountRef.current = links.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bba263788d7ab919$export$deadd1488868c3d4), {
        title: formatMessage($7ed3b9e6215820af$var$i18n.appearsIn),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($g9HBv))), {
            label: "",
            spacing: "none"
        }),
        items: links,
        linkDirection: "incoming",
        aiSummaries: aiSummaries,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        isExpanded: isExpanded,
        onToggleExpanded: onToggleExpanded,
        // A failed query is not an empty graph, so it does not earn the explanation.
        emptyMessage: error ? undefined : formatMessage($7ed3b9e6215820af$var$i18n.empty),
        count: initialCountRef.current ?? 0,
        hasMore: hasNextPage,
        pagination: {
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            // `loading` also covers the initial catch-up paging, which `loadMore` refuses to interrupt.
            isLoading: loading || loadingMore,
            onLoadMore: loadMore
        },
        testId: "teamwork-graph-preview-panel-appears-in-section"
    });
};


/* AtAGlanceSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $I7hWB = parcelRequire("I7hWB");








var $a9aSv = parcelRequire("a9aSv");

/* TeamworkGraphAskRovoButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $bUd6P = parcelRequire("bUd6P");


var $hBYtq = parcelRequire("hBYtq");





var $4agZx = parcelRequire("4agZx");


var $bEvUu = parcelRequire("bEvUu");

// entries in the panel read as one family.
// Button has fixed vertical padding, so Pressable.
const $4fc369165e330a2e$var$styles = {
    button: "_2mHwu8gVvo _0bjKvDKTcp _2sNsIgmnOE _23rrnHyKLB _4c065UPgdg _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _39xV02N91d _0jFU0VUofl _37wbyuDIqT _0hPCNLDIqT _0KLXru66of _1UtDYzZpcK _1eOmH6o126 _3sFUREiSCN _3gzVzLN4oS"
};
const $4fc369165e330a2e$var$i18n = (0, $kSwu1.defineMessages)({
    chatWithRovo: {
        id: "byline-connections.preview-panel.at-a-glance.chat-with-rovo-button",
        defaultMessage: "Chat with Rovo"
    }
});
function $4fc369165e330a2e$export$b29a191a5c5e9({ onClick: onClick, testId: testId }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent((0, $4agZx.getAskRovoClickedEvent)({
            trigger: 'atAGlance'
        })).fire();
        onClick();
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: $4fc369165e330a2e$var$styles.button,
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bUd6P.RovoHexIcon), {
        label: "",
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium",
        weight: "medium",
        maxLines: 1
    }, formatMessage($4fc369165e330a2e$var$i18n.chatWithRovo)));
}


const $91ded8c84d6983c5$var$LOADING_BAR_WIDTHS = [
    '100%',
    '85%',
    '70%'
];
const $91ded8c84d6983c5$var$styles = {
    card: "_2mHwu88HPE _0bjKvDyzSk _4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrunmFW",
    body: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w",
    loading: "_2mHwu82ADO _3iDTPbQ4SZ _0aFT5vbt8w"
};
const $91ded8c84d6983c5$var$i18n = (0, $kSwu1.defineMessages)({
    contextFromYourWork: {
        id: "byline-connections.preview-panel.section.context-from-your-work",
        defaultMessage: "Context from your work"
    },
    loading: {
        id: "byline-connections.preview-panel.section.context-from-your-work.loading",
        defaultMessage: "Loading context from your work"
    },
    error: {
        id: "byline-connections.preview-panel.section.at-a-glance.error",
        defaultMessage: "We couldn't generate this summary"
    },
    retryWaiting: {
        id: "byline-connections.preview-panel.section.at-a-glance.retry-waiting",
        defaultMessage: "The summary service is busy. We\u2019ll try again shortly."
    },
    insufficientEvidence: {
        id: "byline-connections.preview-panel.section.at-a-glance.insufficient-evidence.ai-non-final",
        defaultMessage: "We couldn\u2019t generate summaries because there isn\u2019t enough information in this page and its connections."
    }
});
const $91ded8c84d6983c5$var$Loading = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $91ded8c84d6983c5$var$styles.loading,
        role: "status",
        "aria-label": formatMessage($91ded8c84d6983c5$var$i18n.loading),
        testId: "teamwork-graph-preview-panel-at-a-glance-section--loading"
    }, $91ded8c84d6983c5$var$LOADING_BAR_WIDTHS.map((width)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9aSv.default), {
            key: width,
            width: width,
            height: "var(--ds-space-200, 16px)",
            borderRadius: "var(--ds-radius-small, 4px)",
            isShimmering: true
        })));
}; /** Older responses may contain multiple items, so the whole overview joins into one paragraph. */ 
const $91ded8c84d6983c5$var$Summary = ({ overview: overview })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, overview.map((item)=>item.text).join(' '));
const $91ded8c84d6983c5$var$Failed = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "alert",
        testId: "teamwork-graph-preview-panel-at-a-glance-section--error"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage($91ded8c84d6983c5$var$i18n.error)));
};
const $91ded8c84d6983c5$var$InsufficientEvidence = ()=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "teamwork-graph-preview-panel-at-a-glance-section--insufficient-evidence"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage($91ded8c84d6983c5$var$i18n.insufficientEvidence)));
};
const $91ded8c84d6983c5$export$d7d0920f7a8ebe0d = ({ output: output, loading: loading, error: error, retryPending: retryPending, onAskRovo: onAskRovo })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const headingId = (0, $cozmU.useId)();
    const overview = output?.overview; // An unavailable response is a generation failure, so it shares the failure copy. Every
    // other summary-less state — no request made, insufficient evidence, or an empty
    // generated overview — is a lack of material to summarise rather than an error.
    const failed = Boolean(error) || output?.status === 'UNAVAILABLE';
    let body;
    if (retryPending && !overview?.length) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        role: "status"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        as: "p",
        color: "color.text.subtle"
    }, formatMessage($91ded8c84d6983c5$var$i18n.retryWaiting)));
    else if (loading) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91ded8c84d6983c5$var$Loading, null);
    else if (overview?.length) // Keep the summary if a later refetch fails.
    body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91ded8c84d6983c5$var$Summary, {
        overview: overview
    });
    else if (failed) body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91ded8c84d6983c5$var$Failed, null);
    else body = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($91ded8c84d6983c5$var$InsufficientEvidence, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $91ded8c84d6983c5$var$styles.card,
        role: "region",
        "aria-labelledby": headingId,
        testId: "teamwork-graph-preview-panel-at-a-glance-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall",
        as: "h3",
        id: headingId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        weight: "bold"
    }, formatMessage($91ded8c84d6983c5$var$i18n.contextFromYourWork))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $91ded8c84d6983c5$var$styles.body,
        testId: "teamwork-graph-preview-panel-at-a-glance-section--body"
    }, body, onAskRovo ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        testId: "teamwork-graph-preview-panel-at-a-glance-section--ask-rovo-slot"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4fc369165e330a2e$export$b29a191a5c5e9), {
        onClick: onAskRovo,
        testId: "teamwork-graph-preview-panel-at-a-glance-section--ask-rovo"
    })) : null));
};









var $4bg4c = parcelRequire("4bg4c");


var $86sr7 = parcelRequire("86sr7");


const $e66409e8a5c11d6d$var$i18n = (0, $kSwu1.defineMessages)({
    linksTo: {
        id: "byline-connections.preview-panel.section.links-to",
        defaultMessage: "Links to"
    },
    empty: {
        id: "byline-connections.preview-panel.section.links-to.empty",
        defaultMessage: "This content does not link to anything."
    }
});
const $e66409e8a5c11d6d$export$f7d0d6af791d1bb = ({ links: links, aiSummaries: aiSummaries, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, isExpanded: isExpanded, onToggleExpanded: onToggleExpanded })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    // Reorders unconnected links first; the full length means no truncation.
    const items = (0, $cozmU.useMemo)(()=>(0, $86sr7.getTopConnectionLinks)(links, links.length), [
        links
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bba263788d7ab919$export$deadd1488868c3d4), {
        title: formatMessage($e66409e8a5c11d6d$var$i18n.linksTo),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4bg4c))), {
            label: "",
            spacing: "none"
        }),
        items: items,
        linkDirection: "outgoing",
        aiSummaries: aiSummaries,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        isExpanded: isExpanded,
        onToggleExpanded: onToggleExpanded,
        emptyMessage: formatMessage($e66409e8a5c11d6d$var$i18n.empty),
        testId: "teamwork-graph-preview-panel-links-to-section"
    });
};









var $arQY7 = parcelRequire("arQY7");


var $fBqzD = parcelRequire("fBqzD");


var $dinVW = parcelRequire("dinVW");


var $d6Ahp = parcelRequire("d6Ahp");


var $fnCzB = parcelRequire("fnCzB");


var $3EM6l = parcelRequire("3EM6l");


var $a6t12 = parcelRequire("a6t12");


var $I7TEB = parcelRequire("I7TEB");




/* PersonRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $w6R6I = parcelRequire("w6R6I");







const $f4d154f3da73b0ad$var$styles = {
    row: "_2mHwu88HPE _0bjKvDOLYo _4c065U8HPE _2Y7lL48HPE _3iDTPbQ4SZ _0hPCNLDIqT _39xV02N91d _0KLXrujOvk _2fwxA5ecOK",
    interactive: "_23rrnHo10F _1eOmH6o126",
    content: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu8Pgdg _3iDTPbQ4SZ _0aFT5vbt8w _4ouGXIdnbC",
    name: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1kk5Tk7GSX _1UtDYzy7kJ _1ANEUSLRg7 _39HuIbz8Lp",
    role: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzZpcK _1ANEUSLRg7 _39HuIbz8Lp"
};
const $f4d154f3da73b0ad$export$2360cd0b07b95057 = ({ avatar: avatar, name: name, role: role, onClick: onClick, testId: testId })=>{
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, avatar, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f4d154f3da73b0ad$var$styles.content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f4d154f3da73b0ad$var$styles.name
    }, name), role ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f4d154f3da73b0ad$var$styles.role
    }, role) : null));
    return onClick ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($f4d154f3da73b0ad$var$styles.row, $f4d154f3da73b0ad$var$styles.interactive),
        onClick: onClick,
        testId: testId
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $f4d154f3da73b0ad$var$styles.row,
        testId: testId
    }, content);
};



var $lkmGM = parcelRequire("lkmGM");


var $3Jm25 = parcelRequire("3Jm25");


var $kC09O = parcelRequire("kC09O");


var $d7JJ3 = parcelRequire("d7JJ3");




const $fc61a0da1ca0778a$export$ea801fe748451cc = 3;
const $fc61a0da1ca0778a$var$i18n = (0, $kSwu1.defineMessages)({
    agentAttribution: {
        id: "byline-connections.preview-panel.agent.attribution",
        defaultMessage: "with {name}"
    },
    heading: {
        id: "byline-connections.preview-panel.section.people-and-agents",
        defaultMessage: "People & Agents"
    },
    empty: {
        id: "byline-connections.preview-panel.section.people-and-agents.empty",
        defaultMessage: "There are no contributors yet. Relationships are mapped automatically as your team works together on this page. Start a conversation or share this page to strengthen your team\u2019s graph."
    }
});
const $fc61a0da1ca0778a$var$relationshipMessages = (0, $kSwu1.defineMessages)({
    created: {
        id: "byline-connections.preview-panel.person.relationship.created",
        defaultMessage: "Creator of this page"
    },
    contributed: {
        id: "byline-connections.preview-panel.person.relationship.contributed",
        defaultMessage: "Contributor of this page"
    },
    owns: {
        id: "byline-connections.preview-panel.person.relationship.owns",
        defaultMessage: "Owner of this page"
    },
    updated: {
        id: "byline-connections.preview-panel.person.relationship.updated",
        defaultMessage: "Editor of this page"
    },
    viewed: {
        id: "byline-connections.preview-panel.person.relationship.viewed",
        defaultMessage: "Viewer of this page"
    },
    favorited: {
        id: "byline-connections.preview-panel.person.relationship.favorited",
        defaultMessage: "Favoriter of this page"
    },
    liked: {
        id: "byline-connections.preview-panel.person.relationship.liked",
        defaultMessage: "Liker of this page"
    },
    'mentioned-in': {
        id: "byline-connections.preview-panel.person.relationship.mentioned-in",
        defaultMessage: "Mentionee of this page"
    },
    snapshotted: {
        id: "byline-connections.preview-panel.person.relationship.snapshotted",
        defaultMessage: "Snapshot creator of this page"
    },
    watches: {
        id: "byline-connections.preview-panel.person.relationship.watches",
        defaultMessage: "Watcher of this page"
    },
    'shared-with': {
        id: "byline-connections.preview-panel.person.relationship.shared-with",
        defaultMessage: "Recipient of this page"
    }
});
const $fc61a0da1ca0778a$var$messageForRelationship = (relationship)=>$fc61a0da1ca0778a$var$relationshipMessages[relationship];
/**
 * The person's profile in the people directory. Never `encodeURIComponent` the account id — the
 * colon in `70121:ed05…` is legal in a path, and `%3A` gives a URL the route cannot resolve.
 */ const $fc61a0da1ca0778a$var$profileUrl = (accountId)=>`/wiki/people/${accountId}?ref=confluence`;
/** Human rows open a profile; agent data does not supply a profile destination. */ const $fc61a0da1ca0778a$var$PersonListRow = ({ personOrAgent: personOrAgent })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const colorMode = (0, $3EM6l.useAgentAvatarColorMode)();
    const attributedUser = personOrAgent.agent?.attributedUser;
    const onClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.PEOPLE_AND_AGENTS_ROW_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE),
                // The relationship tells us whether readers open authors or mere viewers.
                // Deliberately no name or account id — this payload carries no personal data.
                attributes: {
                    relationship: personOrAgent.primaryRelationship
                }
            }
        }).fire();
        // Graph Store can return a person with no account id. Record the press, but skip
        // navigation rather than send the reader to a dead `/wiki/people/`.
        if (!personOrAgent.accountId) return;
        window.open($fc61a0da1ca0778a$var$profileUrl(personOrAgent.accountId), '_blank', 'noopener,noreferrer');
    }, [
        createAnalyticsEvent,
        personOrAgent
    ]);
    const row = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f4d154f3da73b0ad$export$2360cd0b07b95057), {
        // Hidden: `Avatar` labels itself with `name`, which the row already shows as text, so
        // without this the button announces the person twice. `name` stays for the initials.
        avatar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true"
        }, personOrAgent.agent && attributedUser?.name.trim() ? // Omit identity IDs so these decorative avatars do not create profile-card actions.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fnCzB.AgentUserDualAvatar), {
            agentName: personOrAgent.name,
            agentAvatarUrl: personOrAgent.picture ?? undefined,
            agentIcon: personOrAgent.agent.agentIcon,
            userName: attributedUser.name,
            userAvatarUrl: attributedUser.avatarURL || undefined,
            size: "large",
            colorMode: colorMode
        }) : personOrAgent.agent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d6Ahp.AgentRowAvatar), {
            name: personOrAgent.name,
            avatarUrl: personOrAgent.picture ?? undefined,
            agentIcon: personOrAgent.agent.agentIcon,
            avatarSize: "medium",
            hasInlineSpacing: false,
            colorMode: colorMode
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
            src: personOrAgent.picture ?? undefined,
            name: personOrAgent.name,
            size: "medium"
        })),
        name: personOrAgent.name,
        role: attributedUser?.name.trim() ? formatMessage($fc61a0da1ca0778a$var$i18n.agentAttribution, {
            name: attributedUser.name
        }) : formatMessage($fc61a0da1ca0778a$var$messageForRelationship(personOrAgent.primaryRelationship)),
        onClick: personOrAgent.agent ? undefined : onClick,
        // Keyed on the ARI, the only id `parsePagePeople` guarantees is present.
        testId: `teamwork-graph-person-row-${personOrAgent.ari}`
    });
    if (personOrAgent.agent) return row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6t12.ProfileCardWrapper), {
        userId: personOrAgent.accountId,
        fullName: personOrAgent.name,
        trigger: "hover",
        position: "left-start",
        fullWidthTrigger: true,
        // The row button owns focus and its accessible name; the card handles bubbled keys.
        disabledAriaAttributes: true
    }, row);
};
const $fc61a0da1ca0778a$export$89a2053dc433659f = ({ people: people, loading: loading, hasError: hasError, isExpanded: controlledExpanded, onToggleExpanded: onToggleExpanded })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isExpanded, toggleExpanded] = (0, $bG6aJ.useExpandedState)(controlledExpanded, onToggleExpanded);
    const onToggle = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.PEOPLE_AND_AGENTS_SHOW_MORE_ACTION_SUBJECT_ID),
                source: (0, $I7TEB.ANALYTICS_SOURCE),
                // The direction of this press, not the state it was in — `true` is an expand.
                attributes: {
                    isExpanding: !isExpanded
                }
            }
        }).fire();
        toggleExpanded();
    }, [
        createAnalyticsEvent,
        isExpanded,
        toggleExpanded
    ]);
    // Nothing to show while discovery is in flight, and nothing to explain when it failed: an
    // error is not an empty graph, so the section stays out rather than claiming no one is here.
    if (people.length === 0 && (loading || hasError)) return null;
    const hasHiddenPeople = people.length > $fc61a0da1ca0778a$export$ea801fe748451cc;
    const listedPeople = isExpanded ? people : people.slice(0, $fc61a0da1ca0778a$export$ea801fe748451cc);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.100",
        testId: "teamwork-graph-people-and-agents"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Jm25.SectionHeader), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fBqzD))), {
            label: "",
            color: "currentColor"
        }),
        label: formatMessage($fc61a0da1ca0778a$var$i18n.heading),
        count: people.length
    }), people.length === 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7JJ3.SectionEmptyState), {
        message: formatMessage($fc61a0da1ca0778a$var$i18n.empty),
        testId: "teamwork-graph-people-and-agents-empty"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lkmGM.PressableGroup), {
        testId: "teamwork-graph-people-and-agents-group"
    }, listedPeople.map((personOrAgent)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($fc61a0da1ca0778a$var$PersonListRow, {
            key: personOrAgent.ari,
            personOrAgent: personOrAgent
        })), hasHiddenPeople ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kC09O.ShowMoreRow), {
        isExpanded: isExpanded,
        onClick: onToggle,
        testId: "teamwork-graph-people-and-agents-show-more"
    }) : null));
};





/* SyncedFromSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $iMZH0 = parcelRequire("iMZH0");





var $e9QBI = parcelRequire("e9QBI");


var $idfQJ = parcelRequire("idfQJ");




const $bc447dd95fa0dc07$var$styles = {
    row: "_0bjKvDyzSk _4bt5LAnQyn _2WAcuGnQyn",
    headerIcon: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC"
};
const $bc447dd95fa0dc07$var$i18n = (0, $kSwu1.defineMessages)({
    syncedFrom: {
        id: "byline-connections.preview-panel.section.synced-from",
        defaultMessage: "Synced from"
    }
});
const $bc447dd95fa0dc07$export$ef217adc8b500549 = ({ connection: connection, isExpanded: isExpanded, onToggleExpanded: onToggleExpanded })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!connection) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bG6aJ.ConnectionsByLineSectionShell), {
        title: formatMessage($bc447dd95fa0dc07$var$i18n.syncedFrom),
        count: 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iMZH0))), {
            label: "",
            spacing: "none"
        }),
        trailing: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            xcss: $bc447dd95fa0dc07$var$styles.headerIcon,
            "aria-hidden": "true"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idfQJ.DevDocsScmProviderIcon), {
            provider: connection.provider
        })),
        isExpanded: isExpanded,
        onToggleExpanded: onToggleExpanded,
        testId: "teamwork-graph-preview-panel-synced-from-section"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bc447dd95fa0dc07$var$styles.row
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e9QBI.DevDocsConnectionRow), {
        connection: connection
    })));
};


const $79ecff49a6b66de2$var$styles = {
    connectionsColumn: "_2mHwu8NHnM _3iDTPbQ4SZ _0aFT5vbt8w _24h04i2Njc",
    card: "_0bjKvD8fU6 _4bt5LAnQyn _2WAcuGnQyn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _0aFT5vbt8w _0KLXrulfZc _24h04i2Njc",
    linksGroup: "_2mHwu88HPE _3iDTPbQ4SZ _0aFT5vbt8w",
    linksHeader: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    countBadge: "_0bjKvDcjp5 _2sNsIg7NXe _4c065UPgdg _2Y7lL41Y8M _3iDTPbQ4SZ _0jFU0Vey7F _4ouGXIoWWg _4kiQYAey7F _37wbyuDIqT _0hPCNLDIqT _3YEZNOdnbC _0KLXruG6qS _1UtDYzUktF _24h04i2Njc"
};
const $79ecff49a6b66de2$var$i18n = (0, $kSwu1.defineMessages)({
    links: {
        id: "byline-connections.preview-panel.links-header",
        defaultMessage: "Links"
    },
    linksEmpty: {
        id: "byline-connections.preview-panel.links-empty",
        defaultMessage: "This content isn\u2019t linked with anything yet."
    }
});

// view and the AI summary blocks with it. This component ships in the byline's after-paint chunk
// on every view page, so that section is a lazy boundary and loads once the panel or the modal
// mounts it. Nothing stands in while its chunk loads: the section is absent while its graph
// query is in flight anyway.
const $79ecff49a6b66de2$var$RelatedContentSection = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "Rmsyo",
    name: "RelatedContentSection",
    loader: async ()=>(await (parcelRequire("cXMAQ"))).RelatedContentSection
});
const $79ecff49a6b66de2$export$214f8ada772c6956 = ({ connections: connections, atAGlance: atAGlance, onPreviewOpen: onPreviewOpen, onAskRovo: onAskRovo, onAtAGlanceAskRovo: onAtAGlanceAskRovo, sectionExpansion: sectionExpansion })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const aiSummaries = (0, $cozmU.useMemo)(()=>(0, $fc4cd27910e257d3$export$4f955c0b5efa5938)(atAGlance.output), [
        atAGlance.output
    ]);
    const peopleAndAgentsLoading = connections.people.loading || connections.agentViewers.loading || connections.agentContributors.loading;
    const peopleAndAgentsHasError = Boolean(connections.people.error || connections.agentViewers.error || connections.agentContributors.error || connections.agentContributors.availability === 'unavailable'); // Resolves the controller to the controlled props a section forwards to its shell.
    // Returns nothing when uncontrolled, so the shell keeps owning the state.
    const expansionOf = (section)=>sectionExpansion ? {
            isExpanded: sectionExpansion.isExpanded(section),
            onToggleExpanded: ()=>sectionExpansion.toggle(section)
        } : {};
    const totalLinks = (connections.syncedFrom.connection ? 1 : 0) + connections.appearsIn.links.length + connections.linksTo.links.length;
    const hasMore = connections.appearsIn.hasNextPage; // The card is replaced by the empty state only once the one slice that could still fill it
    // has settled; "Links to" and "Synced from" are read synchronously, so they never wait. A
    // failed incoming query is not an empty graph, so the card stays for that too.
    const hasNoLinks = totalLinks === 0 && !connections.appearsIn.loading && !connections.appearsIn.error;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $79ecff49a6b66de2$var$styles.connectionsColumn
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $91ded8c84d6983c5$export$d7d0920f7a8ebe0d), {
        ...atAGlance,
        onAskRovo: onAtAGlanceAskRovo
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($79ecff49a6b66de2$var$RelatedContentSection, {
        ...connections.relatedContent,
        aiSummaries: aiSummaries,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        ...expansionOf('relatedContent')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $79ecff49a6b66de2$var$styles.linksGroup
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $79ecff49a6b66de2$var$styles.linksHeader
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: "",
        color: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        weight: "semibold",
        color: "color.text"
    }, formatMessage($79ecff49a6b66de2$var$i18n.links)), totalLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $79ecff49a6b66de2$var$styles.countBadge
        ])
    }, totalLinks, hasMore ? '+' : null) : null), hasNoLinks ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d7JJ3.SectionEmptyState), {
        message: formatMessage($79ecff49a6b66de2$var$i18n.linksEmpty),
        testId: "teamwork-graph-preview-panel-links-empty"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $79ecff49a6b66de2$var$styles.card
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bc447dd95fa0dc07$export$ef217adc8b500549), {
        ...connections.syncedFrom,
        ...expansionOf('syncedFrom')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7ed3b9e6215820af$export$696cfca056e338c6), {
        ...connections.appearsIn,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        ...expansionOf('appearsIn')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e66409e8a5c11d6d$export$f7d0d6af791d1bb), {
        ...connections.linksTo,
        onPreviewOpen: onPreviewOpen,
        onAskRovo: onAskRovo,
        ...expansionOf('linksTo')
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fc61a0da1ca0778a$export$89a2053dc433659f), {
        people: connections.people.peopleAndAgents,
        loading: peopleAndAgentsLoading,
        hasError: peopleAndAgentsHasError,
        ...expansionOf('people')
    }));
};
module.exports["ConnectionSections"] = $79ecff49a6b66de2$export$214f8ada772c6956;

});

parcelRegister("bG6aJ", function(module, exports) {
/* ConnectionsByLineSectionShell.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7sJoX = parcelRequire("7sJoX");


var $aDSIl = parcelRequire("aDSIl");


var $iMnC5 = parcelRequire("iMnC5");


var $hBYtq = parcelRequire("hBYtq");


var $xICd5 = parcelRequire("xICd5");

const $b63cd2ec09ae1c0c$var$MAX_BODY_HEIGHT = '306px';
const $b63cd2ec09ae1c0c$var$wrapperStyles = null;
const $b63cd2ec09ae1c0c$var$styles = {
    header: "_2mHwu81Y8M _2sNsIgmnOE _0bjKvDKxmn _4c065UPgdg _2Y7lL4Pgdg _3iDTPbQ4SZ _0hPCNLDIqT _4xdlr0FlnN _0jFU0VUofl _0KLXrujOvk _0wOv4Q7zJH _1UtDYzy7kJ _2fwxA5ecOK",
    iconBefore: "_4c065U1Y8M _2Y7lL41Y8M _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _24h04i2Njc _3YEZNOdnbC",
    titleGroup: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _2mHwu82ADO _3iDTPbQ4SZ _4ouGXIdnbC _0hPCNLDIqT",
    titleText: "_2sNsIgEqul _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1UtDYzy7kJ _1ANEUSLRg7 _39HuIbz8Lp",
    trailing: "_2mHwu82ADO _3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC",
    chevron: "_4c065U1Y8M _2Y7lL41Y8M _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _39xV02oWWg _0jFU0VoWWg _24h04i2Njc _3YEZNOdnbC",
    body: "_2mHwu81Y8M _3iDTPbgBM8 _21ioM3W9qI _0NUa3rc7VA _2WAcuGIZbP"
};
const $b63cd2ec09ae1c0c$var$ChevronIcon = ({ isExpanded: isExpanded })=>isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "none"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)",
        spacing: "none"
    }); /**
                                                                                                                                                                                                                     * The section's expanded state and the handler that flips it, in one of two modes — the
                                                                                                                                                                                                                     * same controlled/uncontrolled split as a React `<input>`:
                                                                                                                                                                                                                     *
                                                                                                                                                                                                                     * - Controlled: `controlledExpanded` is passed, so the caller owns the state and the
                                                                                                                                                                                                                     *   handler defers to `onToggle`. The modal uses this to hold the state above the swap to
                                                                                                                                                                                                                     *   Rovo, so a section stays expanded across it.
                                                                                                                                                                                                                     * - Uncontrolled: neither is passed, so the hook owns the state (starting from
                                                                                                                                                                                                                     *   `defaultExpanded`, collapsed unless a section opts in) and the handler flips it.
                                                                                                                                                                                                                     *   The panel and popup use this; "At a glance" is the opt-in.
                                                                                                                                                                                                                     *
                                                                                                                                                                                                                     * Exported because `PeopleAndAgentsSection` needs the same split without the rest of the shell:
                                                                                                                                                                                                                     * it is a `PressableGroup`, not a collapsible body, so it discloses extra rows rather than
                                                                                                                                                                                                                     * hiding all of them. Keep one implementation of the split rather than two.
                                                                                                                                                                                                                     */ 
const $b63cd2ec09ae1c0c$export$47360455f9bb4561 = (controlledExpanded, onToggle, defaultExpanded = false)=>{
    const [uncontrolledExpanded, setUncontrolledExpanded] = (0, $cozmU.useState)(defaultExpanded);
    const isControlled = controlledExpanded !== undefined;
    const toggle = (0, $cozmU.useCallback)(()=>{
        if (isControlled) onToggle?.();
        else setUncontrolledExpanded((prev)=>!prev);
    }, [
        isControlled,
        onToggle
    ]);
    return [
        isControlled ? controlledExpanded : uncontrolledExpanded,
        toggle
    ];
}; /**
    * Chrome for an expandable preview-panel section, with no opinion on what the body
    * contains: `ConnectionsByLineSection` wraps this to render smart-link rows, other
    * callers supply their own.
    *
    * The body is capped and scrolls, so a long section cannot push the ones below it
    * out of view.
    */ 
const $b63cd2ec09ae1c0c$export$8bedf248b7e9989d = ({ title: title, count: count, hasMore: hasMore = false, iconBefore: iconBefore, trailing: trailing, children: children, bodyRef: bodyRef, defaultExpanded: defaultExpanded = false, isExpanded: controlledExpanded, onToggleExpanded: onToggleExpanded, testId: testId })=>{
    const [isExpanded, handleClick] = $b63cd2ec09ae1c0c$export$47360455f9bb4561(controlledExpanded, onToggleExpanded, defaultExpanded);
    const id = (0, $cozmU.useId)();
    const headerId = `${id}-header`;
    const bodyId = `${id}-body`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": testId,
        className: (0, $hekY6.default)([
            "_2mHwu8kG2W _4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _3mHaMX9r67 _2yjt2x6wH8 _4auqkJNvrM _0KLXrulfZc _24h04i2Njc _1JRIqYdnbC"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        id: headerId,
        "aria-expanded": isExpanded,
        "aria-controls": bodyId,
        onClick: handleClick,
        xcss: $b63cd2ec09ae1c0c$var$styles.header,
        testId: testId ? `${testId}--header` : undefined
    }, iconBefore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.iconBefore
        ])
    }, iconBefore) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.titleGroup
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.titleText
        ])
    }, title), count !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $xICd5.SectionCountBadge), {
        count: count,
        hasMore: hasMore && count > 0
    }) : null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.trailing
        ])
    }, trailing, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $b63cd2ec09ae1c0c$var$styles.chevron
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b63cd2ec09ae1c0c$var$ChevronIcon, {
        isExpanded: isExpanded
    })))), isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: bodyRef,
        id: bodyId,
        role: "region",
        "aria-labelledby": headerId,
        tabIndex: 0,
        xcss: $b63cd2ec09ae1c0c$var$styles.body,
        testId: testId ? `${testId}--body` : undefined
    }, children) : null);
};
module.exports["useExpandedState"] = $b63cd2ec09ae1c0c$export$47360455f9bb4561;
module.exports["ConnectionsByLineSectionShell"] = $b63cd2ec09ae1c0c$export$8bedf248b7e9989d;

});

parcelRegister("lkmGM", function(module, exports) {
/* PressableGroup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $c4a4c0e327cf4b83$var$styles = {
    container: "_0bjKvD8fU6 _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbQ4SZ _0aFT5vbt8w _39xV02N91d _0KLXrulfZc _24h04i2Njc",
    row: "_4ouGXIdnbC",
    firstRow: "_2C2kUQ8fU6 _1Lz9lo8fU6",
    lastRow: "_1v9SsV8fU6 _3XDz3B8fU6",
    divider: "_3zygPU9r67 _2IVJ4M6wH8 _22sfPnNvrM"
};
const $c4a4c0e327cf4b83$export$25678a1bf665462c = ({ children: children, testId: testId })=>{
    const rows = (0, $cozmU.Children).toArray(children);
    const lastIndex = rows.length - 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $c4a4c0e327cf4b83$var$styles.container,
        testId: testId
    }, rows.map((row, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div" // eslint-disable-next-line react/no-array-index-key -- `Children.toArray` keys every element it returns, so element rows reuse that key; index is only the fallback for the strings and numbers it passes through unkeyed.
        , {
            key: /*#__PURE__*/ (0, $cozmU.isValidElement)(row) ? row.key ?? index : index,
            // asserting the group's shape needs to reach.
            "data-testid": testId ? `${testId}--row-${index}` : undefined,
            className: (0, $hekY6.default)([
                $c4a4c0e327cf4b83$var$styles.row,
                index === 0 && $c4a4c0e327cf4b83$var$styles.firstRow,
                index === lastIndex && $c4a4c0e327cf4b83$var$styles.lastRow,
                index > 0 && $c4a4c0e327cf4b83$var$styles.divider
            ])
        }, row)));
};
module.exports["PressableGroup"] = $c4a4c0e327cf4b83$export$25678a1bf665462c;

});

parcelRegister("3Jm25", function(module, exports) {
/* SectionHeader.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $xICd5 = parcelRequire("xICd5");

const $87914a6ea05af414$var$styles = {
    header: "_2mHwu82ADO _3iDTPbQ4SZ _0hPCNLDIqT",
    label: "_2sNsIgmnOE _1kk5Tk7GSX _1UtDYzy7kJ"
};
const $87914a6ea05af414$export$8adb256d999cd5a0 = ({ icon: icon, label: label, count: count })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $87914a6ea05af414$var$styles.header
    }, icon, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $87914a6ea05af414$var$styles.label
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $xICd5.SectionCountBadge), {
        count: count
    }));
module.exports["SectionHeader"] = $87914a6ea05af414$export$8adb256d999cd5a0;

});

parcelRegister("d7JJ3", function(module, exports) {
/* SectionEmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $8ba00a728dc0b537$var$styles = {
    container: "_0bjKvD8fU6 _4c065U5zaO _2Y7lL45zaO _3iDTPbQ4SZ _4kiQYAaXQy _37wbyuDIqT _0hPCNLDIqT _4xdlr0FlnN _24h04i2Njc",
    message: "_2sNsIgmnOE _3C14nsjBF4 _1UtDYzot27 _2fwxA5DIqT"
};
const $8ba00a728dc0b537$export$24bce80953fa3740 = ({ message: message, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $8ba00a728dc0b537$var$styles.container,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $8ba00a728dc0b537$var$styles.message
    }, message));
module.exports["SectionEmptyState"] = $8ba00a728dc0b537$export$24bce80953fa3740;

});

parcelRegister("cXMAQ", function(module, exports) {

let $9700b0556dbf3d90$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $9700b0556dbf3d90$var$load("6wr18"),
    $9700b0556dbf3d90$var$load("ca0UP"),
    $9700b0556dbf3d90$var$load("a92TB"),
    $9700b0556dbf3d90$var$load("ffEVr"),
    $9700b0556dbf3d90$var$load("4qYqO")
]).then(()=>parcelRequire('fBexU'));

});

parcelRegister("bT2y0", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");

const $6683769cb9483b95$var$i18n = (0, $kSwu1.defineMessages)({
    promptHeading: {
        id: "byline-connections.preview-panel.modal.ask-rovo-links-prompt-heading",
        defaultMessage: "Fetch the content behind each of these links and use it as context for subsequent tasks:"
    }
});
const $6683769cb9483b95$export$62c77a9657de28e5 = (connections)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return (0, $cozmU.useMemo)(()=>{
        const links = [
            ...connections.appearsIn.links,
            ...connections.linksTo.links,
            ...connections.relatedContent.links
        ];
        const urls = new Set();
        for (const { url: url } of links)if (url) urls.add(url);
        return urls.size ? [
            formatMessage($6683769cb9483b95$var$i18n.promptHeading),
            ...[
                ...urls
            ].map((url, index)=>`${index + 1}. ${url}`)
        ].join('\n') : null;
    }, [
        connections,
        formatMessage
    ]);
};
module.exports["useLinksContextPrompt"] = $6683769cb9483b95$export$62c77a9657de28e5;

});

parcelRegister("auHsF", function(module, exports) {

let $7a3e6b3df68e07c4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7a3e6b3df68e07c4$var$load("9CFD7"),
    $7a3e6b3df68e07c4$var$load("6THhx"),
    $7a3e6b3df68e07c4$var$load("k0Z8C"),
    $7a3e6b3df68e07c4$var$load("60PUI"),
    $7a3e6b3df68e07c4$var$load("1xeJ3"),
    $7a3e6b3df68e07c4$var$load("bx9z9")
]).then(()=>parcelRequire('hECmq'));

});

parcelRegister("6ckMU", function(module, exports) {
/* TeamworkGraphShareContextButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $ad7Ou = parcelRequire("ad7Ou");


var $w6R6I = parcelRequire("w6R6I");


var $V3JOP = parcelRequire("V3JOP");


var $hBYtq = parcelRequire("hBYtq");


var $4aRua = parcelRequire("4aRua");


var $I7TEB = parcelRequire("I7TEB");


var $jmjWc = parcelRequire("jmjWc");


const $9b0607d973efc2a0$export$b7ebe10419fd4a15 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "m-mIv",
    name: "ShareContextModalLoadable",
    loader: async ()=>(await (parcelRequire("56M0J"))).ShareContextModal
});


/* ShareContextAgentIcons.tsx generated by @compiled/babel-plugin v3.0.2 */ 






var $iMnC5 = parcelRequire("iMnC5");


var $4H55s = parcelRequire("4H55s");


var $jh2Zn = parcelRequire("jh2Zn");


var $hje3t = parcelRequire("hje3t");

const $22e6b97dca61a97a$var$styles = {
    pile: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC",
    claude: "_2AERacBk1w",
    tile: "_3iDTPbccYA _0GTcwR5UaJ"
};
function $22e6b97dca61a97a$export$88d45626ea05cf64() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        "aria-hidden": "true",
        xcss: $22e6b97dca61a97a$var$styles.pile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hje3t.RovoTileIcon), {
        size: "xxsmall"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: (0, $w6R6I.cx)($22e6b97dca61a97a$var$styles.tile, $22e6b97dca61a97a$var$styles.claude)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H55s.ClaudeIcon), {
        label: "",
        size: "xxsmall"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        xcss: $22e6b97dca61a97a$var$styles.tile
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jh2Zn.CursorIcon), {
        label: "",
        size: "xxsmall"
    })));
}



var $bEvUu = parcelRequire("bEvUu");

// Button has fixed vertical padding, so the footer uses Pressable to match the design.
const $475879d9027932e9$var$styles = {
    footerButton: "_2mHwu82ADO _0bjKvDKTcp _2sNsIgmnOE _4c065UPgdg _2Y7lL48HPE _2V7sgONvrM _3hxITi6wH8 _3vBAKH9r67 _3iDTPbQ4SZ _0jFU0VUofl _37wbyuDIqT _0hPCNLDIqT _4xdlr0FlnN _0KLXru66of _1UtDYzZpcK _1eOmH6o126 _3gzVzLN4oS",
    fullWidth: "_39xV02N91d"
};
const $475879d9027932e9$var$i18n = (0, $kSwu1.defineMessages)({
    shareContextWithAgent: {
        id: "byline-connections.preview-panel.footer.share-context-with-agent",
        defaultMessage: "Share context with AI agent"
    },
    shareContext: {
        id: "byline-connections.preview-panel.modal.share-context-button",
        defaultMessage: "Share context"
    }
});
function $475879d9027932e9$export$b674a24ba120da05({ contentId: contentId, testId: testId = 'teamwork-graph-modal-share-context', shouldFitContainer: shouldFitContainer = false, variant: variant = 'default', onOpen: onOpen, source: source = (0, $I7TEB.ANALYTICS_SOURCE), onAskRovo: onAskRovo }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bEvUu.useTwgAnalyticsEvents)();
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const [hasOpenedModal, setHasOpenedModal] = (0, $cozmU.useState)(false);
    const handleClick = (0, $cozmU.useCallback)(()=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: (0, $I7TEB.SHARE_CONTEXT_ACTION_SUBJECT_ID),
                source: source
            }
        }).fire();
        if (onOpen) {
            onOpen();
            return;
        }
        setHasOpenedModal(true);
        setIsModalOpen(true);
    }, [
        createAnalyticsEvent,
        onOpen,
        source
    ]);
    const closeModal = (0, $cozmU.useCallback)(()=>setIsModalOpen(false), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, variant === 'footer' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hBYtq.Pressable), {
        xcss: (0, $w6R6I.cx)($475879d9027932e9$var$styles.footerButton, shouldFitContainer && $475879d9027932e9$var$styles.fullWidth),
        onClick: handleClick,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22e6b97dca61a97a$export$88d45626ea05cf64), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        color: "color.text.subtle",
        size: "medium",
        weight: "medium",
        maxLines: 1
    }, formatMessage($475879d9027932e9$var$i18n.shareContextWithAgent))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "primary",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($V3JOP))),
        onClick: handleClick,
        shouldFitContainer: shouldFitContainer,
        testId: testId
    }, formatMessage($475879d9027932e9$var$i18n.shareContext)), hasOpenedModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9b0607d973efc2a0$export$b7ebe10419fd4a15), {
        isOpen: isModalOpen,
        onClose: closeModal,
        contentId: contentId,
        onAskRovo: onAskRovo
    }));
}
module.exports["TeamworkGraphShareContextButton"] = $475879d9027932e9$export$b674a24ba120da05;

});

parcelRegister("56M0J", function(module, exports) {

let $3b82c1407600bfb2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $3b82c1407600bfb2$var$load("1olsN"),
    $3b82c1407600bfb2$var$load("cyDpt"),
    $3b82c1407600bfb2$var$load("fKQ9j"),
    $3b82c1407600bfb2$var$load("Nr0vr")
]).then(()=>parcelRequire('casUE'));

});

parcelRegister("5tMCB", function(module, exports) {
/* TeamworkGraphChatColumn.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1sCHt = parcelRequire("1sCHt");


var $I7hWB = parcelRequire("I7hWB");


var $kdlgT = parcelRequire("kdlgT");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $fGDv8 = parcelRequire("fGDv8");


var $zCcSI = parcelRequire("zCcSI");

const $2471d2fa1075b3d2$var$BASE_UI_CONFIG = {
    externalEmbed: true,
    fullScreen: false,
    // Open on a fresh backend-backed conversation (created inside the chat's own store
    // container) instead of the shared EMPTY_CONVERSATION_ID, so the first send performs no
    // EMPTY→real transition that rebuilds the chat and re-seeds the prompt, and each open gets a
    // unique draft slot. The behaviour is experiment-gated inside conversation-assistant.
    createConversationOnMount: {
        followUpSource: 'teamworkGraphByline'
    },
    elements: {
        mainChatHeader: false,
        navbar: false,
        closeButton: false,
        fullscreenButton: false,
        newChatButton: false,
        createAgentButton: false,
        browseAgentsButton: false,
        agentsMenu: false,
        stagingAreaEnabled: false
    }
};
const $2471d2fa1075b3d2$var$styles = {
    root: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0aFT5vbt8w _0jFU0VN91d _4kiQYAdnbC",
    header: "_4c065U5zaO _2Y7lL4kG2W _3YEZNOdnbC _3iDTPbQ4SZ _37wbyuI7V3 _0hPCNLDIqT",
    chat: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4kiQYAdnbC"
};
const $2471d2fa1075b3d2$var$i18n = (0, $kSwu1.defineMessages)({
    heading: {
        id: "byline-connections.preview-panel.modal.rovo-column.heading",
        defaultMessage: "Rovo"
    },
    backLabel: {
        id: "byline-connections.preview-panel.modal.rovo-column.back-label",
        defaultMessage: "Back to connections"
    }
});
function $2471d2fa1075b3d2$export$8fbab62a7f19201d({ onBack: onBack, prefilledPrompt: prefilledPrompt }) {
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const config = (0, $zCcSI.useConversationAssistantConfig)({
        preventAbortRequestsOnStandaloneChatClose: true
    });
    const uiConfig = (0, $cozmU.useMemo)(()=>prefilledPrompt ? {
            ...$2471d2fa1075b3d2$var$BASE_UI_CONFIG,
            initialPromptText: prefilledPrompt,
            // Without this, `initialPromptText` is only applied for users in the
            // `cc_ai_growth_welcome_from_rovo` experiment.
            shouldSeedInitialPromptText: true
        } : $2471d2fa1075b3d2$var$BASE_UI_CONFIG, [
        prefilledPrompt
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2471d2fa1075b3d2$var$styles.root,
        testId: "teamwork-graph-modal-rovo-column"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2471d2fa1075b3d2$var$styles.header
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        alignBlock: "center",
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kdlgT))),
        label: formatMessage($2471d2fa1075b3d2$var$i18n.backLabel),
        appearance: "subtle",
        spacing: "compact",
        shape: "circle",
        onClick: onBack,
        testId: "teamwork-graph-modal-rovo-back"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $I7hWB.default), {
        size: "xsmall"
    }, formatMessage($2471d2fa1075b3d2$var$i18n.heading)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $2471d2fa1075b3d2$var$styles.chat
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fGDv8.default), {
        testId: "teamwork-graph-modal-chat",
        config: config,
        uiConfig: uiConfig
    })));
}
module.exports["TeamworkGraphChatColumn"] = $2471d2fa1075b3d2$export$8fbab62a7f19201d;

});

parcelRegister("aKxcs", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<b75dcd816ce4b8bd73313cd50a946812>>
 * @relayHash 5d29dbb06afa46621e34f49131b3f839
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1f47dc690f4d212f9c3ec615c12da22fb42b20f4278924ecd25cbbba4d12671c
const $64132a3f8ab78d31$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current",
                        "draft"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v1 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "title"
                        },
                        {
                            "concreteType": "OperationCheckResult",
                            "kind": "LinkedField",
                            "name": "operations",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "operation"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "targetType"
                                }
                            ]
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                v1 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "alias"
                                }
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "BylineClassificationQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "BylineClassificationQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "5d29dbb06afa46621e34f49131b3f839",
            "id": "1f47dc690f4d212f9c3ec615c12da22fb42b20f4278924ecd25cbbba4d12671c",
            "metadata": {},
            "name": "BylineClassificationQuery",
            "operationKind": "query",
            "text": "query BylineClassificationQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\",\"draft\"]){nodes{id,title,operations{operation,targetType},space{id,name,key,alias},type,status}}}"
        }
    };
}();
$64132a3f8ab78d31$var$node.hash = "e42e71a5c3870b4bc1b88d032b366270";
var $64132a3f8ab78d31$export$2e2bcd8739ae039 = $64132a3f8ab78d31$var$node;


/**
 * @generated SignedSource<<161eb8de8e725ca0b3b4b39ce9a07b04>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $87d62e4cd7f32dc5$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "BylineClassification_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "concreteType": "OperationCheckResult",
                "kind": "LinkedField",
                "name": "operations",
                "plural": true,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "operation"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "targetType"
                    }
                ]
            },
            {
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "alias"
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "useContentClassification_content"
            }
        ],
        "type": "Content"
    };
}();
$87d62e4cd7f32dc5$var$node.hash = "b485efc177facaa2fb781adacdeaa29e";
var $87d62e4cd7f32dc5$export$2e2bcd8739ae039 = $87d62e4cd7f32dc5$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $jMyy4 = parcelRequire("jMyy4");


var $cuWTe = parcelRequire("cuWTe");


var $1ggpj = parcelRequire("1ggpj");


var $iiPY2 = parcelRequire("iiPY2");


var $knzfV = parcelRequire("knzfV");


var $1u6lx = parcelRequire("1u6lx");


var $bFMG7 = parcelRequire("bFMG7");





var $b3j2Y = parcelRequire("b3j2Y");


var $jjv3l = parcelRequire("jjv3l");


var $cD1qu = parcelRequire("cD1qu");


var $aSsfA = parcelRequire("aSsfA");


var $6mKj3 = parcelRequire("6mKj3");


var $1xpoY = parcelRequire("1xpoY");

const $5278cea226e8a354$export$84b0a317f0d2e2ff = (0, $87d62e4cd7f32dc5$export$2e2bcd8739ae039);
const $5278cea226e8a354$export$5dc05a3e9ee4399c = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { contentId: contentId, classificationContextFragmentRef: classificationContextFragmentRef, contentFragmentRef: contentFragmentRef } = t0;
    if (classificationContextFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_classification_context_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t1;
        if ($[0] !== classificationContextFragmentRef || $[1] !== contentId) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContextFragmentReader, {
                contentId: contentId,
                contentFragmentRef: classificationContextFragmentRef
            });
            $[0] = classificationContextFragmentRef;
            $[1] = contentId;
            $[2] = t1;
        } else t1 = $[2];
        return t1;
    }
    let t1;
    if ($[3] !== contentFragmentRef || $[4] !== contentId) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationLegacyQueryReader, {
            contentId: contentId,
            contentFragmentRef: contentFragmentRef
        });
        $[3] = contentFragmentRef;
        $[4] = contentId;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
const $5278cea226e8a354$var$BylineClassificationContextFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { contentId: contentId, contentFragmentRef: contentFragmentRef } = t0;
    const contentData = (0, $6SsN4.useFragment)($5278cea226e8a354$export$84b0a317f0d2e2ff, contentFragmentRef);
    const readerProps = $5278cea226e8a354$var$useBylineClassificationReaderProps(contentId, contentData);
    let t1;
    if ($[0] !== contentData || $[1] !== contentId || $[2] !== readerProps.contentStatusContext) {
        t1 = {
            contentId: contentId,
            contentFragmentRef: contentData,
            contentStatusContext: readerProps.contentStatusContext,
            shouldReadFromQueries: true
        };
        $[0] = contentData;
        $[1] = contentId;
        $[2] = readerProps.contentStatusContext;
        $[3] = t1;
    } else t1 = $[3];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassificationFromFragment)(t1);
    let t2;
    if ($[4] !== contentClassificationMetadata || $[5] !== readerProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContent, {
            ...readerProps,
            contentClassificationMetadata: contentClassificationMetadata
        });
        $[4] = contentClassificationMetadata;
        $[5] = readerProps;
        $[6] = t2;
    } else t2 = $[6];
    return t2;
};
const $5278cea226e8a354$var$BylineClassificationLegacyQueryReader = (t0)=>{
    const $ = (0, $bDgLe.c)(9);
    const { contentId: contentId, contentFragmentRef: contentFragmentRef } = t0;
    let t1;
    if ($[0] !== contentId) {
        t1 = {
            variables: {
                contentId: contentId
            }
        };
        $[0] = contentId;
        $[1] = t1;
    } else t1 = $[1];
    const { data: data, error: bylineClassificationQueryError } = (0, $jMyy4.useQueryInterop)((0, $64132a3f8ab78d31$export$2e2bcd8739ae039), {
        ...t1,
        __callerPackage__: "content-header"
    });
    const contentData = data?.content?.nodes?.[0];
    const readerProps = $5278cea226e8a354$var$useBylineClassificationReaderProps(contentId, contentData);
    if (bylineClassificationQueryError) {
        let t2;
        if ($[2] !== bylineClassificationQueryError) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: bylineClassificationQueryError
            });
            $[2] = bylineClassificationQueryError;
            $[3] = t2;
        } else t2 = $[3];
        return t2;
    }
    if (contentFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_meta_frag_reader") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t2;
        if ($[4] !== contentFragmentRef || $[5] !== readerProps) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationMetadataFragmentReader, {
                ...readerProps,
                contentFragmentRef: contentFragmentRef
            });
            $[4] = contentFragmentRef;
            $[5] = readerProps;
            $[6] = t2;
        } else t2 = $[6];
        return t2;
    }
    let t2;
    if ($[7] !== readerProps) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationMetadataQueryReader, readerProps);
        $[7] = readerProps;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
const $5278cea226e8a354$var$useBylineClassificationReaderProps = (contentId, contentData)=>{
    const $ = (0, $bDgLe.c)(19);
    const isExternal = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const rawContentType = contentData?.type ?? undefined;
    const isArchived = contentData?.status === "archived";
    const isDraft = contentData?.status === "draft";
    const isViewEditOrLive = (0, $aSsfA.useGetPageMode)();
    let t0;
    if ($[0] !== isArchived || $[1] !== isDraft || $[2] !== isViewEditOrLive || $[3] !== rawContentType) {
        t0 = (0, $cuWTe.getContentMode)(rawContentType, isArchived, isDraft, isViewEditOrLive) || isViewEditOrLive || (0, $cD1qu.PageMode).VIEW;
        $[0] = isArchived;
        $[1] = isDraft;
        $[2] = isViewEditOrLive;
        $[3] = rawContentType;
        $[4] = t0;
    } else t0 = $[4];
    const contentMode = t0;
    let t1;
    if ($[5] !== contentMode || $[6] !== rawContentType) {
        t1 = {
            type: rawContentType,
            mode: contentMode
        };
        $[5] = contentMode;
        $[6] = rawContentType;
        $[7] = t1;
    } else t1 = $[7];
    const contentType = t1;
    let contentStatusContext;
    if (contentType.mode === "live" || contentType.mode === (0, $cD1qu.PageMode).VIEW && (0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false)) contentStatusContext = "current-and-draft";
    else if (contentType.mode === "edit" || contentType.mode === "draft") contentStatusContext = "draft-only";
    else contentStatusContext = "current-only";
    const t2 = contentData?.space?.key || "";
    const t3 = contentData?.space?.key;
    let t4;
    if ($[8] !== contentType.mode) {
        t4 = contentType.mode === (0, $cD1qu.PageMode).VIEW && !(0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false);
        $[8] = contentType.mode;
        $[9] = t4;
    } else t4 = $[9];
    let t5;
    if ($[10] !== contentData || $[11] !== contentId || $[12] !== contentStatusContext || $[13] !== contentType || $[14] !== isExternal || $[15] !== t2 || $[16] !== t3 || $[17] !== t4) {
        t5 = {
            contentId: contentId,
            spaceKey: t2,
            spaceKeyOverride: t3,
            contentData: contentData,
            contentType: contentType,
            contentStatusContext: contentStatusContext,
            isExternal: isExternal,
            isViewModeReadOnly: t4
        };
        $[10] = contentData;
        $[11] = contentId;
        $[12] = contentStatusContext;
        $[13] = contentType;
        $[14] = isExternal;
        $[15] = t2;
        $[16] = t3;
        $[17] = t4;
        $[18] = t5;
    } else t5 = $[18];
    return t5;
};
const $5278cea226e8a354$var$BylineClassificationMetadataQueryReader = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let contentId;
    let props;
    let spaceKeyOverride;
    if ($[0] !== t0) {
        ({ contentId: contentId, spaceKeyOverride: spaceKeyOverride, ...props } = t0);
        $[0] = t0;
        $[1] = contentId;
        $[2] = props;
        $[3] = spaceKeyOverride;
    } else {
        contentId = $[1];
        props = $[2];
        spaceKeyOverride = $[3];
    }
    let t1;
    if ($[4] !== contentId || $[5] !== props.contentStatusContext || $[6] !== spaceKeyOverride) {
        t1 = {
            contentId: contentId,
            spaceKeyOverride: spaceKeyOverride,
            contentStatusContext: props.contentStatusContext,
            shouldReadFromQueries: true
        };
        $[4] = contentId;
        $[5] = props.contentStatusContext;
        $[6] = spaceKeyOverride;
        $[7] = t1;
    } else t1 = $[7];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassification)(t1);
    let t2;
    if ($[8] !== contentClassificationMetadata || $[9] !== contentId || $[10] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContent, {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata,
            ...props
        });
        $[8] = contentClassificationMetadata;
        $[9] = contentId;
        $[10] = props;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
const $5278cea226e8a354$var$BylineClassificationMetadataFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    let contentFragmentRef;
    let contentId;
    let props;
    if ($[0] !== t0) {
        ({ contentId: contentId, contentFragmentRef: contentFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = contentFragmentRef;
        $[2] = contentId;
        $[3] = props;
    } else {
        contentFragmentRef = $[1];
        contentId = $[2];
        props = $[3];
    }
    let t1;
    if ($[4] !== contentFragmentRef || $[5] !== contentId || $[6] !== props.contentStatusContext) {
        t1 = {
            contentId: contentId,
            contentFragmentRef: contentFragmentRef,
            contentStatusContext: props.contentStatusContext,
            shouldReadFromQueries: true
        };
        $[4] = contentFragmentRef;
        $[5] = contentId;
        $[6] = props.contentStatusContext;
        $[7] = t1;
    } else t1 = $[7];
    const contentClassificationMetadata = (0, $bFMG7.useContentClassificationFromFragment)(t1);
    let t2;
    if ($[8] !== contentClassificationMetadata || $[9] !== contentId || $[10] !== props) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5278cea226e8a354$var$BylineClassificationContent, {
            contentId: contentId,
            contentClassificationMetadata: contentClassificationMetadata,
            ...props
        });
        $[8] = contentClassificationMetadata;
        $[9] = contentId;
        $[10] = props;
        $[11] = t2;
    } else t2 = $[11];
    return t2;
};
const $5278cea226e8a354$var$BylineClassificationContent = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { contentId: contentId, spaceKey: spaceKey, contentData: contentData, contentType: contentType, contentClassificationMetadata: contentClassificationMetadata, isExternal: isExternal, isViewModeReadOnly: isViewModeReadOnly } = t0;
    let t1;
    if ($[0] !== contentClassificationMetadata.isReclassificationPermitted || $[1] !== contentData?.operations) {
        t1 = (0, $6mKj3.expVal)("dlp_auto_classifications_enabled", "isEnabled", false) ? contentClassificationMetadata.isReclassificationPermitted ?? false : contentData?.operations?.some($5278cea226e8a354$var$_temp);
        $[0] = contentClassificationMetadata.isReclassificationPermitted;
        $[1] = contentData?.operations;
        $[2] = t1;
    } else t1 = $[2];
    const hasUpdatePermission = t1;
    const readOnly = isExternal || !hasUpdatePermission || isViewModeReadOnly;
    const isClassificationEnabled = contentClassificationMetadata.featureEnabled ?? false;
    let t2;
    if ($[3] !== contentClassificationMetadata || $[4] !== contentId || $[5] !== contentType || $[6] !== isClassificationEnabled || $[7] !== readOnly || $[8] !== spaceKey) {
        t2 = isClassificationEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iiPY2.ContentTypeClassificationLoader), {
            variant: (0, $1u6lx.TagButtonUIVariant).default,
            spaceKey: spaceKey,
            contentId: contentId,
            contentType: contentType.type ?? "",
            contentClassificationMetadata: contentClassificationMetadata,
            readOnly: readOnly,
            spacing: "expanded"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $knzfV.ClassificationEditModal), {
            contentId: contentId,
            spaceKey: spaceKey,
            contentClassificationMetadata: contentClassificationMetadata
        })) : null;
        $[3] = contentClassificationMetadata;
        $[4] = contentId;
        $[5] = contentType;
        $[6] = isClassificationEnabled;
        $[7] = readOnly;
        $[8] = spaceKey;
        $[9] = t2;
    } else t2 = $[9];
    return t2;
};
function $5278cea226e8a354$var$_temp(operation) {
    return operation?.targetType && (0, $1ggpj.VALID_OPERATION_TARGETS).includes(operation.targetType) && operation.operation === "update";
}
module.exports["BylineClassification"] = $5278cea226e8a354$export$5dc05a3e9ee4399c;

});

parcelRegister("6iOCg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kNIYN = parcelRequire("kNIYN");


var $kmQhR = parcelRequire("kmQhR");


var $kA6Zo = parcelRequire("kA6Zo");


var $buxP3 = parcelRequire("buxP3");


var $1LXnB = parcelRequire("1LXnB");


var $jVylI = parcelRequire("jVylI");


var $aV3a0 = parcelRequire("aV3a0");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $jjv3l = parcelRequire("jjv3l");


var $6mKj3 = parcelRequire("6mKj3");


var $gektR = parcelRequire("gektR");


var $e4o8D = parcelRequire("e4o8D");


var $1xpoY = parcelRequire("1xpoY");








var $8wW9d = parcelRequire("8wW9d");


var $7Ndnw = parcelRequire("7Ndnw");


var $3b6WO = parcelRequire("3b6WO");


var $eSLr0 = parcelRequire("eSLr0");


var $6ld6a = parcelRequire("6ld6a");

const $e105dde0a43b3be2$export$b613c53a0aeac846 = (contentId)=>{
    const $ = (0, $bDgLe.c)(15);
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId,
            location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    const { webItems: connectItems, loading: loadingConnectItems, error: connectError } = (0, $6ld6a.useWebItemLocation)(t0);
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE)
        };
        $[2] = t1;
    } else t1 = $[2];
    const { extensions: forgeItems, loading: loadingForgeItems, error: forgeError } = (0, $3b6WO.useExtensionList)(t1);
    let t2;
    let t3;
    if ($[3] !== connectItems || $[4] !== forgeItems) {
        t2 = ()=>{
            (0, $8wW9d.recordNonContentAppKeys)("byline", [
                ...connectItems?.map($e105dde0a43b3be2$var$_temp) ?? [],
                ...forgeItems?.map($e105dde0a43b3be2$var$_temp2) ?? []
            ]);
        };
        t3 = [
            connectItems,
            forgeItems
        ];
        $[3] = connectItems;
        $[4] = forgeItems;
        $[5] = t2;
        $[6] = t3;
    } else {
        t2 = $[5];
        t3 = $[6];
    }
    (0, $cozmU.useEffect)(t2, t3);
    const t4 = connectItems?.length > 0 || forgeItems?.length > 0;
    let t5;
    if ($[7] !== connectError || $[8] !== connectItems || $[9] !== forgeError || $[10] !== forgeItems || $[11] !== loadingConnectItems || $[12] !== loadingForgeItems || $[13] !== t4) {
        t5 = {
            hasApps: t4,
            connectItems: connectItems,
            loadingConnectItems: loadingConnectItems,
            connectError: connectError,
            forgeItems: forgeItems,
            loadingForgeItems: loadingForgeItems,
            forgeError: forgeError
        };
        $[7] = connectError;
        $[8] = connectItems;
        $[9] = forgeError;
        $[10] = forgeItems;
        $[11] = loadingConnectItems;
        $[12] = loadingForgeItems;
        $[13] = t4;
        $[14] = t5;
    } else t5 = $[14];
    return t5;
};
function $e105dde0a43b3be2$var$_temp(item) {
    return item.completeKey;
}
function $e105dde0a43b3be2$var$_temp2(item_0) {
    return item_0.id;
}



var $j2moL = parcelRequire("j2moL");


var $35Exc = parcelRequire("35Exc");








var $kSwu1 = parcelRequire("kSwu1");


var $iW7aI = parcelRequire("iW7aI");


var $aDSIl = parcelRequire("aDSIl");


var $1sCHt = parcelRequire("1sCHt");


var $3izAL = parcelRequire("3izAL");


var $kh0hi = parcelRequire("kh0hi");




const $120e402a2d601a31$var$i18n = (0, $kSwu1.defineMessages)({
    showAllApps: {
        id: "content-header.livepages.by-line.showAllApps",
        defaultMessage: "Show all apps"
    },
    showLessApps: {
        id: "content-header.livepages.by-line.showLess",
        defaultMessage: "Show less"
    }
});
const $120e402a2d601a31$var$toggleButtonGradientStyles = (0, $buxP3.xcss)({
    height: '100%',
    position: 'relative',
    '::before': {
        content: '""',
        background: `linear-gradient(to right, transparent, ${"var(--ds-surface, #FFFFFF)"})`,
        height: '100%',
        left: 'space.negative.400',
        position: 'absolute',
        width: '32px'
    }
});
const $120e402a2d601a31$var$buttonStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: "var(--ds-radius-small, 4px)",
    color: 'color.text.subtle',
    display: 'flex',
    font: 'font.body.small',
    gap: 'space.075',
    padding: 'space.050',
    paddingInlineStart: 'space.075',
    paddingInlineEnd: 'space.075',
    whiteSpace: 'nowrap',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $120e402a2d601a31$export$a2051cde2c49a6fb = (t0)=>{
    const $ = (0, $bDgLe.c)(7);
    const { isExpanded: isExpanded, handleToggle: handleToggle } = t0;
    const intl = (0, $kSwu1.useIntl)();
    const t1 = !isExpanded && $120e402a2d601a31$var$toggleButtonGradientStyles;
    let t2;
    if ($[0] !== handleToggle || $[1] !== intl || $[2] !== isExpanded) {
        t2 = !isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
            appearance: "subtle",
            spacing: "compact",
            icon: $120e402a2d601a31$var$_temp,
            label: intl.formatMessage($120e402a2d601a31$var$i18n.showAllApps),
            onClick: handleToggle,
            testId: "show-all-apps-button"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
            xcss: $120e402a2d601a31$var$buttonStyles,
            onClick: handleToggle,
            testId: "show-less-apps-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iW7aI))), {
            label: "",
            size: "small"
        }), intl.formatMessage($120e402a2d601a31$var$i18n.showLessApps));
        $[0] = handleToggle;
        $[1] = intl;
        $[2] = isExpanded;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== t1 || $[5] !== t2) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t1,
            testId: "single-line-byline-toggle-wrapper"
        }, t2);
        $[4] = t1;
        $[5] = t2;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
function $120e402a2d601a31$var$_temp(iconProps) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
        ...iconProps,
        size: "small"
    });
}



var $3aDMt = parcelRequire("3aDMt");


var $87We3 = parcelRequire("87We3");

const $202654fe0d7532c2$var$singleLineBaseStyles = (0, $buxP3.xcss)({
    whiteSpace: 'nowrap',
    width: '100%',
    overflowX: 'hidden'
});
const $202654fe0d7532c2$var$appsContainerStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    gap: 'space.050',
    overflow: 'hidden'
});
const $202654fe0d7532c2$var$bylineContentStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    display: 'flex',
    flexShrink: 0,
    gap: 'space.050'
});
const $202654fe0d7532c2$var$singleLineWrapStyles = (0, $buxP3.xcss)({
    flexWrap: 'wrap',
    overflowX: 'visible'
});
const $202654fe0d7532c2$var$centerAlignmentStyles = (0, $buxP3.xcss)({
    justifyContent: 'center',
    marginLeft: 'auto',
    marginRight: 'auto',
    width: 'initial'
});
const $202654fe0d7532c2$var$maxWidthStyles = (0, $buxP3.xcss)({
    maxWidth: '760px'
});
// when the last byline app is on the first row of the byline, its top position should be within this offset
// this is assuming no byline items are wrapping themselves (which they shouldn't be)
const $202654fe0d7532c2$var$BYLINE_SINGLE_ROW_TOP_OFFSET = 15;
const $202654fe0d7532c2$var$AppsContainer = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $202654fe0d7532c2$var$appsContainerStyles
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $202654fe0d7532c2$export$cc95b64079434472 = /*#__PURE__*/ (0, $cozmU.memo)(({ contentId: contentId, children: children, contentType: contentType = 'page', isTitleCenterAlignedOverride: isTitleCenterAlignedOverride, showByLineExtensions: showByLineExtensions = true, bylineAppContentProperties: bylineAppContentProperties })=>{
    const bylineAppsDefaultCollapsed = (0, $1xpoY.default).getBoolean('confluence_byline_app_default_collapsed', false);
    const [shouldShowToggleButton, setShouldShowToggleButton] = (0, $cozmU.useState)(false);
    const [haveAppsLoaded, setHaveAppsLoaded] = (0, $cozmU.useState)(false);
    const [isExpanded, setIsExpanded] = (0, $cozmU.useState)(!bylineAppsDefaultCollapsed);
    const [currentParentWidth, setCurrentParentWidth] = (0, $cozmU.useState)();
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const bylineRef = (0, $cozmU.useRef)(null);
    const { isTitleCenteredInitial: isTitleCenteredInitial } = (0, $aV3a0.useTitleContentPropertiesForEditor)({
        contentId: contentId,
        contentType: contentType
    });
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { hasApps: hasApps, connectItems: connectItems, connectError: connectError, forgeItems: forgeItems, forgeError: forgeError, loadingConnectItems: loadingConnectItems, loadingForgeItems: loadingForgeItems } = (0, $e105dde0a43b3be2$export$b613c53a0aeac846)(contentId);
    const [initialSnapshot] = (0, $cozmU.useState)(()=>{
        if (!renderServerPlaceholder || isRestrictedExternalShare || !showByLineExtensions || !(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) return {
            contentId: contentId,
            snapshot: undefined
        };
        // Enrolled loads have already paid the preload cost, so they remain exposed even when
        // an incomplete result prevents the snapshot from being rendered.
        const snapshot = (0, $87We3.createByLineAppSnapshot)({
            connectError: connectError,
            connectItems: connectItems,
            forgeError: forgeError,
            forgeItems: forgeItems,
            loadingConnectItems: loadingConnectItems,
            loadingForgeItems: loadingForgeItems,
            bylineAppContentProperties: bylineAppContentProperties
        });
        // Keep the server/mount-time presentation immutable while the client queries refresh.
        return {
            contentId: contentId,
            snapshot: (0, $87We3.isByLineAppSnapshotAuthoritative)(snapshot) ? snapshot : undefined
        };
    });
    const isInitialSnapshotRetired = (0, $cozmU.useRef)(false);
    (0, $cozmU.useEffect)(()=>{
        // This snapshot belongs only to the initial hydration. Once another page commits,
        // never make it eligible again if SPA navigation later returns to the initial page.
        if (initialSnapshot.snapshot && contentId !== initialSnapshot.contentId) isInitialSnapshotRetired.current = true;
    }, [
        contentId,
        initialSnapshot
    ]);
    const authoritativeSnapshot = !isInitialSnapshotRetired.current && initialSnapshot.contentId === contentId ? initialSnapshot.snapshot : undefined;
    (0, $cozmU.useEffect)(()=>{
        if (!bylineRef.current || !haveAppsLoaded) return;
        const bylineAppsRoot = authoritativeSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? bylineRef.current.querySelector('[data-byline-app-runtime]') : bylineRef.current;
        if (!bylineAppsRoot) return;
        const forgeApps = Array.from(bylineAppsRoot.querySelectorAll('[data-testid="forge-byline-header-wrapper"]'));
        const webItemApps = Array.from(bylineAppsRoot.querySelectorAll('[data-testid="web-item-link"]'));
        // forge items are rendered after web items so theyd be last if rendered
        const appsList = [
            ...webItemApps,
            ...forgeApps
        ];
        const lastAppElement = appsList[appsList.length - 1];
        if (!lastAppElement) return;
        const bylineRefRect = bylineRef.current?.getBoundingClientRect();
        const lastAppRect = lastAppElement.getBoundingClientRect();
        const areOnSameLine = Math.abs(bylineRefRect.top - lastAppRect.top) < $202654fe0d7532c2$var$BYLINE_SINGLE_ROW_TOP_OFFSET;
        if (isExpanded) {
            // theres no need to calculate overflow below if the apps are already expanded
            // we just need to check if all apps fit in the first row so we can hide the toggle button
            setShouldShowToggleButton(!areOnSameLine);
            return;
        }
        // Check if elements are on the same line by comparing their top positions
        setShouldShowToggleButton(lastAppRect.right > bylineRefRect.right);
    }, [
        authoritativeSnapshot,
        currentParentWidth,
        haveAppsLoaded,
        isExpanded
    ]);
    const toggleShowAllApps = ()=>{
        setIsExpanded((currentState)=>!currentState);
    };
    const handleBylineAppsLoaded = (0, $cozmU.useCallback)(()=>{
        setHaveAppsLoaded(true);
    }, []);
    const updateContentAreaWidth = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))((width)=>{
        setCurrentParentWidth(width);
    }, 100);
    // this container is necessary to prevent the byline overflow from pushing the show more button out of view
    const RestrictAppsInOverflowContainer = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment : $202654fe0d7532c2$var$AppsContainer;
    const shouldShowApps = !isRestrictedExternalShare && (hasApps || Boolean(authoritativeSnapshot?.apps.length)) && showByLineExtensions;
    const bylineApps = renderServerPlaceholder && window.__SSR_REACT_STREAMING__ ? authoritativeSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aDMt.AuthoritativeByLineApps), {
        snapshot: authoritativeSnapshot
    }) : null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $j2moL.LazyLivePagesByLineApps), {
        contentId: contentId,
        connectItems: connectItems,
        forgeItems: forgeItems,
        forgeError: forgeError,
        showLivePagesExtensionPoints: true,
        isSingleLineByline: true,
        onBylineAppsLoaded: handleBylineAppsLoaded,
        loadingConnectItems: loadingConnectItems,
        loadingForgeItems: loadingForgeItems,
        authoritativeSnapshot: authoritativeSnapshot
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
        to: [
            (0, $gektR.AlignmentButtonContainer)
        ]
    }, (alignmentButtonContainer)=>{
        const isTitleCenterAligned = isTitleCenterAlignedOverride || (!alignmentButtonContainer.state.isLoadingComplete ? isTitleCenteredInitial : alignmentButtonContainer.state.alignmentButtonState === (0, $jVylI.TitleAlignmentType).CENTER);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35Exc.BylineStyledMainDivSingleLine), {
            isExpanded: isExpanded
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            testId: "byline-single-line",
            ref: bylineRef,
            xcss: [
                $202654fe0d7532c2$var$singleLineBaseStyles,
                // show more toggles to enable wrap are dependent on having apps present
                // this would prevent an edge case of a very long byline (or tiny viewport) with no apps being cut off
                (isExpanded || !shouldShowApps) && $202654fe0d7532c2$var$singleLineWrapStyles,
                isTitleCenterAligned && $202654fe0d7532c2$var$centerAlignmentStyles,
                isTitleCenterAligned && !isExpanded && $202654fe0d7532c2$var$maxWidthStyles
            ],
            gap: "space.050"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $202654fe0d7532c2$var$bylineContentStyles
        }, children), shouldShowApps && bylineApps ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ECOSYSTEM
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(RestrictAppsInOverflowContainer, null, bylineApps)) : null), renderServerPlaceholder && window.__SSR_REACT_STREAMING__ ? null : shouldShowApps && shouldShowToggleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $120e402a2d601a31$export$a2051cde2c49a6fb), {
            isExpanded: isExpanded,
            handleToggle: toggleShowAllApps
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1LXnB.WidthObserver), {
            setWidth: updateContentAreaWidth
        }));
    });
});
module.exports["SingleLineByLine"] = $202654fe0d7532c2$export$cc95b64079434472;

});

parcelRegister("j2moL", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");


var $6mKj3 = parcelRequire("6mKj3");


var $80koo = parcelRequire("80koo");


var $b3j2Y = parcelRequire("b3j2Y");


var $7Sm4c = parcelRequire("7Sm4c");


var $jmjWc = parcelRequire("jmjWc");











var $ah4BL = parcelRequire("ah4BL");


var $9DHhW = parcelRequire("9DHhW");


var $9wGTI = parcelRequire("9wGTI");


var $asQED = parcelRequire("asQED");


var $17wUi = parcelRequire("17wUi");


var $1UApO = parcelRequire("1UApO");


var $euq7N = parcelRequire("euq7N");







/**
 * @generated SignedSource<<146f014633927f394ddf960a506da573>>
 * @relayHash 7c8317bb717346ea2ddd7f2fdb49f2d0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4c54ae82f4f2aaf407e36724c9a56ad7521ffa4ac52a827b9d418240e4a5d4b7
const $25c03fd7fde92d1a$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "InvokeExtensionResponse",
            "kind": "LinkedField",
            "name": "invokeExtension",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "concreteType": "InvocationResponsePayload",
                    "kind": "LinkedField",
                    "name": "response",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "body"
                        }
                    ]
                },
                {
                    "concreteType": "MutationError",
                    "kind": "LinkedField",
                    "name": "errors",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        },
                        {
                            "kind": "LinkedField",
                            "name": "extensions",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "__typename"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "statusCode"
                                },
                                {
                                    "kind": "InlineFragment",
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        }
                                    ],
                                    "type": "BulkMutationErrorExtension"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ByLineForgeAppinvokeExtensionMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ByLineForgeAppinvokeExtensionMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "7c8317bb717346ea2ddd7f2fdb49f2d0",
            "id": "4c54ae82f4f2aaf407e36724c9a56ad7521ffa4ac52a827b9d418240e4a5d4b7",
            "metadata": {},
            "name": "ByLineForgeAppinvokeExtensionMutation",
            "operationKind": "mutation",
            "text": "mutation ByLineForgeAppinvokeExtensionMutation($input:InvokeExtensionInput!){invokeExtension(input:$input){success,response{body},errors{message,extensions{__typename,statusCode,...on BulkMutationErrorExtension{id}}}}}"
        }
    };
}();
$25c03fd7fde92d1a$var$node.hash = "00321bd07f93db1aae1039ee5a2af686";
var $25c03fd7fde92d1a$export$2e2bcd8739ae039 = $25c03fd7fde92d1a$var$node;








var $9aYkv = parcelRequire("9aYkv");


var $kSwu1 = parcelRequire("kSwu1");


var $4n1IT = parcelRequire("4n1IT");


var $kh0hi = parcelRequire("kh0hi");


var $buxP3 = parcelRequire("buxP3");


var $lpNn5 = parcelRequire("lpNn5");


var $lfoFx = parcelRequire("lfoFx");








var $1kHsc = parcelRequire("1kHsc");


var $7Ndnw = parcelRequire("7Ndnw");


var $aF5bm = parcelRequire("aF5bm");


var $4vC63 = parcelRequire("4vC63");


var $7QUD1 = parcelRequire("7QUD1");


var $lOI2p = parcelRequire("lOI2p");


var $jYZsR = parcelRequire("jYZsR");


var $hIaUw = parcelRequire("hIaUw");


var $grspz = parcelRequire("grspz");


var $8a9Dm = parcelRequire("8a9Dm");


var $9fBoq = parcelRequire("9fBoq");


var $ep3mz = parcelRequire("ep3mz");


var $bQm3c = parcelRequire("bQm3c");


var $7W8i8 = parcelRequire("7W8i8");


var $5ZqQS = parcelRequire("5ZqQS");


var $3IBnw = parcelRequire("3IBnw");


var $3jwuS = parcelRequire("3jwuS");


var $de2j9 = parcelRequire("de2j9");


var $6UqI3 = parcelRequire("6UqI3");


var $6uUjl = parcelRequire("6uUjl");


var $jMyy4 = parcelRequire("jMyy4");


var $1JyKZ = parcelRequire("1JyKZ");


var $308Wd = parcelRequire("308Wd");


var $e5xte = parcelRequire("e5xte");







var $46f2a733fab59ac5$exports = {};
$46f2a733fab59ac5$exports = new URL("AK_AddonIcon.7997ef8d.svg", import.meta.url).toString();



var $83fWZ = parcelRequire("83fWZ");


var $5vpeX = parcelRequire("5vpeX");


var $7sf7C = parcelRequire("7sf7C");
















const $92aefd48974e22dc$export$9bfd6c1ca71ef80d = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { appId: appId, contentId: contentId, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const reportedTitleAlignmentRef = (0, $cozmU.useRef)(null);
    let t1;
    if ($[0] !== appId || $[1] !== contentId || $[2] !== createAnalyticsEvent || $[3] !== hasAuthoritativeBylineAppSnapshot) {
        t1 = (titleChanged, resolutionOutcome)=>{
            if (!hasAuthoritativeBylineAppSnapshot || !(0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true)) return;
            const reported = reportedTitleAlignmentRef.current;
            if (reported?.appId === appId && reported.contentId === contentId) return;
            reportedTitleAlignmentRef.current = {
                appId: appId,
                contentId: contentId
            };
            createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    action: "resolved",
                    actionSubject: "forgeExtension",
                    actionSubjectId: "dynamicProperties",
                    source: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                    attributes: {
                        resolutionOutcome: resolutionOutcome,
                        titleChanged: titleChanged
                    }
                }
            }).fire();
        };
        $[0] = appId;
        $[1] = contentId;
        $[2] = createAnalyticsEvent;
        $[3] = hasAuthoritativeBylineAppSnapshot;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};


const $1cb9b1bda2de2c04$var$EXPERIENCE_NAME = (0, $irVI7.VIEW_PAGE_BYLINE_FORGE_EXPERIENCE); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cb9b1bda2de2c04$var$ContentWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEkG2W _1EqgXl4DOi _0NUa3r4DOi _2WAcuGIZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1cb9b1bda2de2c04$var$i18n = (0, $kSwu1.defineMessages)({
    appIcon: {
        id: "content-header.forge.byline-app.app-icon-alt",
        defaultMessage: "App Icon"
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1cb9b1bda2de2c04$var$ByLineForgeAppHeaderWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(8);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "span" : t2;
        const { isHidden: isHidden, ...__cmpldp } = __cmplp;
        const t3 = __cmplp.isHidden ? "none" : "inline-block";
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        let t5;
        if ($[5] !== __cmpls || $[6] !== t4) {
            t5 = {
                ...__cmpls,
                "--_z2o4qt": t4
            };
            $[5] = __cmpls;
            $[6] = t4;
            $[7] = t5;
        } else t5 = $[7];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t5,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_3iDTPb3qsO _0adFHsPgdg _0DCa9D98eZ _3932vvYbGa _02cRtH6wH8 _0z71MC98eZ _4tUF3yYbGa _0a2Gmi6wH8 _0ReiIH7zJH",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $1cb9b1bda2de2c04$var$Image = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "img" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEn1Zi _0jFU0VEbN9 _39xV02EbN9 _3iDTPbvbI6 _1RrJLiYXK7 _1UtDYz8ujp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $1cb9b1bda2de2c04$var$forgeAppButtonStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.small',
    display: 'inline-flex',
    font: 'font.body.small',
    color: 'color.text.subtle',
    gap: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    marginRight: 'space.0',
    padding: 'space.050',
    transition: "var(--ds-button-hovered, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))",
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        textDecoration: 'none'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed',
        transition: "var(--ds-button-pressed, background-color border-color 150ms cubic-bezier(0.4, 1, 0.6, 1))"
    }
});
const $1cb9b1bda2de2c04$var$forgeAppButtonDotStyles = (0, $buxP3.xcss)({
    '::before': {
        content: '"\u2022"',
        display: 'inline-block',
        paddingRight: 'space.050',
        alignSelf: 'center',
        textDecoration: 'none'
    }
});
const $1cb9b1bda2de2c04$var$sharedForgeAppButtonStyles = (0, $buxP3.xcss)({
    backgroundColor: 'color.background.neutral.subtle',
    display: 'inline-flex',
    padding: 'space.0'
});
const $1cb9b1bda2de2c04$var$ByLineForgeAppTrigger = ({ app: app, reference: reference, defineTriggerRef: defineTriggerRef, toggleClose: toggleClose, isOpen: isOpen, extensionData: extensionData, isHidden: isHidden, hideDot: hideDot, appTitle: appTitle, setAppTitle: setAppTitle, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot, authoritativePresentation: authoritativePresentation, contentPropertyKeys: contentPropertyKeys })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const appHasDynamicProperties = !!app.properties.dynamicProperties;
    const [contentPropertyKey, setContentPropertyKey] = (0, $cozmU.useState)(app.properties.contentPropertyKey || '');
    const initialAppTitleRef = (0, $cozmU.useRef)(appTitle);
    const { cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const workspaceARI = (0, $aF5bm.useWorkspaceARI)();
    const [appIcon, setAppIcon] = (0, $cozmU.useState)(()=>app.properties.contentPropertyKey && authoritativePresentation && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? authoritativePresentation?.icon?.src || null : app.properties.icon || null);
    const [appTooltip, setAppTooltip] = (0, $cozmU.useState)(()=>app.properties.contentPropertyKey && authoritativePresentation && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? authoritativePresentation?.tooltip || null : app.properties.tooltip || null);
    const reportTitleAlignment = (0, $92aefd48974e22dc$export$9bfd6c1ca71ef80d)({
        appId: app.id,
        contentId: extensionData.content?.id,
        hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot
    });
    const [isLoading, setIsLoading] = (0, $cozmU.useState)(appHasDynamicProperties && (!app.properties.contentPropertyKey && !hasAuthoritativeBylineAppSnapshot || !(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)));
    const localId = (0, $cozmU.useMemo)(()=>(0, $grspz.getLocalId)(app.id), [
        app.id
    ]);
    const getContextToken = (0, $1JyKZ.useGetContextToken)({
        extension: app,
        extensionData: extensionData,
        localId: localId,
        contextIds: [
            workspaceARI
        ]
    });
    const getContextTokenRef = (0, $cozmU.useRef)(getContextToken);
    (0, $cozmU.useEffect)(()=>{
        getContextTokenRef.current = getContextToken;
    }, [
        getContextToken
    ]);
    const [bylineDynamicPropertiesMutation] = (0, $308Wd.useMutationInterop)((0, $25c03fd7fde92d1a$export$2e2bcd8739ae039), {
        interopApolloAggClient: true,
        __callerPackage__: "content-header"
    });
    const fetchDynamicProperties = (0, $cozmU.useCallback)(async ()=>{
        const extensionId = app.id;
        const contextPayload = {
            cloudId: cloudId,
            localId: localId,
            extension: extensionData
        };
        let contextToken;
        try {
            contextToken = await getContextTokenRef.current();
        } catch (e) {
            reportTitleAlignment(false, 'failed');
            throw new Error(`Failed to get context token: ${e}`);
        }
        const result = await bylineDynamicPropertiesMutation({
            variables: {
                input: {
                    entryPoint: 'dynamicProperties',
                    contextIds: [
                        workspaceARI
                    ],
                    extensionId: extensionId,
                    payload: {
                        context: contextPayload,
                        ...contextPayload,
                        // TODO: This is temporary for Forge apps' backward compatibility
                        ...contextToken ? {
                            contextToken: contextToken
                        } : {}
                    }
                }
            }
        }).catch((e)=>{
            return {
                data: {
                    invokeExtension: {
                        success: false,
                        errors: [
                            {
                                message: e
                            }
                        ]
                    }
                }
            };
        });
        setIsLoading(false); // @ts-expect-error The types here are a bit messy. Typegen for AGG should help solve that
        const { response: response, success: success } = result.data?.invokeExtension; // @ts-expect-error The types here are a bit messy. Typegen for AGG should help solve that
        const errors = result.data?.invokeExtension.errors;
        if (!success) {
            const logger = (0, $7W8i8.getLogger)('by-line-apps');
            const errorMessages = errors.map((error)=>error.message).join(' ');
            reportTitleAlignment(false, 'failed'); // prints error to aid forge developer && allow Ecosystem to track these errors
            logger.error`Failed to fetch dynamic properties for ByLine Forge app: ${app.id} with error: ${errorMessages}`;
            if (errorMessages !== 'User consent required') (0, $5ZqQS.getMonitoringClient)().submitError(new Error(`Failed to fetch dynamic properties for ByLine Forge app: ${app.id} with error: ${errorMessages}`), {
                attribution: (0, $3IBnw.Attribution).ECOSYSTEM
            });
            return;
        }
        if (!response && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) {
            reportTitleAlignment(false, 'succeeded');
            return;
        }
        if (response.body) {
            const { body: { title: dynamicPropsTitle, tooltip: dynamicPropsTooltip, icon: dynamicPropsIcon } } = response;
            reportTitleAlignment(Boolean(dynamicPropsTitle && (0, $9fBoq.extensionTitle)(app, dynamicPropsTitle) !== (0, $9fBoq.extensionTitle)(app)), 'succeeded');
            dynamicPropsTitle && setAppTitle((0, $9fBoq.extensionTitle)(app, dynamicPropsTitle));
            dynamicPropsTooltip && setAppTooltip(dynamicPropsTooltip);
            dynamicPropsIcon && setAppIcon(dynamicPropsIcon);
        } else reportTitleAlignment(false, 'succeeded');
    }, [
        app,
        cloudId,
        extensionData,
        bylineDynamicPropertiesMutation,
        workspaceARI,
        setAppTitle,
        localId,
        reportTitleAlignment
    ]);
    // Validation function for content property data
    const validateContentPropertyDataCallback = (0, $cozmU.useCallback)((data)=>{
        const defaultValues = {
            title: initialAppTitleRef.current,
            icon: app.properties.icon || '',
            tooltip: app.properties.tooltip || '',
            contentPropertyKey: app.properties.contentPropertyKey || ''
        };
        if ((0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) return (0, $5vpeX.validateContentPropertyData)(data, {
            ...defaultValues,
            // The manifest title is undecorated; the client adds the environment suffix once.
            title: app.properties.contentPropertyKey ? app.properties.title || '' : defaultValues.title
        }, (0, $euq7N.getBylineAppContentPropertyKeys)([
            app
        ]));
        return (0, $5vpeX.validateContentPropertyData)(data, defaultValues);
    }, [
        app
    ]); // Validation function specifically for FORGE_CONTENT_PROPERTY_UPDATED event data
    const validateEventDataCallback = (0, $cozmU.useCallback)((eventData)=>{
        const defaultValues = {
            title: appTitle,
            icon: app.properties.icon || '',
            tooltip: app.properties.tooltip || ''
        };
        return (0, $5vpeX.validateEventData)(eventData, defaultValues);
    }, [
        appTitle,
        app.properties.icon,
        app.properties.tooltip
    ]);
    const runGeneralContentPropertyQuery = (0, $cozmU.useCallback)(()=>{
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { data: generalContentPropertyData, refetch: refetchQueryContentProperties } = // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $jMyy4.useQueryInterop)((0, $7sf7C.default), {
            variables: {
                contentId: extensionData.content?.id,
                ...(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? {
                    keys: contentPropertyKeys ?? (0, $euq7N.getBylineAppContentPropertyKeys)([
                        app
                    ])
                } : {}
            },
            __callerPackage__: "content-header"
        });
        return {
            data: generalContentPropertyData,
            refetch: refetchQueryContentProperties
        };
    }, [
        app,
        contentPropertyKeys,
        extensionData
    ]); // Run general content property query to get all properties (including IDs), if the app has a contentPropertyKey
    const queryResult = app.properties.contentPropertyKey ? runGeneralContentPropertyQuery() : null;
    const generalData = queryResult?.data || null;
    const refetchContentProperties = queryResult?.refetch; // Validate content property data and get clean values
    const validatedProperties = !generalData && app.properties.contentPropertyKey && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? null : validateContentPropertyDataCallback(generalData);
    (0, $cozmU.useEffect)(()=>{
        // refetch for updates on popup.content close
        // Only run if app has defined contentPropertyKey
        if (contentPropertyKey && !!validatedProperties?.contentPropertyKey && validatedProperties.contentPropertyKey !== '') {
            setContentPropertyKey(validatedProperties.contentPropertyKey);
            setIsLoading(false); // Update app properties with validated values
            if (validatedProperties.title && validatedProperties.title !== '') setAppTitle((0, $9fBoq.extensionTitle)(app, validatedProperties.title));
            if (validatedProperties.icon && validatedProperties.icon !== '') setAppIcon(validatedProperties.icon);
            if (validatedProperties.tooltip && validatedProperties.tooltip !== '') setAppTooltip(validatedProperties.tooltip);
        } else if (!isOpen && appHasDynamicProperties && (!contentPropertyKey || !(0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true))) fetchDynamicProperties();
    }, [
        isOpen,
        appHasDynamicProperties,
        fetchDynamicProperties,
        validatedProperties?.title,
        validatedProperties?.icon,
        validatedProperties?.tooltip,
        validatedProperties?.contentPropertyKey,
        setAppTitle,
        setAppIcon,
        setAppTooltip,
        setContentPropertyKey,
        contentPropertyKey,
        app
    ]); // Event listener for FORGE_CONTENT_PROPERTY_UPDATED events
    (0, $cozmU.useEffect)(()=>{
        const handleContentPropertyUpdate = async (event)=>{
            const customEvent = event;
            if (customEvent.detail?.payload?.propertyKey !== app.properties.contentPropertyKey) return;
             // Refetch content properties to get the latest data and ensure proper validation
            // This is important when multiple apps use the same contentPropertyKey
            if (refetchContentProperties) try {
                await refetchContentProperties();
            } catch (error) {
                // eslint-disable-next-line no-console
                console.warn('Failed to refetch content properties on event update:', error);
            }
             // Validate the event data using the specific event validation method
            const validatedData = validateEventDataCallback(customEvent.detail?.payload); // Update app properties with validated values
            if (validatedData.title && validatedData.title !== '') {
                if ((0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) setAppTitle((currentTitle)=>validatedData.title === currentTitle ? validatedData.title : (0, $9fBoq.extensionTitle)(app, validatedData.title));
                else setAppTitle((0, $9fBoq.extensionTitle)(app, validatedData.title));
            }
            if (validatedData.icon && validatedData.icon !== '') setAppIcon(validatedData.icon);
            if (validatedData.tooltip && validatedData.tooltip !== '') setAppTooltip(validatedData.tooltip);
        }; // Only process if this event is for our content property key
        if (!contentPropertyKey || contentPropertyKey === '') return ()=>{}; // Return empty cleanup function to maintain React lifecycle consistency
        document.addEventListener('forge.bridge.FORGE_CONTENT_PROPERTY_UPDATED', handleContentPropertyUpdate); // Cleanup function to remove event listener
        return ()=>{
            document.removeEventListener('forge.bridge.FORGE_CONTENT_PROPERTY_UPDATED', handleContentPropertyUpdate);
        };
    }, [
        validateEventDataCallback,
        contentPropertyKey,
        setAppTitle,
        setAppIcon,
        setAppTooltip,
        app,
        refetchContentProperties
    ]);
    const appImageAlt = formatMessage($1cb9b1bda2de2c04$var$i18n.appIcon);
    const handleAppImageError = (event)=>{
        event.currentTarget.src = (0, (/*@__PURE__*/$parcel$interopDefault($46f2a733fab59ac5$exports)));
    };
    const ForgeAppButton = hasAuthoritativeBylineAppSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        testId: "byline-forge-app-button",
        xcss: $1cb9b1bda2de2c04$var$sharedForgeAppButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5xte.BylineAppTriggerVisual), {
        isInteractive: true,
        showDot: !(isHidden || hideDot)
    }, appIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: appImageAlt,
        "data-testid": "byline-forge-app-image",
        height: 14,
        onError: handleAppImageError,
        src: appIcon,
        width: 14
    }) : null, appTitle)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.default), {
        testId: "byline-forge-app-button",
        xcss: [
            $1cb9b1bda2de2c04$var$forgeAppButtonStyles,
            !(isHidden || hideDot) && $1cb9b1bda2de2c04$var$forgeAppButtonDotStyles
        ]
    }, appIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$Image, {
        alt: appImageAlt,
        "data-testid": "byline-forge-app-image",
        onError: handleAppImageError,
        src: appIcon
    }) : null, appTitle);
    const bylineForgeAppHeaderWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppHeaderWrapper, {
        ref: defineTriggerRef && reference ? defineTriggerRef(reference) : null,
        onClick: toggleClose,
        isHidden: isHidden,
        "data-testid": "forge-byline-header-wrapper"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "small",
        testId: "byline-forge-app-trigger-loading-spinner"
    }) : ForgeAppButton);
    return app.properties?.keyboardShortcut?.accelerator ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcutVisualizer), {
        module: app,
        tooltip: appTooltip ?? ''
    }, bylineForgeAppHeaderWrapper) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        tag: "span",
        content: appTooltip
    }, bylineForgeAppHeaderWrapper);
};
const $1cb9b1bda2de2c04$export$d2159b9f3f077903 = (t0)=>{
    const $ = (0, $bDgLe.c)(85);
    const { app: app, contentId: contentId, isHidden: t1, setShowAll: t2, hideDot: t3, hasAuthoritativeBylineAppSnapshot: t4, authoritativePresentation: authoritativePresentation, contentPropertyKeys: contentPropertyKeys } = t0;
    const isHidden = t1 === undefined ? false : t1;
    const setShowAll = t2 === undefined ? $1cb9b1bda2de2c04$var$_temp : t2;
    const hideDot = t3 === undefined ? false : t3;
    const hasAuthoritativeBylineAppSnapshot = t4 === undefined ? false : t4;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { activationId: activationId } = (0, $bQm3c.useSessionData)();
    const isLivePage = (0, $3jwuS.useIsCurrentPageLive)();
    const isOnEditRoute = (0, $de2j9.useIsEditorPage)();
    const isEditing = isLivePage || isOnEditRoute;
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    const [popupRef, setPopupRef] = (0, $cozmU.useState)(null);
    const [triggerRef, setTriggerRef] = (0, $cozmU.useState)(null);
    let t5;
    if ($[0] !== app || $[1] !== authoritativePresentation) {
        t5 = ()=>app.properties.contentPropertyKey && authoritativePresentation && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true) ? authoritativePresentation.label : (0, $9fBoq.extensionTitle)(app);
        $[0] = app;
        $[1] = authoritativePresentation;
        $[2] = t5;
    } else t5 = $[2];
    const [appTitle, setAppTitle] = (0, $cozmU.useState)(t5);
    const [t6] = (0, $ep3mz.usePageState)();
    const { routeName: routeName, spaceKey: spaceAlias } = t6;
    const { spaceId: spaceId, spaceKey: spaceKey } = (0, $6uUjl.useSpaceIdentifiers)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t7;
    if ($[3] !== routeName) {
        t7 = (0, $hIaUw.getContentType)(routeName);
        $[3] = routeName;
        $[4] = t7;
    } else t7 = $[4];
    const t8 = isLivePage ? "live" : null;
    let t9;
    if ($[5] !== contentId || $[6] !== t7 || $[7] !== t8) {
        t9 = {
            id: contentId,
            type: t7,
            subtype: t8
        };
        $[5] = contentId;
        $[6] = t7;
        $[7] = t8;
        $[8] = t9;
    } else t9 = $[8];
    const t10 = spaceKey || spaceAlias;
    let t11;
    if ($[9] !== spaceId || $[10] !== t10) {
        t11 = {
            id: spaceId,
            key: t10
        };
        $[9] = spaceId;
        $[10] = t10;
        $[11] = t11;
    } else t11 = $[11];
    let t12;
    if ($[12] !== t11 || $[13] !== t9) {
        t12 = {
            type: (0, $7Ndnw.FORGE_MODULE_BYLINE),
            content: t9,
            space: t11
        };
        $[12] = t11;
        $[13] = t9;
        $[14] = t12;
    } else t12 = $[14];
    const extensionData = (0, $83fWZ.useMemoizedObj)(t12);
    let t13;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = (node)=>{
            setPopupRef(node);
        };
        $[15] = t13;
    } else t13 = $[15];
    const defineContentRef = t13;
    let t14;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = (ref)=>(node_0)=>{
                setTriggerRef(node_0);
                ref(node_0);
            };
        $[16] = t14;
    } else t14 = $[16];
    const defineTriggerRef = t14;
    let t15;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = ()=>{
            setIsOpen(false);
        };
        $[17] = t15;
    } else t15 = $[17];
    const onClose = t15;
    let t16;
    if ($[18] !== contentId || $[19] !== experienceTracker || $[20] !== isOpen) {
        t16 = ()=>{
            !isOpen && experienceTracker.start({
                name: $1cb9b1bda2de2c04$var$EXPERIENCE_NAME,
                id: contentId,
                timeout: 10000
            });
            setIsOpen(!isOpen);
        };
        $[18] = contentId;
        $[19] = experienceTracker;
        $[20] = isOpen;
        $[21] = t16;
    } else t16 = $[21];
    const toggleClose = t16;
    let t17;
    if ($[22] !== activationId || $[23] !== app || $[24] !== contentId || $[25] !== createAnalyticsEvent || $[26] !== experienceTracker || $[27] !== routeName || $[28] !== spaceAlias || $[29] !== spaceId) {
        t17 = ()=>{
            experienceTracker.succeed({
                name: $1cb9b1bda2de2c04$var$EXPERIENCE_NAME
            });
            const appId = (0, $8a9Dm.getAppId)(app);
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "invoked",
                    actionSubject: "forgeExtension",
                    actionSubjectId: appId,
                    containerType: "space",
                    containerId: spaceId,
                    objectType: (0, $hIaUw.getContentType)(routeName),
                    objectId: contentId,
                    source: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                    attributes: {
                        activationId: activationId,
                        appId: appId,
                        moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE),
                        moduleKey: (0, $8a9Dm.getModuleKey)(app),
                        spaceType: (0, $6UqI3.getSpaceType)(spaceAlias),
                        spaceId: spaceId
                    }
                }
            }).fire();
        };
        $[22] = activationId;
        $[23] = app;
        $[24] = contentId;
        $[25] = createAnalyticsEvent;
        $[26] = experienceTracker;
        $[27] = routeName;
        $[28] = spaceAlias;
        $[29] = spaceId;
        $[30] = t17;
    } else t17 = $[30];
    const onInitialRender = t17;
    let t18;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = {
            close: onClose
        };
        $[31] = t18;
    } else t18 = $[31];
    const bridge = t18;
    let t19;
    if ($[32] !== popupRef || $[33] !== triggerRef) {
        t19 = {
            onClose: onClose,
            popupRef: popupRef,
            triggerRef: triggerRef
        };
        $[32] = popupRef;
        $[33] = triggerRef;
        $[34] = t19;
    } else t19 = $[34];
    (0, $lOI2p.useInlineDialogCloseManager)(t19);
    if (!spaceKey) return null;
    let InvisibleDiv;
    if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
        InvisibleDiv = /*#__PURE__*/ (0, $cozmU.forwardRef)($1cb9b1bda2de2c04$var$_temp2);
        $[35] = InvisibleDiv;
    } else InvisibleDiv = $[35];
    if (app.properties.viewportContainer === "modal") {
        let t20;
        if ($[36] !== app || $[37] !== appTitle || $[38] !== authoritativePresentation || $[39] !== contentPropertyKeys || $[40] !== extensionData || $[41] !== hasAuthoritativeBylineAppSnapshot || $[42] !== hideDot || $[43] !== isHidden || $[44] !== isOpen || $[45] !== toggleClose) {
            t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppTrigger, {
                app: app,
                appTitle: appTitle,
                setAppTitle: setAppTitle,
                isOpen: isOpen,
                toggleClose: toggleClose,
                extensionData: extensionData,
                isHidden: isHidden,
                hideDot: hideDot,
                hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot,
                authoritativePresentation: authoritativePresentation,
                contentPropertyKeys: contentPropertyKeys
            });
            $[36] = app;
            $[37] = appTitle;
            $[38] = authoritativePresentation;
            $[39] = contentPropertyKeys;
            $[40] = extensionData;
            $[41] = hasAuthoritativeBylineAppSnapshot;
            $[42] = hideDot;
            $[43] = isHidden;
            $[44] = isOpen;
            $[45] = toggleClose;
            $[46] = t20;
        } else t20 = $[46];
        let t21;
        if ($[47] !== InvisibleDiv || $[48] !== app || $[49] !== extensionData || $[50] !== isOpen || $[51] !== onInitialRender) {
            t21 = isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(InvisibleDiv, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ByLineForgeApp), {
                app: app,
                extensionData: extensionData,
                onInitialRender: onInitialRender,
                onTearDown: onClose,
                bridge: bridge
            })) : null;
            $[47] = InvisibleDiv;
            $[48] = app;
            $[49] = extensionData;
            $[50] = isOpen;
            $[51] = onInitialRender;
            $[52] = t21;
        } else t21 = $[52];
        let t22;
        if ($[53] !== t20 || $[54] !== t21) {
            t22 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t20, t21);
            $[53] = t20;
            $[54] = t21;
            $[55] = t22;
        } else t22 = $[55];
        return t22;
    }
    const t20 = !isEditing;
    let t21;
    if ($[56] !== app || $[57] !== extensionData || $[58] !== onInitialRender || $[59] !== popupRef) {
        t21 = (t22)=>{
            const { update: scheduleUpdate } = t22;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ContentWrapper, {
                ref: defineContentRef,
                "data-testid": "forge-popup-content-wrapper"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jYZsR.ResizeChangeListener), {
                onUpdate: scheduleUpdate,
                popupRef: popupRef
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7QUD1.ByLineForgeApp), {
                app: app,
                extensionData: extensionData,
                onInitialRender: onInitialRender,
                onTearDown: onClose,
                bridge: bridge
            })));
        };
        $[56] = app;
        $[57] = extensionData;
        $[58] = onInitialRender;
        $[59] = popupRef;
        $[60] = t21;
    } else t21 = $[60];
    let t22;
    if ($[61] !== app || $[62] !== appTitle || $[63] !== authoritativePresentation || $[64] !== contentPropertyKeys || $[65] !== extensionData || $[66] !== hasAuthoritativeBylineAppSnapshot || $[67] !== hideDot || $[68] !== isHidden || $[69] !== isOpen || $[70] !== toggleClose) {
        t22 = (t23)=>{
            const { ref: ref_0 } = t23;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1cb9b1bda2de2c04$var$ByLineForgeAppTrigger, {
                app: app,
                appTitle: appTitle,
                setAppTitle: setAppTitle,
                reference: ref_0,
                isOpen: isOpen,
                defineTriggerRef: defineTriggerRef,
                toggleClose: toggleClose,
                extensionData: extensionData,
                isHidden: isHidden,
                hideDot: hideDot,
                hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot,
                authoritativePresentation: authoritativePresentation,
                contentPropertyKeys: contentPropertyKeys
            });
        };
        $[61] = app;
        $[62] = appTitle;
        $[63] = authoritativePresentation;
        $[64] = contentPropertyKeys;
        $[65] = extensionData;
        $[66] = hasAuthoritativeBylineAppSnapshot;
        $[67] = hideDot;
        $[68] = isHidden;
        $[69] = isOpen;
        $[70] = toggleClose;
        $[71] = t22;
    } else t22 = $[71];
    let t23;
    if ($[72] !== appTitle || $[73] !== isOpen || $[74] !== t20 || $[75] !== t21 || $[76] !== t22) {
        t23 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
            shouldRenderToParent: t20,
            testId: "forge-action-popup",
            role: "dialog",
            content: t21,
            label: appTitle,
            isOpen: isOpen,
            placement: "bottom-start",
            trigger: t22
        });
        $[72] = appTitle;
        $[73] = isOpen;
        $[74] = t20;
        $[75] = t21;
        $[76] = t22;
        $[77] = t23;
    } else t23 = $[77];
    let t24;
    if ($[78] !== app || $[79] !== isEditing || $[80] !== setShowAll) {
        t24 = !isEditing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4vC63.ForgeKeyboardShortcut), {
            module: app,
            action: ()=>{
                setShowAll(true);
                setIsOpen(true);
            }
        });
        $[78] = app;
        $[79] = isEditing;
        $[80] = setShowAll;
        $[81] = t24;
    } else t24 = $[81];
    let t25;
    if ($[82] !== t23 || $[83] !== t24) {
        t25 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, t23, t24);
        $[82] = t23;
        $[83] = t24;
        $[84] = t25;
    } else t25 = $[84];
    return t25;
};
function $1cb9b1bda2de2c04$var$_temp() {}
function $1cb9b1bda2de2c04$var$_temp2(t0, __cmplr) {
    const { as: t1, style: __cmpls, ...__cmplp } = t0;
    const C = t1 === undefined ? "div" : t1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_3iDTPbYbGa",
            __cmplp.className
        ])
    });
}















var $5SGpQ = parcelRequire("5SGpQ");


var $jmUhx = parcelRequire("jmUhx");

const $8a60fc49afcf0f5b$var$i18n = (0, $kSwu1.defineMessages)({
    showMore: {
        id: "content-header.by-line.apps-show-more",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "content-header.by-line.apps.show-less",
        defaultMessage: "Show less"
    }
});
const $8a60fc49afcf0f5b$export$94132a0e348806d4 = null; // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $8a60fc49afcf0f5b$var$ShowMoreLess = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbvbI6 _1UtDYzZpcK _0wOv4Q7zJH _3UcnShqogv _1Yjlt598eZ _2AckfdYbGa _42hYr56wH8 _3Ku51IbQDk _0OU75rvbI6 _1eQ8NNZpcK",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-disable @atlaskit/ui-styling-standard/no-important-styles */ 
const $8a60fc49afcf0f5b$var$StyledButton = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $5SGpQ.default) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4vhRtvue9s _2yzFFQSqN7",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /* eslint-enable @atlaskit/ui-styling-standard/no-important-styles */ 
const $8a60fc49afcf0f5b$export$e5bc424bebb08325 = (t0)=>{
    const $ = (0, $bDgLe.c)(11);
    const { showMore: t1, showButtonDesign: t2, setShowAll: setShowAll } = t0;
    const showMore = t1 === undefined ? false : t1;
    const showButtonDesign = t2 === undefined ? false : t2;
    const intl = (0, $kSwu1.useIntl)();
    const textKey = showMore ? $8a60fc49afcf0f5b$var$i18n.showMore : $8a60fc49afcf0f5b$var$i18n.showLess;
    const testIdText = showMore ? "more" : "less";
    let t3;
    if ($[0] !== setShowAll || $[1] !== showMore) {
        t3 = (event)=>{
            if (event.key === "Enter") {
                setShowAll(showMore);
                setTimeout($8a60fc49afcf0f5b$var$_temp, 0);
            }
        };
        $[0] = setShowAll;
        $[1] = showMore;
        $[2] = t3;
    } else t3 = $[2];
    const handleKeyDown = t3;
    let t4;
    if ($[3] !== handleKeyDown || $[4] !== intl || $[5] !== setShowAll || $[6] !== showButtonDesign || $[7] !== showMore || $[8] !== testIdText || $[9] !== textKey) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, showButtonDesign ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a60fc49afcf0f5b$var$StyledButton, {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
                label: ""
            }),
            appearance: "subtle",
            testId: `live-pages-byline-show-${testIdText}`,
            onClick: ()=>setShowAll(showMore)
        }, intl.formatMessage(textKey)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($8a60fc49afcf0f5b$var$ShowMoreLess, {
            role: "button",
            onClick: ()=>setShowAll(showMore),
            "data-testid": `byline-show-${testIdText}`,
            tabIndex: 0,
            onKeyDown: handleKeyDown,
            id: "byline-apps-show-more-less-toggle"
        }, intl.formatMessage(textKey)));
        $[3] = handleKeyDown;
        $[4] = intl;
        $[5] = setShowAll;
        $[6] = showButtonDesign;
        $[7] = showMore;
        $[8] = testIdText;
        $[9] = textKey;
        $[10] = t4;
    } else t4 = $[10];
    return t4;
};
function $8a60fc49afcf0f5b$var$_temp() {
    document.getElementById("byline-apps-show-more-less-toggle")?.focus();
}


const $cd6af931b4e9ea04$var$NUMBER_OF_VISIBLE_APPS = 3;
const $cd6af931b4e9ea04$var$LIVE_PAGES_NUMBER_OF_VISIBLE_APPS = 4; // eslint-disable-next-line @compiled/no-exported-css, @compiled/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $cd6af931b4e9ea04$export$94132a0e348806d4 = null; // eslint-disable-next-line @compiled/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/design-system/no-styled-tagged-template-expression -- Ignored via go/DSP-18766
const $cd6af931b4e9ea04$var$StyledWebItemList = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? (0, $asQED.WebItemList) : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _2XghbEn1Zi _2qu77JdnbC _1vTVu6dnbC _1NtoLtdnbC _0HXiU0dnbC _27y5OMdnbC _2Cd6PSdnbC _1jHGkcdnbC _2oVaLednbC _0dSRFrvbI6 _29szWcvbI6 _2IjzHGZpcK _13g1dfZpcK _20I9K8qogv _2nx5EY98eZ _1JfYJOYbGa _1blFbC6wH8 _45DIsCbQDk _3Za31wvbI6 _1SZqtMZpcK _2tv9TP98eZ _0WrLWkYbGa _46xcRf6wH8 _2HYQVbKGUX _27sYQ7YXK7 _1UihsyKGUX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, name: name, isEmpty: isEmpty } = t0;
    if (isEmpty) return children;
    let t1;
    if ($[0] !== children || $[1] !== name) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ah4BL.UFOThirdPartySegment), {
            name: name
        }, children);
        $[0] = children;
        $[1] = name;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $cd6af931b4e9ea04$export$127ace2288e0ed63 = ({ contentId: contentId, connectItems: connectItems, forgeItems: forgeItems, onLoad: onLoad, showLivePagesExtensionPoints: showLivePagesExtensionPoints, showLoader: showLoader, isSingleLineByline: isSingleLineByline = false, hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot = false, authoritativeForgeAppIds: authoritativeForgeAppIds = [], authoritativeForgeAppPresentations: authoritativeForgeAppPresentations = [] })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const contentPropertyKeys = (0, $cozmU.useMemo)(()=>(0, $euq7N.getBylineAppContentPropertyKeys)(forgeItems), [
        forgeItems
    ]);
    const numberOfVisibleApps = showLivePagesExtensionPoints ? $cd6af931b4e9ea04$var$LIVE_PAGES_NUMBER_OF_VISIBLE_APPS : $cd6af931b4e9ea04$var$NUMBER_OF_VISIBLE_APPS;
    const [isShowAll, setShowAll] = (0, $cozmU.useState)((0, $17wUi.confluenceLocalStorageInstance).getItemAsBoolean((0, $1UApO.keys).BYLINE_APPS_SHOW_ALL));
    (0, $cozmU.useEffect)(()=>{
        (0, $17wUi.confluenceLocalStorageInstance).setItem((0, $1UApO.keys).BYLINE_APPS_SHOW_ALL, isShowAll);
    }, [
        isShowAll
    ]);
    (0, $cozmU.useEffect)(()=>{
        onLoad();
    }, [
        onLoad
    ]);
    (0, $cozmU.useEffect)(()=>{
        createAnalyticsEvent({
            type: 'sendTrackEvent',
            data: {
                action: 'rendered',
                actionSubject: 'bylineApps',
                source: 'ByLineAppsComponent',
                attributes: {
                    numberOfApps: connectItems?.length + forgeItems?.length
                }
            }
        }).fire();
    }, [
        createAnalyticsEvent,
        connectItems?.length,
        forgeItems?.length
    ]);
    if (showLoader) // Doing this to prevent flash during live pages SSR hydration step.
    // At this point, the data has been loaded but showLoader is still true since the onLoad is asynchronously setting the showLoader
    // state to false. It will briefly render both the placeholder and the actual content at the same time.
    // Returning null here ensures we only show actual content when the loader is not showing and prevents the flash.
    return null;
    connectItems = connectItems || [];
    forgeItems = forgeItems || [];
    const renderPart = (cApps, fApps, numberOfForgeAppsToShow)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, cApps.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper, {
            name: "byline-apps-connect-items",
            isEmpty: cApps.length === 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd6af931b4e9ea04$var$StyledWebItemList, {
            pageId: contentId,
            webItems: cApps,
            ContainerTagName: "span",
            webItemClassName: "bylineWebItem",
            hideDot: showLivePagesExtensionPoints || isSingleLineByline,
            noContainer: isSingleLineByline,
            useBadgeStyles: true,
            hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot,
            isLegacyConnectApp: (0, $9wGTI.fg)('customer-messaging-iframe-banner-enabled')
        })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($cd6af931b4e9ea04$var$UFOByLineAppsComponentWrapper, {
            name: "byline-apps-forge-items",
            isEmpty: fApps.length === 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, fApps.map((app, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1cb9b1bda2de2c04$export$d2159b9f3f077903), {
                key: app.id,
                app: app,
                contentId: contentId,
                isHidden: isShowAll ? false : idx >= numberOfForgeAppsToShow,
                setShowAll: setShowAll,
                hideDot: showLivePagesExtensionPoints || isSingleLineByline,
                hasAuthoritativeBylineAppSnapshot: hasAuthoritativeBylineAppSnapshot && ((0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? authoritativeForgeAppIds.includes(app.id) : true),
                contentPropertyKeys: contentPropertyKeys,
                authoritativePresentation: authoritativeForgeAppPresentations.find(({ id: id })=>id === app.id)?.presentation
            }))))); // single line byline renders all apps initially, hiding them in overflow until user clicks show more button
    // when user clicks show more, they are shown and wrapped to next line
    if (isSingleLineByline) return renderPart(connectItems, forgeItems, connectItems.length + forgeItems.length);
    if (connectItems.length + forgeItems.length <= numberOfVisibleApps) return renderPart(connectItems, forgeItems, forgeItems.length);
    else {
        // We should show the first numberOfVisibleApps apps including Connect and Forge app;
        // however, all Forge apps need to be RENDERED in order for the Forge Keyboard Shortcut listener
        // to be rendered and active. If (Connect app + Forge apps) is greater than numberOfVisibleApps,
        // then we will show the first numberOfVisibleApps Connect and Forge apps, render all the
        // Forge apps, but visually hide the Forge apps that go beyond numberOfVisibleApps.
        const numberOfConnectAppsToRender = Math.min(connectItems.length, numberOfVisibleApps);
        const numberOfForgeAppsToShow_0 = numberOfVisibleApps - numberOfConnectAppsToRender;
        const firstConnectApps = connectItems.slice(0, numberOfConnectAppsToRender);
        const remainingConnectApps = connectItems.slice(numberOfConnectAppsToRender);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderPart(firstConnectApps, forgeItems, numberOfForgeAppsToShow_0), isShowAll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, renderPart(remainingConnectApps, [], 0), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a60fc49afcf0f5b$export$e5bc424bebb08325), {
            showMore: false,
            showButtonDesign: !!showLivePagesExtensionPoints,
            setShowAll: setShowAll
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8a60fc49afcf0f5b$export$e5bc424bebb08325), {
            showMore: true,
            showButtonDesign: !!showLivePagesExtensionPoints,
            setShowAll: setShowAll
        }));
    }
};



var $3aDMt = parcelRequire("3aDMt");

const $dc19d0558ac0af95$var$ByLineAppRuntimeHandoff = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c _2Sx1tOYbGa",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $dc19d0558ac0af95$var$ByLineAppRuntime = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $dc19d0558ac0af95$var$ByLineAppSnapshotFallback = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbcK7c",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $dc19d0558ac0af95$export$da423a9f3d95b9b8 = (t0)=>{
    const $ = (0, $bDgLe.c)(26);
    const { contentId: contentId, connectItems: connectItems, forgeItems: forgeItems, forgeError: forgeError, isSingleLineByline: isSingleLineByline, onBylineAppsLoaded: onBylineAppsLoaded, showLivePagesExtensionPoints: showLivePagesExtensionPoints, loadingConnectItems: t1, loadingForgeItems: t2, authoritativeSnapshot: authoritativeSnapshot } = t0;
    const loadingConnectItems = t1 === undefined ? false : t1;
    const loadingForgeItems = t2 === undefined ? false : t2;
    const isLoading = loadingConnectItems || loadingForgeItems;
    let t3;
    if ($[0] !== onBylineAppsLoaded) {
        t3 = ()=>{
            onBylineAppsLoaded?.();
        };
        $[0] = onBylineAppsLoaded;
        $[1] = t3;
    } else t3 = $[1];
    const handleLoad = t3;
    const shouldRenderBylineApps = !isLoading;
    let t4;
    if ($[2] !== authoritativeSnapshot?.apps) {
        t4 = authoritativeSnapshot?.apps ?? [];
        $[2] = authoritativeSnapshot?.apps;
        $[3] = t4;
    } else t4 = $[3];
    let t5;
    if ($[4] !== t4) {
        t5 = t4.filter($dc19d0558ac0af95$var$_temp);
        $[4] = t4;
        $[5] = t5;
    } else t5 = $[5];
    const authoritativeForgeAppPresentations = t5;
    let t6;
    if ($[6] !== authoritativeForgeAppPresentations) {
        t6 = authoritativeForgeAppPresentations.map($dc19d0558ac0af95$var$_temp2);
        $[6] = authoritativeForgeAppPresentations;
        $[7] = t6;
    } else t6 = $[7];
    const authoritativeForgeAppIds = t6;
    let t7;
    if ($[8] !== authoritativeForgeAppIds || $[9] !== authoritativeForgeAppPresentations || $[10] !== authoritativeSnapshot || $[11] !== connectItems || $[12] !== contentId || $[13] !== forgeError || $[14] !== forgeItems || $[15] !== handleLoad || $[16] !== isSingleLineByline || $[17] !== showLivePagesExtensionPoints) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $80koo.RequireLegacyWRM), {
            key: "byline-app-wrm",
            wrm: "wr!com.atlassian.plugins.atlassian-connect-plugin:confluence-atlassian-connect-content-byline-resources-v5"
        }, ()=>{
            if (forgeError && (!authoritativeSnapshot || !(0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true))) {
                if (!(0, $7Sm4c.isErrorMarkedAsHandled)(forgeError)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                    error: forgeError
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                    name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
                });
            }
            const unhandledForgeError = forgeError && !(0, $7Sm4c.isErrorMarkedAsHandled)(forgeError) ? forgeError : undefined;
            const apps = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, unhandledForgeError ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: unhandledForgeError
            }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cd6af931b4e9ea04$export$127ace2288e0ed63), {
                key: contentId,
                contentId: contentId,
                forgeItems: forgeError ? [] : forgeItems,
                connectItems: connectItems,
                showLivePagesExtensionPoints: showLivePagesExtensionPoints,
                onLoad: handleLoad,
                isSingleLineByline: isSingleLineByline,
                hasAuthoritativeBylineAppSnapshot: Boolean(authoritativeSnapshot),
                authoritativeForgeAppIds: authoritativeForgeAppIds,
                authoritativeForgeAppPresentations: authoritativeForgeAppPresentations
            }), unhandledForgeError ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1eaCJ.ExperienceSuccess), {
                name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
            }));
            return authoritativeSnapshot && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc19d0558ac0af95$var$ByLineAppRuntime, {
                "data-byline-app-runtime": true
            }, apps) : apps;
        });
        $[8] = authoritativeForgeAppIds;
        $[9] = authoritativeForgeAppPresentations;
        $[10] = authoritativeSnapshot;
        $[11] = connectItems;
        $[12] = contentId;
        $[13] = forgeError;
        $[14] = forgeItems;
        $[15] = handleLoad;
        $[16] = isSingleLineByline;
        $[17] = showLivePagesExtensionPoints;
        $[18] = t7;
    } else t7 = $[18];
    const runtimeApps = t7;
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.EXTENSION_POINT_BYLINE_EXPERIENCE)
        });
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== authoritativeSnapshot || $[21] !== runtimeApps || $[22] !== shouldRenderBylineApps) {
        t9 = shouldRenderBylineApps && (authoritativeSnapshot && (0, $6mKj3.expValEquals)("confluence_ssr_byline", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc19d0558ac0af95$var$ByLineAppRuntimeHandoff, null, runtimeApps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($dc19d0558ac0af95$var$ByLineAppSnapshotFallback, {
            "data-byline-app-snapshot": true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aDMt.AuthoritativeByLineApps), {
            snapshot: authoritativeSnapshot
        }))) : runtimeApps);
        $[20] = authoritativeSnapshot;
        $[21] = runtimeApps;
        $[22] = shouldRenderBylineApps;
        $[23] = t9;
    } else t9 = $[23];
    let t10;
    if ($[24] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t8, t9);
        $[24] = t9;
        $[25] = t10;
    } else t10 = $[25];
    return t10;
};

const $dc19d0558ac0af95$export$573ad1d5e82d9d7e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "9W4UB",
    name: "LazyLivePagesByLineApps",
    loader: async ()=>{
        return (await Promise.resolve(module.exports)).LivePagesByLineApps;
    },
    loading: (props)=>props.authoritativeSnapshot && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aDMt.AuthoritativeByLineApps), {
            snapshot: props.authoritativeSnapshot
        }) : null
});
function $dc19d0558ac0af95$var$_temp(app) {
    return app.producer === "forge" && app.presentation.resolution === "resolved";
}
function $dc19d0558ac0af95$var$_temp2(t0) {
    const { id: id } = t0;
    return id;
}
module.exports["LivePagesByLineApps"] = $dc19d0558ac0af95$export$da423a9f3d95b9b8;
module.exports["LazyLivePagesByLineApps"] = $dc19d0558ac0af95$export$573ad1d5e82d9d7e;

});

parcelRegister("83fWZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3u5lg = parcelRequire("3u5lg");

const $7a82ae306aa8d2fb$export$656295fdbe704c1d = (obj)=>{
    const ref = (0, $cozmU.useRef)(obj);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(ref.current, obj)) ref.current = obj;
    return ref.current;
};
const $7a82ae306aa8d2fb$export$3b131fc84567c0ad = (data)=>{
    if (!data) return false;
    if ('singleContent' in data) return false;
    if ('content' in data) {
        const properties = data?.content?.nodes?.[0]?.properties?.nodes || [];
        const editorVersion = properties.find((p)=>p?.key === 'editor');
        return editorVersion?.value?.includes('v2') || false;
    }
    return false;
};
const $7a82ae306aa8d2fb$export$44be1e207a638653 = (graphqlUser)=>({
        isAnonymous: !graphqlUser?.accountId,
        userId: graphqlUser?.accountId ?? undefined,
        fullName: graphqlUser?.displayName,
        avatarUrl: graphqlUser?.profilePicture?.path
    });
module.exports["useMemoizedObj"] = $7a82ae306aa8d2fb$export$656295fdbe704c1d;
module.exports["isFabricEditor"] = $7a82ae306aa8d2fb$export$3b131fc84567c0ad;
module.exports["toUserProps"] = $7a82ae306aa8d2fb$export$44be1e207a638653;

});

parcelRegister("5YSiR", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");


const $5cc6a47526452ac3$export$a07022482001031b = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "R7O8o",
    name: "LazyAIPlannerSyncByline",
    loader: async ()=>(await (parcelRequire("hU4YT"))).AIPlannerSyncByline,
    loading: ()=>null
});
module.exports["LazyAIPlannerSyncByline"] = $5cc6a47526452ac3$export$a07022482001031b;

});

parcelRegister("hU4YT", function(module, exports) {

let $d08b87ce6288381e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d08b87ce6288381e$var$load("ca0UP"),
    $d08b87ce6288381e$var$load("a92TB"),
    $d08b87ce6288381e$var$load("i1I18"),
    $d08b87ce6288381e$var$load("3w65n")
]).then(()=>parcelRequire('9gzhk'));

});

parcelRegister("3TrzI", function(module, exports) {
const $b443a1044784ca20$export$847f5bb75f781390 = 'AI_PLANNER';
const $b443a1044784ca20$export$593a849e6e9b7c73 = 'artifact.resolveByConfluenceContentAri';
module.exports["AI_PLANNER_GENERATED_BY"] = $b443a1044784ca20$export$847f5bb75f781390;
module.exports["AI_PLANNER_SYNC_BYLINE_RESOLVER_PROCEDURE"] = $b443a1044784ca20$export$593a849e6e9b7c73;

});

parcelRegister("cI2rq", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $eqEJl = parcelRequire("eqEJl");


var $6mKj3 = parcelRequire("6mKj3");


var $euq7N = parcelRequire("euq7N");


var $7sf7C = parcelRequire("7sf7C");

const $f5477882acb5003c$export$1ea55ec97ca20a67 = (contentId, t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const enabled = t0 === undefined ? true : t0;
    const relayContext = (0, $cozmU.useContext)((0, $6SsN4.ReactRelayContext));
    if (!enabled || !contentId || !relayContext || !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)("confluence_ssr_byline", "isEnabled", true)) return;
    let t1;
    let t2;
    if ($[0] !== contentId || $[1] !== relayContext) {
        t2 = Symbol.for("react.early_return_sentinel");
        bb0: {
            const keys = (0, $euq7N.getBylineAppContentPropertyKeys)();
            if (keys.length === 0) {
                t2 = undefined;
                break bb0;
            }
            const operation = (0, $eqEJl.createOperationDescriptor)((0, $eqEJl.getRequest)((0, $7sf7C.default)), {
                contentId: contentId,
                keys: keys
            });
            t1 = relayContext.environment.lookup(operation.fragment);
        }
        $[0] = contentId;
        $[1] = relayContext;
        $[2] = t1;
        $[3] = t2;
    } else {
        t1 = $[2];
        t2 = $[3];
    }
    if (t2 !== Symbol.for("react.early_return_sentinel")) return t2;
    const snapshot = t1;
    const data = snapshot.data;
    return snapshot.isMissingData ? undefined : data?.content?.nodes?.[0]?.properties ?? undefined;
};
module.exports["useBylineAppContentProperties"] = $f5477882acb5003c$export$1ea55ec97ca20a67;

});

parcelRegister("dGhsu", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<662cb69c38d7d9eb20e64b514bde7e8f>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $95f197b43e539c4a$var$node = function() {
    var v0 = {
        "kind": "Variable",
        "name": "useNewContentTopper",
        "variableName": "useNewContentTopper"
    };
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeConnectionAncestors"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useNewContentTopper"
            }
        ],
        "kind": "Fragment",
        "name": "ContentTitleWithByLine_content",
        "selections": [
            {
                "args": [
                    v0 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "ContentTitle_content"
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "includeConnectionAncestors",
                        "variableName": "includeConnectionAncestors"
                    },
                    v0 /*: any*/ 
                ],
                "kind": "FragmentSpread",
                "name": "ByLine_content"
            },
            {
                "kind": "FragmentSpread",
                "name": "ArchivedPageBannerV2Status_content"
            },
            {
                "kind": "FragmentSpread",
                "name": "MeetingNotesAutomationDiscoveryFragment_content"
            }
        ],
        "type": "Content"
    };
}();
$95f197b43e539c4a$var$node.hash = "91555ecdfbb0de4b8c123665e7056de8";
var $95f197b43e539c4a$export$2e2bcd8739ae039 = $95f197b43e539c4a$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");




var $9XdgS = parcelRequire("9XdgS");




var $kQRQB = parcelRequire("kQRQB");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $4PPzL = parcelRequire("4PPzL");


var $3IBnw = parcelRequire("3IBnw");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $gjEAi = parcelRequire("gjEAi");


var $kygIi = parcelRequire("kygIi");


var $8zMP3 = parcelRequire("8zMP3");


var $bQm3c = parcelRequire("bQm3c");


var $1xpoY = parcelRequire("1xpoY");


var $35oAA = parcelRequire("35oAA");

const $aaeb66d37f355457$export$a5ae28e9da358c58 = (0, $95f197b43e539c4a$export$2e2bcd8739ae039);
const $aaeb66d37f355457$var$ByLineWithClassificationFragment = (0, $9XdgS.ByLine);
const $aaeb66d37f355457$var$ByLineFromFragmentWithClassificationFragment = (0, $9XdgS.ByLineFromFragment);
const $aaeb66d37f355457$var$BylineCenterStyles = (0, $buxP3.xcss)({
    justifyContent: 'center'
});
const $aaeb66d37f355457$var$ApprovalBannerStyles = (0, $buxP3.xcss)({
    marginBlockEnd: 'space.200'
});
const $aaeb66d37f355457$var$styles = {
    titleAreaBannerWrapper: "_0rIjyk5zaO"
};
const $aaeb66d37f355457$var$TitleAreaBannerWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(2);
    const { children: children } = t0;
    let t1;
    if ($[0] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaeb66d37f355457$var$styles.titleAreaBannerWrapper
        }, children);
        $[0] = children;
        $[1] = t1;
    } else t1 = $[1];
    return t1;
};
const $aaeb66d37f355457$export$6ac99e13b8ebf390 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8zMP3.SuspenseWithDataFetcher), {
            dataFetcherName: "byline-apps"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineInner, props));
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $aaeb66d37f355457$var$ContentTitleWithByLineInner = (t0)=>{
    const $ = (0, $bDgLe.c)(24);
    let analyticsBylineFragmentRef;
    let byLineContributors;
    let bylineClassificationFragmentRef;
    let contentClassificationFragmentRef;
    let contentFragmentRef;
    let props;
    let reactionsContentFragmentRef;
    let titleSpaceFragmentRef;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, byLineContributors: byLineContributors, titleSpaceFragmentRef: titleSpaceFragmentRef, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsBylineFragmentRef;
        $[2] = byLineContributors;
        $[3] = bylineClassificationFragmentRef;
        $[4] = contentClassificationFragmentRef;
        $[5] = contentFragmentRef;
        $[6] = props;
        $[7] = reactionsContentFragmentRef;
        $[8] = titleSpaceFragmentRef;
    } else {
        analyticsBylineFragmentRef = $[1];
        byLineContributors = $[2];
        bylineClassificationFragmentRef = $[3];
        contentClassificationFragmentRef = $[4];
        contentFragmentRef = $[5];
        props = $[6];
        reactionsContentFragmentRef = $[7];
        titleSpaceFragmentRef = $[8];
    }
    if (contentFragmentRef && !(0, $1xpoY.default).isKillSwitchOn("confluence_vp_title_byline_frag_dedup") && (0, $6mKj3.expVal)("confluence_exp_vp_document", "isEnabled", false)) {
        let t1;
        if ($[9] !== analyticsBylineFragmentRef || $[10] !== byLineContributors || $[11] !== bylineClassificationFragmentRef || $[12] !== contentClassificationFragmentRef || $[13] !== contentFragmentRef || $[14] !== props || $[15] !== reactionsContentFragmentRef || $[16] !== titleSpaceFragmentRef) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineFragmentReader, {
                ...props,
                contentFragmentRef: contentFragmentRef,
                byLineContributors: byLineContributors,
                titleSpaceFragmentRef: titleSpaceFragmentRef,
                bylineClassificationFragmentRef: bylineClassificationFragmentRef,
                contentClassificationFragmentRef: contentClassificationFragmentRef,
                reactionsContentFragmentRef: reactionsContentFragmentRef,
                analyticsBylineFragmentRef: analyticsBylineFragmentRef
            });
            $[9] = analyticsBylineFragmentRef;
            $[10] = byLineContributors;
            $[11] = bylineClassificationFragmentRef;
            $[12] = contentClassificationFragmentRef;
            $[13] = contentFragmentRef;
            $[14] = props;
            $[15] = reactionsContentFragmentRef;
            $[16] = titleSpaceFragmentRef;
            $[17] = t1;
        } else t1 = $[17];
        return t1;
    }
    let t1;
    if ($[18] !== analyticsBylineFragmentRef || $[19] !== bylineClassificationFragmentRef || $[20] !== contentClassificationFragmentRef || $[21] !== props || $[22] !== reactionsContentFragmentRef) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ContentTitleWithByLineQuery, {
            ...props,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        });
        $[18] = analyticsBylineFragmentRef;
        $[19] = bylineClassificationFragmentRef;
        $[20] = contentClassificationFragmentRef;
        $[21] = props;
        $[22] = reactionsContentFragmentRef;
        $[23] = t1;
    } else t1 = $[23];
    return t1;
};
const $aaeb66d37f355457$var$ContentTitleWithByLineQuery = (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { contentId: contentId, spaceKey: spaceKey, banner: banner, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, headingContainer: headingContainer, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, meetingNotesAutomationDiscoveryFragmentRef: meetingNotesAutomationDiscoveryFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, hasByLine: t1 } = t0;
    const hasByLine = t1 === undefined ? true : t1;
    const { versionOverride: versionOverride, embeddedContentRender: embeddedContentRender } = (0, $35oAA.useViewPageParams)();
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== contentType || $[1] !== isEmbeddedPage || $[2] !== isRovoLLMEnabled) {
        t2 = isRovoLLMEnabled && contentType === "page" && !isEmbeddedPage && (0, $9wGTI.fg)("cc_automations_discovery_nudges");
        $[0] = contentType;
        $[1] = isEmbeddedPage;
        $[2] = isRovoLLMEnabled;
        $[3] = t2;
    } else t2 = $[3];
    const shouldRenderMeetingNotesAutomationDiscovery = t2;
    let t3;
    if ($[4] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[4] = contentId;
        $[5] = t3;
    } else t3 = $[5];
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t3);
    const isBylineCenterStyles = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const t4 = isBylineCenterStyles && $aaeb66d37f355457$var$BylineCenterStyles;
    let t5;
    if ($[6] !== t4) {
        t5 = [
            t4
        ];
        $[6] = t4;
        $[7] = t5;
    } else t5 = $[7];
    const t6 = isBylineCenterStyles ? "centered-content-title-and-byline" : "content-title-and-byline";
    let t7;
    if ($[8] !== analyticsBylineFragmentRef || $[9] !== bylineClassificationFragmentRef || $[10] !== contentClassificationFragmentRef || $[11] !== contentId || $[12] !== contentSubType || $[13] !== contentType || $[14] !== embeddedContentRender || $[15] !== hasByLine || $[16] !== hasByLineContributors || $[17] !== hasByLineExtensions || $[18] !== meetingNotesAutomationDiscoveryFragmentRef || $[19] !== reactionsContentFragmentRef || $[20] !== shouldRenderMeetingNotesAutomationDiscovery || $[21] !== shouldShowBylineReactions || $[22] !== spaceId || $[23] !== versionOverride) {
        t7 = hasByLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ByLineWithClassificationFragment, {
            contentId: contentId,
            versionOverride: versionOverride,
            embeddedContentRender: embeddedContentRender,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        }), (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaeb66d37f355457$var$ApprovalBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gjEAi.ApprovalBanner), null))), shouldRenderMeetingNotesAutomationDiscovery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kygIi.LazyMeetingNotesAutomationDiscoveryFragment), {
            contentFragmentRef: meetingNotesAutomationDiscoveryFragmentRef,
            postOfficePlacementId: "confluence-view-page-title-area-banner",
            WrapperComponent: $aaeb66d37f355457$var$TitleAreaBannerWrapper
        }));
        $[8] = analyticsBylineFragmentRef;
        $[9] = bylineClassificationFragmentRef;
        $[10] = contentClassificationFragmentRef;
        $[11] = contentId;
        $[12] = contentSubType;
        $[13] = contentType;
        $[14] = embeddedContentRender;
        $[15] = hasByLine;
        $[16] = hasByLineContributors;
        $[17] = hasByLineExtensions;
        $[18] = meetingNotesAutomationDiscoveryFragmentRef;
        $[19] = reactionsContentFragmentRef;
        $[20] = shouldRenderMeetingNotesAutomationDiscovery;
        $[21] = shouldShowBylineReactions;
        $[22] = spaceId;
        $[23] = versionOverride;
        $[24] = t7;
    } else t7 = $[24];
    let t8;
    if ($[25] !== t5 || $[26] !== t6 || $[27] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t5,
            testId: t6
        }, t7);
        $[25] = t5;
        $[26] = t6;
        $[27] = t7;
        $[28] = t8;
    } else t8 = $[28];
    let t9;
    if ($[29] !== banner || $[30] !== contentId || $[31] !== hasCoverPicture || $[32] !== headingContainer || $[33] !== isEmbeddedPage || $[34] !== pageWidthType || $[35] !== spaceKey || $[36] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kQRQB.ContentTitle), {
            banner: banner,
            contentId: contentId,
            spaceKey: spaceKey,
            headingContainer: headingContainer,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage
        }, t8);
        $[29] = banner;
        $[30] = contentId;
        $[31] = hasCoverPicture;
        $[32] = headingContainer;
        $[33] = isEmbeddedPage;
        $[34] = pageWidthType;
        $[35] = spaceKey;
        $[36] = t8;
        $[37] = t9;
    } else t9 = $[37];
    return t9;
};
const $aaeb66d37f355457$var$ContentTitleWithByLineFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(42);
    const { contentFragmentRef: contentFragmentRef, byLineContributors: byLineContributors, titleSpaceFragmentRef: titleSpaceFragmentRef, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, contentId: contentId, spaceKey: spaceKey, banner: banner, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, headingContainer: headingContainer, hasCoverPicture: hasCoverPicture, pageWidthType: pageWidthType, isEmbeddedPage: isEmbeddedPage, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, hasByLine: t1 } = t0;
    const hasByLine = t1 === undefined ? true : t1;
    const content = (0, $6SsN4.useFragment)($aaeb66d37f355457$export$a5ae28e9da358c58, contentFragmentRef);
    const { isRovoLLMEnabled: isRovoLLMEnabled } = (0, $bQm3c.useSessionData)();
    let t2;
    if ($[0] !== contentType || $[1] !== isEmbeddedPage || $[2] !== isRovoLLMEnabled) {
        t2 = isRovoLLMEnabled && contentType === "page" && !isEmbeddedPage && (0, $9wGTI.fg)("cc_automations_discovery_nudges");
        $[0] = contentType;
        $[1] = isEmbeddedPage;
        $[2] = isRovoLLMEnabled;
        $[3] = t2;
    } else t2 = $[3];
    const shouldRenderMeetingNotesAutomationDiscovery = t2;
    let t3;
    if ($[4] !== content) {
        t3 = (0, $zalpJ.getTitleContentProperty)({
            content: {
                nodes: [
                    content
                ]
            }
        });
        $[4] = content;
        $[5] = t3;
    } else t3 = $[5];
    const { titleContentProperties: titleContentProperties } = t3;
    let t4;
    if ($[6] !== banner || $[7] !== content) {
        t4 = /*#__PURE__*/ (0, $cozmU.isValidElement)(banner) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(banner, {
            contentFragmentRef: content
        }) : banner;
        $[6] = banner;
        $[7] = content;
        $[8] = t4;
    } else t4 = $[8];
    const bannerWithContentFragmentRef = t4;
    const isBylineCenterStyles = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const t5 = isBylineCenterStyles && $aaeb66d37f355457$var$BylineCenterStyles;
    let t6;
    if ($[9] !== t5) {
        t6 = [
            t5
        ];
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const t7 = isBylineCenterStyles ? "centered-content-title-and-byline" : "content-title-and-byline";
    let t8;
    if ($[11] !== analyticsBylineFragmentRef || $[12] !== byLineContributors || $[13] !== bylineClassificationFragmentRef || $[14] !== content || $[15] !== contentClassificationFragmentRef || $[16] !== contentId || $[17] !== contentSubType || $[18] !== contentType || $[19] !== hasByLine || $[20] !== hasByLineContributors || $[21] !== hasByLineExtensions || $[22] !== reactionsContentFragmentRef || $[23] !== shouldRenderMeetingNotesAutomationDiscovery || $[24] !== shouldShowBylineReactions || $[25] !== spaceId) {
        t8 = hasByLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($aaeb66d37f355457$var$ByLineFromFragmentWithClassificationFragment, {
            contentId: contentId,
            contentFragmentRef: content,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentContributors: byLineContributors,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            hasByLineContributors: hasByLineContributors,
            hasByLineExtensions: hasByLineExtensions,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentType: contentType,
            contentSubType: contentSubType,
            spaceId: spaceId
        }), (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $aaeb66d37f355457$var$ApprovalBannerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gjEAi.ApprovalBanner), null))), shouldRenderMeetingNotesAutomationDiscovery && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kygIi.LazyMeetingNotesAutomationDiscoveryFragment), {
            contentFragmentRef: content,
            postOfficePlacementId: "confluence-view-page-title-area-banner",
            WrapperComponent: $aaeb66d37f355457$var$TitleAreaBannerWrapper
        }));
        $[11] = analyticsBylineFragmentRef;
        $[12] = byLineContributors;
        $[13] = bylineClassificationFragmentRef;
        $[14] = content;
        $[15] = contentClassificationFragmentRef;
        $[16] = contentId;
        $[17] = contentSubType;
        $[18] = contentType;
        $[19] = hasByLine;
        $[20] = hasByLineContributors;
        $[21] = hasByLineExtensions;
        $[22] = reactionsContentFragmentRef;
        $[23] = shouldRenderMeetingNotesAutomationDiscovery;
        $[24] = shouldShowBylineReactions;
        $[25] = spaceId;
        $[26] = t8;
    } else t8 = $[26];
    let t9;
    if ($[27] !== t6 || $[28] !== t7 || $[29] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: t6,
            testId: t7
        }, t8);
        $[27] = t6;
        $[28] = t7;
        $[29] = t8;
        $[30] = t9;
    } else t9 = $[30];
    let t10;
    if ($[31] !== bannerWithContentFragmentRef || $[32] !== content || $[33] !== contentId || $[34] !== hasCoverPicture || $[35] !== headingContainer || $[36] !== isEmbeddedPage || $[37] !== pageWidthType || $[38] !== spaceKey || $[39] !== t9 || $[40] !== titleSpaceFragmentRef) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kQRQB.ContentTitleFromFragment), {
            banner: bannerWithContentFragmentRef,
            contentId: contentId,
            spaceKey: spaceKey,
            headingContainer: headingContainer,
            hasCoverPicture: hasCoverPicture,
            pageWidthType: pageWidthType,
            isEmbeddedPage: isEmbeddedPage,
            contentFragmentRef: content,
            spaceFragmentRef: titleSpaceFragmentRef
        }, t9);
        $[31] = bannerWithContentFragmentRef;
        $[32] = content;
        $[33] = contentId;
        $[34] = hasCoverPicture;
        $[35] = headingContainer;
        $[36] = isEmbeddedPage;
        $[37] = pageWidthType;
        $[38] = spaceKey;
        $[39] = t9;
        $[40] = titleSpaceFragmentRef;
        $[41] = t10;
    } else t10 = $[41];
    return t10;
};
module.exports["ContentTitleWithByLine"] = $aaeb66d37f355457$export$6ac99e13b8ebf390;

});

parcelRegister("9IvbC", function(module, exports) {

let $71306a162b99b673$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $71306a162b99b673$var$load("22DNY").then(()=>parcelRequire('6VDyY'));

});

parcelRegister("aFVlD", function(module, exports) {

let $7c5a37d152808876$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $7c5a37d152808876$var$load("1olsN"),
    $7c5a37d152808876$var$load("cyDpt"),
    $7c5a37d152808876$var$load("9iWFV"),
    $7c5a37d152808876$var$load("fkGqG"),
    $7c5a37d152808876$var$load("5Hvgu"),
    $7c5a37d152808876$var$load("1YWCO"),
    $7c5a37d152808876$var$load("fq1gG"),
    $7c5a37d152808876$var$load("30b92"),
    $7c5a37d152808876$var$load("6wr18"),
    $7c5a37d152808876$var$load("59hV4"),
    $7c5a37d152808876$var$load("1tkDl"),
    $7c5a37d152808876$var$load("JZOBE"),
    $7c5a37d152808876$var$load("4x9Jx"),
    $7c5a37d152808876$var$load("8YxM8"),
    $7c5a37d152808876$var$load("ea3NB"),
    $7c5a37d152808876$var$load("fuOfV"),
    $7c5a37d152808876$var$load("jL1Ke"),
    $7c5a37d152808876$var$load("5MQ0D"),
    $7c5a37d152808876$var$load("ffEVr"),
    $7c5a37d152808876$var$load("lixsQ"),
    $7c5a37d152808876$var$load("h4Nf7"),
    $7c5a37d152808876$var$load("Wowvf"),
    $7c5a37d152808876$var$load("4g6rd"),
    $7c5a37d152808876$var$load("ayJxT"),
    $7c5a37d152808876$var$load("hhss7"),
    $7c5a37d152808876$var$load("43z9c"),
    $7c5a37d152808876$var$load("7EorR"),
    $7c5a37d152808876$var$load("1C6qR")
]).then(()=>parcelRequire('kTkGJ'));

});

parcelRegister("e2zD6", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $7Qvc2 = parcelRequire("7Qvc2");

const $05a5c042457d6268$var$CREATED_BY_AI_LABEL = 'Created with Rovo';
const $05a5c042457d6268$var$EDITED_BY_AI_LABEL = 'Edited with Rovo';
const $05a5c042457d6268$var$READ_BY_AI_LABEL = 'Viewed by Rovo';
const $05a5c042457d6268$var$SOURCE_LABEL = 'Source';
const $05a5c042457d6268$var$EVIDENCE_LABEL = 'Evidence';
const $05a5c042457d6268$var$PERSISTENCE_LABEL = 'Persistence';
const $05a5c042457d6268$var$NETWORK_CALLS_LABEL = 'Network calls';
const $05a5c042457d6268$var$CREATOR_LABEL = 'Creator';
const $05a5c042457d6268$var$VERSION_LABEL = 'Version';
const $05a5c042457d6268$var$UNKNOWN_CREATOR_NAME = 'the page creator';
const $05a5c042457d6268$var$REAL_DATA_SOURCE_VALUE = 'Page content property (generatedBy)';
const $05a5c042457d6268$var$REAL_DATA_NONE_VALUE = 'None (read from existing page data)';
const $05a5c042457d6268$var$SPARK_RECEIPT_SCENARIOS = {
    CREATED_BY_AI: {
        id: 'CREATED_BY_AI',
        label: $05a5c042457d6268$var$CREATED_BY_AI_LABEL,
        description: 'Spark preview data indicates Rovo created this page.'
    },
    EDITED_BY_AI: {
        id: 'EDITED_BY_AI',
        label: $05a5c042457d6268$var$EDITED_BY_AI_LABEL,
        description: 'Spark preview data indicates Rovo helped edit this page.'
    },
    READ_BY_AI: {
        id: 'READ_BY_AI',
        label: $05a5c042457d6268$var$READ_BY_AI_LABEL,
        description: 'Spark preview data indicates Rovo read this page as context.'
    }
};
const $05a5c042457d6268$var$ROVO_AGENT_ACTOR = {
    id: 'rovo-agent-spark-preview',
    name: 'Rovo agent',
    type: 'agent',
    agentType: 'rovo',
    iconKey: 'rovo-agent'
};
const $05a5c042457d6268$var$SPACE_ORGANIZER_ACTOR = {
    id: 'space-organizer-agent-spark-preview',
    name: 'Space Organizer Agent',
    type: 'agent',
    agentType: 'space-organizer',
    iconKey: 'space-organizer-agent'
};
const $05a5c042457d6268$var$DEV_DOCS_ACTOR = {
    id: 'dev-docs-agent-spark-preview',
    name: 'Dev Docs Agent',
    type: 'agent',
    agentType: 'dev-docs',
    iconKey: 'dev-docs-agent'
};
const $05a5c042457d6268$var$FABRICATED_BUCKETS = [
    {
        scenarioId: 'EDITED_BY_AI',
        actor: $05a5c042457d6268$var$SPACE_ORGANIZER_ACTOR
    },
    {
        scenarioId: 'READ_BY_AI',
        actor: $05a5c042457d6268$var$DEV_DOCS_ACTOR
    }
];
const $05a5c042457d6268$var$isValidContentId = (contentId)=>/^[1-9]\d*$/.test(contentId);
const $05a5c042457d6268$var$resolveFabricatedBucket = (contentId)=>{
    const lastDigit = Number(contentId.charAt(contentId.length - 1));
    return lastDigit % $05a5c042457d6268$var$FABRICATED_BUCKETS.length;
};
const $05a5c042457d6268$var$createSparkPreviewSignals = (scenario)=>[
        {
            id: 'source',
            label: $05a5c042457d6268$var$SOURCE_LABEL,
            value: 'Spark preview fixture'
        },
        {
            id: 'evidence',
            label: $05a5c042457d6268$var$EVIDENCE_LABEL,
            value: `Example evidence for ${scenario.label.toLowerCase()}`
        },
        {
            id: 'persistence',
            label: $05a5c042457d6268$var$PERSISTENCE_LABEL,
            value: 'None'
        },
        {
            id: 'network',
            label: $05a5c042457d6268$var$NETWORK_CALLS_LABEL,
            value: 'None'
        }
    ];
const $05a5c042457d6268$var$createSparkPreviewEvents = (actor, scenario)=>[
        {
            id: 'context-reviewed',
            occurredAt: '2026-06-03T21:00:00.000Z',
            title: 'Context reviewed',
            description: `${actor.name} inspected example page context for ${scenario.label.toLowerCase()}.`
        },
        {
            id: 'agent-action',
            occurredAt: '2026-06-03T21:02:00.000Z',
            title: scenario.label,
            description: `${actor.name} performed the Spark preview activity recorded in this receipt.`
        },
        {
            id: 'receipt-created',
            occurredAt: '2026-06-03T21:04:00.000Z',
            title: 'Receipt prepared',
            description: 'Example evidence was collected for review in this Spark preview receipt.'
        }
    ].sort((a, b)=>a.occurredAt.localeCompare(b.occurredAt));
// Builds a CREATED_BY_AI receipt backed by REAL page data (creator, created/updated timestamps,
// version number) for pages confirmed to be created by Rovo Smart Create. Events with a missing
// timestamp are omitted so the panel never renders an Invalid Date.
const $05a5c042457d6268$var$createRealCreatedByAiReceipt = (contentId, pageData)=>{
    const scenario = $05a5c042457d6268$var$SPARK_RECEIPT_SCENARIOS.CREATED_BY_AI;
    const creatorName = pageData.creatorName?.trim() || $05a5c042457d6268$var$UNKNOWN_CREATOR_NAME;
    const versionDetail = typeof pageData.versionNumber === 'number' ? `${$05a5c042457d6268$var$VERSION_LABEL} ${pageData.versionNumber}` : null;
    const events = [];
    if (pageData.createdAt) events.push({
        id: 'page-created',
        occurredAt: pageData.createdAt,
        title: scenario.label,
        description: `${creatorName} created this page with Rovo.`
    });
    if (pageData.lastUpdatedAt) events.push({
        id: 'page-last-updated',
        occurredAt: pageData.lastUpdatedAt,
        title: 'Last updated',
        description: versionDetail ? `Latest published change (${versionDetail.toLowerCase()}).` : 'Latest published change.'
    });
    events.sort((a, b)=>a.occurredAt.localeCompare(b.occurredAt));
    const signals = [
        {
            id: 'source',
            label: $05a5c042457d6268$var$SOURCE_LABEL,
            value: $05a5c042457d6268$var$REAL_DATA_SOURCE_VALUE
        },
        {
            id: 'creator',
            label: $05a5c042457d6268$var$CREATOR_LABEL,
            value: creatorName
        },
        {
            id: 'version',
            label: $05a5c042457d6268$var$VERSION_LABEL,
            value: versionDetail ?? 'Unknown'
        },
        {
            id: 'persistence',
            label: $05a5c042457d6268$var$PERSISTENCE_LABEL,
            value: $05a5c042457d6268$var$REAL_DATA_NONE_VALUE
        },
        {
            id: 'network',
            label: $05a5c042457d6268$var$NETWORK_CALLS_LABEL,
            value: $05a5c042457d6268$var$REAL_DATA_NONE_VALUE
        }
    ];
    return {
        contentId: contentId,
        actor: $05a5c042457d6268$var$ROVO_AGENT_ACTOR,
        scenario: scenario,
        // CREATED_BY_AI receipts are sourced from real page data, so they must NOT claim "no audit log
        // was created" — that copy only applies to fabricated Spark preview receipts.
        summary: `Created with Rovo by ${creatorName}. This receipt is sourced from existing page data.`,
        events: events,
        signals: signals
    };
};
const $05a5c042457d6268$export$a31b6deb77eb892e = (contentId, pageData)=>{
    if (!(0, $9wGTI.fg)('cc_sparks_agent_trust_receipt')) return null;
    const normalizedContentId = contentId.trim();
    if (!$05a5c042457d6268$var$isValidContentId(normalizedContentId)) return null;
    // Real CREATED_BY_AI data only when the page is positively confirmed as Rovo Smart Create.
    // Exact-literal match excludes null, ONBOARDING, and AI_PLANNER.
    if (pageData?.generatedBy === (0, $7Qvc2.ROVO_SMART_CREATION_GENERATED_BY)) return $05a5c042457d6268$var$createRealCreatedByAiReceipt(normalizedContentId, pageData);
    // Non-Rovo pages fall back to fabricated EDITED_BY_AI / READ_BY_AI demo receipts only — never
    // CREATED_BY_AI, so "Created with Rovo" is never asserted on a page Rovo did not create.
    const { scenarioId: scenarioId, actor: actor } = $05a5c042457d6268$var$FABRICATED_BUCKETS[$05a5c042457d6268$var$resolveFabricatedBucket(normalizedContentId)];
    const scenario = $05a5c042457d6268$var$SPARK_RECEIPT_SCENARIOS[scenarioId];
    return {
        contentId: normalizedContentId,
        actor: actor,
        scenario: scenario,
        summary: `${scenario.description} This receipt identifies ${actor.name}, the recorded agent activity, and the chronological events available for review. Spark preview data only, not a durable audit log.`,
        events: $05a5c042457d6268$var$createSparkPreviewEvents(actor, scenario),
        signals: $05a5c042457d6268$var$createSparkPreviewSignals(scenario)
    };
};
module.exports["resolveAgentTrustReceipt"] = $05a5c042457d6268$export$a31b6deb77eb892e;

});

parcelRegister("38aC9", function(module, exports) {
/* SmartLinkIconRenderer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $kTb7m = parcelRequire("kTb7m");

const $034a9b0def7554d2$var$baseStyles = null; // Image icons fill their wrapper; the wrapper carries the desired pixel size.
const $034a9b0def7554d2$var$imgStyles = null; // Stack chips keep third-party product images at 10px inside the 16px glyph tile, matching
// the pre-app-icon byline. Menu rows keep the 16px face.
const $034a9b0def7554d2$var$imageStyles = {
    stack: "_39xV02uFDC _0jFU0VuFDC",
    menu: "_39xV02ey7F _0jFU0Vey7F"
}; // AtlasKit React-element icons (@atlaskit/icon, @atlaskit/object) render an <svg> at a fixed
// intrinsic 16px that ignores the wrapper size, so we render at that natural size and scale the
// whole composed icon down with a centred transform — this shrinks any element icon uniformly
// without distorting or clipping it. 16px -> 10px in the stack; the menu keeps the natural size.
const $034a9b0def7554d2$var$elementStyles = {
    stack: "_39xV02ey7F _0jFU0Vey7F _46hvQmFQfX _1VJPcaGquZ _0yKXXaDIqT",
    menu: "_39xV02ey7F _0jFU0Vey7F"
}; // Product logos already include a branded tile. AtlasKit IconWrapper is `inline-block`, so the
// SVG sits on a line box and looks high in the chip. The slot is a flex container and the
// wrapper span is also flex so the logo centres on both axes.
const $034a9b0def7554d2$var$logoStyles = {
    stack: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02N91d _0jFU0VN91d _4ouGXIdnbC _4kiQYAdnbC _4ya3eEdnbC _4v6ugQQ4SZ _1XJ99dDIqT _3NACppDIqT",
    menu: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _39xV02oWWg _0jFU0VoWWg _4ouGXIdnbC _4kiQYAdnbC _3YEZNOdnbC _4ya3eEdnbC _4v6ugQQ4SZ _1XJ99dDIqT _3NACppDIqT"
};
// surfaces as the browser's "broken image" glyph. <img> load failures aren't caught by React error
// boundaries — they only surface through the DOM `onError` event — so we attach `onError` to the
// <img> at the point it's created here and swap in a neutral link icon on failure.
const $034a9b0def7554d2$var$ImageIcon = ({ src: src, size: size })=>{
    const [hasErrored, setHasErrored] = (0, $cozmU.useState)(false); // Reset when the source changes — the menu reuses one renderer instance across rows.
    (0, $cozmU.useEffect)(()=>{
        setHasErrored(false);
    }, [
        src
    ]);
    if (hasErrored) // The fallback is an <svg> element icon, so it uses the element wrapper (which applies the
    // stack scale-down / menu natural-size logic) rather than the image wrapper.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
            $034a9b0def7554d2$var$elementStyles[size]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
        label: "",
        color: "var(--ds-icon-subtle, #505258)"
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
            $034a9b0def7554d2$var$imageStyles[size]
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: "",
        src: src,
        onError: ()=>setHasErrored(true),
        className: (0, $hekY6.default)([
            "_3iDTPbvLZJ _39xV02N91d _0jFU0VN91d _00EA0egIor"
        ])
    }));
};
const $034a9b0def7554d2$export$24f3a21bb86b5d0c = ({ icon: icon, size: size })=>{
    if (icon.kind === 'image') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($034a9b0def7554d2$var$ImageIcon, {
        src: icon.src,
        size: size
    });
    if (icon.kind === 'logo') {
        const logoNode = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(icon.node, {
            size: size === 'stack' ? 'xxsmall' : 'small'
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-hidden": "true",
            "data-testid": "smart-link-logo",
            className: (0, $hekY6.default)([
                $034a9b0def7554d2$var$logoStyles[size]
            ])
        }, logoNode);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC",
            $034a9b0def7554d2$var$elementStyles[size]
        ])
    }, icon.node);
};
module.exports["SmartLinkIconRenderer"] = $034a9b0def7554d2$export$24f3a21bb86b5d0c;

});

parcelRegister("jDHty", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $7c8469b2a0f7d0de$export$d77e972d07b86701 = (initialData)=>{
    let current = initialData;
    const subscribers = new Set();
    const notify = ()=>{
        subscribers.forEach((callback)=>{
            callback();
        });
    };
    const publish = (data)=>{
        current = data;
        notify();
    };
    const clear = ()=>{
        current = initialData;
        notify();
    };
    const subscribe = (callback)=>{
        subscribers.add(callback);
        return ()=>{
            subscribers.delete(callback);
        };
    };
    // Returns the stored object rather than building a new one, so
    // `useSyncExternalStore` sees a stable snapshot between publishes.
    const getSnapshot = ()=>current;
    const getServerSnapshot = ()=>initialData;
    /**
	 * Reads the published data, but only when it belongs to `contentId`. The filter
	 * lives here rather than in each consumer so a new section cannot forget it and
	 * silently render the previous page's data after an SPA transition.
	 */ const useValue = (contentId)=>{
        const data = (0, $cozmU.useSyncExternalStore)(subscribe, getSnapshot, getServerSnapshot);
        return data.contentId === contentId ? data : initialData;
    };
    const clearForTesting = ()=>{
        current = initialData;
        subscribers.clear();
    };
    return {
        publish: publish,
        clear: clear,
        subscribe: subscribe,
        useValue: useValue,
        clearForTesting: clearForTesting
    };
};
module.exports["createPanelDataBridge"] = $7c8469b2a0f7d0de$export$d77e972d07b86701;

});

parcelRegister("8WngQ", function(module, exports) {
const $cebcf46595f8344d$export$89a33a230d65db65 = [
    {
        cypherName: 'atlassian_user_created_confluence_page',
        relationship: 'created',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_contributed_to_confluence_page',
        relationship: 'contributed',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_owns_confluence_page',
        relationship: 'owns',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_updated_confluence_page',
        relationship: 'updated',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_viewed_confluence_page',
        relationship: 'viewed',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_favorited_confluence_page',
        relationship: 'favorited',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_liked_confluence_page',
        relationship: 'liked',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_mentioned_in_confluence_page',
        relationship: 'mentioned-in',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_snapshotted_confluence_page',
        relationship: 'snapshotted',
        direction: 'incoming'
    },
    {
        cypherName: 'atlassian_user_watches_confluence_page',
        relationship: 'watches',
        direction: 'incoming'
    },
    {
        cypherName: 'confluence_page_shared_with_atlassian_user',
        relationship: 'shared-with',
        direction: 'outgoing'
    }
];
const $cebcf46595f8344d$export$3ad09bd8c18dea3b = (value)=>$cebcf46595f8344d$export$89a33a230d65db65.some(({ relationship: relationship })=>relationship === value);
const $cebcf46595f8344d$export$7cb477f6de87aaf0 = (value)=>value === 'incoming' || value === 'outgoing';
module.exports["PAGE_PEOPLE_RELATIONSHIPS"] = $cebcf46595f8344d$export$89a33a230d65db65;
module.exports["isPagePeopleRelationship"] = $cebcf46595f8344d$export$3ad09bd8c18dea3b;
module.exports["isPagePeopleRelationshipDirection"] = $cebcf46595f8344d$export$7cb477f6de87aaf0;

});

parcelRegister("hTfX9", function(module, exports) {
/* BylineConnectionIconStack.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $38aC9 = parcelRequire("38aC9");


var $jJhQa = parcelRequire("jJhQa");


var $f0mzK = parcelRequire("f0mzK");


var $8tDDs = parcelRequire("8tDDs");

const $a9443aed03d2e255$var$styles = {
    stack: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _2YgrGrP0S5",
    spacingBefore: "_0GTcwR1Y8M",
    spacingAfter: "_2xTnZx1Y8M"
};
const $a9443aed03d2e255$var$appIconTileStyles = null;
const $a9443aed03d2e255$var$glyphTileStyles = null;
const $a9443aed03d2e255$var$placeholderIconTileStyles = null;
const $a9443aed03d2e255$var$firstIconTileStyles = null;
const $a9443aed03d2e255$var$secondIconTileStyles = null;
const $a9443aed03d2e255$var$thirdIconTileStyles = null;
const $a9443aed03d2e255$var$isAtlasKitAppLogo = (icon)=>icon.icon.kind === 'logo';
const $a9443aed03d2e255$export$de98155121ad78a4 = ({ links: links, incomingLinks: incomingLinks, additionalIcons: additionalIcons, appearance: appearance = 'default', minIcons: minIcons, spacing: spacing = 'after' })=>{
    const realIcons = (0, $cozmU.useMemo)(()=>(0, $jJhQa.getBylineConnectionIcons)(links, additionalIcons, incomingLinks), [
        links,
        additionalIcons,
        incomingLinks
    ]);
    const icons = (0, $cozmU.useMemo)(()=>{
        const target = Math.min(minIcons ?? 0, (0, $jJhQa.MAX_BYLINE_CONNECTION_ICONS));
        if (realIcons.length >= target) return realIcons;
        const padding = appearance === 'placeholder' ? Array.from({
            length: target - realIcons.length
        }, (_, index)=>(0, $f0mzK.createPlaceholderConnectionIcon)(realIcons.length + index)) : (0, $8tDDs.getFallbackConnectionIcons)(realIcons, target - realIcons.length);
        return [
            ...realIcons,
            ...padding
        ];
    }, [
        realIcons,
        minIcons,
        appearance
    ]);
    if (icons.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": "byline-connections-icon-stack",
        className: (0, $hekY6.default)([
            $a9443aed03d2e255$var$styles.stack,
            spacing === 'before' && $a9443aed03d2e255$var$styles.spacingBefore,
            spacing === 'after' && $a9443aed03d2e255$var$styles.spacingAfter
        ])
    }, icons.map((icon, index)=>{
        const isPlaceholderTile = appearance === 'placeholder';
        const useAppChrome = !isPlaceholderTile && $a9443aed03d2e255$var$isAtlasKitAppLogo(icon);
        const chip = useAppChrome ? 'app' : 'glyph';
        switch(index){
            case 0:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    key: icon.key,
                    "data-chip": chip,
                    className: (0, $hekY6.default)([
                        useAppChrome ? "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc" : "_0bjKvDKxmn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc",
                        isPlaceholderTile && "_3vBAKHhQC5 _0KLXruVrZW",
                        "_42Yu6BPvK5"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
                    icon: icon.icon,
                    size: "stack"
                }));
            case 1:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    key: icon.key,
                    "data-chip": chip,
                    "data-rotation-enabled": true,
                    className: (0, $hekY6.default)([
                        useAppChrome ? "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc" : "_0bjKvDKxmn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc",
                        isPlaceholderTile && "_3vBAKHhQC5 _0KLXruVrZW",
                        "_0GTcwR5UaJ _42Yu6Bbhqd _2AERac9ub0"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
                    icon: icon.icon,
                    size: "stack"
                }));
            case 2:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    key: icon.key,
                    "data-chip": chip,
                    className: (0, $hekY6.default)([
                        useAppChrome ? "_4bt5LAnQyn _2WAcuGnQyn _0bjKvD0O7w _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc" : "_0bjKvDKxmn _3vBAKH9r67 _3hxITi6wH8 _2V7sgONvrM _3iDTPbccYA _0hPCNLDIqT _37wbyuDIqT _24h04i2Njc _1mT5xdRAKS _3YEZNOdnbC _39xV02ey7F _0jFU0Vey7F _0KLXrulfZc",
                        isPlaceholderTile && "_3vBAKHhQC5 _0KLXruVrZW",
                        "_0GTcwR5UaJ _42Yu6BgtVO"
                    ])
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $38aC9.SmartLinkIconRenderer), {
                    icon: icon.icon,
                    size: "stack"
                }));
            default:
                return null;
        }
    }));
};
module.exports["BylineConnectionIconStack"] = $a9443aed03d2e255$export$de98155121ad78a4;

});

parcelRegister("86sr7", function(module, exports) {
const $b7da36d1b8481eed$export$97a0c2716ca9f0c9 = 3;
const $b7da36d1b8481eed$var$isUnconnected = (link)=>link.access === 'unauthorized';
function $b7da36d1b8481eed$export$8c96aced19644e7c(links, limit = $b7da36d1b8481eed$export$97a0c2716ca9f0c9) {
    return [
        ...links
    ].sort((a, b)=>{
        const rankDiff = Number($b7da36d1b8481eed$var$isUnconnected(b)) - Number($b7da36d1b8481eed$var$isUnconnected(a));
        return rankDiff !== 0 ? rankDiff : a.occurrenceIndex - b.occurrenceIndex;
    }).slice(0, limit);
}
module.exports["DEFAULT_VISIBLE_LINK_COUNT"] = $b7da36d1b8481eed$export$97a0c2716ca9f0c9;
module.exports["getTopConnectionLinks"] = $b7da36d1b8481eed$export$8c96aced19644e7c;

});

parcelRegister("e9QBI", function(module, exports) {
/* DevDocsConnectionRow.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $8VfSP = parcelRequire("8VfSP");


var $8oBbn = parcelRequire("8oBbn");


var $iMnC5 = parcelRequire("iMnC5");


var $1l0kj = parcelRequire("1l0kj");


var $dinVW = parcelRequire("dinVW");


var $bQm3c = parcelRequire("bQm3c");


var $fONL3 = parcelRequire("fONL3");


var $4P3Ik = parcelRequire("4P3Ik");


var $idfQJ = parcelRequire("idfQJ");

const $bd9b9a29e384189b$var$i18n = (0, $kSwu1.defineMessages)({
    // Message id retained from the byline menu section so existing translations
    // carry over now that the row is shared with the preview panel.
    providerRepo: {
        id: "dev-docs.byline-connection.menu.section.provider-repo.ai-non-final",
        defaultMessage: "{provider} repo"
    }
});
const $bd9b9a29e384189b$var$styles = {
    rowWrapper: "_4c065U2ADO _2Y7lL48HPE",
    textColumn: "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEAEMG _4ouGXIdnbC",
    title: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1kk5Tku7m9 _1UtDYzy7kJ _1ANEUSLRg7 _39HuIbz8Lp",
    metadata: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1kk5Tku7m9 _1UtDYzKGUX _1ANEUSLRg7 _39HuIbz8Lp",
    metadataPart: "_4bt5LAnQyn _2WAcuGnQyn _4ouGXIdnbC _1ANEUSLRg7 _39HuIbz8Lp",
    metadataSeparator: "_0bjKvDS5Zs _2YLqiK1Y8M _3iDTPbvbI6 _3YEZNOdnbC _39xV024Y4b _0jFU0V4Y4b _0KLXrugozt"
};
const $bd9b9a29e384189b$var$LinkItemWithInteraction = (0, $8oBbn.default); /**
                                                                                                  * A single Dev Docs source row. Falls back to a non-interactive row when the
                                                                                                  * repository URL cannot be resolved.
                                                                                                  *
                                                                                                  * Shared by the Teamwork Graph byline menu and the preview panel, so it renders no
                                                                                                  * section heading of its own.
                                                                                                  */ 
const $bd9b9a29e384189b$export$bc1a2b85ad79f624 = ({ connection: connection, onNavigate: onNavigate })=>{
    const intl = (0, $kSwu1.useIntl)();
    const { formatMessage: formatMessage } = intl;
    const { environment: environment } = (0, $bQm3c.useSessionData)();
    const [isRepositoryLinkIconVisible, setIsRepositoryLinkIconVisible] = (0, $cozmU.useState)(false);
    const lastSynced = (0, $4P3Ik.formatDevDocsRelativeSyncTime)(connection.lastSynced, intl);
    const providerConfig = (0, $fONL3.getDevDocsSourceProviderConfigFromValue)(connection.provider);
    const providerDisplayName = providerConfig?.displayName ?? (0, $fONL3.getDevDocsSourceProviderDisplayName)(connection.provider);
    const repositoryUrl = (0, $fONL3.getDevDocsRepositoryUrl)({
        environment: environment,
        provider: connection.provider,
        repoName: connection.repoName
    });
    const providerTypeLabel = providerDisplayName ? formatMessage($bd9b9a29e384189b$var$i18n.providerRepo, {
        provider: providerDisplayName
    }) : null;
    const metadataParts = [
        providerTypeLabel,
        connection.owner,
        lastSynced
    ].filter((metadataPart)=>Boolean(metadataPart));
    const metadata = metadataParts.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        as: "span",
        alignBlock: "center",
        xcss: $bd9b9a29e384189b$var$styles.metadata
    }, metadataParts.map((metadataPart, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, {
            key: `${metadataPart}-${index}`
        }, index > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $bd9b9a29e384189b$var$styles.metadataSeparator,
            "aria-hidden": "true"
        }) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            xcss: $bd9b9a29e384189b$var$styles.metadataPart
        }, metadataPart)))) : null;
    const rowText = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        xcss: $bd9b9a29e384189b$var$styles.textColumn,
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bd9b9a29e384189b$var$styles.title
    }, connection.repoName), metadata);
    const showRepositoryLinkIcon = (0, $cozmU.useCallback)(()=>{
        setIsRepositoryLinkIconVisible(true);
    }, []);
    const hideRepositoryLinkIcon = (0, $cozmU.useCallback)(()=>{
        setIsRepositoryLinkIconVisible(false);
    }, []);
    if (!repositoryUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $bd9b9a29e384189b$var$styles.rowWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
        space: "space.150",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idfQJ.DevDocsScmProviderLogo), {
        provider: connection.provider
    }), rowText));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($bd9b9a29e384189b$var$LinkItemWithInteraction, {
        href: repositoryUrl,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: onNavigate,
        onMouseEnter: showRepositoryLinkIcon,
        onMouseLeave: hideRepositoryLinkIcon,
        onFocus: showRepositoryLinkIcon,
        onBlur: hideRepositoryLinkIcon,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $idfQJ.DevDocsScmProviderLogo), {
            provider: connection.provider
        }),
        iconAfter: isRepositoryLinkIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8VfSP))), {
            label: "",
            color: "var(--ds-icon-subtle, #505258)",
            testId: "dev-docs-byline-repository-link-icon"
        }) : null
    }, rowText);
};
module.exports["DevDocsConnectionRow"] = $bd9b9a29e384189b$export$bc1a2b85ad79f624;

});

parcelRegister("xICd5", function(module, exports) {
/* SectionCountBadge.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");

const $5accbe136c7255ea$var$styles = {
    badge: "_0bjKvDcjp5 _2sNsIg7NXe _4c065UPgdg _2Y7lL41Y8M _3iDTPbQ4SZ _0jFU0Vey7F _4ouGXIoWWg _4kiQYAey7F _37wbyuDIqT _0hPCNLDIqT _3YEZNOdnbC _0KLXruG6qS _1UtDYzUktF _24h04i2Njc"
};
const $5accbe136c7255ea$export$2211d1b0625dcf47 = ({ count: count, hasMore: hasMore = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        className: (0, $hekY6.default)([
            $5accbe136c7255ea$var$styles.badge
        ])
    }, count, hasMore ? '+' : null);
module.exports["SectionCountBadge"] = $5accbe136c7255ea$export$2211d1b0625dcf47;

});

parcelRegister("5vpeX", function(module, exports) {

var $6mKj3 = parcelRequire("6mKj3");

// Utility function to check if a value is a non-empty string
const $3b594b06ac9b7376$var$isNonEmptyString = (value)=>{
    return typeof value === 'string' && value.trim() !== '';
};
// Utility function to validate and set a byline content property value
const $3b594b06ac9b7376$var$validatePropertyValue = (key, value, validatedProperties)=>{
    if (value !== undefined) {
        if ($3b594b06ac9b7376$var$isNonEmptyString(value)) validatedProperties[key] = value;
        else // eslint-disable-next-line no-console
        console.warn(`Byline content property ${key} must be a non-empty string, got:`, typeof value);
    }
};
// Validation function for extracting property node from GraphQL query data
const $3b594b06ac9b7376$var$validateContentPropertyQuery = (data, contentPropertyKey, exactKeys)=>{
    // Check if data exists and has the expected structure
    if (!data || !data.content || !data.content.nodes || data.content.nodes.length === 0 || !data.content.nodes[0].properties || !data.content.nodes[0].properties.nodes || data.content.nodes[0].properties.nodes.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('Invalid byline content property query data');
        return null;
    }
    // Get all objects that match the contentPropertyKey
    const properties = data.content.nodes[0].properties.nodes;
    let matchingObjects;
    if (exactKeys && (0, $6mKj3.expValEquals)('confluence_ssr_byline', 'isEnabled', true)) matchingObjects = properties.filter((property)=>property !== null && exactKeys.includes(property.key ?? ''));
    else {
        const contentKeyPattern = new RegExp(contentPropertyKey);
        matchingObjects = properties.filter((property)=>{
            // Preserve the legacy error and fallback for malformed property lists.
            if (property === null) throw new TypeError('Invalid byline content property node');
            return contentKeyPattern.test(property.key ?? '');
        });
    }
    if (matchingObjects.length === 0) {
        // eslint-disable-next-line no-console
        console.warn('No property nodes matching content property key pattern found');
        return null;
    }
    if (matchingObjects.length > 1) {
        // eslint-disable-next-line no-console
        console.warn('Multiple property nodes matching content property key pattern found. Please make sure your contentPropertyKey is unique, like a UUID.');
        return null;
    }
    const propertyNode = matchingObjects[0];
    const validContentPropertyKey = propertyNode.key ?? undefined;
    if (!propertyNode.value) {
        // eslint-disable-next-line no-console
        console.warn('Byline content property data has no value');
        return null;
    }
    return {
        propertyNode: propertyNode,
        validContentPropertyKey: validContentPropertyKey
    };
};
// Common function to validate title, icon, and tooltip properties
const $3b594b06ac9b7376$var$validateProperties = (propertyValue, validatedProperties)=>{
    // validate each property
    $3b594b06ac9b7376$var$validatePropertyValue('title', propertyValue.title, validatedProperties);
    $3b594b06ac9b7376$var$validatePropertyValue('icon', propertyValue.icon, validatedProperties);
    $3b594b06ac9b7376$var$validatePropertyValue('tooltip', propertyValue.tooltip, validatedProperties);
};
const $3b594b06ac9b7376$export$48cf1be175912dd = (data, defaultValues, exactKeys)=>{
    try {
        // Validate and extract the query data
        const queryResult = $3b594b06ac9b7376$var$validateContentPropertyQuery(data, defaultValues.contentPropertyKey, exactKeys);
        if (!queryResult) return defaultValues;
        const { propertyNode: propertyNode, validContentPropertyKey: validContentPropertyKey } = queryResult;
        // Parse JSON with error handling
        let propertyValue;
        try {
            propertyValue = JSON.parse(propertyNode.value ?? '');
        } catch (jsonError) {
            // eslint-disable-next-line no-console
            console.error('Failed to parse byline content property JSON:', jsonError);
            return defaultValues;
        }
        // Validate the structure of the parsed value
        if (typeof propertyValue !== 'object' || propertyValue === null) {
            // eslint-disable-next-line no-console
            console.error('Byline content property value is not an object:', propertyValue);
            return defaultValues;
        }
        const validatedProperties = {
            ...defaultValues
        };
        // Validate each property using the byline content property value utility function
        $3b594b06ac9b7376$var$validateProperties(propertyValue, validatedProperties);
        if (validContentPropertyKey && validContentPropertyKey !== '') validatedProperties.contentPropertyKey = validContentPropertyKey;
        return validatedProperties;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Unexpected error in content property validation:', error);
        return defaultValues;
    }
};
const $3b594b06ac9b7376$export$96933cae6933ce51 = (eventData, defaultValues)=>{
    try {
        // Check if eventData exists and has the expected structure
        if (!eventData || !eventData.propertyKey || !eventData.valueUpdate) {
            // eslint-disable-next-line no-console
            console.warn('Invalid FORGE_CONTENT_PROPERTY_UPDATED event data structure');
            return defaultValues;
        }
        const valueUpdate = eventData.valueUpdate;
        // Validate the structure of valueUpdate
        if (typeof valueUpdate !== 'object' || valueUpdate === null) {
            // eslint-disable-next-line no-console
            console.error('Event valueUpdate is not an object:', valueUpdate);
            return defaultValues;
        }
        const validatedProperties = {
            ...defaultValues
        };
        $3b594b06ac9b7376$var$validateProperties(valueUpdate, validatedProperties);
        return validatedProperties;
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Unexpected error in event data validation:', error);
        return defaultValues;
    }
};
module.exports["validateContentPropertyData"] = $3b594b06ac9b7376$export$48cf1be175912dd;
module.exports["validateEventData"] = $3b594b06ac9b7376$export$96933cae6933ce51;

});

parcelRegister("3aDMt", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $e5xte = parcelRequire("e5xte");


var $87We3 = parcelRequire("87We3");

const $73425511e70f8b25$export$85c37fe80d19fd66 = (t0)=>{
    const $ = (0, $bDgLe.c)(4);
    const { snapshot: snapshot } = t0;
    let apps;
    if ($[0] !== snapshot.apps) {
        apps = [];
        for (const app of snapshot.apps)if (app.presentation.resolution === "resolved") apps.push(app);
        $[0] = snapshot.apps;
        $[1] = apps;
    } else apps = $[1];
    const resolvedApps = apps;
    if (!(0, $87We3.isByLineAppSnapshotAuthoritative)(snapshot)) return null;
    let t1;
    if ($[2] !== resolvedApps) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, resolvedApps.map($73425511e70f8b25$var$_temp));
        $[2] = resolvedApps;
        $[3] = t1;
    } else t1 = $[3];
    return t1;
};
function $73425511e70f8b25$var$_temp(t0) {
    const { id: id, presentation: presentation, producer: producer } = t0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $e5xte.BylineAppTriggerVisual), {
        "data-byline-app-producer": producer,
        "data-testid": producer === "connect" ? "web-item-link" : "forge-byline-header-wrapper",
        key: id,
        title: presentation.tooltip
    }, presentation.icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
        alt: "",
        height: presentation.icon.height,
        src: presentation.icon.src,
        width: presentation.icon.width
    }) : null, producer === "connect" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        dangerouslySetInnerHTML: {
            __html: presentation.label
        }
    }) : presentation.label);
}
module.exports["AuthoritativeByLineApps"] = $73425511e70f8b25$export$85c37fe80d19fd66;

});

parcelRegister("9XdgS", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<5a7bb06770f2b343c8473e42d15fcb56>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b0ceb5a87a1ab66b$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "ByLineContributors_contentContributors",
    "selections": [
        {
            "kind": "ScalarField",
            "name": "count"
        },
        {
            "kind": "ScalarField",
            "name": "isCurrentUserContributor"
        },
        {
            "kind": "ScalarField",
            "name": "isOwnerContributor"
        },
        {
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "type"
                },
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                },
                {
                    "kind": "InlineFragment",
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "accountId"
                        }
                    ],
                    "type": "KnownUser"
                },
                {
                    "concreteType": "Icon",
                    "kind": "LinkedField",
                    "name": "profilePicture",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "path"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "ContentContributors"
};
$b0ceb5a87a1ab66b$var$node.hash = "779053a535fff2e4b879239a0c659d33";
var $b0ceb5a87a1ab66b$export$2e2bcd8739ae039 = $b0ceb5a87a1ab66b$var$node;


/**
 * @generated SignedSource<<ee71c3f2c1807926afd626e17901d50d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $02a8f9783e035b58$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "type"
    }, v2 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v3 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v4 = [
        v1 /*: any*/ ,
        v3 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "accountId"
                }
            ],
            "type": "KnownUser"
        },
        {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "profilePicture",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "path"
                }
            ]
        }
    ], v5 = {
        "kind": "ScalarField",
        "name": "number"
    }, v6 = {
        "kind": "ScalarField",
        "name": "key"
    }, v7 = {
        "kind": "ScalarField",
        "name": "value"
    }, v8 = [
        {
            "concreteType": "JsonContentProperty",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ 
            ]
        }
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "includeConnectionAncestors"
            },
            {
                "defaultValue": false,
                "kind": "LocalArgument",
                "name": "useNewContentTopper"
            }
        ],
        "kind": "Fragment",
        "name": "ByLine_content",
        "selections": [
            {
                "kind": "FragmentSpread",
                "name": "useReadTime_content"
            },
            v0 /*: any*/ ,
            v1 /*: any*/ ,
            v2 /*: any*/ ,
            {
                "concreteType": "History",
                "kind": "LinkedField",
                "name": "history",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "createdDate"
                    },
                    {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "kind": "LinkedField",
                        "name": "ownedBy",
                        "plural": false,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "kind": "LinkedField",
                        "name": "lastOwnedBy",
                        "plural": false,
                        "selections": v4 /*: any*/ 
                    }
                ]
            },
            {
                "concreteType": "Version",
                "kind": "LinkedField",
                "name": "version",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": v4 /*: any*/ 
                    },
                    {
                        "kind": "ScalarField",
                        "name": "friendlyWhen"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "when"
                    },
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "contentTypeModified"
                    }
                ]
            },
            {
                "concreteType": "ContentProperties",
                "kind": "LinkedField",
                "name": "contentProperties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "PublishedContentProperties",
                        "kind": "LinkedField",
                        "name": "latest",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "generatedBy"
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "FragmentSpread",
                "name": "RendererContentState_content"
            },
            {
                "condition": "useNewContentTopper",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "pageTitlePublished",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "key",
                                "value": "page-title-property-published"
                            }
                        ],
                        "concreteType": "PaginatedJsonContentPropertyList",
                        "kind": "LinkedField",
                        "name": "properties",
                        "plural": false,
                        "selections": [
                            {
                                "concreteType": "JsonContentProperty",
                                "kind": "LinkedField",
                                "name": "nodes",
                                "plural": true,
                                "selections": [
                                    v0 /*: any*/ ,
                                    v6 /*: any*/ ,
                                    v7 /*: any*/ ,
                                    {
                                        "concreteType": "Version",
                                        "kind": "LinkedField",
                                        "name": "version",
                                        "plural": false,
                                        "selections": [
                                            v5 /*: any*/ 
                                        ]
                                    }
                                ]
                            }
                        ],
                        "storageKey": "properties(key:\"page-title-property-published\")"
                    }
                ]
            },
            {
                "alias": "editorProperty",
                "args": [
                    {
                        "kind": "Literal",
                        "name": "key",
                        "value": "editor"
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": v8 /*: any*/ ,
                "storageKey": "properties(key:\"editor\")"
            },
            {
                "concreteType": "ContentMetadata",
                "kind": "LinkedField",
                "name": "metadata",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
                        "kind": "LinkedField",
                        "name": "frontend",
                        "plural": false,
                        "selections": [
                            {
                                "condition": "useNewContentTopper",
                                "kind": "Condition",
                                "passingValue": true,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "coverPictureWidth"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeConnectionAncestors",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "ancestors",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "title"
                            },
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            {
                                "concreteType": "History",
                                "kind": "LinkedField",
                                "name": "history",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "LinkedField",
                                        "name": "createdBy",
                                        "plural": false,
                                        "selections": [
                                            v3 /*: any*/ 
                                        ]
                                    }
                                ]
                            },
                            {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "keys",
                                        "value": [
                                            "devdocsProperties",
                                            "smartFolderProperties"
                                        ]
                                    }
                                ],
                                "concreteType": "PaginatedJsonContentPropertyList",
                                "kind": "LinkedField",
                                "name": "properties",
                                "plural": false,
                                "selections": v8 /*: any*/ ,
                                "storageKey": "properties(keys:[\"devdocsProperties\",\"smartFolderProperties\"])"
                            }
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$02a8f9783e035b58$var$node.hash = "3f05feb4c48e931bd5441145ff3e2092";
var $02a8f9783e035b58$export$2e2bcd8739ae039 = $02a8f9783e035b58$var$node;



var $cozmU = parcelRequire("cozmU");


var $6SsN4 = parcelRequire("6SsN4");


var $9DHhW = parcelRequire("9DHhW");


var $kvJHJ = parcelRequire("kvJHJ");


var $7boqA = parcelRequire("7boqA");


var $zalpJ = parcelRequire("zalpJ");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $irVI7 = parcelRequire("irVI7");


var $ln0hx = parcelRequire("ln0hx");


var $dnfJM = parcelRequire("dnfJM");


var $jjv3l = parcelRequire("jjv3l");


var $7Sm4c = parcelRequire("7Sm4c");


var $ep3mz = parcelRequire("ep3mz");


var $c0urc = parcelRequire("c0urc");

var $1SNEF = parcelRequire("1SNEF");


var $jMyy4 = parcelRequire("jMyy4");


var $6mKj3 = parcelRequire("6mKj3");


var $fxLAA = parcelRequire("fxLAA");


var $80xNa = parcelRequire("80xNa");


var $fabPv = parcelRequire("fabPv");


var $hlP5l = parcelRequire("hlP5l");








var $hekY6 = parcelRequire("hekY6");





var $jVylI = parcelRequire("jVylI");




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f1d8e46f2fc87fe7$var$Container = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEQU1O _0jFU0VUF4f _3iDTPbQ4SZ",
            __cmplp.isTitleCenterAligned ? "_37wbyuDIqT" : "_37wbyuzUZr",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Circle = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDS5Zs _0KLXruGsB2",
            __cmplp.isTitleCenterAligned ? "_39xV02NHnM" : "_39xV02Va5s",
            __cmplp.isTitleCenterAligned ? "_0jFU0VNHnM" : "_0jFU0VVa5s",
            __cmplp.isTitleCenterAligned ? "_313842dnbC _0adFHsXJux _1DCdHidnbC _2XsHFMdnbC" : "_3138424Y4b _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$LineContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _2XsHFM2ADO _0adFHsFQfX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Line1 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDcjp5 _0KLXruGsB2 _39xV02QEt6 _0jFU0VEbN9 _3138421Y8M",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$Line2 = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_0bjKvDcjp5 _0KLXruGsB2 _0jFU0VxpxF _3138421Y8M",
            __cmplp.isTitleCenterAligned ? "_39xV024qGD" : "_39xV02b1xp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$var$FirstRowContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _37wbyuDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f1d8e46f2fc87fe7$export$438daec06afefb9e = ()=>{
    const $ = (0, $bDgLe.c)(17);
    const [contentId] = (0, $ep3mz.usePageContentId)();
    let t0;
    if ($[0] !== contentId) {
        t0 = {
            contentId: contentId
        };
        $[0] = contentId;
        $[1] = t0;
    } else t0 = $[1];
    const { titleContentProperties: titleContentProperties } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t0);
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    if (isTitleCenterAligned) {
        let t1;
        if ($[2] !== isTitleCenterAligned) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Circle, {
                isTitleCenterAligned: isTitleCenterAligned
            });
            $[2] = isTitleCenterAligned;
            $[3] = t1;
        } else t1 = $[3];
        let t2;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line1, null);
            $[4] = t2;
        } else t2 = $[4];
        let t3;
        if ($[5] !== t1) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$FirstRowContainer, null, t1, t2);
            $[5] = t1;
            $[6] = t3;
        } else t3 = $[6];
        let t4;
        if ($[7] !== isTitleCenterAligned) {
            t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line2, {
                isTitleCenterAligned: isTitleCenterAligned
            });
            $[7] = isTitleCenterAligned;
            $[8] = t4;
        } else t4 = $[8];
        let t5;
        if ($[9] !== t3 || $[10] !== t4) {
            t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$LineContainer, null, t3, t4);
            $[9] = t3;
            $[10] = t4;
            $[11] = t5;
        } else t5 = $[11];
        let t6;
        if ($[12] !== isTitleCenterAligned || $[13] !== t5) {
            t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Container, {
                isTitleCenterAligned: isTitleCenterAligned
            }, t5);
            $[12] = isTitleCenterAligned;
            $[13] = t5;
            $[14] = t6;
        } else t6 = $[14];
        return t6;
    }
    let t1;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Circle, null);
        $[15] = t1;
    } else t1 = $[15];
    let t2;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Container, null, t1, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$LineContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line1, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f1d8e46f2fc87fe7$var$Line2, null)));
        $[16] = t2;
    } else t2 = $[16];
    return t2;
};



var $83fWZ = parcelRequire("83fWZ");








var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $9wGTI = parcelRequire("9wGTI");


var $04VgG = parcelRequire("04VgG");


var $fImWv = parcelRequire("fImWv");





var $7om8k = parcelRequire("7om8k");


var $jmjWc = parcelRequire("jmjWc");


const $b3f1a98366675b36$export$bffecd160d81d78c = (0, $jmjWc.LoadableBackground)({
    __loadable_id__: "yzXpt",
    loader: async ()=>(await (parcelRequire("9IvbC"))).AutoConversionByLine,
    name: 'AutoConversionByLine'
});






var $jkVM2 = parcelRequire("jkVM2");


var $63EIj = parcelRequire("63EIj");








var $5sUij = parcelRequire("5sUij");


var $kSwu1 = parcelRequire("kSwu1");








var $kA6Zo = parcelRequire("kA6Zo");





var $b35Wv = parcelRequire("b35Wv");





var $hSqtY = parcelRequire("hSqtY");


var $isEtk = parcelRequire("isEtk");


var $bQm3c = parcelRequire("bQm3c");


var $5Kc7f = parcelRequire("5Kc7f");











var $bFPHx = parcelRequire("bFPHx");


const $7b10285448e39671$export$818988cb4f30ec46 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "vP7ts",
    name: "ReactionsSSRLoader",
    loading: (props)=>{
        return props?.summaryViewEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bFPHx.ReactionsPlaceholder), null);
    },
    loader: async ()=>(await (parcelRequire("aFVlD"))).Reactions
});



var $1NF8X = parcelRequire("1NF8X");


var $3FlVr = parcelRequire("3FlVr");


var $ke5Nx = parcelRequire("ke5Nx");

/**
 * @generated SignedSource<<84ffca27fbfe7c65cbcf62a794426f5e>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $3c4825abea248692$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "ReactionsContentFragment_content",
        "selections": [
            v0 /*: any*/ ,
            {
                "concreteType": "ReactionsSummaryResponse",
                "kind": "LinkedField",
                "name": "contentReactionsSummary",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "reactionsCount"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "ari"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "containerAri"
                    },
                    {
                        "concreteType": "ReactionsSummaryForEmoji",
                        "kind": "LinkedField",
                        "name": "reactionsSummaryForEmoji",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "emojiId"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "count"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "reacted"
                            },
                            v0 /*: any*/ 
                        ]
                    }
                ]
            }
        ],
        "type": "Content"
    };
}();
$3c4825abea248692$var$node.hash = "8f56d4c4019bf4c3d755d097e2930c4e";
var $3c4825abea248692$export$2e2bcd8739ae039 = $3c4825abea248692$var$node;


const $ec5d2b49526d7beb$export$775e4c56cd01bef0 = (0, $3c4825abea248692$export$2e2bcd8739ae039);


const $7bbeff754c7e0bdb$var$i18n = (0, $kSwu1.defineMessages)({
    addNew: {
        id: "reactions.view-page.byline.reactions.add.new",
        defaultMessage: "Add new"
    },
    addReaction: {
        id: "reactions.view-page.byline.reactions.add.reaction",
        defaultMessage: "Add reaction"
    }
});
const $7bbeff754c7e0bdb$var$ViewPageReactionsContainerCommonStyles = (0, $buxP3.xcss)({
    display: 'flex',
    clear: 'both',
    overflow: 'visible',
    maxWidth: 'unset',
    margin: 'unset',
    marginBottom: 'space.025',
    marginTop: 'space.025',
    height: '28px'
});
const $7bbeff754c7e0bdb$var$ReactionsComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(20);
    const { contentId: contentId, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, noFlexWrap: noFlexWrap, noRelativeContainer: noRelativeContainer, reactionsData: reactionsData } = t0;
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [state] = (0, $isEtk.useContentState)();
    const { focusedPageReactionsId: focusedPageReactionsId } = (0, $ke5Nx.useReactionsQueryParams)();
    const { edition: edition } = (0, $bQm3c.useSessionData)();
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            rootMargin: "-100px 0px 0px 0px",
            triggerOnce: true
        };
        $[0] = t1;
    } else t1 = $[0];
    const [reactionsRef, reactionsSectionInView] = (0, $5sUij.useInView)(t1);
    let t2;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b35Wv))), {
            testId: "emoji-add-icon",
            color: "var(--ds-icon-subtle, #505258)",
            label: ""
        });
        $[1] = t2;
    } else t2 = $[1];
    const customIcon = t2;
    const isSSR = Boolean(window.__SSR_RENDERED__);
    const isInViewAndNotOnServer = reactionsSectionInView && state?.isContentReady;
    let t3;
    if ($[2] !== contentId || $[3] !== contentSubType || $[4] !== contentType || $[5] !== edition || $[6] !== focusedPageReactionsId || $[7] !== formatMessage || $[8] !== noFlexWrap || $[9] !== noRelativeContainer || $[10] !== reactionsData || $[11] !== spaceId) {
        t3 = ()=>{
            if (contentType && spaceId) {
                const ReactionsLoader = focusedPageReactionsId ? (0, $1NF8X.ReactionsLoaderBackground) : (0, $7b10285448e39671$export$818988cb4f30ec46);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
                    testId: "view-page-byline-reactions-wrapper",
                    "data-vc": "view-page-byline-reactions-wrapper"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(ReactionsLoader, {
                    contentId: contentId,
                    location: contentType,
                    containerId: spaceId,
                    containerType: (0, $3FlVr.ReactionContainerType).SPACE,
                    contentSubType: contentSubType,
                    reactionsData: reactionsData,
                    summaryViewEnabled: true,
                    summaryViewThreshold: 1,
                    allowSelectFromSummaryView: true,
                    useButtonAlignmentStyling: true,
                    summaryViewPlacement: "bottom-start",
                    customAnalyticsAttributes: {
                        edition: edition
                    },
                    isSubtle: true,
                    reactionPickerTriggerIcon: customIcon,
                    useDefaultStyledContainer: true,
                    noFlexWrap: noFlexWrap,
                    noRelativeContainer: noRelativeContainer,
                    reactionPickerTriggerText: formatMessage($7bbeff754c7e0bdb$var$i18n.addNew),
                    hoverableSummaryView: true,
                    optimisticallyLoadSummaryEmojis: isSSR,
                    renderParticleEffectOnSummaryView: true
                }));
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null);
        };
        $[2] = contentId;
        $[3] = contentSubType;
        $[4] = contentType;
        $[5] = edition;
        $[6] = focusedPageReactionsId;
        $[7] = formatMessage;
        $[8] = noFlexWrap;
        $[9] = noRelativeContainer;
        $[10] = reactionsData;
        $[11] = spaceId;
        $[12] = t3;
    } else t3 = $[12];
    const displayReactions = t3;
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [
            $7bbeff754c7e0bdb$var$ViewPageReactionsContainerCommonStyles
        ];
        $[13] = t4;
    } else t4 = $[13];
    let t5;
    if ($[14] !== displayReactions || $[15] !== isInViewAndNotOnServer) {
        t5 = isSSR || isInViewAndNotOnServer ? displayReactions() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Kc7f.ReactionsSummaryViewPlaceholder), null);
        $[14] = displayReactions;
        $[15] = isInViewAndNotOnServer;
        $[16] = t5;
    } else t5 = $[16];
    let t6;
    if ($[17] !== reactionsRef || $[18] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            ref: reactionsRef,
            testId: "view-page-byline-reactions",
            xcss: t4
        }, t5);
        $[17] = reactionsRef;
        $[18] = t5;
        $[19] = t6;
    } else t6 = $[19];
    return t6;
};
const $7bbeff754c7e0bdb$export$c52ae103b3391553 = (props)=>{
    const $ = (0, $bDgLe.c)(2);
    let t0;
    if ($[0] !== props) {
        const reactions = props.reactionsContentFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbeff754c7e0bdb$var$ViewPageBylineReactionsFragmentReader, {
            ...props,
            reactionsContentFragmentRef: props.reactionsContentFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbeff754c7e0bdb$var$ReactionsComponent, props);
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hSqtY.TransparentErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).NOTIFICATIONS
        }, reactions);
        $[0] = props;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
};
const $7bbeff754c7e0bdb$var$ViewPageBylineReactionsFragmentReader = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let props;
    let reactionsContentFragmentRef;
    if ($[0] !== t0) {
        ({ reactionsContentFragmentRef: reactionsContentFragmentRef, ...props } = t0);
        $[0] = t0;
        $[1] = props;
        $[2] = reactionsContentFragmentRef;
    } else {
        props = $[1];
        reactionsContentFragmentRef = $[2];
    }
    const content = (0, $6SsN4.useFragment)((0, $ec5d2b49526d7beb$export$775e4c56cd01bef0), reactionsContentFragmentRef);
    let t1;
    if ($[3] !== content.contentReactionsSummary || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($7bbeff754c7e0bdb$var$ReactionsComponent, {
            ...props,
            reactionsData: content.contentReactionsSummary
        });
        $[3] = content.contentReactionsSummary;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};



var $2wo33 = parcelRequire("2wo33");


var $lfBMY = parcelRequire("lfBMY");


var $cD1qu = parcelRequire("cD1qu");








var $a9SX7 = parcelRequire("a9SX7");


var $JTIzG = parcelRequire("JTIzG");


var $l2a4I = parcelRequire("l2a4I");








var $ad7Ou = parcelRequire("ad7Ou");


var $jC4nA = parcelRequire("jC4nA");


var $aWwYt = parcelRequire("aWwYt");


var $b2GGc = parcelRequire("b2GGc");


var $e2zD6 = parcelRequire("e2zD6");

const $577177aaf22dc1ba$var$i18n = (0, $kSwu1.defineMessages)({
    viewReceiptAction: {
        id: "agent-trust-receipt.byline-chip.view-receipt-action.non-final",
        defaultMessage: "View receipt"
    }
});
const $577177aaf22dc1ba$var$AgentTrustReceiptBylineChipButton = ({ receipt: receipt })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showObjectSidebar: showObjectSidebar } = (0, $aWwYt.useObjectSidebarActions)();
    const chipLabel = `${receipt.scenario.label} - ${formatMessage($577177aaf22dc1ba$var$i18n.viewReceiptAction)}`;
    const openReceiptPanel = (0, $cozmU.useCallback)(()=>{
        showObjectSidebar((0, $b2GGc.createAgentTrustReceiptPanel)({
            receipt: receipt
        }), 'push');
    }, [
        receipt,
        showObjectSidebar
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        appearance: "subtle",
        spacing: "compact",
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jC4nA))),
        testId: "agent-trust-receipt-byline-chip",
        onClick: openReceiptPanel
    }, chipLabel);
};
const $577177aaf22dc1ba$var$AgentTrustReceiptBylineChipInner = ({ contentId: contentId, generatedBy: generatedBy, creatorName: creatorName, createdAt: createdAt, lastUpdatedAt: lastUpdatedAt, versionNumber: versionNumber })=>{
    const receipt = (0, $cozmU.useMemo)(()=>(0, $e2zD6.resolveAgentTrustReceipt)(contentId, {
            generatedBy: generatedBy,
            creatorName: creatorName,
            createdAt: createdAt,
            lastUpdatedAt: lastUpdatedAt,
            versionNumber: versionNumber
        }), [
        contentId,
        generatedBy,
        creatorName,
        createdAt,
        lastUpdatedAt,
        versionNumber
    ]);
    if (!receipt) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($577177aaf22dc1ba$var$AgentTrustReceiptBylineChipButton, {
        receipt: receipt
    });
};
const $577177aaf22dc1ba$export$5f6967bf6f7e3690 = $577177aaf22dc1ba$var$AgentTrustReceiptBylineChipInner;



var $5vi32 = parcelRequire("5vi32");


var $6iOCg = parcelRequire("6iOCg");


var $35Exc = parcelRequire("35Exc");

















var $5ZtfK = parcelRequire("5ZtfK");

const $5783a7702ddb8025$var$loadingStyle = (0, $buxP3.xcss)({
    width: '85px',
    backgroundColor: 'color.skeleton.subtle',
    height: '24px',
    borderRadius: 'radius.full'
});
const $5783a7702ddb8025$var$lastUpdateStyles = (0, $buxP3.xcss)({
    marginTop: 'space.025',
    marginLeft: 'space.100',
    marginRight: 'space.150'
});
const $5783a7702ddb8025$var$i18n = (0, $kSwu1.defineMessages)({
    lastUpdateIconLabel: {
        id: "content-header.by-line.live-pages.last.updated.icon.label",
        defaultMessage: "Last updated"
    }
});
const $5783a7702ddb8025$export$b76f09da983efdc2 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(10);
    const { version: version, loading: loading } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($5783a7702ddb8025$var$i18n.lastUpdateIconLabel);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5ZtfK))), {
            label: t1,
            color: "var(--ds-text-subtle, #505258)",
            testId: "last-updated-icon"
        });
        $[2] = t1;
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    if ($[4] !== loading || $[5] !== version) {
        t3 = loading && !version.friendlyWhen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            xcss: $5783a7702ddb8025$var$loadingStyle,
            alignItems: "center",
            justifyContent: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null)) : version?.friendlyWhen;
        $[4] = loading;
        $[5] = version;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.default), {
            alignItems: "center",
            gap: "space.075",
            xcss: $5783a7702ddb8025$var$lastUpdateStyles,
            testId: "live-page-last-updated"
        }, t2, t3);
        $[7] = t2;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    return t4;
});



var $aKxcs = parcelRequire("aKxcs");


var $5YSiR = parcelRequire("5YSiR");


var $3TrzI = parcelRequire("3TrzI");

const $22b7bc4596013b99$var$bylineLastUpdatedStyles = (0, $buxP3.xcss)({
    marginTop: 'space.negative.025',
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.075'
});
const $22b7bc4596013b99$var$ReadTimeWithContentFragmentRef = (0, $04VgG.ReadTime);
// Downstream packages are checked against the last generated confluence-analytics declaration.
const $22b7bc4596013b99$var$AnalyticsByLineWithFragmentRef = (0, $fImWv.AnalyticsByLine);
const $22b7bc4596013b99$export$773979b66159aa2 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(58);
    const { contentId: contentId, author: author, owner: owner, version: version, contributorsCount: contributorsCount, isOwnerContributor: isOwnerContributor, hasByLineContributors: hasByLineContributors, hasByLineExtensions: hasByLineExtensions, isFabricPage: isFabricPage, titleContentProperties: titleContentProperties, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, contentSubType: contentSubType, spaceId: spaceId, generatedBy: generatedBy, connectionAncestors: connectionAncestors, createdDate: createdDate, contentFragmentRef: contentFragmentRef, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, bylineAppContentProperties: bylineAppContentProperties } = t0;
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const [contentTypeFromContext] = (0, $ep3mz.useContentType)();
    const { isAudioBylineEntrypointEnabled: isAudioBylineEntrypointEnabled } = (0, $JTIzG.useAudioFeatureFlags)();
    const t1 = contentType ?? contentTypeFromContext;
    let t2;
    if ($[0] !== contentId || $[1] !== t1) {
        t2 = {
            contentId: contentId,
            contentType: t1,
            operation: (0, $lfBMY.OperationTypes).UPDATE,
            status: (0, $cD1qu.CURRENT_STATUS)
        };
        $[0] = contentId;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const canUpdateContent = (0, $2wo33.useCanPerformContentOperation)(t2);
    const hasEditPermission = canUpdateContent ?? false;
    const isEmbeddedConfluence = (0, $5vi32.useIsEmbeddedConfluence_DO_NOT_USE)();
    const isTitleCenterAligned = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER;
    const showByLineContributors = hasByLineContributors ?? true;
    const showByLineExtensions = hasByLineExtensions ?? true;
    let t3;
    if ($[3] !== generatedBy || $[4] !== isEmbeddedConfluence) {
        t3 = generatedBy === (0, $3TrzI.AI_PLANNER_GENERATED_BY) && (0, $9wGTI.fg)("confluence_ai_planner_sync_byline") && !(isEmbeddedConfluence && (0, $9wGTI.fg)("migrate_planner_to_docs_tab"));
        $[3] = generatedBy;
        $[4] = isEmbeddedConfluence;
        $[5] = t3;
    } else t3 = $[5];
    const shouldRenderAIPlannerSyncByline = t3;
    const BylineMainDiv = (0, $6mKj3.expValEquals)("confluence_byline_min_height", "isEnabled", true) ? (0, $35Exc.StandardPageBylineStyledMainDiv) : (0, $35Exc.StyledMainDiv);
    let t4;
    if ($[6] !== author || $[7] !== bylineClassificationFragmentRef || $[8] !== contentClassificationFragmentRef || $[9] !== contentFragmentRef || $[10] !== contentId || $[11] !== contentType || $[12] !== contentTypeFromContext || $[13] !== contributorsCount || $[14] !== generatedBy || $[15] !== hasEditPermission || $[16] !== isFabricPage || $[17] !== isOwnerContributor || $[18] !== owner || $[19] !== showByLineContributors || $[20] !== version) {
        t4 = showByLineContributors && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7om8k.BadgeStylePageOwnershipByline), {
            owner: owner,
            author: author,
            analyticsSource: "renderer",
            contributorCountWithoutOwner: contributorsCount - (isOwnerContributor ? 1 : 0),
            generatedBy: generatedBy
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKxcs.BylineClassification), {
            contentId: contentId,
            classificationContextFragmentRef: bylineClassificationFragmentRef,
            contentFragmentRef: contentClassificationFragmentRef
        }), (0, $6mKj3.expValEquals)("confluence_approvals_eap", "isEnabled", true) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jkVM2.EditorContentState), {
            contentId: contentId,
            contentType: contentType ?? contentTypeFromContext,
            isViewMode: true,
            canEdit: hasEditPermission,
            userOffline: false
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $63EIj.RendererContentState), {
            contentId: contentId,
            isDraft: false,
            hasSeparator: false,
            contentFragmentRef: contentFragmentRef
        }), !isFabricPage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            xcss: $22b7bc4596013b99$var$bylineLastUpdatedStyles,
            testId: "page-last-modified"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5783a7702ddb8025$export$b76f09da983efdc2), {
            version: version
        })));
        $[6] = author;
        $[7] = bylineClassificationFragmentRef;
        $[8] = contentClassificationFragmentRef;
        $[9] = contentFragmentRef;
        $[10] = contentId;
        $[11] = contentType;
        $[12] = contentTypeFromContext;
        $[13] = contributorsCount;
        $[14] = generatedBy;
        $[15] = hasEditPermission;
        $[16] = isFabricPage;
        $[17] = isOwnerContributor;
        $[18] = owner;
        $[19] = showByLineContributors;
        $[20] = version;
        $[21] = t4;
    } else t4 = $[21];
    let t5;
    if ($[22] !== contentId || $[23] !== contentType || $[24] !== contentTypeFromContext || $[25] !== generatedBy || $[26] !== isEmbeddedConfluence || $[27] !== shouldRenderAIPlannerSyncByline) {
        t5 = shouldRenderAIPlannerSyncByline && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5YSiR.LazyAIPlannerSyncByline), {
            contentId: contentId,
            contentType: contentType ?? contentTypeFromContext,
            generatedBy: generatedBy,
            isEmbeddedConfluence: isEmbeddedConfluence
        });
        $[22] = contentId;
        $[23] = contentType;
        $[24] = contentTypeFromContext;
        $[25] = generatedBy;
        $[26] = isEmbeddedConfluence;
        $[27] = shouldRenderAIPlannerSyncByline;
        $[28] = t5;
    } else t5 = $[28];
    let t6;
    if ($[29] !== analyticsBylineFragmentRef || $[30] !== author || $[31] !== connectionAncestors || $[32] !== contentFragmentRef || $[33] !== contentId || $[34] !== contentSubType || $[35] !== contentType || $[36] !== createdDate || $[37] !== generatedBy || $[38] !== isAudioBylineEntrypointEnabled || $[39] !== isRestrictedExternalShare || $[40] !== reactionsContentFragmentRef || $[41] !== shouldShowBylineReactions || $[42] !== showByLineExtensions || $[43] !== spaceId || $[44] !== version?.number || $[45] !== version?.when) {
        t6 = showByLineExtensions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22b7bc4596013b99$var$ReadTimeWithContentFragmentRef, {
            contentId: contentId,
            contentFragmentRef: contentFragmentRef
        }), (0, $9wGTI.fg)("cc_sparks_agent_trust_receipt") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $577177aaf22dc1ba$export$5f6967bf6f7e3690), {
            contentId: contentId,
            generatedBy: generatedBy,
            creatorName: author?.fullName,
            createdAt: createdDate,
            lastUpdatedAt: version?.when,
            versionNumber: version?.number
        }), (0, $6mKj3.isExperimentEnabled)("confluence_1p_and_3p_connection_byline_experiment") && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l2a4I.BylineConnections), {
            contentId: contentId,
            connectionAncestors: connectionAncestors,
            pageVersion: version?.number,
            pageUpdatedAt: version?.when
        }), isAudioBylineEntrypointEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a9SX7.ListenByline), {
            contentId: contentId,
            contentType: contentType ?? undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($22b7bc4596013b99$var$AnalyticsByLineWithFragmentRef, {
            contentId: contentId,
            contentAuthorId: author.userId,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef
        }), shouldShowBylineReactions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7bbeff754c7e0bdb$export$c52ae103b3391553), {
            contentId: contentId,
            contentType: contentType,
            spaceId: spaceId,
            contentSubType: contentSubType,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            noFlexWrap: true,
            noRelativeContainer: true
        }), !isRestrictedExternalShare && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3f1a98366675b36$export$bffecd160d81d78c), null));
        $[29] = analyticsBylineFragmentRef;
        $[30] = author;
        $[31] = connectionAncestors;
        $[32] = contentFragmentRef;
        $[33] = contentId;
        $[34] = contentSubType;
        $[35] = contentType;
        $[36] = createdDate;
        $[37] = generatedBy;
        $[38] = isAudioBylineEntrypointEnabled;
        $[39] = isRestrictedExternalShare;
        $[40] = reactionsContentFragmentRef;
        $[41] = shouldShowBylineReactions;
        $[42] = showByLineExtensions;
        $[43] = spaceId;
        $[44] = version?.number;
        $[45] = version?.when;
        $[46] = t6;
    } else t6 = $[46];
    let t7;
    if ($[47] !== bylineAppContentProperties || $[48] !== contentId || $[49] !== isTitleCenterAligned || $[50] !== showByLineExtensions || $[51] !== t4 || $[52] !== t5 || $[53] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $35Exc.StyledTextDiv), {
            hasBadgeStylePageOwnerBylineItem: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6iOCg.SingleLineByLine), {
            contentId: contentId,
            isTitleCenterAlignedOverride: isTitleCenterAligned,
            showByLineExtensions: showByLineExtensions,
            bylineAppContentProperties: bylineAppContentProperties
        }, t4, t5, t6));
        $[47] = bylineAppContentProperties;
        $[48] = contentId;
        $[49] = isTitleCenterAligned;
        $[50] = showByLineExtensions;
        $[51] = t4;
        $[52] = t5;
        $[53] = t6;
        $[54] = t7;
    } else t7 = $[54];
    let t8;
    if ($[55] !== isTitleCenterAligned || $[56] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(BylineMainDiv, {
            className: "page-metadata-modification-info",
            "data-testid": "page-main-div",
            isTitleCenterAligned: isTitleCenterAligned
        }, t7);
        $[55] = isTitleCenterAligned;
        $[56] = t7;
        $[57] = t8;
    } else t8 = $[57];
    return t8;
});



var $9HhEw = parcelRequire("9HhEw");

const $3ade7df4fa86d9cd$export$83e33e2cb03d444b = (0, $9HhEw.default);



var $cI2rq = parcelRequire("cI2rq");

const $0559514361f7ee96$export$f2d7ca777241edb7 = (0, $02a8f9783e035b58$export$2e2bcd8739ae039);
const $0559514361f7ee96$export$4aabfa7af1f71de0 = (0, $b0ceb5a87a1ab66b$export$2e2bcd8739ae039);
// WARN: This is temporary code to send analytics event when we would crash the part
// of the ByLine experience when byline user is undefined due to any reason.
// This is done as part of https://ops.internal.atlassian.com/jira/browse/HOT-106424
// investigation. This code should be removed once we know the root cause/impact.
const $0559514361f7ee96$var$HOT106424Tracker = (t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { content: content, contentId: contentId, contentContributors: contentContributors, isExternalShareRequest: isExternalShareRequest } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t1;
    if ($[0] !== content || $[1] !== contentContributors?.nodes || $[2] !== contentId || $[3] !== createAnalyticsEvent || $[4] !== isExternalShareRequest) {
        t1 = ()=>{
            const byUser = content?.version?.by;
            const createdBy = content?.history?.createdBy;
            const hasEmptyContributors = (contentContributors?.nodes || []).some($0559514361f7ee96$var$_temp);
            const contentHistory = content?.history;
            const createdDate = content?.history?.createdDate;
            if (hasEmptyContributors || !createdBy || !byUser) createAnalyticsEvent({
                type: "sendOperationalEvent",
                data: {
                    source: "byLine",
                    action: "byLineUserEmpty",
                    actionSubject: "content",
                    attributes: {
                        contentId: contentId,
                        isExternalShareRequest: isExternalShareRequest,
                        hasEmptyContributors: hasEmptyContributors,
                        hasCreatedBy: Boolean(createdBy),
                        hasByUser: Boolean(byUser),
                        hasContent: Boolean(content),
                        hasHistory: Boolean(contentHistory),
                        hasCreatedDate: Boolean(createdDate)
                    }
                }
            }).fire();
        };
        $[0] = content;
        $[1] = contentContributors?.nodes;
        $[2] = contentId;
        $[3] = createAnalyticsEvent;
        $[4] = isExternalShareRequest;
        $[5] = t1;
    } else t1 = $[5];
    let t2;
    if ($[6] !== content || $[7] !== contentContributors || $[8] !== contentId || $[9] !== createAnalyticsEvent || $[10] !== isExternalShareRequest) {
        t2 = [
            content,
            contentId,
            contentContributors,
            createAnalyticsEvent,
            isExternalShareRequest
        ];
        $[6] = content;
        $[7] = contentContributors;
        $[8] = contentId;
        $[9] = createAnalyticsEvent;
        $[10] = isExternalShareRequest;
        $[11] = t2;
    } else t2 = $[11];
    (0, $cozmU.useEffect)(t1, t2);
    return null;
};
const $0559514361f7ee96$export$3da174e1e9f9b5b4 = (t0)=>{
    const $ = (0, $bDgLe.c)(71);
    let analyticsBylineFragmentRef;
    let bylineClassificationFragmentRef;
    let contentClassificationFragmentRef;
    let contentContributors;
    let contentFragmentRef;
    let contentId;
    let contentSubType;
    let contentType;
    let passThroughProps;
    let reactionsContentFragmentRef;
    let shouldShowBylineReactions;
    let spaceId;
    if ($[0] !== t0) {
        ({ contentFragmentRef: contentFragmentRef, contentContributors: contentContributors, contentId: contentId, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, ...passThroughProps } = t0);
        $[0] = t0;
        $[1] = analyticsBylineFragmentRef;
        $[2] = bylineClassificationFragmentRef;
        $[3] = contentClassificationFragmentRef;
        $[4] = contentContributors;
        $[5] = contentFragmentRef;
        $[6] = contentId;
        $[7] = contentSubType;
        $[8] = contentType;
        $[9] = passThroughProps;
        $[10] = reactionsContentFragmentRef;
        $[11] = shouldShowBylineReactions;
        $[12] = spaceId;
    } else {
        analyticsBylineFragmentRef = $[1];
        bylineClassificationFragmentRef = $[2];
        contentClassificationFragmentRef = $[3];
        contentContributors = $[4];
        contentFragmentRef = $[5];
        contentId = $[6];
        contentSubType = $[7];
        contentType = $[8];
        passThroughProps = $[9];
        reactionsContentFragmentRef = $[10];
        shouldShowBylineReactions = $[11];
        spaceId = $[12];
    }
    const content = (0, $6SsN4.useFragment)($0559514361f7ee96$export$f2d7ca777241edb7, contentFragmentRef);
    const bylineAppContentProperties = (0, $cI2rq.useBylineAppContentProperties)(contentId);
    const contentContributorsData = (0, $6SsN4.useFragment)($0559514361f7ee96$export$4aabfa7af1f71de0, contentContributors ?? null);
    if (!content) return null;
    const t1 = content.history?.createdBy;
    let t2;
    if ($[13] !== t1) {
        t2 = (0, $83fWZ.toUserProps)(t1);
        $[13] = t1;
        $[14] = t2;
    } else t2 = $[14];
    const author = t2;
    let t3;
    if ($[15] !== content.history?.ownedBy || $[16] !== content.type) {
        t3 = content.history?.ownedBy && (content.type === "page" || content.type === "blogpost") ? (0, $83fWZ.toUserProps)(content.history?.ownedBy) : null;
        $[15] = content.history?.ownedBy;
        $[16] = content.type;
        $[17] = t3;
    } else t3 = $[17];
    const owner = t3;
    const t4 = content.version?.by;
    let t5;
    if ($[18] !== t4) {
        t5 = (0, $83fWZ.toUserProps)(t4);
        $[18] = t4;
        $[19] = t5;
    } else t5 = $[19];
    const by = t5;
    const contributorsCount = contentContributorsData?.count || 0;
    const isOwnerContributor = contentContributorsData?.isOwnerContributor || false;
    let t6;
    if ($[20] !== content.editorProperty?.nodes) {
        const editorVersion = content.editorProperty?.nodes?.find($0559514361f7ee96$var$_temp2);
        t6 = editorVersion?.value?.includes("v2") || false;
        $[20] = content.editorProperty?.nodes;
        $[21] = t6;
    } else t6 = $[21];
    const isFabricPage = t6;
    let t7;
    if ($[22] !== content) {
        t7 = (0, $zalpJ.getTitleContentProperty)({
            content: {
                nodes: [
                    content
                ]
            }
        });
        $[22] = content;
        $[23] = t7;
    } else t7 = $[23];
    const { titleContentProperties: titleContentProperties } = t7;
    const generatedBy = content.contentProperties?.latest?.generatedBy;
    let t8;
    let t9;
    if ($[24] !== contentId) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.VIEW_PAGE_BYLINE_EXPERIENCE),
            id: contentId
        });
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC)
        });
        $[24] = contentId;
        $[25] = t8;
        $[26] = t9;
    } else {
        t8 = $[25];
        t9 = $[26];
    }
    const t10 = content.ancestors ?? null;
    const t11 = content.history?.createdDate || null;
    const t12 = content.version?.friendlyWhen || "";
    const t13 = content.version?.when || null;
    const t14 = Number(content.version?.number || "");
    const t15 = content.version?.contentTypeModified || false;
    let t16;
    if ($[27] !== by || $[28] !== t12 || $[29] !== t13 || $[30] !== t14 || $[31] !== t15) {
        t16 = {
            friendlyWhen: t12,
            when: t13,
            number: t14,
            by: by,
            contentTypeModified: t15
        };
        $[27] = by;
        $[28] = t12;
        $[29] = t13;
        $[30] = t14;
        $[31] = t15;
        $[32] = t16;
    } else t16 = $[32];
    let t17;
    if ($[33] !== analyticsBylineFragmentRef || $[34] !== author || $[35] !== bylineAppContentProperties || $[36] !== bylineClassificationFragmentRef || $[37] !== content || $[38] !== contentClassificationFragmentRef || $[39] !== contentId || $[40] !== contentSubType || $[41] !== contentType || $[42] !== contributorsCount || $[43] !== generatedBy || $[44] !== isFabricPage || $[45] !== isOwnerContributor || $[46] !== owner || $[47] !== passThroughProps || $[48] !== reactionsContentFragmentRef || $[49] !== shouldShowBylineReactions || $[50] !== spaceId || $[51] !== t10 || $[52] !== t11 || $[53] !== t16 || $[54] !== titleContentProperties) {
        t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22b7bc4596013b99$export$773979b66159aa2), {
            contentId: contentId,
            author: author,
            owner: owner,
            contributorsCount: contributorsCount,
            isOwnerContributor: isOwnerContributor,
            isFabricPage: isFabricPage,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentSubType: contentSubType,
            spaceId: spaceId,
            contentType: contentType,
            titleContentProperties: titleContentProperties,
            generatedBy: generatedBy,
            connectionAncestors: t10,
            createdDate: t11,
            contentFragmentRef: content,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            bylineAppContentProperties: bylineAppContentProperties,
            version: t16,
            ...passThroughProps
        });
        $[33] = analyticsBylineFragmentRef;
        $[34] = author;
        $[35] = bylineAppContentProperties;
        $[36] = bylineClassificationFragmentRef;
        $[37] = content;
        $[38] = contentClassificationFragmentRef;
        $[39] = contentId;
        $[40] = contentSubType;
        $[41] = contentType;
        $[42] = contributorsCount;
        $[43] = generatedBy;
        $[44] = isFabricPage;
        $[45] = isOwnerContributor;
        $[46] = owner;
        $[47] = passThroughProps;
        $[48] = reactionsContentFragmentRef;
        $[49] = shouldShowBylineReactions;
        $[50] = spaceId;
        $[51] = t10;
        $[52] = t11;
        $[53] = t16;
        $[54] = titleContentProperties;
        $[55] = t17;
    } else t17 = $[55];
    let t18;
    if ($[56] !== contributorsCount) {
        t18 = {
            contributorsCount: contributorsCount
        };
        $[56] = contributorsCount;
        $[57] = t18;
    } else t18 = $[57];
    let t19;
    if ($[58] !== contentId || $[59] !== t18) {
        t19 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC),
            customData: t18
        });
        $[58] = contentId;
        $[59] = t18;
        $[60] = t19;
    } else t19 = $[60];
    let t20;
    if ($[61] !== content || $[62] !== contentContributorsData || $[63] !== contentId) {
        t20 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0559514361f7ee96$var$HOT106424Tracker, {
            content: content,
            contentId: contentId,
            contentContributors: contentContributorsData,
            isExternalShareRequest: false
        });
        $[61] = content;
        $[62] = contentContributorsData;
        $[63] = contentId;
        $[64] = t20;
    } else t20 = $[64];
    let t21;
    if ($[65] !== t17 || $[66] !== t19 || $[67] !== t20 || $[68] !== t8 || $[69] !== t9) {
        t21 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4PPzL.ErrorBoundary), {
            attribution: (0, $3IBnw.Attribution).BACKBONE
        }, t8, t9, t17, t19, t20);
        $[65] = t17;
        $[66] = t19;
        $[67] = t20;
        $[68] = t8;
        $[69] = t9;
        $[70] = t21;
    } else t21 = $[70];
    return t21;
};
const $0559514361f7ee96$export$3b7993d3cbe5f289 = (t0)=>{
    const $ = (0, $bDgLe.c)(25);
    const { contentId: contentId, versionOverride: versionOverride, embeddedContentRender: embeddedContentRender, shouldShowBylineReactions: shouldShowBylineReactions, contentType: contentType, spaceId: spaceId, contentSubType: contentSubType, bylineClassificationFragmentRef: bylineClassificationFragmentRef, contentClassificationFragmentRef: contentClassificationFragmentRef, reactionsContentFragmentRef: reactionsContentFragmentRef, analyticsBylineFragmentRef: analyticsBylineFragmentRef, ...passThroughProps } = t0;
    const [spaceKey] = (0, $ep3mz.usePageSpaceKey)();
    const isRestrictedExternalShare = (0, $jjv3l.useIsRestrictedExternalShareRequest)();
    const isAccessLinkRequest = (0, $dnfJM.useIsAccessLinkRequest)();
    const bylineAppContentProperties = (0, $cI2rq.useBylineAppContentProperties)(contentId, !isRestrictedExternalShare);
    const t1 = versionOverride || null;
    const t2 = embeddedContentRender || null;
    let t3;
    let t4;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (0, $6mKj3.expValEquals)("cc-markdown-mode", "isEnabled", true);
        t4 = (0, $6mKj3.isExperimentEnabled)("confluence_1p_and_3p_connection_byline_experiment");
        $[0] = t3;
        $[1] = t4;
    } else {
        t3 = $[0];
        t4 = $[1];
    }
    let t5;
    if ($[2] !== contentId || $[3] !== spaceKey || $[4] !== t1 || $[5] !== t2) {
        t5 = {
            contentId: contentId,
            spaceKey: spaceKey,
            versionOverride: t1,
            embeddedContentRender: t2,
            limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
            useNewContentTopper: true,
            isMarkdownModeEnabled: t3,
            includeDevDocsBylineConnection: t4
        };
        $[2] = contentId;
        $[3] = spaceKey;
        $[4] = t1;
        $[5] = t2;
        $[6] = t5;
    } else t5 = $[6];
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = {
            allowOnExternalPage: true,
            single: true
        };
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] !== t5) {
        t7 = {
            variables: t5,
            context: t6,
            errorPolicy: "all"
        };
        $[8] = t5;
        $[9] = t7;
    } else t7 = $[9];
    const { data: data, loading: loading, error: error, refetch: refetch } = (0, $jMyy4.useQueryInterop)(isRestrictedExternalShare ? (0, $3ade7df4fa86d9cd$export$83e33e2cb03d444b) : (0, $fxLAA.default), {
        ...t7,
        __callerPackage__: "content-header"
    });
    let t8;
    if ($[10] !== contentId || $[11] !== refetch) {
        t8 = ()=>refetch({
                contentId: contentId,
                cacheBuster: ""
            });
        $[10] = contentId;
        $[11] = refetch;
        $[12] = t8;
    } else t8 = $[12];
    const reload = t8;
    let t9;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = [
            (0, $c0urc.ReloadType).content
        ];
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== reload) {
        t10 = {
            name: "byline",
            types: t9,
            reload: reload
        };
        $[14] = reload;
        $[15] = t10;
    } else t10 = $[15];
    (0, $1SNEF.useQuickReloadSubscriber)(t10);
    const renderByLine = ()=>{
        if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $f1d8e46f2fc87fe7$export$438daec06afefb9e), null);
        const content = isRestrictedExternalShare ? data?.singleContent : data?.content?.nodes?.[0];
        const shouldRenderWithSpaceDenial = isAccessLinkRequest && Boolean(content) && (0, $fabPv.isSpaceDenialOnly)(error);
        if (error && shouldRenderWithSpaceDenial) (0, $7Sm4c.markErrorAsHandled)(error);
        else if (error) {
            if ((0, $1uFM6.isUnauthorizedError)(error)) {
                (0, $7Sm4c.markErrorAsHandled)(error);
                return null;
            } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $b3j2Y.ErrorDisplay), {
                error: error
            });
        } else {
            if (!content) return null;
        }
        const author = (0, $83fWZ.toUserProps)(content?.history?.createdBy);
        const owner = content?.history?.ownedBy && (content?.type === "page" || content?.type === "blogpost") ? (0, $83fWZ.toUserProps)(content?.history?.ownedBy) : null;
        const by = (0, $83fWZ.toUserProps)(content?.version?.by);
        const contributorsCount = data?.contentContributors?.count || 0;
        const isOwnerContributor = data?.contentContributors?.isOwnerContributor || false;
        const isFabricPage = !isRestrictedExternalShare ? (0, $83fWZ.isFabricEditor)(data) : false;
        const { titleContentProperties: titleContentProperties } = (0, $zalpJ.getTitleContentProperty)(data);
        const contentHeaderContent = !isRestrictedExternalShare ? data?.content?.nodes?.[0] : null;
        const generatedBy = contentHeaderContent?.contentProperties?.latest?.generatedBy;
        const connectionAncestors = contentHeaderContent?.ancestors ?? null;
        const componentProps = {
            contentId: contentId,
            author: author,
            owner: owner,
            contributorsCount: contributorsCount,
            isOwnerContributor: isOwnerContributor,
            isFabricPage: isFabricPage,
            shouldShowBylineReactions: shouldShowBylineReactions,
            contentSubType: contentSubType,
            spaceId: spaceId,
            contentType: contentType,
            titleContentProperties: titleContentProperties,
            generatedBy: generatedBy,
            connectionAncestors: connectionAncestors,
            createdDate: content?.history?.createdDate || null,
            bylineClassificationFragmentRef: bylineClassificationFragmentRef,
            contentClassificationFragmentRef: contentClassificationFragmentRef,
            reactionsContentFragmentRef: reactionsContentFragmentRef,
            analyticsBylineFragmentRef: analyticsBylineFragmentRef,
            bylineAppContentProperties: bylineAppContentProperties,
            version: {
                friendlyWhen: content?.version?.friendlyWhen || "",
                when: content?.version?.when || null,
                number: Number(content?.version?.number || ""),
                by: by,
                contentTypeModified: content?.version?.contentTypeModified || false
            },
            ...passThroughProps
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $22b7bc4596013b99$export$773979b66159aa2), componentProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kvJHJ.PageSegmentLoadEnd), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC),
            customData: {
                contributorsCount: contributorsCount
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0559514361f7ee96$var$HOT106424Tracker, {
            content: content,
            contentId: contentId,
            contentContributors: data?.contentContributors,
            isExternalShareRequest: isRestrictedExternalShare
        }));
    };
    const T0 = (0, $4PPzL.ErrorBoundary);
    const t11 = (0, $3IBnw.Attribution);
    let t12;
    let t13;
    if ($[16] !== contentId) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ln0hx.ExperienceStart), {
            name: (0, $irVI7.VIEW_PAGE_BYLINE_EXPERIENCE),
            id: contentId
        });
        t13 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7boqA.PageSegmentLoadStart), {
            key: contentId,
            metric: (0, $hlP5l.BYLINE_METRIC)
        });
        $[16] = contentId;
        $[17] = t12;
        $[18] = t13;
    } else {
        t12 = $[17];
        t13 = $[18];
    }
    const t14 = renderByLine();
    let t15;
    if ($[19] !== T0 || $[20] !== t11.BACKBONE || $[21] !== t12 || $[22] !== t13 || $[23] !== t14) {
        t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            attribution: t11.BACKBONE
        }, t12, t13, t14);
        $[19] = T0;
        $[20] = t11.BACKBONE;
        $[21] = t12;
        $[22] = t13;
        $[23] = t14;
        $[24] = t15;
    } else t15 = $[24];
    return t15;
};
function $0559514361f7ee96$var$_temp(node) {
    return !node;
}
function $0559514361f7ee96$var$_temp2(property) {
    return property?.key === "editor";
}
module.exports["ByLineFromFragment"] = $0559514361f7ee96$export$3da174e1e9f9b5b4;
module.exports["ByLine"] = $0559514361f7ee96$export$3b7993d3cbe5f289;

});

parcelRegister("f0mzK", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kTb7m = parcelRequire("kTb7m");

const $3dd61ef4b34e980c$export$1516ba114d4009a6 = (index, appearance = 'placeholder')=>({
        key: `placeholder-link-${index}`,
        label: '',
        icon: {
            kind: 'element',
            key: `placeholder-link-${index}`,
            label: '',
            node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))), {
                label: "",
                color: appearance === 'placeholder' ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon-subtle, #505258)",
                testId: "byline-connections-ssr-placeholder-icon"
            })
        }
    });
module.exports["createPlaceholderConnectionIcon"] = $3dd61ef4b34e980c$export$1516ba114d4009a6;

});

parcelRegister("8tDDs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4H55s = parcelRequire("4H55s");


var $jh2Zn = parcelRequire("jh2Zn");


var $hje3t = parcelRequire("hje3t");

const $6c7256c3d4e0ce19$var$claude = {
    key: 'Claude',
    label: 'Claude',
    icon: {
        kind: 'logo',
        key: 'Claude',
        label: 'Claude',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4H55s.ClaudeIcon), {
            label: "",
            size: "xxsmall",
            testId: "byline-connections-claude-icon"
        })
    }
};
const $6c7256c3d4e0ce19$var$cursor = {
    key: 'Cursor',
    label: 'Cursor',
    icon: {
        kind: 'logo',
        key: 'Cursor',
        label: 'Cursor',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jh2Zn.CursorIcon), {
            label: "",
            size: "xxsmall",
            testId: "byline-connections-cursor-icon"
        })
    }
};
const $6c7256c3d4e0ce19$var$rovo = {
    key: 'Rovo',
    label: 'Rovo',
    icon: {
        kind: 'logo',
        key: 'Rovo',
        label: 'Rovo',
        node: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hje3t.RovoTileIcon), {
            size: "xxsmall"
        })
    }
};
const $6c7256c3d4e0ce19$export$9191577ae9981ba3 = (icons, count)=>{
    // With no usable connection icons, match the existing Share context with AI entry.
    const fallbacks = icons.length === 0 ? [
        $6c7256c3d4e0ce19$var$rovo,
        $6c7256c3d4e0ce19$var$claude,
        $6c7256c3d4e0ce19$var$cursor
    ] : [
        $6c7256c3d4e0ce19$var$claude,
        $6c7256c3d4e0ce19$var$cursor,
        $6c7256c3d4e0ce19$var$rovo
    ];
    const existingProducts = new Set(icons.flatMap(({ key: key, label: label })=>[
            key.toLowerCase(),
            label.toLowerCase()
        ]));
    return fallbacks.filter(({ key: key })=>!existingProducts.has(key.toLowerCase())).slice(0, count);
};
module.exports["getFallbackConnectionIcons"] = $6c7256c3d4e0ce19$export$9191577ae9981ba3;

});

parcelRegister("87We3", function(module, exports) {

var $euq7N = parcelRequire("euq7N");


var $9fBoq = parcelRequire("9fBoq");


var $5vpeX = parcelRequire("5vpeX");

const $deb788b04f754a67$export$f3f60ff46f4bf02b = (snapshot)=>snapshot.completeness === 'complete' && snapshot.producers.connect === 'complete' && snapshot.producers.forge === 'complete';
const $deb788b04f754a67$var$getProducerStatus = ({ error: error, hasItems: hasItems, loading: loading })=>{
    if (error) return 'failed';
    if (loading && !hasItems) return 'pending';
    return 'complete';
};
const $deb788b04f754a67$var$getCompleteness = (connect, forge)=>{
    if (connect === 'complete' && forge === 'complete') return 'complete';
    if (connect === 'failed' && forge === 'failed') return 'failed';
    return 'partial';
};
const $deb788b04f754a67$export$d1d89135a42756e9 = ({ connectError: connectError, connectItems: connectItems, forgeError: forgeError, forgeItems: forgeItems, loadingConnectItems: loadingConnectItems, loadingForgeItems: loadingForgeItems, bylineAppContentProperties: bylineAppContentProperties })=>{
    const connectStatus = $deb788b04f754a67$var$getProducerStatus({
        error: connectError,
        hasItems: connectItems.length > 0,
        loading: loadingConnectItems
    });
    const forgeStatus = $deb788b04f754a67$var$getProducerStatus({
        error: forgeError,
        hasItems: forgeItems.length > 0,
        loading: loadingForgeItems
    });
    const connectApps = connectItems.map((item, order)=>({
            id: item.completeKey || item.id || `connect-${order}`,
            order: order,
            producer: 'connect',
            presentation: {
                ...item.icon?.path ? {
                    icon: {
                        height: item.icon.height ?? 14,
                        src: item.icon.path,
                        width: item.icon.width ?? 14
                    }
                } : {},
                label: item.label ?? '',
                resolution: 'resolved',
                source: 'connectWebItem',
                ...item.tooltip ? {
                    tooltip: item.tooltip
                } : {}
            }
        }));
    const forgeApps = forgeItems.map((app, index)=>{
        const contentPropertyKey = app.properties.contentPropertyKey;
        const hasDynamicProperties = Boolean(app.properties.dynamicProperties);
        const defaultPresentation = {
            contentPropertyKey: contentPropertyKey ?? '',
            icon: app.properties.icon ?? '',
            title: app.properties.title ?? '',
            tooltip: app.properties.tooltip ?? ''
        };
        const contentPropertyPresentation = contentPropertyKey && bylineAppContentProperties?.nodes?.length ? (0, $5vpeX.validateContentPropertyData)({
            content: {
                nodes: [
                    {
                        properties: bylineAppContentProperties
                    }
                ]
            }
        }, defaultPresentation, (0, $euq7N.getBylineAppContentPropertyKeys)([
            app
        ])) : defaultPresentation;
        const presentationIcon = contentPropertyPresentation?.icon || app.properties.icon;
        const presentationTitle = contentPropertyPresentation?.title || app.properties.title;
        const presentationTooltip = contentPropertyPresentation?.tooltip || app.properties.tooltip;
        // Validation returns the original defaults when stored data cannot be used.
        const source = contentPropertyKey ? contentPropertyPresentation !== defaultPresentation ? 'contentProperty' : 'manifest' : hasDynamicProperties ? 'dynamicProperties' : 'manifest';
        return {
            id: app.id,
            order: connectApps.length + index,
            producer: 'forge',
            presentation: {
                ...presentationIcon ? {
                    icon: {
                        height: 14,
                        src: presentationIcon,
                        width: 14
                    }
                } : {},
                label: presentationTitle ? (0, $9fBoq.extensionTitle)(app, presentationTitle) : '',
                resolution: presentationTitle ? 'resolved' : 'unresolved',
                source: source,
                ...presentationTooltip ? {
                    tooltip: presentationTooltip
                } : {}
            }
        };
    });
    return {
        apps: [
            ...connectApps,
            ...forgeApps
        ],
        completeness: $deb788b04f754a67$var$getCompleteness(connectStatus, forgeStatus),
        producers: {
            connect: connectStatus,
            forge: forgeStatus
        }
    };
};
module.exports["isByLineAppSnapshotAuthoritative"] = $deb788b04f754a67$export$f3f60ff46f4bf02b;
module.exports["createByLineAppSnapshot"] = $deb788b04f754a67$export$d1d89135a42756e9;

});

parcelRegister("35Exc", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

const $0adb659d8e3039a1$export$c008670b78f0cf4f = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isTitleCenterAligned: isTitleCenterAligned, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2sNsIg7NXe _2XghbEQU1O _1UtDYzZpcK _3iDTPbQ4SZ _0hPCNLDIqT",
            __cmplp.isTitleCenterAligned ? "_2fwxA5DIqT" : "_2fwxA5OLYo",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$8360598613515efc = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$c008670b78f0cf4f : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4kiQYAS40j",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0adb659d8e3039a1$export$3ed1f5d7ee09c27 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$c008670b78f0cf4f : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEPgdg _0hPCNLDIqT _2O5Vij7dHp _42Yu6BgtVO _1ANEUSLRg7",
            !!__cmplp.hasFixedHeight ? "_0jFU0VUofl" : "_0jFU0VIZbP",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$var$BylineStyledMainDivSingleLineWrapper = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let children;
    let props;
    if ($[0] !== t0) {
        const { isExpanded: isExpanded, children: t1, ...t2 } = t0;
        children = t1;
        props = t2;
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0adb659d8e3039a1$export$3ed1f5d7ee09c27, props, children);
        $[3] = children;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
}; /* eslint-enable @typescript-eslint/no-unused-vars */ 
const $0adb659d8e3039a1$export$b95808ab42b44324 = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$var$BylineStyledMainDivSingleLineWrapper : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d _1mT5xdRAKS _42Yu6BIZbP",
            __cmplp.isExpanded ? "_00U5WxHZdu" : "_00U5WxdnbC",
            __cmplp.isExpanded ? "_4afKC8A17z" : "_4afKC8dnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $0adb659d8e3039a1$export$6a3337cf751e21ac = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { hasBadgeStylePageOwnerBylineItem: hasBadgeStylePageOwnerBylineItem, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_39xV02N91d _0luBOg98eZ _2h5UOzYbGa _3W2WEt6wH8 _0gKGieM7Tp _0uGipI98eZ _0DlTgX98eZ _1Oh6lc98eZ _1KbF3r98eZ _2LQVB40Rl6 _27PHXJ0Rl6 _38ddKy0Rl6 _1R2oCZ0Rl6 _4BW6TR6wH8 _2IWu1s6wH8 _4i4dA66wH8 _06nYrP6wH8 _1EjoPeAwSC _1BrKNsAwSC _1E1xWzAwSC _3bFj0TAwSC",
            !!__cmplp.hasBadgeStylePageOwnerBylineItem ? "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC" : "_2XghbE8UTm",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $0adb659d8e3039a1$export$5237d2d172029aad = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
/*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $0adb659d8e3039a1$export$6a3337cf751e21ac : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0hPCNLDIqT _313842FQfX",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
module.exports["StyledMainDiv"] = $0adb659d8e3039a1$export$c008670b78f0cf4f;
module.exports["StandardPageBylineStyledMainDiv"] = $0adb659d8e3039a1$export$8360598613515efc;
module.exports["BylineStyledMainDivSingleLine"] = $0adb659d8e3039a1$export$b95808ab42b44324;
module.exports["StyledTextDiv"] = $0adb659d8e3039a1$export$6a3337cf751e21ac;

});


//# sourceMappingURL=EditorByLineArea.266ed9c9.js.map
